// translations/common/navigation.js

export const navigation = {
  de: {
    nav: {
      title: 'pAIoneer Labs GmbH',
      home: 'Startseite',
      team: 'Team',
      events: 'Events',
      finance: 'Finanz-KI',
      openApp: 'App öffnen',
      account: 'Konto',
      admin: 'Admin',
      logout: 'Ausloggen',
      teaching: 'Lehre',
      agenticdev: 'IDD / Agentic Coding',
      iddLegacy: 'Altsoftware modernisieren',
      iddMethod: 'Intent-Driven Development',
      veridion: 'Veridion',
      kyveil: 'Anonymisierung',
      quantum: 'Quanten-KI',
      login: 'Einloggen',
      languageNames: {
        en: 'Englisch',
        de: 'Deutsch',
        nl: 'Niederländisch',
        uk: 'Ukrainisch',
        fr: 'Französisch',
        it: 'Italienisch',
        es: 'Spanisch',
        sv: 'Schwedisch',
        fi: 'Finnisch',
        ja: 'Japanisch',
        pl: 'Polnisch',
        bg: 'Bulgarisch'
      }
    },
    footer: {
      managingDirectors: 'Geschäftsführer',
      servicesTitle: 'Services',
      legal: {
        title: 'Rechtliches',
        imprint: 'Impressum',
        privacy: 'Datenschutz',
        aiTransparency: 'KI-Transparenz',
        cookieSettings: 'Cookie-Einstellungen',
        terms: 'AGB'
      },
      copyright: 'Alle Rechte vorbehalten.'
    },
    auth: {
      validating: 'Validierung läuft...',
      errors: {
        registrationFailed: 'Registrierung fehlgeschlagen: ',
        unknownError: 'Unbekannter Fehler',
        exchangeRateUnavailable: 'Für EUR-Budgets ist aktuell kein Wechselkurs verfügbar.',
        passwordTooWeak: 'Das Passwort ist zu kurz oder zu schwach.',
        adminRequired: 'Nur Administratoren dürfen diesen Bereich öffnen.',
        lastAdminProtected: 'Mindestens ein aktiver Administrator muss erhalten bleiben.',
        userExists: 'Ein Benutzer mit diesen Daten existiert bereits.',
        userCreateInvalid: 'Die Benutzerdaten sind unvollständig oder ungültig.',
        mailNotConfigured: 'Das Mail-System ist noch nicht vollständig konfiguriert.'
      }
    },
    account: {
      username: 'Benutzername',
      email: 'E-Mail',
      roles: 'Rollen',
      manageText: 'Passwort, Zwei-Faktor-Authentifizierung, aktive Sitzungen und E-Mail-Adresse ändern Sie in der Kontoverwaltung.',
      manageButton: 'Kontoverwaltung öffnen',
      signedOut: 'Sie sind nicht angemeldet.'
    },
    admin: {
      datalake: {
        loading: "Lädt …",
        loadFailed: "Der Data Lake ist nicht erreichbar",
        refresh: "Aktualisieren",
        generatedAt: "Stand",
        notRolled: "Dieser Bereich ist im Backend noch nicht ausgerollt. Sobald die neuen Endpunkte live sind, erscheint hier der gemessene Zustand.",
        loadMore: "Mehr laden",
        yes: "ja",
        no: "nein",
        none: "keine",
        close: "Schließen",
        summaryTitle: "Zwei Hypothesen, eine Werkbank",
        summaryBody: "Die Architektur-Hypothese sagt: Das mathematische Gefäß entscheidet, was das Modell werden kann — sie steht auf der LLM-Paper-Seite. Die Daten-Hypothese sagt: Erst verknüpfte, verifizierte Trainingsdaten machen das Gefäß voll — ihr dient diese Seite. Der Autopilot füllt den Datenbestand fortlaufend, startet das Training, sobald der Datenplan des Papers in jedem Bereich auf Deutsch und Englisch erreicht ist, misst das Ergebnis mit der Benchmark-Suite und veröffentlicht das Modell privat auf HuggingFace. Jede Zahl hier ist gemessen oder als Vorgabe gekennzeichnet.",
        summaryArchButton: "Zur Architektur-Hypothese (LLM-Paper)",
        apTitle: "Autopilot",
        tpTitle: "Weg zum Trainingsstart",
        tpSubtitle: "Wo der Autopilot gerade steht: jeder Schritt bis zum laufenden Training mit Zustand, Zeit und Fortschritt.",
        tpNow: "Jetzt",
        tpStep: "Schritt",
        tpOf: "von",
        tpSince: "seit",
        tpFor: "läuft seit",
        tpHeartbeat: "letztes Lebenszeichen",
        tpDone: "erledigt",
        tpRunning: "läuft",
        tpWaiting: "wartet",
        tpFailed: "gescheitert",
        tpSkipped: "übersprungen",
        tpProgress: "Fortschritt",
        tpRows: "Zeilen",
        tpRate: "pro Sekunde",
        tpRemaining: "geschätzte Restzeit",
        tpEstimateNote: "Schätzung aus den gemessenen Zählern",
        tpPhaseReading: "liest ein Datenpaket",
        tpPhaseAdmission: "Zulassung (Duplikate, Entropie)",
        tpPhaseEncoding: "Tokenisierung",
        tpNoTiming: "Zeitangaben meldet dieser Engine-Stand noch nicht.",
        tpBlockers: "Blocker und Fehler",
        tpNone: "Keine Blocker.",
        trTitle: "Trainingslauf (live)",
        trSubtitle: "Direkt aus dem Run-Verzeichnis des Trainers gelesen — funktioniert auch, während der Worker neu startet.",
        trNoRun: "Noch kein Trainingslauf mit Fortschrittsdaten.",
        trStateTraining: "trainiert",
        trStateStarting: "startet",
        trStateFinished: "fertig",
        trStateSilent: "still seit {age}",
        trStep: "Schritt",
        trOf: "von",
        trRemaining: "Restzeit (Schätzung aus der gemessenen Rate)",
        trSecondsPerStep: "s pro Schritt",
        trProgress: "Fortschritt der geplanten Schritte",
        trRun: "Lauf",
        trResumed: "fortgesetzt ab Schritt {step}",
        trVersion: "Trainingsdatenstand",
        trModel: "Modell",
        trTokensPerSecond: "Tokens/s",
        trTokensSeen: "Tokens gesehen",
        trVram: "GPU-Speicher",
        trCap: "Deckel",
        trLastHeartbeat: "Letzter Heartbeat",
        trAgo: "vor {age}",
        trShardReads: "Shard-Lesungen lokal / über den Worker",
        trLossTitle: "Loss-Verlauf",
        trLossTotal: "Gesamt",
        trLossNtp: "Next-Token",
        trLossMtp: "Multi-Token",
        trChartEmpty: "Noch keine Schritte gemeldet.",
        trAxisNote: "Waagrecht: Trainingsschritt, senkrecht: Loss (natürlicher Logarithmus). Mit der Maus über die Kurve fahren zeigt die Werte eines Schritts.",
        trValue: "Wert",
        trCurrentValue: "aktuell",
        trPoints: "{count} Messpunkte insgesamt",
        trStages: "Lehrplan-Stufen",
        trStageFoundation: "Fundament (Rohtext)",
        trStageCapability: "Fähigkeiten",
        trStageAnneal: "Anneal",
        trStageCurrent: "läuft",
        trStageDone: "fertig",
        trStageAhead: "kommt noch",
        trShards: "Shards",
        trRows: "Zeilen",
        trCheckpoint: "Neuester Checkpoint",
        trCheckpointNone: "noch keiner",
        trCheckpoints: "Vollständige Checkpoints auf der Platte",
        trCheckpointEvery: "alle {minutes} min",
        trKernels: "Aktive Kernel",
        trDeviations: "Abweichungen",
        trBlockStorage: "Kopie im Block Storage",
        trBlockStorageNone: "noch keine — die erste folgt nach dem ersten Checkpoint",
        trUploading: "Upload läuft: Schritt {step}",
        treeCkRun: "Trainingslauf",
        treeCkCopy: "Checkpoint im Block Storage, kopiert {time}",
        treeCkLocal: "Checkpoint auf der Platte des Servers",
        treeCkUploading: "wird gerade in den Block Storage kopiert",
        trKpiProgress: "Fortschritt",
        trKpiTokens: "Tokens",
        trKpiThroughput: "Durchsatz",
        trKpiLoss: "Loss",
        trKpiLr: "Lernrate",
        trKpiGpu: "GPU-Speicher",
        trEndAt: "Ende ca. {time}",
        trSeenPlanned: "gesehen / geplant",
        trBest: "bester {value}",
        trHourAgo: "{value} ggü. vor 1 h",
        trPerplexity: "Perplexität {value}",
        trPhaseWarmup: "Warm-up",
        trPhaseCosine: "Cosinus-Abfall",
        trPhaseStable: "stabile Phase",
        trPhaseDecay: "Abkühlung",
        trKpiEpoch: "Epoche",
        trEpochValue: "{epoch} von {epochs}",
        trPlanTitle: "Laufplan",
        trPlanExplain: "Warm-up auf die Spitzen-Lernrate, danach konstant über vier gemischte Epochen des Korpus; die Abkühlphase trainiert auf der hochwertigsten Mischung (Fähigkeits-Samples, Lehrbuch-Texte, Anneal) und senkt die Lernrate auf null.",
        trPlanPhase: "Phase",
        trPlanStableSteps: "Geplante Schritte der stabilen Phase",
        trPlanDecay: "Abkühlung",
        trPlanDecayAhead: "ab Schritt {step} · in etwa {time}",
        trPlanDecayAheadNoTime: "ab Schritt {step}",
        trPlanDecayRunning: "seit Schritt {step} · {steps} Schritte bis Lernrate null",
        trPlanTokensPerStep: "Token je Optimierungsschritt",
        trPlanTokensPerStepValue: "{tokens} ({accum} Mikro-Batches)",
        trPlanRecompute: "Aktivierungs-Neuberechnung",
        trPlanRecomputeOn: "an – gemessen schneller mit größerem Mikro-Batch",
        trPlanRecomputeOff: "aus – gemessen schneller ohne",
        trPlanFim: "Dokumente im Lückenfüllen-Format bisher",
        tbTitle: "Lehrbuch-Programm",
        tbSubtitle: "Foundation-Texte, von Teachern als Lehrbuchtext umgeschrieben; jede Zahl und jeder Eigenname muss in der Quelle stehen.",
        tbTokens: "Lehrbuch-Token",
        tbTokensSub: "{pct} % des Ziels von {target}",
        tbSamples: "Angenommene Umschreibungen",
        tbJobs: "Abgeschlossene Jobs",
        tbTeacher: "Teacher-Token je Lehrbuch-Token",
        tbCost: "Kosten je Mio. Lehrbuch-Token",
        tbCostNone: "das Gateway meldet keine Kosten; gezählt werden die Teacher-Token",
        tbExplain: "Läuft parallel zum Training; spätere Epochen und die Abkühlphase lesen, was bis dahin versiegelt ist.",
        trThroughputTitle: "Durchsatz (Tokens/s)",
        trCurriculumTitle: "Lehrplan",
        trStageTokens: "{tokens} Tokens",
        trStageBegins: "beginnt bei Schritt {step}",
        trPlanWarningLabel: "Achtung",
        trPlanWarning: "Der Lauf endet nach {max} Schritten in der Stufe „{stage}“ — die Fähigkeits-Daten beginnen erst bei Schritt {cap}. Ein voller Durchgang bräuchte {steps} Schritte (≈ {days} Tage).",
        trPlanOk: "Die geplanten Schritte reichen bis zur Stufe „{stage}“.",
        trCheckpointsTitle: "Checkpoints",
        trNextCheckpoint: "Nächster Checkpoint",
        trInSpan: "in {span}",
        trResumes: "Wiederaufnahme",
        trNoResume: "keine",
        trConfig: "Konfiguration",
        trHealth: "Zustand",
        trMicroBatch: "Mikro-Batch / Tokens pro Schritt",
        trSeqLen: "Sequenzlänge",
        trLrPlan: "Lernraten-Plan",
        trLrPlanValue: "Spitze {lr}, Warm-up {warmup} Schritte, Cosinus bis Schritt {max}",
        trSpikes: "Loss-Spitzen (letzte Stunde)",
        trProgressSub: "Schritt {step} von {max} · läuft seit {elapsed}",
        trTokensSub: "von {planned} geplant",
        trPathTrainingDetail: "{pct} % · Schritt {step} von {max} · Ende ca. {end}",
        trReadinessRunning: "Das Training läuft: {pct} % geschafft (Schritt {step} von {max}), Loss {loss}, Ende ca. {end}.",
        tdvDraftsHistory: "Ältere Entwürfe, nie versiegelt ({count})",
        runsHistory: "Abgebrochene und gescheiterte Läufe ({count})",
        trAxisStep: "Trainingsschritt",
        trAxisLoss: "Loss (nat. Logarithmus)",
        trCountdown: "{d} T {h} h {m} min {s} s",
        trTimerWaiting: "Timer folgt nach den ersten Messpunkten.",
        trTimerStageEnds: "Stufe „{stage}“ endet in",
        trTimerAt: "am {time}",
        trTimerNext: "Danach „{stage}“: {span}, ab {time}",
        trTimerRunEnds: "Lauf endet in {span} (am {time})",
        trStepTimeSub: "{wall} s je Schritt gemessen · Rechenzeit {compute} s",
        trEtaTitle: "Restzeit aus der gemessenen Schrittdauer",
        trEtaEpochEnds: "Epoche {epoch} von {epochs} endet in",
        trEtaEpochAt: "am {time} (Schritt {step})",
        trEtaNextEpoch: "Epoche {epoch}: ab {time} (Schritt {step})",
        trEtaDecay: "Abkühlphase beginnt in {span} (am {time}, Schritt {step})",
        trEtaBasis: "Grundlage: {wall} s je Schritt, Mittel der letzten {n} Schritte ohne {pauses} Pausen (Relaunch, Stillstand); Rechenzeit laut Trainer {compute} s je Schritt.",
        devTitle: "Abweichungen vom Bauplan",
        devNone: "Keine Abweichungen — der Lauf folgt dem Bauplan vollständig.",
        devPlanned: "geplant",
        devLimit: "Einschränkung",
        devSeqLen: "Kontextlänge",
        devSeqLenText: "Trainiert mit {trained} Tokens Kontext statt der im Bauplan vorgesehenen {spec}. Die lange Kontextlänge kommt in einer späteren Phase dazu.",
        devFim: "Lückenfüllen (FIM)",
        devFimText: "Das Lückenfüll-Ziel ({rate} % der Blöcke) ist im Bauplan angekündigt, aber in diesem Lauf noch nicht aktiv.",
        devTermination: "Abbruch-Sonde",
        devTerminationText: "Die Abbruch-Sonde ist kein Trainingsziel, sondern ein eigener Modus nach dem Training; sie läuft später über einen fertigen Checkpoint.",
        devDecision: "Entscheidungs-Ziel",
        devDecisionText: "Das Entscheidungs-Ziel ist aktiv, aber in den Nachtrainings-Stufen dieses Laufs kamen keine Entscheidungsmarken an.",
        devKernelOff: "Beschleunigung abgeschaltet",
        devKernelUnverifiedText: "Der Kernel „{kernel}“ wurde von der Probe nicht bestätigt und läuft als Standard-Berechnung.",
        devKernelUnavailableText: "Der Kernel „{kernel}“ ist auf dieser Karte nicht verfügbar und läuft als Standard-Berechnung.",
        devKernelFellBackText: "Der Kernel „{kernel}“ ist im Lauf auf die Standard-Berechnung zurückgefallen ({reason}).",
        devOptimizer: "Optimizer",
        devOptimizerText: "Optimizer-Zustände laufen in bfloat16 statt in 8 Bit (bitsandbytes nicht verfügbar) — mehr Speicher, gleiche Mathematik.",
        devScale: "Modellgröße",
        devScaleText: "Das Modell ist auf {scale} % der Bauplan-Größe instanziiert, weil die volle Größe nicht in den gemessenen Speicher passte.",
        devMediaHeads: "Medien-Köpfe",
        devMediaHeadsText: "Die Köpfe für Bild/Audio sind untrainiert, weil der Datenstand keine Medien-Tokens enthält — für einen Text-Strang geplant.",
        devVision: "Bildpfad",
        devVisionText: "Der Bildpfad ist gebaut, hat aber mit null Bildern trainiert, weil der Datenstand keine enthält.",
        devOther: "Sonstiges",
        trStageShare: "{pct} % dieser Stufe geschafft",
        cap_tool_calling: "Werkzeug-Aufrufe",
        cap_deep_reasoning: "Tiefes Schlussfolgern",
        cap_software_engineering: "Software-Entwicklung",
        cap_office_finance: "Büro & Finanzen",
        cap_doc_understanding: "Dokument-Verständnis",
        tpExplainThresholds: "Für jede Fähigkeit des gewählten Strangs müssen genug geprüfte Trainingsbeispiele im Data Lake liegen. Ziel und Messwert stehen hier pro Fähigkeit.",
        tpThresholdsDetail: "{met} von {total} Fähigkeiten haben ihr Ziel erreicht",
        tpThresholdRow: "{measured} Beispiele",
        tpForeignThresholds: "Nicht für diesen Strang: {list} — gehört zu einem anderen Strang und blockiert nichts.",
        tpStepTokenizerReleaseExplain: "Der Tokenizer zerlegt Text in Zahlen. Er wird einmal festgeschrieben und an die Architektur gemeldet, damit Daten und Modell dieselbe Sprache sprechen.",
        tpStepTokenizeTdvExplain: "Alle geprüften Trainingsbeispiele werden mit dem festgeschriebenen Tokenizer in Zahlenfolgen übersetzt.",
        tpStepTokenizeCorpusExplain: "Der gesamte Rohtext des Data Lake wird in Zahlenfolgen übersetzt — das ist die Masse für das Fundament.",
        tpStepTdvCreateExplain: "Aus allen tokenisierten Daten wird ein fester Datenstand (TDV) zusammengestellt, mit Lehrplan und gemessener Token-Menge.",
        tpStepTdvSealExplain: "Der Datenstand wird unveränderlich gemacht und mit Beschreibung in den Block Storage kopiert.",
        tpStepCompatExplain: "Zwölf Regeln prüfen, ob Datenstand und Architektur zusammenpassen (Tokenizer, Kontextlänge, Trainingsziele, Speicher). Alle müssen grün sein.",
        tpStepVramExplain: "Misst auf der Karte, ob genug GPU-Speicher für den deklarierten Bedarf frei ist.",
        tpVramDetail: "{free} GB frei, {need} GB nötig",
        tpStepTrainStartExplain: "Der Autopilot startet den Trainingslauf, sobald alle Voraussetzungen erfüllt sind.",
        tpStepTrainingExplain: "Der Lauf trainiert eigenständig mit Checkpoints alle 30 Minuten und setzt nach jeder Unterbrechung von selbst fort. Details auf der Seite „Training & Veröffentlichung“.",
        tpVramRunning: "Karte vom laufenden Training belegt ({need} GB Bedarf); beim Start erfüllt",
        trPathTrainingDetailNoEnd: "{pct} % · Schritt {step} von {max}",
        srTitle: "Datenbereitschaft je Modell-Strang",
        srSubtitle: "Während ein Strang trainiert, bereitet der Data Lake die Daten der anderen weiter vor — bis zur eigenen versiegelten Version, ohne Trainingsstart.",
        srTrainingNow: "trainiert gerade",
        srSelected: "ausgewählt",
        srDataReady: "Daten bereit",
        srPreparing: "in Vorbereitung",
        srModalities: "Eingabe: {in} · Ausgabe: {out}",
        srThresholds: "Ziele: {met} von {total} erreicht",
        srCorpus: "Tokenisierter Korpus",
        srCorpusValue: "{tokens} Tokens in {shards} Datenpaketen",
        srVersion: "Neueste Version",
        srNoVersion: "noch keine",
        srLacking: "Fehlt noch",
        srLacksNothing: "nichts — die Version wartet auf ihren Strang",
        srLackThresholds: "Ziele nicht erreicht",
        srLackCodec: "Bild-/Audio-Codec nicht freigegeben",
        srLackTokenizer: "Tokenizer nicht gemeldet",
        srLackVersion: "keine versiegelte Version",
        srSelectedNote: "Dieser Strang trainiert gerade; sein Weg steht oben.",
        srSelectedIdleNote: "Dieser Strang ist für das nächste Training ausgewählt; sein Weg steht oben.",
        srUnselectedNote: "Dieser Strang startet kein Training, solange ein anderer gewählt ist — seine Daten werden trotzdem vollständig vorbereitet.",
        modText: "Text",
        modImage: "Bild",
        modAudio: "Audio",
        modVideo: "Video",
        tpStepThresholds: "Ziele erreichen",
        tpStepPlan: "Datenplan des Papers erreichen",
        tpExplainPlan: "Das Paper legt fest, wie viele eindeutige, geprüfte Tokens jeder Bereich braucht. Deutsch und Englisch tragen je mindestens die Hälfte davon, Code zählt ohne Sprache. Gezählt werden die zugelassenen Tokens nach dem Entfernen von Duplikaten, nicht die Rohschätzung.",
        tpPlanDetail: "{met} von {total} Bereichen erreicht",
        tpPlanRowLang: "{have} / {target} · Deutsch {de} / {half} · Englisch {en} / {half}",
        tpPlanRowFree: "{have} / {target}",
        tpPlanOpen: "offen: {langs}",
        tpLangDe: "Deutsch",
        tpLangEn: "Englisch",
        tpPlanProvisional: "Vorläufig gezählt mit dem bisherigen Tokenizer; maßgeblich ist der neu trainierte.",
        tpStepOwnTokenizer: "Eigener Tokenizer des Strangs",
        tpStepOwnTokenizerExplain: "Der Strang trainiert mit einem eigenen Tokenizer, gelernt auf einem ausgewogenen Korpus mit Code. Erst in seinen Tokens zählt der Datenplan endgültig.",
        tpPlanCat_knowledge: "Wissen",
        tpPlanCat_code: "Code",
        tpPlanCat_mathematics: "Mathematik",
        tpPlanCat_domain: "Fachtexte",
        tpPlanCat_textbook: "Lehrbuch",
        tpPlanCat_agentic: "Agentisch",
        tpPlanFlow: "Zufluss {rate} pro Stunde",
        tpPlanEtaDays: "noch etwa {n} Tage",
        tpPlanEtaHours: "noch etwa {n} Stunden",
        tpPlanNoFlow: "kein Zufluss in den letzten 24 Stunden",
        tpPlanBinding: "Engpass",
        tpBind_download: "Download",
        tpBind_allowance: "Tageskontingent des Block Storage",
        tpBind_ingest: "Ingest",
        tpBind_teachers: "Lehrer-Modelle",
        thrPlanTitle: "Samples je Fähigkeit (gemessen)",
        thrPlanNote: "Die Ziele dieses Strangs legt sein Paper fest: der Datenplan je Bereich, Deutsch und Englisch, im „Weg zum Trainingsstart“. Schwellen je Fähigkeit gelten nur für Stränge ohne Datenplan; hier steht, was je Fähigkeit gemessen vorliegt.",
        thrPlanRow: "{samples} Samples · {tokens} Tokens",
        srDataPlan: "Datenplan des Papers: {met} von {total} Bereichen erreicht",
        srLackDataPlan: "Datenplan nicht erreicht",
        srPlanOpen: "offen: {areas}",
        tpBind_source: "keine Quelle in dieser Sprache",
        tpBind_paused: "Download pausiert",
        tdvPlanEmpty: "Noch kein Datenstand der aktiven Spezifikation. Der Autopilot baut und versiegelt ihn, sobald der Datenplan des Papers erreicht ist.",
        compatPlanNone: "Noch keine Prüfung: Geprüft wird der Datenstand der aktiven Spezifikation, sobald er versiegelt wird.",
        mixPlanTitle: "Mischung laut Paper",
        mixPlanNote: "Jeder Trainingsschritt zieht die Bereiche in diesen festen Anteilen; die Abklingphase hebt den hochwertigen Anteil auf bis zur Hälfte. Mischungsziele je Fähigkeit gelten nur für Stränge ohne Datenplan.",
        mixPlanShare: "{area} {pct} %",
        sitTitle: "Lagebild",
        sitSubtitle: "Wo das Training steht, in einem Blick: was je Bereich des Papers fehlt, was gerade läuft und was danach kommt.",
        sitHeadlineDays: "Das Training kann frühestens in etwa {time} starten; am längsten braucht {area} (Engpass: {bottleneck}).",
        sitHeadlineBlocked: "Der Datenplan wird so nicht erreicht: {items} hat keine Quelle. Daran wird gearbeitet: offene Datensätze recherchieren oder geprüft übersetzen.",
        sitHeadlineReached: "Der Datenplan ist erreicht; jetzt folgen Tokenizer, neue Tokenisierung, Versiegeln und Prüfung.",
        sitHeadlineUnknown: "Für den Rest fehlt noch eine Messung des Zuflusses.",
        sitHold: "Der Start ist zusätzlich angehalten, bis alle Bausteine geprüft sind.",
        sitArea: "Bereich",
        sitTotal: "Gesamt",
        sitFlow: "Zufluss",
        sitLeft: "Noch",
        sitBottleneck: "Engpass",
        sitNoLanguage: "ohne Sprache",
        sitNoSource: "keine Quelle",
        sitReached: "erreicht",
        sitDays: "{n} Tage",
        sitHours: "{n} Std.",
        sitPerHour: "{value} pro Stunde",
        sitPerHourTokens: "{value} Tokens pro Stunde",
        sitRunningTitle: "Was gerade läuft",
        sitDownloads: "Downloads",
        sitIngest: "Verarbeitung in Textabschnitte",
        sitTokenize: "Tokenisierung",
        sitGenerate: "Erzeugung durch Lehrer-Modelle",
        sitIdle: "ruht",
        sitNextTitle: "Was danach kommt",
        sitNextSteps: "Tokenizer mit Code trainieren → ganzen Korpus neu tokenisieren → Datenstand versiegeln → Prüfungen → Trainingsstart",
        sitProvisional: "Die Mengen sind vorläufig mit dem bisherigen Tokenizer gezählt; endgültig zählt der neu trainierte.",
        tpPlanSeeSituation: "Bereiche, Sprachen und Restzeiten stehen im Lagebild oben.",
        sitHeadlineBlocks: "Das Training kann noch nicht starten: Es fehlen Bausteine, die noch gebaut werden müssen ({items}). Die Daten wachsen parallel.",
        sitDuration: "Dauer des Trainings: etwa {days} Tage für {budget} Tokens bei gemessenen {rate} Tokens pro Sekunde auf demselben Netz.",
        sitBlocksTitle: "Bausteine des Trainings",
        sitStateNotBuilt: "noch nicht gebaut",
        sitStateWaiting: "wartet",
        sitStateReady: "fertig",
        sitBlockWaitsFor: "wartet auf: {items}",
        sitBenchProgress: "{made} von {total} geprüften Aufgaben",
        sitBlockParts: "gebaut: {built} · offen: {open}",
        part_graph_bundles: "verknüpfte Dokumente",
        part_repository_bundles: "ganze Repositories",
        part_long_context: "langer Kontext",
        part_fine_tuning: "Feintuning",
        part_reinforcement_learning: "Belohnungslernen",
        part_real_folding: "echtes Falten des Kontexts",
        sitBlock_data: "Daten nach dem Plan des Papers",
        sitBlock_tokenizer: "Tokenizer mit Code",
        sitBlock_bench: "Benchmark-Suite des Papers",
        sitBlock_trainer: "Trainer: Fensterstufen, festes Budget, feste Mischung",
        sitBlock_bundles: "Bündel: verknüpfte Dokumente und ganze Repositories",
        sitBlock_post_training: "Nachtraining: langer Kontext, Feintuning, Belohnungslernen",
        tpStepTokenizerRelease: "Tokenizer-Freigabe",
        tpStepTokenizeTdv: "Trainingsbeispiele tokenisieren",
        tpStepTokenizeCorpus: "Korpus tokenisieren",
        tpStepTdvCreate: "Datenstand erstellen",
        tpStepTdvSeal: "Datenstand versiegeln",
        apAfterSealLabel: "Nach dem Versiegeln automatisch weitermachen",
        apAfterSealOn: "EIN",
        apAfterSealOff: "AUS",
        apAfterSealConfirmOn: "Nach dem Versiegeln automatisch weitermachen? Der Weg zum Trainingsstart geht dann ohne Pause weiter: Kompatibilitätsprüfung, GPU-Prüfungen und Trainingsstart.",
        apAfterSealConfirmOff: "Nach dem Versiegeln wieder anhalten? Der Autopilot pausiert dann nach dem Versiegeln des Datenstands zur Auswertung.",
        apAfterSealTurnedOn: "Der Weg zum Trainingsstart geht nach dem Versiegeln automatisch weiter.",
        apAfterSealTurnedOff: "Der Autopilot hält nach dem Versiegeln an.",
        apAfterSealWaiting: "Datenstand versiegelt – der Autopilot pausiert zur Auswertung.",
        apAfterSealStep: "Auswertung des versiegelten Datenstands",
        apAfterSealHint: "Nach dem Versiegeln liegen alle Daten verarbeitet im Block Storage. Ist der Schalter aus, pausiert der Autopilot dort zur Auswertung; eingeschaltet geht der Weg automatisch weiter.",
        tpStepCompat: "Kompatibilitätsprüfung",
        tpStepVram: "VRAM-Probe",
        tpStepTrainStart: "Trainingsstart",
        tpStepTraining: "Training läuft",
        apSubtitle: "Ein Schalter für den ganzen Kreislauf: Daten sammeln, verarbeiten und verknüpfen, Beispiele erzeugen, trainieren, sobald der Datenplan des Papers erreicht ist, benchmarken und privat veröffentlichen. Jede Blockade wird benannt statt überspielt.",
        apOn: "Autopilot EIN",
        apOff: "Autopilot AUS",
        apTurnOn: "Autopilot einschalten",
        apTurnOff: "Autopilot ausschalten",
        apConfirmOn: "Autopilot einschalten? Er füllt den Datenbestand fortlaufend bis zum versiegelten Datenstand; danach pausiert er zur Auswertung, außer „Nach dem Versiegeln automatisch weitermachen“ ist eingeschaltet.",
        apConfirmOff: "Autopilot ausschalten? Laufende Arbeit endet kontrolliert; nichts wird verworfen.",
        apEnabled: "Autopilot eingeschaltet",
        apDisabled: "Autopilot ausgeschaltet",
        apPause: "Pausieren",
        apResume: "Fortsetzen",
        apResumed: "Autopilot fortgesetzt",
        apPausedNote: "Autopilot pausiert",
        apPausedPill: "pausiert",
        apPhaseLabel: "Phase",
        apPhaseSince: "seit {time}",
        apCycleId: "Zyklus",
        apBlockedLabel: "Blockiert",
        apCycleTitle: "Fortschritt des laufenden Zyklus",
        apCycleEmpty: "Kein Zyklus aktiv.",
        colPhase: "Phase",
        colPending: "Wartet",
        colRunning: "Läuft",
        colDone: "Fertig",
        colFailed: "Fehlgeschlagen",
        thrTitle: "Schwellen je Fähigkeit",
        thrSubtitle: "Ab diesen Mengen versiegelt der Autopilot eine Trainingsdaten-Version und startet das Training; die Balken zeigen den gemessenen Fortschritt.",
        thrMet: "erreicht",
        thrNotMet: "offen",
        thrDefault: "vorbelegter Standard",
        thrForeign: 'nicht für den gewählten Strang',
        staleSince: 'Worker antwortet gerade nicht — letzter gemessener Stand von',
        staleHint: 'Der Autopilot läuft weiter; die Anzeige aktualisiert sich, sobald der Worker wieder antwortet.',
        idxTitle: 'Vektorindex & Deduplikation',
        idxSubtitle: 'Der eigene HNSW-Index des Lakes für die Graph-Verknüpfung und die gemessene Bereinigung doppelter Chunk-Shards.',
        idxConfigured: 'Index konfiguriert',
        idxReachable: 'Index erreichbar',
        idxPoints: 'Indexpunkte',
        idxBackfill: 'Befüllung aus der Embeddings-Tabelle',
        idxBackfillDone: 'abgeschlossen',
        idxBackfillOpen: 'läuft / offen',
        ddLastPass: 'Letzter Dedup-Durchlauf',
        ddChecked: 'geprüfte Assets',
        ddDropped: 'verworfene Duplikat-Shards',
        ddRows: 'verworfene Chunk-Zeilen',
        ddRemaining: 'offene Kandidaten',
        ddNone: 'noch kein Durchlauf',
        gsTitle: 'Graph-Stufen',
        gsSubtitle: 'Die Teacher-Stufen des Graphen — Embedding und Claim-Extraktion — dienen der graphgestützten Beispielsynthese; darum nehmen sie Chunks in Rangfolge und in der Breite über die Assets: Rang 0 die Dokumente des Owners und Tool-Importe, Rang 1 Expertenwissen (Wissenschaft, Technik, Bücher, Reasoning, German Commons, Wikipedia), Rang 2 allgemeiner Text (Wikisource, Gutenberg, Web-Korpora, Transkripte), Rang 3 Code (nur eingebettet, nie claim-extrahiert). Die Grundmasse erreicht das Token-Korpus ohne Teacher-Durchlauf.',
        gsMeasuredAt: 'Gemessen um',
        gsRanksTitle: 'Rangfolge',
        gsRanksEmpty: 'Noch kein Rangplan gemeldet.',
        gsColRank: 'Rang',
        gsColLabel: 'Quellklasse',
        gsColSources: 'Quellen',
        gsColAssets: 'Assets',
        gsColPendingExtract: 'Offene Extraktion',
        gsColPendingEmbed: 'Offenes Embedding',
        gsRankOwner: 'Owner-Dokumente und Tool-Importe',
        gsRankExpert: 'Expertenwissen',
        gsRankGeneral: 'Allgemeiner Text',
        gsRankCode: 'Code (nur eingebettet)',
        gsRankShort: 'Rang {n}',
        gsLoopsTitle: 'Letzte Runde jeder Schleife',
        gsColLoop: 'Schleife',
        gsColSource: 'Quelle',
        gsColChunks: 'Chunks erledigt',
        gsColClaims: 'Claims',
        gsColEdges: 'Kanten',
        gsColSeconds: 'Sekunden',
        gsColLast: 'Letzte Runde',
        gsLoopEmbed: 'Embedding',
        gsLoopExtract: 'Claim-Extraktion',
        gsLoopLink: 'Verknüpfung',
        gsUngrounded: '{n} unbelegt',
        gsNoRound: 'noch keine Runde',
        gsClaims: 'Claims gesamt',
        gsAssetsWithClaims: 'Assets mit Claims',
        gsDangling: 'Verwaiste Chunk-Knoten',
        gsStuck: 'Hängende Assets (in Verarbeitung ohne laufenden Ingest)',
        gsConcurrency: 'Parallelität der Extraktion',
        gsOrphansLast: 'Letzter Bereinigungslauf',
        gsOrphansNone: 'noch kein Lauf',
        gsOrphansStatusCleaned: 'bereinigt',
        gsOrphansDropped: 'Knoten entfernt',
        gsOrphansRemaining: 'verbleibend',
        gsOrphansHint: 'Nichts zu tun: Der Autopilot plant einen begrenzten Bereinigungslauf selbst, solange Chunk-Knoten ohne Shard existieren. Die Zusammenfassung zeigt den letzten Lauf.',
        thrSamplesBar: "Beispiele",
        thrTokensBar: "Tokens (geschätzt)",
        thrNoMinimum: "gemessen, kein Minimum",
        thrEditTitle: "Schwellen bearbeiten",
        thrEditSubtitle: "Speichern ersetzt alle Schwellen vollständig; vorbelegte Standards gelten nur, bis hier eigene Werte gesetzt sind.",
        thrMinSamples: "Min. Beispiele",
        thrMinTokens: "Min. Tokens (geschätzt)",
        thrEnabled: "aktiv",
        thrAdd: "Zeile hinzufügen",
        thrSave: "Schwellen speichern",
        thrSaved: "Schwellen gespeichert",
        thrEmpty: "Noch keine Schwellen definiert — ohne aktive Schwellen versiegelt der Autopilot nichts und meldet das als Blockade.",
        capability: "Fähigkeit",
        modSignature: "Signatur",
        removeRow: "Entfernen",
        budgetsTitle: "Tagesbudgets",
        budgetsSubtitle: "Verbrauch gegen Obergrenze je Bereich und Tag — die Budgets begrenzen Lehrer- und Embedding-Aufrufe.",
        budgetScope: "Bereich",
        budgetDay: "Tag",
        budgetSpent: "Verbraucht",
        budgetCap: "Obergrenze",
        budgetsEmpty: "Keine Budgets gemeldet.",
        eventsTitle: "Ereignisse",
        eventsSubtitle: "Was der Autopilot zuletzt getan oder gemeldet hat, Neuestes zuerst.",
        eventsEmpty: "Noch keine Ereignisse.",
        storageTitle: "Cloud-Speicher",
        storageSubtitle: "Verbindung zum Block Storage und die Initialisierung der Ordnerstruktur — wiederholbar ohne Nebenwirkungen.",
        connect: "Block Storage verbinden",
        backendLabel: "Cold-Store-Backend",
        backendBlockStorage: "Block Storage",
        backendLocal: "Lokaler Speicher",
        connectedLabel: "Verbindung",
        connectedYes: "verbunden",
        connectedNo: "nicht verbunden",
        accountLabel: "Konto",
        signinValidUntil: "Anmeldung gültig bis",
        oauthClientLabel: "OAuth-Client",
        clientConfigured: "konfiguriert",
        clientNotConfigured: "nicht konfiguriert",
        bootstrapRun: "Struktur initialisieren",
        bootstrapDone: "Initialisierung ausgeführt",
        bootstrapReportTitle: "Letzter Lauf",
        bootstrapNoRun: "In dieser Sitzung wurde noch kein Bootstrap ausgeführt.",
        bootstrapLine: "Angelegte Ordner: {folders} · Dateien im Cold Store: {files} · Wiederholung ohne Änderungen: {idempotent}",
        treeTitle: "Ordnerbaum",
        treeSubtitle: "Der Baum ist eine versionierte Vorgabe: Hier definieren Sie Ordner, der Autopilot darf nur ergänzen. Geschützte Engine-Ordner und nicht-leere Ordner lehnt die Engine mit Begründung ab. Gelöscht wird im Block Storage nur nach festen Regeln, etwa ältere Checkpoint-Kopien (die neuesten zwei bleiben); während eines Gesamt-Downloads warten Löschungen und Überschreibungen, bis er endet.",
        treeActiveVersion: "Aktive Version v{version}",
        treePath: "Pfad",
        treePurpose: "Zweck",
        treeCreatedBy: "Angelegt von",
        treeShards: "Shards",
        treeBytes: "Größe",
        treeActions: "Aktionen",
        treeRetire: "Stilllegen",
        treeRetired: "Ordner stillgelegt",
        treeAddFolder: "Ordner hinzufügen",
        treeFolderAdded: "Ordner angelegt",
        treeVersionsTitle: "Versionen",
        treeEmpty: "Noch keine Ordner definiert.",
        treePlanned: "Geplant — Baum-Spezifikation v{version}",
        treeFiles: "Dateien",
        treeSizesMeasured: "Größen gemessen {measured}; die Ordner, die der Katalog nicht führt, zuletzt im Block Storage durchgezählt {walked}. 1 GB = 10⁹ Bytes.",
        treeSizesNoWalk: "Größen gemessen {measured}; die Ordner, die der Katalog nicht führt, sind noch nicht durchgezählt. 1 GB = 10⁹ Bytes.",
        treeExpand: "{count} Unterordner zeigen",
        treeCollapse: "Unterordner ausblenden",
        treeShowMore: "{count} weitere Ordner zeigen",
        treeSourceCatalog: "Aus dem Katalog: gezählt sind Objekte, die wirklich im Block Storage liegen",
        treeSourceWalk: "Beim Rundgang durch den Block Storage gezählt",
        bsUsageTitle: "Speicherplatz des Block Storage",
        bsUsageSubtitle: "Belegter Platz, Limit und freier Platz des Block-Storage-Kontos und der Anteil des Data Lake daran; die Werte sind höchstens zehn Minuten alt. 1 GB = 10⁹ Bytes.",
        bsUsed: "Belegt",
        bsLimit: "Limit",
        bsFree: "Frei",
        bsNoLimit: "ohne festes Limit",
        bsTrash: "Im Papierkorb",
        bsLake: "Davon Data Lake",
        bsLakeLine: "{size} in {files} Dateien · {share} des belegten Platzes",
        bsMeasuredAt: "Gemessen",
        bsNotConnected: "Der Block Storage ist nicht verbunden; der Speicherplatz erscheint, sobald die Verbindung steht.",
        bsBarLake: "Data Lake",
        bsBarOther: "Übriges im Konto",
        bsDlTitle: "Gesamt-Download",
        bsDlSubtitle: "Lädt den ganzen Block Storage Datei für Datei in dieselbe Ordnerstruktur herunter, ohne Archiv. Solange er läuft, gilt der Schutzmodus: Löschungen und Überschreibungen der erfassten Dateien warten, bis er endet; neue Dateien werden weiter geschrieben und gehören nicht zu diesem Download. Ein laufendes Training wird nie aufgehalten.",
        bsDlButton: "Gesamten Block Storage herunterladen",
        bsDlFolderHint: "Sie wählen einmal einen Zielordner; die Unterordner entstehen dort. Vollständig vorhandene Dateien werden übersprungen, abgebrochene ab ihrer Länge fortgesetzt.",
        bsDlScriptHint: "Dieser Browser kann keine Ordner schreiben. Sie erhalten ein Download-Skript, das dieselbe Ordnerstruktur anlegt und jede Datei fortsetzbar lädt.",
        bsDlWindowsNames: "Zeichen, die Windows in Namen nicht erlaubt (etwa „>“), stehen im Zielordner als %-Code, zum Beispiel %3E.",
        bsDlActiveNote: "Ein Download läuft seit {time}. Die Schaltfläche oben setzt ihn in diesem Browser fort; vollständige Dateien werden übersprungen.",
        bsDlBuilding: "Die Dateiliste wird erstellt: bisher {files} Dateien, {size}.",
        bsDlManifest: "Die Dateiliste wird geladen: {done} von {total} Einträgen.",
        bsDlFolder: "Zielordner",
        bsDlFiles: "Dateien",
        bsDlData: "Daten",
        bsDlOf: "{done} von {total}",
        bsDlRate: "Rate",
        bsDlEta: "Restzeit",
        bsDlEtaUnknown: "wird ermittelt",
        bsDlCurrent: "Wird gerade geladen",
        bsDlSkipped: "{count} bereits vollständig vorhanden, übersprungen",
        bsDlFailed: "{count} Dateien fehlgeschlagen",
        bsDlPausedNote: "Pausiert. Angefangene Dateien werden beim Fortsetzen ab ihrer Länge weitergeladen; der Schutzmodus bleibt, solange diese Seite offen ist.",
        bsDlPause: "Pausieren",
        bsDlContinue: "Fortsetzen",
        bsDlRetryFailed: "Fehlgeschlagene erneut laden",
        bsDlFinish: "Abschließen",
        bsDlStop: "Stoppen",
        bsDlStateBuilding: "Dateiliste in Vorbereitung",
        bsDlStateRunning: "lädt",
        bsDlStatePaused: "pausiert",
        bsDlStateIncomplete: "unvollständig",
        bsDlStateScript: "Skript bereit",
        bsDlStateFinished: "abgeschlossen",
        bsDlStateStopped: "beendet",
        bsDlStateActive: "aktiv",
        bsDlFinished: "Alle {files} Dateien ({size}) liegen im Zielordner; der Download ist abgeschlossen.",
        bsDlFinishedNote: "Der Download ist abgeschlossen; die zurückgehaltenen Löschungen und Überschreibungen laufen jetzt.",
        bsDlStopped: "Der Download ist gestoppt; die zurückgehaltenen Löschungen und Überschreibungen laufen jetzt. Bereits geladene Dateien bleiben erhalten.",
        bsDlEnded: "Der Server hat den Download beendet, etwa nach dreißig Minuten ohne Lebenszeichen. Ein neuer Klick startet ihn neu; vollständige Dateien werden übersprungen.",
        bsDlSession: "Die Anmeldung ist abgelaufen. Bitte neu anmelden; danach setzt die Schaltfläche oben den Download fort.",
        bsDlDiskFull: "Im Zielordner ist kein Platz mehr. Platz schaffen und dann fortsetzen.",
        bsDlPickFailed: "Der Zielordner ließ sich nicht öffnen.",
        bsDlScriptPosix: "Skript für Linux und macOS",
        bsDlScriptWindows: "Skript für Windows",
        bsDlScriptRun: "Skript im Zielordner speichern und dort starten: unter Windows per Doppelklick auf die .cmd-Datei oder in der Eingabeaufforderung, unter Linux und macOS im Terminal mit „sh <Datei>“.",
        bsDlScriptKeyValid: "Der Schlüssel im Skript gilt bis {time}, nur für diesen Download und nur zum Lesen.",
        bsDlScriptHeartbeat: "Solange diese Seite offen ist, meldet sie dem Server, dass der Download noch läuft. Wenn das Skript fertig ist, auf „Abschließen“ klicken.",
        bsDlProtection: "Schutzmodus",
        bsDlProtectionState: "Zustand",
        bsDlProtectionOn: "aktiv seit {time}",
        bsDlProtectionOff: "nicht aktiv",
        bsDlScope: "Umfang des Downloads",
        bsDlScopeValue: "{files} Dateien, {size}",
        bsDlDeferredDeletes: "Zurückgehaltene Löschungen",
        bsDlDeferredOverwrites: "Zurückgehaltene Überschreibungen",
        bsDlAddedSince: "Seit dem Start neu hinzugekommen",
        bsDlLastActivity: "Letztes Lebenszeichen",
        acqTitle: "Datenquellen",
        acqSubtitle: "Kuratierte Quellen mit offener Lizenz: je Quelle Lizenz, Datenschutz-Bewertung, Sprache, Modalität, Byte-Ziel und gemessener Fortschritt. Deaktivierte Quellen nennen ihren Grund, statt still zu fehlen.",
        acqGdprNote: "DSGVO-Grundsatz: Trainingsdaten werden nur aus Quellen mit offener Lizenz und dokumentierter Datenschutz-Bewertung zugelassen; Posteingangs-Daten durchlaufen vor der Beispielbildung einen PII-Scrub (Zähler »PII-gescrubbt«).",
        acqSource: "Quelle",
        acqModality: "Modalität · Sprache",
        acqLicense: "Lizenz",
        acqProtection: "Datenschutz",
        acqProgress: "Fortschritt",
        acqDocs: "{count} Dateien/Objekte gelandet",
        acqTargetReached: "Ziel erreicht",
        acqExhausted: "Quelle erschöpft (Listing liefert nichts mehr)",
        acqEnabledPill: "aktiv",
        acqWaitingBuffer: "wartet: Zwischenspeicher voll, der Upload läuft nach",
        acqDisabledPill: "deaktiviert",
        acqEnable: "Aktivieren",
        acqDisable: "Deaktivieren",
        acqEnabledMsg: "Quelle aktiviert",
        acqDisabledMsg: "Quelle deaktiviert",
        acqTargetLabel: "Ziel (GB)",
        acqSetTarget: "Ziel speichern",
        acqTargetSaved: "Ziel gespeichert",
        acqEmpty: "Noch keine Quellen registriert.",
        balanceTitle: "Sprachbalance Deutsch/Englisch",
        balanceSubtitle: "Heruntergeladene Bytes je Modalität und Sprache — Deutsch darf bei den Seed-Quellen nicht hinter Englisch zurückfallen.",
        balanceEmpty: "Noch keine Messwerte.",
        modText: "Text",
        modAudio: "Audio",
        modImage: "Bild",
        modVideo: "Video",
        prepTitle: "Vorverarbeitung",
        prepSubtitle: "Gezählte Pipeline-Stufen vom registrierten Rohdokument bis zum Trainingsbeispiel — jede Zahl aus dem Katalog; Fehler und Nicht-Unterstütztes sind benannt.",
        prepRegistered: "registriert",
        prepScrubbed: "PII-gescrubbt",
        prepChunked: "zerlegt",
        prepEmbedded: "eingebettet",
        prepExtracted: "extrahiert",
        prepLinked: "verlinkt",
        prepSamples: "Beispiele",
        prepByLang: "Je Sprache",
        prepUnsupported: "Nicht unterstützt",
        prepAwaiting: "Wartet auf eine Stufe",
        prepFailures: "Fehler",
        inboxTitle: "Roh-Posteingang",
        assetWhat: "Inhalt",
        assetFromSource: "aus Quelle {source}",
        assetFromUpload: "manuell hochgeladen",
        mediaParquet: "Tabellendaten (Parquet)",
        treeShardsHint: "Shards sind die Parquet-Datenpakete des Katalogs: je Zeile ein Paket mit Herkunft, Sprache und Zweck — die Spalte „Zweck“ sagt, was in einem Ordner liegt.",
        mediaWords: {
          text: "Text",
          audio: "Audio",
          video: "Video",
          image: "Bild",
          application: "Datei",
        },
        inboxSubtitle: "Eigene Rohdaten in den Lake geben: hier hochladen oder direkt im Cloud-Ordner raw/inbox/ ablegen. Der Abgleich registriert jede Datei; »Jetzt verarbeiten« startet denselben Weg, den der Autopilot von allein geht.",
        uploadButton: "Datei hochladen",
        uploadHint: "Bis 512 MB je Datei. Hochgeladenes landet im Cold Store und wird beim Verarbeiten zerlegt, eingebettet und in den Wissensgraphen verknüpft.",
        uploadTooLarge: "Die Datei ist größer als 512 MB.",
        uploadDone: "Datei übernommen",
        processNow: "Jetzt verarbeiten",
        processStarted: "Verarbeitung gestartet",
        reconcileNow: "Cloud-Ordner abgleichen",
        reconcileDone: "Abgleich ausgeführt",
        unprocessedCount: "{count} unverarbeitet",
        inboxEmpty: "Der Posteingang ist leer.",
        assetName: "Datei",
        assetType: "Typ",
        assetSize: "Größe",
        assetState: "Zustand",
        assetLang: "Sprache",
        assetRegistered: "Registriert",
        assetStates: {
          raw_stored: "Rohdaten gesichert",
          awaiting_stt: "wartet auf Spracherkennung",
          awaiting_content_fetch: "wartet auf den Inhalt hinter der Adresse",
          awaiting_image_codec: "wartet auf den Bild-Codec",
          awaiting_audio_codec: "wartet auf den Audio-Codec",
          awaiting_video_codec: "wartet auf den Video-Codec",
          chunked: "zerlegt & im Graph",
          processed: "verarbeitet",
          registered: "registriert",
          queued: "wartet",
          processing: "in Verarbeitung",
          ingested: "übernommen",
          linked: "verknüpft",
          unsupported: "nicht unterstützt",
          failed: "fehlgeschlagen",
        },
        graphTitle: "Wissensgraph",
        graphSubtitle: "Der verknüpfte Rohbestand: Knoten und Kanten, gezählt aus dem Katalog — aus diesen Verbindungen entstehen die Trainingsbeispiele.",
        graphEmbedded: "Eingebettete Knoten",
        graphModel: "Embedding-Modell",
        graphClusters: "Cluster",
        graphAssetsLinked: "Verknüpfte Rohdaten",
        graphLastLink: "Letzte Verknüpfung",
        graphNodesTitle: "Knoten je Art",
        graphEdgesTitle: "Kanten je Art",
        graphEmpty: "Der Graph ist noch leer — er entsteht mit der ersten verarbeiteten Datei.",
        kindCol: "Art",
        countCol: "Anzahl",
        neighborsTitle: "Nachbarn eines Knotens",
        nodeIdLabel: "Knoten-ID",
        neighborsRun: "Nachbarn abrufen",
        neighborsEmpty: "Keine Nachbarn gefunden.",
        nodeCol: "Knoten",
        edgeKindCol: "Kante",
        weightCol: "Gewicht",
        gapTitle: "Abdeckungs- & Lückenmatrix",
        gapSubtitle: "Gemessener Ist-Bestand gegen die gesetzten Mixing-Ziele je Fähigkeit, Signatur und Stufe — eine SQL-Sicht über den Katalog, nie fest hinterlegt.",
        tier: "Stufe",
        gapHave: "Ist",
        gapTarget: "Ziel",
        gapWeight: "Gewicht",
        gapPriority: "Priorität",
        targetsTitle: "Mixing-Ziele definieren",
        targetsSubtitle: "Ziele tragen Urheber und Zeitpunkt; ohne Ziele zeigt die Matrix den ehrlichen Leerzustand.",
        addTargetRow: "Zeile hinzufügen",
        saveTargets: "Ziele speichern",
        targetsSaved: "Ziele gespeichert",
        statusCol: "Status",
        tdvTitle: "Versiegelter Datenstand",
        tdvSubtitle: "Der Datenstand ist unveränderlich und aus versiegelten Shards zusammengesetzt; ein neuer ersetzt den bisherigen.",
        createTdv: "TDV-Entwurf anlegen",
        tdvCreated: "TDV-Entwurf angelegt",
        tdvId: "TDV",
        tdvName: "Name",
        tdvMembers: "Mitglieder",
        tdvCreatedAt: "Angelegt",
        tdvSealedAt: "Versiegelt",
        tdvStatusDraft: "Entwurf",
        tdvStatusSealed: "versiegelt",
        sealTdv: "Versiegeln",
        tdvSealed: "TDV versiegelt",
        tdvEmpty: "Noch keine Train Data Version — sie entsteht aus versiegelten Shards.",
        compatTitle: "Kompatibilitätsprüfung Architektur und Daten",
        compatSubtitle: "Regeln R1–R12 über zwei maschinenlesbare Dokumente; das Dashboard zeigt den gespeicherten Bericht der Engine und berechnet kein eigenes Urteil.",
        compatAllGreen: "ALL-GREEN",
        compatNotGreen: "nicht ALL-GREEN",
        compatRun: "Prüfung ausführen",
        compatChecked: "Prüfung ausgeführt",
        compatSelectTdv: "Eine TDV in der Liste oben auswählen, um ihren Bericht zu sehen.",
        compatNoReport: "Für diese TDV liegt noch kein gespeicherter Kompatibilitätsbericht vor.",
        compatDraftNote: "Die Datenschnittstelle der Architektur ist ein Entwurf — Tokenizer- und Codec-Artefakte existieren noch nicht; die Prüfung wird mit dem ersten Tokenizer-Release und der ersten versiegelten TDV wirksam.",
        compatRule: "Regel",
        compatTitleCol: "Titel",
        compatKind: "Art",
        compatEvidence: "Verglichene Werte (Evidenz)",
        kindHard: "hart",
        kindWarn: "Hinweis",
        reportsTitle: "Gespeicherte Berichte",
        reportsEmpty: "Noch kein Kompatibilitätsbericht gespeichert.",
        phaseLabel: "Trainingsphase",
        phaseA: "Phase A — Bereitschaft & Evolution",
        phaseB: "Phase B — Training läuft, Architektur eingefroren",
        checklistTitle: "Trainingsbereitschaft (Phase-A-Checkliste)",
        checklistSubtitle: "Live berechnete Voraussetzungen; der Start bleibt gesperrt, bis jeder Punkt erfüllt ist, und jeder unerfüllte Punkt ist benannt.",
        checklistReady: "bereit",
        checklistUnmet: "{count} Punkte unerfüllt",
        checklistUnavailable: "Die Checkliste ist nicht erreichbar.",
        itemSatisfied: "erfüllt",
        itemUnsatisfied: "unerfüllt",
        startTraining: "Phase B starten",
        strandTitle: 'Trainings-Strang',
        strandSubtitle: 'Welcher Modell-Strang trainiert, sobald alle Voraussetzungen erfüllt sind; der nicht gewählte Strang bereitet weiter Daten vor, startet aber nie.',
        strandSelectedBadge: 'ausgewählt',
        strandExplain: 'Der Autopilot trainiert {selected}. {other} sammelt und bereitet weiter vor, startet aber nicht, solange es nicht ausgewählt ist.',
        strandSwitched: 'Auswahl gespeichert.',
        strandSwitchFailed: 'Umschalten fehlgeschlagen.',
        strandUnavailable: 'Dieses Backend liefert noch keine Stränge; nach dem nächsten Core-Rollout erscheint hier die Auswahl.',
        trainingStarted: "Phase B gestartet",
        startBlocked: "Start gesperrt — unerfüllt: {items}",
        selectedTdvLabel: "Gewählter Datenstand",
        computedAt: "Berechnet",
        runsTitle: "Trainingsläufe",
        runsSubtitle: "Nur reale Läufe aus dem Katalog; es gibt keinen simulierten Trainingsprozess.",
        runId: "Lauf",
        archVersion: "Architektur",
        presetCol: "Preset",
        seqLenCol: "Sequenzlänge",
        stepCol: "Schritt",
        lossCol: "Loss",
        runStarted: "Gestartet",
        runFinished: "Beendet",
        runsEmpty: "Noch kein Trainingslauf.",
        abortRun: "Abbrechen",
        confirmAbort: "Diesen Trainingslauf abbrechen?",
        runAborted: "Abbruch angefordert",
        benchLink: "Benchmark",
        benchTitle: "Benchmark-Berichte",
        benchSubtitle: "Die eingefrorene, versionierte Suite läuft nach jedem Training automatisch; jeder Bericht liegt im Lake und hier.",
        benchEmpty: "Noch kein Benchmark-Bericht.",
        suiteVersion: "Suite",
        benchOpen: "Öffnen",
        benchReportFor: "Benchmark-Bericht zu Lauf {run}",
        benchNoMarkdown: "Dieser Bericht trägt kein gerendertes Dokument; die Rohwerte stehen darunter.",
        exportsTitle: "Exporte",
        exportsSubtitle: "Downloads existieren ausschließlich für Exporte abgeschlossener realer Trainingsläufe.",
        exportId: "Export",
        exportSize: "Größe",
        exportSha: "SHA-256",
        download: "Herunterladen",
        exportsEmpty: "Noch kein Export — er entsteht erst aus einem abgeschlossenen realen Trainingslauf.",
        hfTitle: "HuggingFace-Veröffentlichungen",
        hfSubtitle: "Jeder Upload erfolgt privat; die Sichtbarkeit wird nach dem Upload über die API verifiziert. Ein nicht-privates Ergebnis ist ein Fehlerzustand, der den Kreislauf stoppt.",
        hfEmpty: "Noch keine Veröffentlichung.",
        hfRepo: "Repository",
        hfState: "Zustand",
        hfVisibility: "Sichtbarkeit",
        hfPrivateVerified: "privat — verifiziert",
        hfUnverified: "noch nicht verifiziert",
        hfVerifiedAt: "Verifiziert",
        connectTitle: "Block Storage verbinden",
        connectSubtitle: "Anmeldung im Anmeldefenster des Speicheranbieters; der Speicher verbindet sich mit dem Konto, das dort bestätigt.",
        webConnectStart: "Mit dem Speicheranbieter verbinden",
        webConnectWaiting: "Warte auf die Bestätigung im Anmeldefenster des Speicheranbieters …",
        webConnectHint: "Nach der Bestätigung verbindet sich der Speicher automatisch; dieser Dialog aktualisiert sich selbst.",
        publicIdentity: "Öffentliche App-Identität (rclone, geteilte Quota)",
        publicIdentityNote: "Das Anmeldefenster des Speicheranbieters zeigt „rclone“ als anfragende App — die öffentlich geteilte Identität; eine eigene Client-ID (GDRIVE_OAUTH_CLIENT_ID) ersetzt sie jederzeit.",
        manualHint: "Nach der Bestätigung zeigt der Browser eine nicht erreichbare localhost-Seite. Den Wert des Parameters code= aus der Adresszeile kopieren und hier einfügen (die ganze Adresse einfügen geht auch).",
        manualCodeLabel: "Autorisierungscode",
        manualSubmit: "Code einlösen",
        deviceInstead: "Stattdessen Gerätecode verwenden",
        licenseAcceptLink: "Lizenz bei Hugging Face bestätigen",
        deviceFlowTitle: "Block Storage verbinden (Device Flow)",
        deviceFlowSubtitle: "Die Engine startet den Geräte-Anmeldefluss des Anbieters; die Bestätigung erfolgt auf einem zweiten Gerät, abgefragt in begrenzten Intervallen.",
        deviceFlowStart: "Anmeldefluss starten",
        deviceFlowCode: "Gerätecode",
        deviceFlowOpenUrl: "Bestätigungsseite öffnen",
        deviceFlowWaiting: "Warten auf die Bestätigung — die Abfrage läuft im vom Anbieter vorgegebenen Intervall.",
        deviceFlowAuthorized: "Verbunden",
        deviceFlowExpired: "Der Gerätecode ist abgelaufen — den Anmeldefluss erneut starten.",
        readinessTitle: "Bereitschaft bis zum Training",
        readinessSubtitle: "Der gemessene Weg zum ersten Trainingslauf, Stufe für Stufe.",
        readinessCounter: "{green} von {total} erfüllt",
        readinessReady: "Trainingsbereit",
        unblockLabel: "Nächster Schritt",
        readinessUnavailable: "Die Bereitschaftsübersicht ist im Backend noch nicht ausgerollt. Sobald der Endpunkt live ist, erscheint hier der gemessene Stand.",
        stageStates: {
          ok: "erfüllt",
          active: "läuft",
          waiting: "wartet",
          blocked: "blockiert",
        },
      },
      gt: {
        loading: '…',
        unavailable: 'nicht verfügbar',
        equilibrium: 'Optimaler Betriebszustand erreicht: Alle Anfragen wurden beantwortet, sämtliche Aufgabenübergaben verarbeitet und Redundanzen vermieden.',
        standby: 'Standby',
        defTitle: 'Operative Team-Koordination & Leistungsmetriken',
        defSubtitle: 'Messung der operativen Kommunikations- und Übergabequalität aller KI-Rollen: Fokus auf verifizierte Ergebnisse statt unproduktiver Aktivität.',
        defPlayers: 'Beteiligte Rollen & Systeme',
        defPlayersText: 'Die zehn spezialisierten KI-Rollen mit ihren Webex-Bots sowie die menschlichen Entscheidungsträger, die Aufträge und Leitlinien vorgeben.',
        defStrategies: 'Kommunikations- & Arbeitsprinzipien',
        defStrategiesText: 'Direkte Beantwortung von Rückfragen, eindeutige und vollständige Aufgabenübergaben, Vermeidung von Redundanzen und konsequenter Abschluss offener Arbeitspakete.',
        defPayoff: 'Operativer Ergebnisbeitrag (Netto-Nutzen)',
        defPayoffText: 'Abgeschlossene Arbeitspakete, erfolgreich verarbeitete Übergaben und beantwortete Rückfragen — abzüglich Reibungsverlusten (Redundanzen, unbearbeitete Übergaben, unbeantwortete Anfragen).',
        defEquilibrium: 'Optimaler Betriebszustand (Koordinations-Gleichgewicht)',
        defEquilibriumText: 'Zielzustand der Zusammenarbeit: Jede Anfrage wird fristgerecht beantwortet, jede Aufgabenübergabe wird übernommen, keine Information wird doppelt gesendet und kein Arbeitspaket bleibt unbearbeitet.',
        playersTitle: 'Leistungsübersicht nach Rolle (Positionen)',
        playersSubtitle: 'Operative Kommunikations- und Lieferkennzahlen je Rolle: Fachbeiträge und Übergaben (letzte 7 Tage) sowie Meetings und erledigte Arbeitspakete (letzte 30 Tage).',
        playersHint: 'Netto-Nutzen = 3 × erledigte Arbeitspakete + verarbeitete Übergaben − Reibungsverluste (unbearbeitete Übergaben zählen doppelt). Ein negativer Wert zeigt Koordinationsbedarf an.',
        player: 'Rolle / Position',
        contributions: 'Beiträge',
        meetingTurns: 'Meeting',
        handovers: 'Übergaben',
        consumedShort: 'verarbeitet',
        refusedShort: 'abgelehnt',
        delivery: 'Zustellung',
        pausedTurns: 'Pausierte Turns',
        pausedTurnsHint: 'Turns, die im eigenen Postfach des Kollegen liegen, weil die Modelle sie gerade nicht bedienen konnten. Keine Übergaben.',
        closedOpen: 'abgeschlossen / offen',
        noise: 'Reibungsverlust',
        utility: 'Netto-Ergebnisbeitrag',
        meetingsLine: '{held} Meetings, {turns} Beiträge, {u} unbeantwortete Ansprachen (30 Tage).',
        interactionsTitle: 'Aufgabenübergaben zwischen Rollen (Handover-Matrix)',
        interactionsSubtitle: 'Gerichtete Aufgabenübergaben zwischen den Postfächern (letzte 7 Tage): Anzahl, Zustelldauer sowie verarbeitete und abgelehnte Übergaben.',
        interactionsHint: 'Eine Aufgabenübergabe gilt erst nach Verarbeitung durch den Empfänger als abgeschlossen; abgelehnte oder unbearbeitete Übergaben werden als Prozessabweichung ausgewiesen.',
        interactionsEmpty: 'Keine Übergaben im Fenster.',
        from: 'Von',
        to: 'An',
        messages: 'Nachrichten',
        consumed: 'verarbeitet',
        refused: 'abgelehnt',
        deviationsTitle: 'Prozessabweichungen & offene Engpässe',
        deviationsSubtitle: 'Aktuelle Koordinationsmängel: unbeantwortete Rückfragen, unbearbeitete Aufgabenübergaben, redundante Beiträge oder blockierte Arbeitspakete.',
        dev_unanswered_question: 'Unbeantwortete Rückfrage (Zeitüberschreitung)',
        dev_dead_air: 'Aufgabenübergabe ohne Rückmeldung',
        dev_repetition: 'Wiederholung im Meeting',
        dev_meeting_unanswered: 'Direkte Anfrage ohne Rückmeldung',
        dev_work_blocked: 'Arbeit blockiert',
        dev_handover_hop_budget_reached: 'Übergabe-Hop-Budget überschritten',
        dev_commitment_unkept: 'Sprint-Zusage nicht eingehalten',
        devWithheld: 'zurückgehalten',
        devRepetition: 'Wiederholung',
        devDeadAir: 'unbearbeitete Übergabe',
        devMeetingUnanswered: 'ohne Antwort',
        effectiveThresholdCol: 'Eff. Schwelle',
        excessHopsLabel: 'Hop-Überschreitungen',
        timeTitle: 'Durchlaufzeiten & Produktivitätsvergleich (KI vs. manuelle Bearbeitung)',
        timeSubtitle: 'Gemessene KI-Bearbeitungsdauer abgeschlossener Entwicklungsaufgaben im Vergleich zum geschätzten manuellen Arbeitsaufwand.',
        timeHint: 'Kalkulatorische Referenzwerte zur Aufwandsabschätzung; durch die Geschäftsführung konfigurierbar.',
        avgCycle: 'Ø KI-Zyklus',
        fromTasks: 'aus {n} Aufgaben',
        speedup: 'Beschleunigung',
        speedupHint: 'Referenzwert: {h} Personenstunden pro Arbeitspaket',
        humanDelivered: 'Äquivalente Personentage geliefert',
        humanDays: 'Personentage',
        forecast: 'Aufwandsprognose offener Arbeitspakete: {d} Personentage',
        sizes: 'Größen',
        sizeSmall: 'klein',
        sizeMedium: 'mittel',
        sizeLarge: 'groß',
        scrumTitle: 'Scrum',
        scrumSubtitle: 'Sprint, Story Points und Velocity, aus den eigenen Daten der Firma',
        sprintLabel: 'Sprint {n}',
        ends: 'endet',
        committedPts: 'Zugesagte Punkte',
        deliveredPts: 'Gelieferte Punkte',
        remainingPts: 'Verbleibende Punkte',
        burndownTitle: 'Burndown (verbleibende Punkte je Tag)',
        velocityTitle: 'Velocity der abgeschlossenen Sprints',
        predictability: 'Planbarkeit',
        forecastLine: 'Rollierende Velocity {v} Punkte je Sprint · Backlog {b} Punkte ≈ {s} Sprints',
        noSprint: 'Kein Sprint läuft; das nächste Planning eröffnet einen.',
        noItems: 'Noch nichts zugesagt; der Sprint nimmt, was die Menschen bringen.',
        colItem: 'Arbeit',
        colOwner: 'Verantwortlich',
        colPoints: 'Punkte',
        colState: 'Stand',
        itemDone: 'geliefert',
        itemOpen: 'offen',
        unestimated: 'ungeschätzt',
        addedBy: 'hinzugefügt von {who}',
        setGoal: 'Sprintziel',
        sprintDaysLabel: 'Sprintlänge (Tage)',
        save: 'Speichern',
        endSprint: 'Sprint jetzt beenden',
        confirmEndSprint: 'Sprint jetzt beenden? Review, Retrospektive und das nächste Planning laufen sofort.',
        planNow: 'Erstes Planning jetzt halten',
        confirmPlanNow: 'Das Sprint-Planning jetzt halten? Es eröffnet den ersten Sprint in pAIoneer-scrum.',
        sprintPointsCol: 'Sprint-Punkte',
        ceremonySpaceLabel: 'Zeremonie-Raum',
        scrumOfScrums: 'Scrum of Scrums halten',
        confirmScrumOfScrums: 'Scrum of Scrums jetzt über alle Business Units halten?',
        lastScrumOfScrumsTitle: 'Letztes Scrum of Scrums',
        escalatedImpedimentsTitle: 'Eskalierte Impediments',
        unitBreakdownTitle: 'Sprint-Aufschlüsselung je Business Unit',
        colUnit: 'Business Unit',
        colWip: 'Offene Arbeit',
        colImpediments: 'Impediments',
      },
      nav: {
        groups: {
          gametheory: 'Team-Koordination & Scrum',
          demos: 'Live-Vorschauen',
          sovereign: 'Sovereign LLM',
          today: 'Tagesübersicht & Leitstand',
          organisation: 'Organisation',
          work: 'Arbeit',
          communication: 'Kommunikation',
          memory: 'Gedächtnis',
          platform: 'Plattform',
          products: 'Produkte',
          identity: 'Identität',
        },
        pages: {
          gametheory: 'Team-Koordination & Scrum',
          demos: 'Live-Vorschauen',
          llm: 'LLM-Architektur — Paper',
          training: 'Data Lake & KI-Modelltraining',
          today: 'Tagesübersicht & Leitstand',
          work: 'Arbeitspakete und Projekte',
          coding: 'Programmieraufgaben',
          gitlab: 'GitLab und Image-Builds',
          agents: 'Agenten und Entwürfe',
          research: 'Recherchen',
          webex: 'Webex-Räume',
          mailboxes: 'Postfächer',
          conversations: 'Anrufe und Gespräche',
          meetings: 'Besprechungen',
          engines: 'KI-Engines und Grafikkarte',
          usage: 'Verbrauch und Budgets',
          workloads: 'Container-Dienste',
          orchestrator: 'Veridion MCP-Orchestrator',
        },
        sections: {
          demos: {
            previews: 'Live-Vorschauen',
          },
          llm: {
            paper: 'Paper',
            monitoring: 'Überwachung',
          },
          training: {
            autopilot: "Autopilot",
            storage: "Cloud-Speicher & Ordnerbaum",
            acquisition: "Datenbeschaffung & Vorverarbeitung",
            data: "Daten & Wissensgraph",
            training: "Training & Veröffentlichung",
          },
          platform: {
            nodes: 'Cluster-Knoten',
            events: 'Ereignisse',
          },
          smtm: {
            runtime: 'Laufzeitsteuerung',
            prediction: 'Prognosesteuerung',
            status: 'Datenstatus',
            reporting: 'Signale',
            training: 'Modelle',
            console: 'Trainingskonsole',
          },
          agentic: {
            overview: 'Übersicht',
            tools: 'Werkzeuge',
            mcp: 'MCP-Server',
            activity: 'Aktivität',
          },
          'company-memory': {
            content: 'Inhalt',
            search: 'Suche und Lagebilder',
            facts: 'Fakten',
            entity: 'Entitäten',
            remember: 'Erfassen',
            audit: 'Prüfprotokoll',
            console: 'Abfragekonsole',
            stores: 'Speicher',
            graph: 'Wissensgraph',
            day: 'Tag',
            bubbles: 'Abteilungs-Wissensdomänen & Forschung',
          },
          organisation: {
            chart: 'Organigramm',
            colleagues: 'KI-Kollegen und Postfächer',
            voices: 'Stimmen',
            people: 'Personen und Räume',
            approvals: 'Freigaben und Zeitpläne',
            edit: 'Organisation bearbeiten',
          },
          work: {
            items: 'Arbeitspakete',
            projects: 'Projekte in Entwicklung',
          },
          gitlab: {
            gitlab: 'GitLab',
            builds: 'Image-Builds',
          },
          agents: {
            agents: 'Agenten',
            designs: 'Agentenentwürfe',
            definitions: 'Definitionen',
          },
          usage: {
            identities: 'Je Identität',
            budgets: 'Token-Budgets',
            company: 'Firmeninstanz',
            smtm: 'Veridion SMTM',
          },
          orchestrator: {
            runtime: 'Laufzeit',
            mcp: 'MCP-Server',
            tools: 'Werkzeuge',
            activity: 'Aktivität',
          },
        },
        attentionTitle: 'Handlungsbedarf',
        attentionSubtitle: 'Zustände aus allen Bereichen, die ein Eingreifen brauchen. Ein Klick öffnet den Abschnitt.',
        attentionNone: 'Kein Handlungsbedarf.',
        stateTitle: 'Betriebszustand',
        none: 'keine',
        readyOf: '{ready} von {total} bereit',
        connectedOf: '{connected} von {total} verbunden',
        registeredOf: '{registered} von {total} registriert',
        showMore: 'Mehr anzeigen',
        shownOf: '{shown} von {total}',
        expand: 'Aufklappen',
        collapse: 'Zuklappen',
        service: 'Dienst',
        serviceLinks: 'Links',
        controlsTitle: 'Steuerung von Veridion Core',
        confirmRemove: '{what} entfernen?',
        companyIdentitiesTitle: 'Gateway-Identitäten der Firmeninstanz',
        companyIdentitiesSubtitle: 'Die Token des Orchestrators und von Veridion Core im laufenden Zeitfenster des Gateways, jede Identität mit ihrem Budget.',
        conversationsTitle: 'Gespräche aus dem Dashboard',
        conversationsSubtitle: 'Je KI-Kollege die schriftlichen Gespräche aus dem Dashboard; Schreiben und Anrufen öffnen einen Dialog über der Seite.',
        conversationCount: 'Nachrichten',
        conversationLastWritten: 'Zuletzt geschrieben',
        conversationLastAnswered: 'Zuletzt beantwortet',
        exchangesTitle: 'Nachrichten und Antworten',
        exchangesSubtitle: 'Jede Nachricht aus dem Dashboard mit der Antwort des KI-Kollegen, neueste zuerst.',
        conversationMessage: 'Nachricht',
        conversationAnswer: 'Antwort',
        today: {
          wordTitle: 'Aktuelle Führungsdirektive',
          wordNone: 'Aktuell ist keine offene Führungsdirektive hinterlegt.',
          sinceTitle: 'Ereignisse seit dem letzten Aufruf',
          sinceState: 'seit {time}',
          workTitle: 'Aktive Aufgaben & Zuständigkeiten',
          workNone: 'Kein Arbeitspaket ist in Arbeit.',
          nextMeeting: 'Nächstes Meeting',
          lastMeeting: 'Letztes Meeting',
        },
        work: {
          title: 'Arbeitspakete',
          subtitle: 'Jedes offene Arbeitspaket aus dem Firmengedächtnis mit Verantwortlichem, Zustand, Priorität, Termin und den Ergebnissen seiner Szenarien; der Titel öffnet es im Graphen.',
          item: 'Arbeitspaket',
          kind: 'Art',
          owner: 'Verantwortlich',
          status: 'Zustand',
          priority: 'Priorität',
          due: 'Termin',
          scenarios: 'Szenarien',
          updated: 'Aktualisiert',
          none: 'Kein offenes Arbeitspaket.',
          all: 'Alle Verantwortlichen',
        },
        meetings: {
          subtitle: 'Die Meetings der KI-Kollegen, wie Veridion Core sie festhält: Zeitfenster, Zusammenfassung und die Zusagen, die zu Arbeit wurden.',
          slot: 'Zeitfenster',
          kind: 'Art',
          started: 'Begonnen',
          ended: 'Beendet',
          summary: 'Zusammenfassung',
          commitments: 'Zusagen',
          hold: 'Meeting jetzt abhalten',
          held: 'Das Meeting wurde einberufen.',
          notHeld: 'Ein Meeting läuft oder wurde in der letzten halben Stunde abgehalten.',
          holdFailed: 'Das Meeting konnte nicht einberufen werden',
          none: 'Noch kein Meeting festgehalten.',
        },
        research: {
          title: 'Recherchen',
          subtitle: 'Die Recherchen der KI-Kollegen aus der Zeitleiste der Firma, neueste zuerst.',
        },
        attention: {
          toneError: 'Störung',
          toneWarning: 'Hinweis',
          state: {
            platform: '{ready} von {workloads} Workloads bereit, {nodes} von {total} Knoten bereit, {restarts} Neustarts.',
            gateway: '{state}; {models} Modelle geroutet, {backends} von {total} Serving-Backends bereit.',
            engine: '{engine}: {running} laufend, {waiting} wartend',
            usage: '{tokens} Tokens über {identities} Identitäten im Zeitfenster {window}.',
            smtm: 'Prognosetor {gate}, Neuaufbau {rebuild}; {online} von {models} Modellen online, {failed} fehlgeschlagen.',
            smtmSignals: '{open} offene Signale, {resolved} aufgelöst, {failed} Zustellungen fehlgeschlagen.',
            smtmVeridion: '{connected} von {servers} MCP-Servern verbunden.',
            company: 'Orchestrator {status}; {ready} von {workloads} Workloads bereit; Veridion Core {core}; {agents} Agenten laufend, {waiting} wartend.',
            companyWebex: '{registered} von {bots} Bot-Webhooks registriert.',
            approvals: '{approvals} offene Freigaben; {tasks} Coding-Aufgaben warten auf eine Person oder ein Review.',
            sessions: '{users} angemeldete Benutzer, {sessions} Sitzungen, {mfa} verifiziert, {total} Konten.',
            mail: 'SMTP {state}.',
          },
          platformUnreadable: 'Der Zustand der Plattform ist nicht lesbar.',
          nodeNotReady: 'Knoten {name} ist nicht bereit.',
          nodePressure: 'Knoten {name} meldet Engpass: {pressure}.',
          workloadDown: '{name} ({namespace}): {ready} von {desired} bereit.',
          gatewayNotProgrammed: 'Das AI Gateway ist nicht programmiert.',
          smtmGateClosed: 'Das Prognosetor ist geschlossen.',
          smtmRebuild: 'Ein Neuaufbau ist markiert.',
          smtmHint: 'Datenstatus: {hint}.',
          smtmDeliveryFailed: '{count} Signalzustellungen sind fehlgeschlagen.',
          smtmModelsFailed: '{count} Modelle melden einen Fehler.',
          mcpUnreachable: 'MCP-Server {server} von {instance} ist nicht erreichbar.',
          partUnavailable: 'Veridion pAIoneer Labs GmbH: {part} antwortet nicht.',
          parts: {
            orchestrator: 'Orchestrator',
            webex: 'Webex-Bridge',
            knowledge: 'Wissensbasis',
            core: 'Veridion Core',
            mcp: 'MCP-Server',
            usage: 'Verbrauchsbuch',
            gateway: 'Gateway-Verbrauch',
          },
          emergencyStop: 'Der Notstopp von Veridion Core ist aktiv.',
          coreMisconfigured: 'Veridion Core vermisst Einstellungen: {missing}.',
          agentsWaiting: '{count} Agenten warten auf eine Antwort.',
          hostedNotRunning: '{agent} läuft nicht.',
          webhookMissing: 'Der Webhook von {bot} ist nicht registriert.',
          readerNotAuthorised: 'Das Lesen der Firmenräume ist nicht freigegeben.',
          approvalOpen: 'Offene Freigabe ({position}): {question}',
          taskWaiting: 'Coding-Aufgabe wartet auf eine Person: {title}',
          taskReview: 'Merge-Request zur Prüfung bereit: {title}',
        },
      },
      ops: {
        showDetails: 'Details',
        hideDetails: 'Schließen',
        mcpVersion: 'Version',
        mcpUrl: 'Adresse',
        mcpProtocol: 'Transport und Protokoll',
        mcpLastRefresh: 'Zuletzt abgefragt',
        mcpError: 'Fehler',
        noTools: 'Keine Werkzeuge gemeldet.',
        toolServer: 'Herkunft',
        toolAccess: 'Zugriff',
        toolBuiltIn: 'Veridion',
        accessReadOnly: 'lesend',
        accessWrites: 'schreibend',
        accessDestructive: 'verändernd',
        accessUndeclared: 'nicht angegeben',
        usageTitle: 'Verbrauch',
        smtmUsageSubtitle: 'Modellaufrufe, Tokens und vom Anbieter gemeldete Kosten der letzten 30 Tage.',
        usageByPerson: 'Je Person',
        usageByModel: 'Je Modell',
        usageByDay: 'Je Tag',
        model: 'Modell',
        day: 'Tag',
        promptTokens: 'Eingabe-Tokens',
        completionTokens: 'Ausgabe-Tokens',
        noUsage: 'Kein Verbrauch gebucht.',
        runtimeTitle: 'Laufzeit',
        runtimeSubtitle: 'Wie der Orchestrator dieser Instanz Modelle anspricht und Werkzeuge einbindet.',
        executionMode: 'Ausführung',
        providerProtocol: 'Protokoll zum Modell',
        contextWindow: 'Kontextfenster',
        requestTimeout: 'Zeitlimit je Anfrage',
        diagnostics: 'Diagnose',
        diagnosticsOn: 'an',
        diagnosticsOff: 'aus (Leistungsmodus)',
        externalServers: 'Verbundene MCP-Server',
        mcpEndpoint: 'MCP-Endpunkt',
        workloadsTitle: 'Workloads',
        workloadsSubtitle: 'Die Workloads im Namespace paioneer-veridion, wie Kubernetes sie meldet.',
        botsTitle: 'Bots',
        botsSubtitle: 'Die Bots der Organisation, jeder mit seinem Webhook, und die Dienste der Bridge.',
        botAddress: 'Adresse',
        cardWebhook: 'Karten-Webhook',
        webhookState: 'Zustand',
        noBots: 'Die Bridge meldet keine Bots.',
        bridgeServices: {
          knowledgeBase: 'Wissensbasis',
          webResearch: 'Internetrecherche',
          osint: 'OSINT',
          anonymizer: 'Anonymisierung',
        },
        connected: 'angebunden',
        notConnected: 'nicht angebunden',
        activeRooms: 'Aktive Räume',
        allowedRooms: 'Freigegebene Räume',
        surface: 'Oberfläche',
        missingSettings: 'Fehlende Einstellungen',
        none: 'keine',
        instanceToolsTitle: 'Werkzeuge des Orchestrators',
        instanceToolsSubtitle: 'Die Werkzeuge, die der Orchestrator der Firmeninstanz registriert hat.',
        openMailbox: 'Postfach',
        positionMailboxHint: 'KI-Kollegen arbeiten Übergaben anderer KI-Kollegen ab; Aufträge an einen KI-Kollegen gehen über seinen Webex-Raum.',
        mailboxesTitle: 'Postfächer',
        mailboxesSubtitle: 'Je Agent, was in seinem Postfach wartet, zugestellt und gelesen ist. Ein Klick auf eine Zeile filtert die Nachrichten.',
        readAt: 'Gelesen',
        refresh: 'Aktualisieren',
        mailbox: 'Postfach',
        mailboxKind: 'Art',
        mailboxKinds: {
          position: 'KI-Kollege',
          hosted: 'Gehosteter Agent',
          graph: 'Agent',
        },
        lastMessage: 'Letzte Nachricht',
        noMailboxes: 'Keine Postfächer lesbar.',
        messagesTitle: 'Nachrichten',
        messagesSubtitle: 'Nachrichten, Befehle und Übergaben, neueste zuerst. Ein Klick zeigt den ganzen Text.',
        allMailboxes: 'Alle Postfächer',
        allStates: 'Alle Zustände',
        time: 'Zeit',
        from: 'Von',
        to: 'An',
        messageKind: 'Art',
        content: 'Inhalt',
        reply: 'Antwort',
        noMessages: 'Keine Nachrichten.',
        messageKinds: {
          message: 'Nachricht',
          handover: 'Übergabe',
          command: 'Befehl',
          resume: 'Fortsetzung',
          subagent_result: 'Ergebnis eines Sub-Agenten',
          review: 'Prüfung',
        },
        buildsTitle: 'Builds',
        buildsSubtitle: 'Die Images, die Veridion Core für Agenten gebaut hat, neueste zuerst.',
        image: 'Image',
        started: 'Gestartet',
        finished: 'Fertig',
        noBuilds: 'Keine Builds.',
        coreToolsTitle: 'Werkzeuge der Agenten',
        coreToolsSubtitle: 'Die Werkzeuge des Orchestrators, die Veridion Core seinen Agenten anbietet.',
        description: 'Beschreibung',
        coreDailyTitle: 'Verbrauch je Tag und Modell',
        coreDailySubtitle: 'Modellaufrufe von Veridion Core der letzten 30 Tage, je Agent und Modell.',
        coreActivityTitle: 'Aktivität von Veridion Core',
        coreActivitySubtitle: 'Ereignisse der Agenten, KI-Kollegen und Übergaben in Veridion Core, neueste zuerst.',
        event: 'Ereignis',
        tool: 'Werkzeug',
        detail: 'Detail',
      },
      tabCompanyMemory: 'Firmengedächtnis',
      llmPaper: {
        subtitle: 'Die generierte wissenschaftliche Beschreibung der souveränen Modellarchitektur — gerendert aus dem Paper-Dokument, das Veridion Core zur aktiven Spezifikation führt.',
        summaryTitle: 'Was diese Seite zeigt',
        summaryBody: 'Veridion Core führt zur aktiven Modellarchitektur ein generiertes wissenschaftliches Dokument: Titel, Abstract, nummerierte Abschnitte, Architekturdiagramm, Tabellen und Literaturverzeichnis kommen unverändert aus dem Backend; Entwurfswerte sind als solche gekennzeichnet, und die Seite erfindet nichts dazu.',
        refresh: 'Aktualisieren',
        exportPdf: 'Als PDF exportieren',
        strandTraining: 'trainiert',
        strandSelected: 'ausgewählt',
        lcTitle: "Implementierung & Lebenslauf",
        lcSelectedTrains: "trainiert als Nächstes",
        lcCollectsOnly: "sammelt & bereitet vor — startet nicht",
        lcSpec: "Spezifikation",
        lcFrozen: "eingefroren",
        lcArtifacts: "Artefakte (Tokenizer/Codec)",
        lcReleased: "veröffentlicht",
        lcNotReleased: "noch nicht gebaut",
        lcCodecOpen: "Codec offen",
        lcData: "Daten-Schwellen",
        lcThresholdsMet: "erfüllt",
        lcAreasReached: "Datenplan: {met} von {total} Bereichen erreicht",
        lcNoLake: "Data Lake nicht erreichbar",
        lcStage_trainer_image: "Trainer-Image",
        lcStage_sealed_tdv: "TDV versiegelt",
        lcStage_compat_all_green: "Kompatibilität ALL-GREEN",
        lcStage_vram_budget: "VRAM-Budget",
        lcTraining: "Training",
        lcAuto: "startet automatisch bei erfüllten Schwellen",
        lcBench: "Benchmark",
        lcBenchRows: "Messungen",
        lcNoneYet: "noch keine",
        lcRelease: "Export · Hugging Face (privat) · Registry",
        lcReleaseRows: "Artefakte",
        lcReleaseNote: "nach dem Training: privat-verifizierter Upload + Registry-Eintrag",
        lcPipeline: "Trainings-Pipeline",
        lcDone: "erledigt",
        lcActive: "läuft",
        lcWaiting: "wartet",
        lcBlocked: "blockiert",
        lcCapability: "Fähigkeit",
        lcSamples: "Beispiele",
        lcByLanguage: "nach Sprache",
        lcForeign: 'anderer Strang',
        lcCorpus: 'Korpus-Token',
        lcCorpusNone: 'noch nicht tokenisiert',
        loading: 'Lädt …',
        unavailable: 'Das Paper-Dokument ist nicht erreichbar.',
        noPaper: 'Diese Version von Veridion Core liefert noch kein Paper-Dokument. Die Seite zeigt deshalb nichts Erfundenes.',
        abstract: 'Abstract',
        references: 'Literaturverzeichnis',
        appendix: 'Anhang',
        figure: 'Abbildung',
        lastUpdated: 'Zuletzt aktualisiert',
        empty: 'Keine Einträge.',
      },
      llmMonitor: {
        summary: "Betriebsüberwachung des Modells: Status, Datenstand, GPU, Kernel und Durchsatz, Evaluationen und Ereignisse — gemessen aus Veridion Core und dem Data Lake, nichts erfunden.",
        archTitle: 'Architekturstatus',
        archSubtitle: "Die aktive Architektur mit dem Stand der Daten-Schnittstelle und dem Einfrier-Zustand.",
        version: 'Version',
        codename: 'Codename',
        statusLabel: 'Status',
        interfaceStatus: 'Daten-Schnittstelle',
        specSha: 'Spezifikations-Hash (SHA-256, gekürzt)',
        promotedAt: 'Befördert',
        frozenLabel: 'Eingefroren',
        frozenYes: 'Ja',
        frozenNo: 'Nein',
        stateWord_active: "aktiv",
        stateWord_draft: "Entwurf",
        stateWord_released: "freigegeben",
        stateWord_candidate: "Kandidat",
        stateWord_retired: "beendet",
        gpuModel: "Grafikkarte",
        gpuTotal: "Gesamter Grafikspeicher",
        gpuWindow: "Trainingsfenster (gemessen)",
        gpuMeasuredAt: "Gemessen am",
        gpuSource: "Messquelle",
        gpuServing: "Serving",
        gpuInferenceTarget: "Ziel für Inferenz auf einer Karte",
        vramTitle: 'GPU & VRAM-Budget',
        vramSubtitle: 'Das gemessene VRAM-Budget der Grafikkarte, wie Veridion Core es führt.',
        vramNone: 'Kein VRAM-Budget im Datensatz.',
        gateTitle: 'Promotion-Gate',
        gateSubtitle: 'Die Richtlinie, nach der eine Kandidaten-Architektur die aktive ablöst, mit den geforderten Metriken und ihren Gewichten.',
        metric: 'Metrik',
        weight: 'Gewicht',
        gateNone: 'Keine geforderten Metriken hinterlegt.',
        candidatesTitle: 'Kandidaten',
        candidatesNone: 'Keine Kandidaten-Architekturen vorhanden.',
        evidenceTitle: 'Evaluationen',
        evidenceNone: 'Noch keine gemessenen Evaluationen.',
        benchmark: 'Benchmark',
        suite: 'Suite',
        score: 'Wert',
        evaluator: 'Prüfer',
        date: 'Datum',
        changelogTitle: 'Änderungsverlauf',
        changelogNone: 'Noch keine Architektur-Versionen im Verlauf.',
        summaryLabel: 'Zusammenfassung',
        createdAt: 'Angelegt',
        supersededAt: 'Abgelöst',
        eventsTitle: 'Ereignisse',
        eventsNone: 'Keine Ereignisse aufgezeichnet.',
        implTitle: 'Implementierungsstand des Strangs',
        implSubtitle: "Gemessene Fakten: Artefakte der Daten-Schnittstelle, Auswahl, Token-Korpus und Vektorindex; der Datenplan je Bereich steht im Lagebild.",
        implSelected: 'Trainings-Strang',
        implSelectedYes: 'ausgewählt — trainiert als Nächstes',
        implSelectedNo: 'bereitet nur vor (startet nicht)',
        implTokenizer: 'Tokenizer-Artefakt',
        implCodec: 'Codec-Artefakt',
        implNotReleased: 'noch nicht veröffentlicht',
        implCapability: 'Fähigkeit',
        implSamples: 'Beispiele (gemessen/Ziel)',
        implNoDatalake: 'Der Beispiel-Fortschritt ist gerade nicht lesbar (Data-Lake-Schnittstelle nicht erreichbar).',
        implSwitchHint: 'Die Auswahl des Trainings-Strangs wird auf der Trainingsseite umgeschaltet.',
        implSituationLink: "Wo die Daten stehen und was bis zum Training fehlt: Lagebild auf der Trainingsseite",
        kernelTitle: 'Kernel-Beschleunigung & Durchsatz',
        kernelSubtitle: 'Was die Kernel-Sonde auf der Karte gemessen hat: jeder Kernel gegen seine Referenz, der Attention-Backend, der Durchsatz der gewählten Spezifikation — und der Zeitplan aus gemessenen Token und gemessenem Durchsatz.',
        kernelNone: 'Noch keine Kernel-Sonde auf dieser Karte gelaufen; es wird nichts angenommen.',
        kernelName: 'Kernel',
        kernelVerified: 'Bewiesen',
        kernelYes: 'ja',
        kernelNo: 'nein',
        kernelSpeedup: 'Beschleunigung',
        kernelMaxErr: 'Max. Fehler',
        kernelError: 'Befund',
        kernelAttention: 'Attention-Backend',
        kernelDocMask: 'Dokumentgrenzen-Maskierung',
        kernelThroughput: 'Gemessener Durchsatz (Token/s)',
        kernelMicroBatch: 'Mikro-Batch',
        kernelMeasuredAt: 'Gemessen am',
        kernelImage: 'Trainer-Image (Digest)',
        kernelRunPath: 'Kernel-Pfad des letzten Laufs',
        kernelRunNone: 'Noch kein Trainingslauf mit Kernel-Fakten.',
        kernelPlanTitle: 'Zeitplan (Arithmetik über Messwerte)',
        kernelPlanTokens: 'Token-Masse',
        kernelPlanTokensSource: 'Quelle der Token-Masse',
        kernelPlanDays: 'Projizierte Tage für einen Durchlauf',
        kernelPlanNone: 'Noch nicht gemessen — ohne gemessenen Durchsatz oder gemessene Token-Masse wird kein Zeitplan erfunden.',
        kernelSourceTdv: 'versiegelte Trainingsdaten-Version',
        kernelSourceCorpus: 'bisheriger Korpus (nicht versiegelt)',
        kernelSourcePlan: "Budget laut Paper",
        implForeign: 'gehört zu einem anderen Strang',
        implIndex: 'Vektorindex (Graph-Verknüpfung)',
        implIndexNone: 'kein Index gemeldet',
        implIndexDown: 'konfiguriert, antwortet nicht',
        implIndexPoints: 'Punkte',
        implIndexBackfillDone: 'Befüllung abgeschlossen',
        implIndexBackfillOpen: 'Befüllung läuft',
        implIndexLink: 'Index und Deduplikation im Lake-Monitor',
        implCorpus: 'Token-Korpus (Rohtext)',
      },
      software: {
        arch: {
          execTitle: "Souveräne Modellarchitektur",
          execSubtitle: "Die eine aktive Architektur-Spezifikation aus Veridion Core: Jede Kennzahl ist entweder durch ein referenziertes Messartefakt belegt oder vom Backend als Entwurfsziel (nicht gemessen) gekennzeichnet.",
          openDatalake: "Data Lake & KI-Modelltraining öffnen",
          unavailableArch: "Die Architekturdaten sind nicht erreichbar.",
          frozen: "Eingefroren — ein Trainingslauf ist aktiv",
          notFrozen: "Freigegeben (Phase A)",
          version: "Version",
          codename: "Codename",
          statusLabel: "Status",
          createdAt: "Angelegt",
          promotedAt: "Befördert",
          specSha: "Spezifikations-Hash (SHA-256)",
          contextWindow: "Kontextfenster (Entwurf, Tokens)",
          dataInterface: "Daten-Schnittstelle",
          diStatus: {
            draft: "Entwurf",
            complete: "vollständig",
            missing: "fehlt",
          },
          paramsTitle: "Parameter-Bilanz",
          trainingVramTitle: "Trainings-VRAM (deklariert, GB)",
          inferenceTitle: "Inferenz-VRAM (deklariert, GB)",
          declaredTotal: "Deklarierte Summe",
          budgetTitle: "GPU-VRAM-Budget (gemessen)",
          budgetGpu: "Grafikkarte",
          budgetTotal: "Gesamt-VRAM (MiB)",
          budgetFreed: "Freies Trainingsbudget (GB)",
          budgetInferenceTarget: "Einzel-GPU-Inferenzziel (GB)",
          diagramTitle: "Generiertes Architekturdiagramm",
          diagramSubtitle: "Deterministisch aus der gespeicherten Spezifikation erzeugt; neben den Daten existiert kein handgeschriebenes Diagramm.",
          noDiagram: "Die Antwort enthält kein Diagramm.",
          stagesTitle: "Stufenaufbau der Architektur",
          stagesSubtitle: "Direkt aus der gespeicherten Spezifikation; Parameterangaben sind Entwurfswerte.",
          stageCol: "Stufe",
          layersCol: "Schichten",
          mechanismCol: "Funktionsweise",
          paramsCol: "Physische Parameter (Mrd.) & Primärquellen",
          paramsCross: "querschnittlich — in den Stufen enthalten",
          researchTitle: "Forschungsarchiv Quanten- & Frontier-KI",
          researchSubtitle: "Live-Zeilen aus dem Forschungsarchiv von Veridion Core; neue Publikationen kommen über das Werkzeug des Quanten-Kollegen hinzu, jede mit sichtbarer Herkunft.",
          researchEmpty: "Noch keine Publikation im Archiv.",
          evidenceTitle: "Evaluationsnachweise",
          evidenceSubtitle: "Nur gemessene, referenzierte Evaluationen erscheinen hier; ohne Nachweis gibt es keine Punktzahl.",
          evalMetric: "Metrik",
          evalBenchmark: "Benchmark",
          evalSuite: "Suite",
          evalScore: "Wert",
          evalEvaluator: "Prüfer",
          evalDate: "Gemessen am",
          evalArtifact: "Nachweis-Artefakt",
          gateTitle: "Beförderungsregeln (Evidenz-Gate)",
          gateMetrics: "Pflichtmetriken",
          gateEpsilon: "Toleranz (Epsilon)",
          gateConfigVersion: "Gate-Konfiguration (Version)",
          candidatesTitle: "Kandidaten-Warteschlange",
          candidatesSubtitle: "Eingereichte Architektur-Kandidaten mit dem Stand ihrer Nachweise; eingereicht wird über die Forschungs-Runtime, nie über das Dashboard.",
          candidateSubmittedBy: "Eingereicht von",
          candidateEvidence: "Nachweise (vorhanden / erforderlich)",
          candidatesEmpty: "Kein Kandidat eingereicht.",
          changelogTitle: "Entwurfs-Änderungsprotokoll",
          changelogSubtitle: "Abgelöste Entwurfsiterationen — bewusst ohne Kennzahlen: Für sie wurde nie gemessen.",
          changelogSummary: "Zusammenfassung",
          changelogEmpty: "Kein abgelöster Entwurf.",
          supersededAt: "Abgelöst am",
          eventsTitle: "Gate-Ereignisse",
          eventsSubtitle: "Einreichungen, Beförderungen, Ablehnungen und Freeze-Wechsel, wie das Gate sie protokolliert hat.",
          eventsEmpty: "Noch kein Ereignis.",
        },
        title: 'Softwareentwicklung',
        subtitle: 'Die Aufgaben des Coding-Agenten, das GitLab des Unternehmens mit seinem Abgleich aus Azure DevOps, die Merge Requests, die auf ein Review warten, und die Grenzen des GitLab-Knotens.',
        openGitlab: 'GitLab öffnen',
        openSonar: 'SonarQube öffnen',
        loading: 'Lädt …',
        failed: 'Vorgang fehlgeschlagen',
        done: 'Erledigt',
        unavailable: 'Nicht erreichbar',
        capacityTitle: 'GitLab-Knoten',
        capacitySubtitle: 'Der Ressourcen-Controller (Node Guard) passt die Kapazitätsgrenzen des GitLab-Knotens minütlich an die Serverauslastung an, sodass die Produktivumgebung jederzeit ihre garantierte Reserve behält.',
        stateLabel: 'Zustand',
        memory: 'Arbeitsspeicher',
        cpu: 'CPU',
        disk: 'Platte',
        hostFree: 'Frei auf dem Server',
        reserve: 'Reserve für die Produktion',
        codingSlots: 'Coding-Aufgaben gleichzeitig',
        pipelineQuota: 'Pipeline-Jobs',
        recentActions: 'Letzte Anpassungen des Ressourcen-Controllers',
        syncTitle: 'Abgleich aus Azure DevOps',
        syncSubtitle: 'Der GitLab-Master folgt dem Azure-Master; Commits, die nur GitLab hatte, bleiben unter einem Tag replaced/<Zeit> erhalten.',
        syncNow: 'Jetzt abgleichen',
        syncStarted: 'Abgleich gestartet',
        azureCommit: 'Azure-Master',
        gitlabCommit: 'GitLab-Master',
        lastChange: 'Letzte Änderung',
        lastRun: 'Letzter Lauf',
        replaced: 'Unter Tags erhalten',
        noneReplaced: 'nichts',
        jobs: 'Letzte Läufe',
        error: 'Fehler',
        readyTitle: 'Merge Requests bereit zum Review',
        readySubtitle: 'Nur Merge Requests mit grüner Pipeline; gemergt wird in GitLab.',
        noReady: 'Kein Merge Request wartet auf ein Review.',
        tasksTitle: 'Coding-Aufgaben',
        tasksSubtitle: 'Jede Programmierarbeit des Coding-Agenten mit Zustand, Merge Request und Tokens.',
        showFinished: 'Beendete Aufgaben zeigen',
        task: 'Aufgabe',
        requester: 'Auftraggeber',
        statusLabel: 'Zustand',
        mergeRequest: 'Merge Request',
        pipeline: 'Pipeline',
        tokens: 'Tokens',
        updated: 'Aktualisiert',
        noTasks: 'Noch keine Coding-Aufgabe.',
        phase: 'Schritt',
        repository: 'Repository',
        branch: 'Branch',
        openQuestion: 'Offene Frage',
        result: 'Ergebnis',
        sendMessage: 'An die Aufgabe schreiben',
        answerQuestion: 'Frage beantworten',
        urgent: 'Dringend: den laufenden Schritt sofort lenken',
        send: 'Senden',
        messageSent: 'An die Aufgabe zugestellt',
        confirmCancel: 'Diese Aufgabe abbrechen? Ein offener Merge Request wird geschlossen.',
        course: 'Verlauf der Sitzung',
        messages: 'Nachrichten',
        events: 'Ereignisse',
        none: 'keine',
        close: 'Schließen',
        newTitle: 'Neue Aufgabe',
        newSubtitle: 'Dem Coding-Agenten von hier eine Aufgabe geben; sie ist hier und auf ihrer Webex-Karte zu verfolgen.',
        brief: 'Was soll der Agent tun?',
        issue: 'YouTrack-Issue (optional)',
        create: 'Aufgabe anlegen',
        created: 'Aufgabe angelegt',
        usersTitle: 'Administratoren in GitLab',
        usersSubtitle: 'Jeder Administrator hat einen GitLab-User mit Administratorrechten; das Housekeeping hält sie mit Keycloak im Gleichstand.',
        email: 'E-Mail',
        gitlabUser: 'GitLab-User',
        lastHousekeeping: 'Letztes Housekeeping',
        sonarDeleted: 'SonarQube-Projekte gelöschter Branches entfernt',
        previewsTitle: 'Projekte in Entwicklung',
        previewsSubtitle: 'Jedes Projekt in Entwicklung läuft vom ersten Merge an genau einmal: Veridion Core startet den neuesten grünen Stand des Hauptbranches (migration oder master) in Containern hinter der Administrator-Anmeldung, erneuert ihn mit jeder grünen Pipeline, und hier werden die Container gestartet, gestoppt und neu gestartet. Ein Projekt, dessen Pipeline nichts Laufendes baut, steht hier mit dem Grund.',
        previewsSummaryTitle: 'Was diese Ansicht zeigt',
        previewsSummaryBody: 'Jedes Projekt in Entwicklung läuft als eigener Vorschau-Container hinter der Administrator-Anmeldung. Die Liste oben zeigt den neuesten lauffähigen Stand jedes Projekts, die Tabelle darunter die laufenden Container mit Stand, Adresse und Steuerung: öffnen, starten, stoppen, neu starten.',
        previewProject: 'Projekt',
        previewState: 'Laufender Stand',
        previewSince: 'Seit',
        previewAddress: 'Adresse',
        previewMergedAt: 'Gemergt',
        noPreviews: 'Kein Projekt läuft.',
        reasonsLabel: 'Blockierende Ursachen & Diagnose',
        noProjects: 'Kein Projekt in Entwicklung.',
        qualityCoverage: 'Testabdeckung',
        qualityBugs: 'Bugs',
        qualitySmells: 'Code Smells',
        qualityDuplication: 'Duplikate',
        qualityHotspots: 'Offene Hotspots',
        qualityUnavailable: 'Keine SonarQube-Messung',
        openPreview: 'Öffnen',
        startPreview: 'Container starten',
        stopPreview: 'Container stoppen',
        previewStarted: 'Container gestartet',
        previewStopped: 'Container gestoppt',
        restartPreview: 'Container neu starten',
        previewRestarted: 'Container neu gestartet',
        previewControl: 'Container',
        resultTitle: 'Ergebnis in GitLab',
        resultJobs: 'Jobs und Artefakte',
        resultSonar: 'SonarQube',
        resultDelivered: 'Geliefert',
        previewStatus: {
          starting: 'startet',
          running: 'läuft',
          stopped: 'gestoppt',
          failed: 'fehlgeschlagen',
        },
        capacityStates: {
          ok: 'innerhalb der Grenzen',
          tight: 'knapp: die Produktion braucht den Platz',
          full: 'voll: keine neue Arbeit',
          node_down: 'Knoten läuft nicht',
        },
        status: {
          queued: 'wartet auf einen freien Platz',
          working: 'in Arbeit',
          waiting: 'wartet auf Antwort',
          review: 'im Review',
          merged: 'in GitLab gemergt',
          done: 'fertig',
          needs_person: 'braucht einen Menschen',
          rejected: 'ohne Merge geschlossen',
          paused: 'pausiert',
          cancelled: 'abgebrochen',
          failed: 'fehlgeschlagen',
        },
        commands: {
          pause: 'Pausieren',
          resume: 'Fortsetzen',
          cancel: 'Abbrechen',
        },
        repositoryChoice: {
          auto: 'Der Agent entscheidet',
          company: '{project} (Merge durch einen Menschen)',
          own: 'Ein eigenes Projekt in {group}',
        },
        userState: {
          ok: 'im Gleichstand',
          created: 'angelegt',
          unblocked: 'entsperrt',
          'made administrator': 'zum Administrator gemacht',
          blocked: 'gesperrt',
        },
      },
      org: {
        write: 'Schreiben',
        call: "Anrufen",
        callTitle: "Anruf bei {bot}",
        writeTitle: 'Nachricht an {bot}',
        callConfirmEnd: 'Den Anruf beenden?',
        callSubtitle: 'Das Mikrofon läuft während des gesamten Anrufs. Der Bot begrüßt mit seiner Stimme, antwortet kurz, fragt bei offenen Punkten nach und lässt sich unterbrechen. Jeder Satz steht auch in Webex, im Direktraum mit dem Bot.',
        callRinging: "Es klingelt …",
        callConnected: "Verbunden",
        callEnded: "Beendet",
        callEndedHangup: "Sie haben aufgelegt",
        callEndedClosed: "Die Verbindung wurde getrennt",
        callEndedSilence: "90 Sekunden Stille",
        callEndedLimit: "Die Höchstdauer von 30 Minuten ist erreicht",
        callEndedError: "Ein Fehler hat den Anruf beendet",
        callHangUp: "Auflegen",
        callLevel: "Mikrofonpegel",
        callYou: "Sie",
        callSpeaking: "Der Bot spricht …",
        callThinking: 'Die Antwort wird erzeugt …',
        callOvertaken: "von Ihrer nächsten Frage überholt, nicht gesprochen",
        callNothingHeard: "Es wurden keine Worte gehört.",
        callMicDenied: "Der Browser hat das Mikrofon verweigert; erlauben Sie es für diese Seite und rufen Sie erneut an.",
        callNoVoice: "Die Stimme ist gerade nicht verfügbar; die Antwort steht als Text.",
        callRefused: "Der Anruf wurde nicht angenommen: das Ticket war ungültig oder abgelaufen; rufen Sie erneut an.",
        callFailed: "Der Anruf ist fehlgeschlagen",
        voice: "Stimme",
        voiceHint: "Die Stimme, mit der dieser Kollege spricht: in Webex, wenn eine Person die Antwort hören will, und am Telefon. Standard ist ein Sprecher des Audio-Modells bei OpenRouter; eine eigene, geklonte Stimme aus dem Stimmspeicher spricht über die Stimm-Engine der Plattform.",
        voiceSave: "Stimme speichern",
        voiceDefault: "Standard",
        voiceNone: "keine Stimme",
        voiceCloud: "OpenRouter-Sprecher (Standard)",
        voiceOwn: "Eigene Stimmen (geklont)",
        voiceUploadTitle: "Stimmprobe für diesen Kollegen hochladen",
        voiceUploadHint: "Audio oder Video, höchstens 25 MB; der Core wandelt die Probe um, behält bis zu 20 Sekunden, hört ihre Worte und speichert nur den Referenzclip. Der Kollege spricht sofort mit dieser Stimme.",
        voiceUploadName: "Name der Stimme",
        voiceUploadConsent: "Ich bestätige, dass ich das Recht habe, diese Stimme für die Firma zu verwenden: sie ist meine eigene oder die Person hat zugestimmt.",
        voiceUploadButton: "Probe hochladen",
        voiceUploadDone: "Stimme gespeichert",
        voiceTooLarge: "Die Datei ist größer als 25 MB.",
        voicesTitle: "Stimmen",
        voicesSubtitle: "Jede Stimme der Firma ist ein Referenzclip im Stimmspeicher von Veridion Core; die Stimm-Engine klont sie bei jedem Sprechen. Die neun früheren Sprecher stehen als eingefangene Clips darin.",
        voiceSeconds: "Sekunden",
        voiceSource: "Herkunft",
        voiceSourcePreset: "eingefangener Sprecher",
        voiceSourceUpload: "hochgeladene Probe",
        voiceAddedBy: "Hinzugefügt von",
        voiceConsentBy: "Zustimmung bestätigt von",
        voiceWords: "Worte des Clips",
        voiceDelete: "Löschen",
        voiceConfirmDelete: "Diese Stimme löschen? Kollegen, die sie nutzen, sprechen wieder mit ihrer Standardstimme.",
        voiceCapture: "Sprecher der Preset-Engine einfangen",
        voiceCaptureHint: "Spricht je Sprecher einen festen Satz über die Preset-Engine und speichert ihn als Clip; läuft vor dem Wechsel der Engine.",
        voiceCaptured: "Eingefangen",
        voiceEnginePresets: "Die Stimm-Engine bietet feste Sprecher; der Stimmspeicher wird nicht genutzt.",
        chartTitle: "Organigramm",
        executiveTitle: 'Führungsebene',
        unitsTitle: 'Business Units',
        unitLead: 'Leitung',
        unitSupporting: 'Unterstützt von',
        unitMission: 'Auftrag',
        unitPrefix: 'Thread-Präfix',
        standingActive: 'aktiv',
        standingStandby: 'Standby',
        standbyOn: 'Auf Standby setzen',
        standbyOff: 'Aktivieren',
        standbyHint: 'Auf Standby übernimmt ein Kollege keinen Zug aus eigenem Antrieb der Firma und kostet keine Tokens; eine direkte Nachricht einer Person beantwortet er weiterhin.',
        confirmStandby: '{name} auf Standby setzen?',
        confirmActivate: '{name} aktivieren?',
        activity: 'Tätigkeit',
        runtime: 'Laufzeitumgebung',
        modelCloud: 'Cloud-Modell',
        modelGpu: 'Firmen-Engine',
        callModel: 'Telefon-Modell',
        calls30: 'Anrufe, letzte 30 Tage',
        telemetryLine: '{model} · {prompt}+{completion} Tokens · {cost} · STT {asr} ms · LLM {llm} ms · TTS {tts} ms · Gesamt {total} ms{deferred}',
        telemetryDeferred: ' · {count} aufgeschoben',
        chartSubtitle: "Veridions KI-Kollegen: Agenten in Veridion Core, jeder als eigener Webex-Bot erreichbar, in ihren Arbeitsgebieten; darüber die menschlichen Entscheider, darunter die Agenten ohne eigenen Bot und die Firmenbereiche, live aus Veridion Core und Webex gelesen.",
        chartPeople: "Menschliche Entscheider",
        chartPeopleText: "Die menschlichen Entscheider entscheiden alles und handeln in {space}.",
        chartAgentsTitle: "Agenten ohne eigenen Bot: der Coding-Agent, der Veridion MCP Orchestrator und die vom Architekten gebauten Agenten arbeiten im Auftrag eines KI-Kollegen und sprechen über dessen Bot",
        chartDesigned: "Mit dem Architekten entworfene Agenten",
        chartFor: "Im Auftrag von",
        chartSystemsTitle: "Angebundene Systeme",
        chartSpaceHome: "Heimatbereich von",
        chartSpacePurpose: "Zweck",
        chartRoomsTitle: "Firmenbereiche in Webex",
        room: "Bereich",
        roomBots: "Bots",
        positionsTitle: "KI-Kollegen",
        positionsSubtitle: "Jeder KI-Kollege antwortet über seinen eigenen Bot und liest seine Bereiche. Seine Beschreibung ist die Anweisung, nach der er arbeitet.",
        bot: "Bot",
        position: "Aufgabe",
        statusLabel: "Status",
        tokensUsed: "Verbrauchte Tokens",
        tokens30: "Tokens, letzte 30 Tage",
        edit: "Bearbeiten",
        close: "Schließen",
        description: "Beschreibung des KI-Kollegen",
        save: "Speichern",
        resetDescription: "Standardbeschreibung wiederherstellen",
        interests: "Interessenprofil",
        interestsHint: "Welche Arten von Punkten und Themen diesen KI-Kollegen betreffen und wann er nicht betroffen ist. Daran misst der KI-Kollege jede Nachricht in seinen Bereichen.",
        threshold: 'Schwelle für ungefragte Beiträge',
        thresholdHint: 'Von 1 bis 5: wie stark eine Nachricht den KI-Kollegen betreffen muss, bevor er sich ungefragt äußert. Bei 1 meldet er sich schon bei geringer Betroffenheit, bei 5 nur bei hoher.',
        saveProfile: "Profil speichern",
        tools: "Werkzeuge",
        decisionMakersTitle: "Entscheider",
        decisionMakersSubtitle: "Jeder von ihnen kann jede Freigabe erteilen und jede Rückfrage eines KI-Kollegen in Webex beantworten.",
        email: "E-Mail-Adresse",
        add: "Hinzufügen",
        remove: "Entfernen",
        confirmRemove: "Diesen Entscheider entfernen?",
        readerTitle: "Lesen der Firmenbereiche",
        readerSubtitle: "Ein Bot sieht nur Nachrichten, in denen er erwähnt wird. Veridion liest jede Nachricht der Firmenbereiche über die Freigabe eines Kontos, das Mitglied in allen ist.",
        notConfigured: "Die Integration ist nicht eingerichtet",
        authorised: "Freigegeben",
        notAuthorised: "Nicht freigegeben",
        account: "Konto",
        validUntil: "Zugangstoken gültig bis",
        renewUntil: "Freigabe erneuerbar bis",
        authorise: "Lesen freigeben",
        authoriseAgain: "Erneut freigeben",
        linkOpened: "Die Webex-Anmeldung wurde in einem neuen Tab geöffnet.",
        found: "gefunden",
        notFound: "nicht gefunden",
        botsInSpace: "Bots",
        transcripts: "Meeting-Mitschriften",
        yes: "ja",
        no: "nein",
        approvalsTitle: "Offene Freigaben",
        approvalsSubtitle: "Freigaben und Rückfragen, um die KI-Kollegen gebeten haben und die noch kein Entscheider beantwortet hat.",
        originSpace: "Bereich",
        directRoom: "Direktgespräch",
        approvalKinds: { review: "Freigabe", question: "Rückfrage" },
        schedulesTitle: "Zeitpläne",
        schedulesSubtitle: "Wiederkehrende Arbeit, um die jemand in einem Bereich gebeten hat; sie läuft, bis jemand sie beendet.",
        createdBy: "beauftragt von",
        lastRun: "zuletzt ausgeführt",
        end: "Beenden",
        confirmEnd: "Diesen Zeitplan beenden?",
        none: "Keine",
        loading: "Wird geladen …",
        failed: "Fehlgeschlagen",
        working: "In Arbeit …",
        done: "Erledigt",
        memoryTitle: "Organisation",
        memorySubtitle: "Die Menschen und KI-Kollegen der Firma mit dem Gedächtnisbereich, in dem jeder KI-Kollege arbeitet.",
        memoryMember: "Mitglied",
        area: "Bereich",
        decisionMaker: "Entscheider",
        status: { running: "läuft" },
      },
      core: {
        conversationTitle: 'Gespräch aus dem Dashboard',
        conversationHint: 'Jede Nachricht und jede Antwort wird auch in Webex gesagt: im Thread der Arbeit des Agenten, sonst in Ihrem direkten Raum mit dem Bot.',
        conversationEmpty: 'Noch keine Nachricht aus dem Dashboard.',
        writeToAgent: 'Nachricht an diesen Agenten',
        answerPending: 'Antwort steht aus',
        title: 'Veridion Core',
        subtitle: 'Das agentische Betriebssystem hinter dem Firmen-Bot: seine Agenten, ihre Nachrichten und ihr Tokenverbrauch, die Definitionen, der Architekt und die Organisation.',
        done: 'Erledigt.',
        failed: 'Vorgang fehlgeschlagen',
        loading: 'Lädt …',
        working: 'Arbeitet …',
        none: 'Keine.',
        unavailable: 'Veridion Core ist nicht erreichbar',
        errors: {
          AGENT_FINISHED: 'Der Agent ist beendet und nimmt keine Nachrichten mehr an',
          EMERGENCY_STOP: 'Not-Aus (Emergency Stop) ist aktiv',
          DEFINITION_INVALID: 'Die Definition ist nicht gültig',
          TOO_MANY_AGENTS: 'Es laufen zu viele Agenten',
          VERIDION_CORE_NOT_CONFIGURED: 'Veridion Core ist nicht konfiguriert',
          MESSAGE_EMPTY: 'Die Nachricht ist leer',
        },
        status: {
          building: 'Image wird gebaut',
          starting: 'startet',
          running: 'läuft',
          waiting: 'wartet',
          idle: 'bereit',
          paused: 'pausiert',
          completed: 'abgeschlossen',
          failed: 'fehlgeschlagen',
          cancelled: 'abgebrochen',
          stopped: 'gestoppt',
          not_deployed: 'nicht ausgerollt',
        },
        statusLabel: 'Status',
        owner: 'Besitzer',
        definition: 'Definition',
        parent: 'Übergeordneter Agent',
        tokens: 'Tokens',
        progress: 'Fortschritt',
        close: 'Schließen',
        openQuestion: 'Offene Frage',
        result: 'Ergebnis',
        answerQuestion: 'Frage beantworten',
        sendMessage: 'Nachricht an den Agenten',
        urgent: 'Dringend: laufenden Schritt unterbrechen',
        send: 'Senden',
        messageSent: 'Dem Agenten zugestellt.',
        commands: {
          pause: 'Pausieren',
          resume: 'Fortsetzen',
          cancel: 'Abbrechen',
          kill: 'Sofort beenden',
        },
        confirmKill: 'Diesen Agenten und alle zugehörigen Sub-Agenten sofort beenden?',
        subAgents: 'Sub-Agenten',
        graph: 'Graph',
        messages: 'Nachrichten',
        messageStatus: {
          queued: 'wartet',
          delivered: 'zugestellt',
          consumed: 'gelesen',
          refused: 'abgewiesen',
        },
        events: 'Ereignisse',
        containerLog: 'Container-Log',
        version: 'Version',
        activeAgents: 'Laufende Agenten',
        updated: 'Aktualisiert',
        archived: 'archiviert',
        noDefinitions: 'Noch keine Definitionen.',
        versions: 'Versionen',
        from: 'aus',
        startInput: 'Starteingabe als JSON',
        agentStarted: 'Agent gestartet.',
        startAgent: 'Agent starten',
        editAsJson: 'Als JSON bearbeiten',
        confirmArchive: 'Diese Definition archivieren? Laufende Agenten laufen weiter.',
        archive: 'Archivieren',
        definitionJson: 'Definition als JSON',
        definitionJsonHint: 'Eine Definition in der Veridion-Graph-Sprache. Prüfen zeigt ihre Mängel und ihren Graphen; Speichern legt sie als neue freigegebene Version ab.',
        checked: 'Geprüft.',
        validate: 'Prüfen',
        saved: 'Als neue Version gespeichert.',
        saveVersion: 'Als neue Version speichern',
        valid: 'Die Definition ist gültig.',
        you: 'Sie',
        architect: 'Architekt',
        architectPlaceholder: 'Beschreiben Sie, was der Agent tun soll …',
        newDesign: 'Neuer Entwurf',
        unitKinds: {
          company: 'Firma',
          department: 'Abteilung',
          team: 'Team',
          project: 'Projekt',
        },
        partOf: 'Teil von',
        confirmRemove: 'Diese Einheit entfernen? Ihre Mitglieder verlieren diesen Bereich.',
        remove: 'entfernen',
        addUnit: 'Einheit hinzufügen',
        unitId: 'Kennung (Kleinbuchstaben, Bindestriche)',
        unitName: 'Name',
        add: 'Hinzufügen',
        addMember: 'Mitglied hinzufügen',
        memberKinds: {
          person: 'Person (Mailadresse)',
          agent: 'Agent (Kennung)',
          definition: 'Definition (Kennung)',
        },
        memberId: 'Mailadresse oder Kennung',
        role: 'Rolle',
        confirmEmergencyOn: 'Alle Agenten jetzt stoppen? Der Bot antwortet weiter.',
        confirmEmergencyOff: 'Not-Aus aufheben?',
        emergencyStop: 'Not-Aus (Emergency Stop)',
        emergencyRelease: 'Not-Aus aufheben',
        emergencyActive: 'Not-Aus ist aktiv',
        autopilotOn: 'Autopilot einschalten',
        autopilotOff: 'Autopilot ausschalten',
        autopilotActive: 'Autopilot ist aktiv: Veridion Core beantwortet jede Karte an die Menschen selbst',
        autopilotUnitsTitle: 'Autopilot je Business Unit',
        autopilotUnitsHint: 'Schaltet den Autopiloten einzeln je Business Unit und für die Exekutive ein oder aus. Gehaltene Arbeit bleibt immer unberührt.',
        autopilotUnitOn: 'Autopilot an',
        autopilotUnitOff: 'Autopilot aus',
        limitsBuilds: 'Image-Builds je Kollege und Tag',
        limitsDesigns: 'Agentenentwürfe je Kollege und Tag',
        limitsSave: 'Tageslimits setzen',
        limitsNone: '0 = kein Limit',
        confirmAutopilotOn: 'Autopilot einschalten? Veridion Cores eigener Entscheider beantwortet dann sofort jede offene und jede neue Karte in pAIoneer-humans-and-bots, sichtbar im Thread der Karte.',
        confirmAutopilotOff: 'Autopilot ausschalten? Ab dann entscheiden wieder die Menschen.',
        model: 'Modell',
        codingModel: 'Coding-Modell',
        modelsTitle: 'Modelle nach Rolle',
        modelsSubtitle: 'Auf welchem Modell jede Rolle von Veridion Core denkt: das Gesicht und die Steuerung der Firma, das Telefon, der Architekt und der Richter der Requirements-Urteile. Wählbar sind nur Modelle, die das Gateway routet; leer heißt Standard der Konfiguration.',
        roleCoordinator: 'Koordinator (Gesicht und Steuerung)',
        roleCall: 'Telefon',
        roleArchitect: 'Architekt',
        roleRequirementsJudge: 'Requirements-Richter',
        roleJudge: 'Urteile des Core',
        roleEar: 'Spracherkennung Telefonie (STT)',
        roleStt: 'Spracherkennung Webex (STT)',
        modelGroupVllm: 'vLLM (eigene Karte)',
        modelGroupAudio: 'Audio (eigene Karte / Cloud)',
        modelGroupCloud: 'OpenRouter (Cloud)',
        directLlmTitle: 'Direkter LLM-Zugang',
        directLlmSubtitle: 'Mit einem vLLM oder Cloud-Modell direkt sprechen, ohne Bots, Agenten oder Webex',
        directLlmHint: 'Admin-Direktzugang: das gewählte Modell antwortet roh, gebucht unter „console“, ohne Lanes, Rollen oder Werkzeuge.',
        directLlmModel: 'Modell',
        directLlmSystem: 'System-Prompt (optional)',
        directLlmSystemPlaceholder: 'z. B. Du bist …',
        directLlmPrompt: 'Nachricht',
        directLlmPromptPlaceholder: 'Was möchtest du das Modell direkt fragen?',
        directLlmSend: 'Senden',
        directLlmSending: 'Sendet …',
        directLlmUsage: '{prompt}+{completion} Tokens · {cost}',
        modelCurrent: 'Im Einsatz',
        modelDefault: 'Standard',
        modelChosen: 'Gewählt',
        modelDefaultOption: 'Standard der Konfiguration',
        modelNotRouted: 'vom Gateway nicht geroutet',
        modelSave: 'Speichern',
        engineSilver: 'Firmen-Engine (Silber)',
        engineGold: 'Firmen-Engine (Gold, dem Orchestrator vorbehalten)',
        callsTitle: 'Telefonanrufe',
        callsSubtitle: 'Jeder gesprochene Zug des Telefons, getrennt von der Arbeit der Kollegen gebucht: Tokens, Kosten und die Zeit von Ohr, Verstand und Stimme, je Kollege und Modell, für die letzten 30 Tage und heute; darunter die neuesten Züge.',
        callsTurns: 'Züge',
        callsCalls: 'Anrufe',
        callsAvgTotal: 'Ø gesamt ms',
        callsAvgAsr: 'Ø Spracherkennung (STT) ms',
        callsAvgLlm: 'Ø Modell-Inferenz (LLM) ms',
        callsAvgTts: 'Ø Sprachsynthese (TTS) ms',
        callsDeferred: 'Aufgeschoben',
        callsToday: 'Heute',
        callsWindow: 'Letzte 30 Tage',
        callsRecent: 'Neueste Züge',
        callsPerson: 'Person',
        callsRounds: 'Runden',
        callsNone: 'Noch kein Anruf gebucht.',
        unitKindExecutive: 'Führungsebene',
        unitKindBusinessUnit: 'Business Unit',
        orgSynced: 'Führungsebene und Business Units sind in der Organisation von Veridion Core definiert und hierher synchronisiert; sie werden dort geändert, nicht auf dieser Seite.',
        memory: 'Gedächtnis',
        ready: 'bereit',
        notReady: 'nicht bereit',
        factExtraction: 'Faktenextraktion aktiv',
        cluster: 'Cluster-Zugriff',
        agentsRunning: 'Laufende Agenten',
        agentsWaiting: 'wartend',
        definitions: 'Definitionen',
        gatewayIdentity: 'Gateway-Identität',
        gatewayTokens: 'Gateway-Tokens im Zeitfenster',
        hostedTitle: 'Gehostete Agenten',
        hostedSubtitle: 'KI-Anwendungen, die Veridion Core in eigenen Containern startet und betreibt.',
        agent: 'Agent',
        actions: 'Aktionen',
        confirmHosted: '{action}: {agent}?',
        hostedActions: {
          start: 'starten',
          stop: 'stoppen',
          restart: 'neu starten',
        },
        open: 'öffnen',
        agentsTitle: 'Agenten',
        agentsSubtitle: 'Jeder Agent und Sub-Agent läuft in einem eigenen Container. Öffnen Sie einen Eintrag, um Nachrichten zu senden oder den Prozess zu steuern.',
        showFinished: 'Beendete Agenten zeigen',
        noAgents: 'Keine Agenten.',
        definitionsTitle: 'Definitionen',
        definitionsSubtitle: 'Freigegebene Agenten-Graphen mit ihren Versionen.',
        designsTitle: 'Agentenentwürfe',
        designsSubtitle: 'Jeder Agent, den der Architekt entworfen hat, für eine Person oder für die Arbeit eines KI-Kollegen: wofür und warum, jede Frage mit Antwort, die Testläufe gegen die Szenarien, die Freigabe und die Läufe.',
        design: 'Entwurf',
        designFor: 'Für',
        designWork: 'Arbeit',
        designState: 'Zustand',
        designApprovedBy: 'Freigegeben von',
        designAgent: 'Gebauter Agent',
        filterState: 'Status',
        filterAll: 'Alle',
        filterOpen: 'Offen',
        filterDone: 'Fertig',
        filterFailed: 'Gescheitert',
        filterCurrent: 'Aktiv und kürzlich gescheitert',
        filterActive: 'Aktiv',
        filterFinished: 'Beendet',
        filterPosition: 'KI-Kollege',
        pagePrev: 'Zurück',
        pageNext: 'Weiter',
        pageLabel: 'Seite',
        searchLabel: 'Suchen',
        showMore: 'Mehr anzeigen',
        noDesigns: 'Noch kein Agent entworfen.',
        designReason: 'Warum die Werkzeuge nicht reichten',
        designRecord: 'Protokoll',
        designAgents: 'Agenten des Entwurfs',
        designTestRun: 'Testlauf',
        designRun: 'Lauf',
        designStatus: { designing: 'wird entworfen', testing: 'im Test', asking: 'wartet auf Antwort', approval: 'wartet auf Freigabe', running: 'läuft', done: 'erledigt', failed: 'fehlgeschlagen', cancelled: 'abgebrochen' },
        builtBy: 'Gebaut von',
        builtFor: 'Für die Arbeit',
        viaCodingTask: 'über den Coding-Agenten',
        designTests: 'Testläufe',
        designRuns: 'Läufe',
        designByPerson: 'Person im Gespräch',
        diagramsTitle: 'Diagramme',
        diagramsSubtitle: 'Bilder von Abläufen, Architekturen und Plänen, die KI-Kollegen, Agenten und der Developer gezeichnet haben, mit Titel, Legende und Mermaid-Code.',
        noDiagrams: 'Noch kein Diagramm.',
        diagramAuthor: 'Autor',
        diagramBasedOn: 'Erweitert',
        diagramCode: 'Mermaid-Code',
        architectTitle: 'Architekt',
        architectSubtitle: 'Einen Agenten im Gespräch entwerfen. Der Architekt fragt, was er nicht selbst klären kann, und legt den Agenten erst nach Ihrer Freigabe an.',
        orgTitle: 'Organisation',
        orgSubtitle: 'Abteilungen, Teams und Projekte mit ihren Mitgliedern; das Firmengedächtnis wird entlang dieser Struktur geteilt.',
        usageTitle: 'Verbrauch je Agent',
        usageSubtitle: 'Modellaufrufe, Tokens und gemeldete Kosten der letzten 30 Tage.',
        calls: 'Aufrufe',
        source: 'Quelle',
        gpuTokens: 'Token Grafikkarte',
        cloudTokens: 'Token Cloud',
        usageByModel: 'Je Kollege und Modell',
        cost: 'Kosten',
      },
      memory: {
        archOverviewTitle: "Architektur-Überblick: Wie das Unternehmensgedächtnis aufgebaut ist",
        archOverviewText: "Veridion Core speichert das Unternehmenswissen in drei Schichten: Neo4j als zeitbehafteter Wissensgraph für Fakten, Entscheidungen und Arbeitspakete, PostgreSQL für transaktionale Agenten-, Postfach- und Sprint-Zustände und Qdrant für die Vektorsuche über Unternehmensdokumente. Jeder Geschäftsbereich arbeitet in einer fachlich isolierten Wissensdomäne; bereichsübergreifende Ergebnisse laufen über protokollierte Übergaben.",
        clustersTitle: "Abteilungs-Wissensdomänen",
        clustersSubtitle: "Jeder Geschäftsbereich arbeitet in einer abgegrenzten Neo4j-Wissensdomäne; Knoten- und Kantenzahlen stammen live aus Neo4j, die Beschreibungen aus der gekennzeichneten Erstbefüllung. Ein Klick öffnet die Domäne im Wissensgraphen.",
        clusterCode: "Kürzel",
        clusterName: "Wissensdomäne",
        clusterId: "Kennung",
        clusterRoles: "Rollen",
        clusterBridges: "Übergabe-Brücken",
        clusterPolicy: "Fachlicher Fokus & Isolationsrichtlinie",
        clusterCounts: "Knoten / Kanten (live)",
        clusterInsights: "Erkenntnisse (Erstbefüllung)",
        clusterOpenButton: "Im Wissensgraphen öffnen",
        countsUnavailable: "Neo4j nicht erreichbar — keine Zählung",
        researchTitle: "Forschungsarchiv Quanten- & Frontier-KI",
        researchSubtitle: "Wissenschaftliche Schlüsselpublikationen & Architektur-Referenzen — Live-Zeilen aus Veridion Core; die Herkunft jeder Zeile ist sichtbar.",
        researchEmpty: "Noch keine Publikation im Archiv.",
        researchIngestNote: "Neue Publikationen nimmt der Quanten-Kollege über sein Werkzeug auf; das Dashboard liest das Archiv nur.",
        researchPublication: "Publikation",
        researchMechanism: "Kernverfahren",
        researchRelevance: "Relevanz für die Architektur",
        researchOrigin: "Herkunft",
        researchSeeded: "Erstbefüllung",
        researchMotivates: "Begründet Version",
        title: 'Firmengedächtnis',
        subtitle: 'Was Veridion Core in Neo4j festhält: Erinnerungen nach Bereich, Fakten mit ihrem Gültigkeitszeitraum und das Audit dessen, was Agenten getan haben.',
        failed: 'Vorgang fehlgeschlagen',
        loading: 'Lädt …',
        unavailable: 'Das Gedächtnis ist nicht erreichbar',
        database: 'Datenbank',
        ready: 'bereit',
        notReady: 'nicht bereit',
        factExtraction: 'Faktenextraktion',
        episodesQueued: 'Wartende Episoden',
        lastError: 'Letzter Fehler',
        contentTitle: 'Inhalt',
        contentSubtitle: 'Knoten je Label und Erinnerungen je Bereich und Art.',
        label: 'Label',
        count: 'Anzahl',
        empty: 'Noch nichts.',
        scope: 'Bereich',
        kind: 'Art',
        kinds: {
          fact: 'Fakt',
          decision: 'Entscheidung',
          task: 'Aufgabe',
          procedure: 'Vorgehen',
          note: 'Notiz',
          episode: 'Episode',
        },
        searchTitle: 'Suche',
        searchSubtitle: 'Der Abruf, den Agenten nutzen: Bedeutung, Wörter und extrahierte Fakten.',
        searchPlaceholder: 'Suchbegriff oder Frage',
        allScopes: 'alle Bereiche',
        search: 'Suchen',
        noResults: 'Nichts gefunden.',
        text: 'Text',
        validFrom: 'Gültig ab',
        source: 'Quelle',
        extracted: 'extrahiert',
        recorded: 'erfasst',
        rememberTitle: 'Merken',
        rememberSubtitle: 'Einen Fakt, eine Entscheidung, Aufgabe, ein Vorgehen oder eine Notiz in einem Bereich ablegen.',
        remembered: 'Gespeichert.',
        remember: 'Merken',
        created: 'Angelegt',
        validity: 'Gültigkeit',
        invalid: 'ungültig',
        confirmInvalidate: 'Diese Erinnerung als nicht mehr gültig markieren?',
        invalidate: 'als ungültig markieren',
        forget: 'vergessen',
        confirmForget: 'Diesen Eintrag endgültig vergessen? Er wird aus dem Gedächtnis gelöscht und lässt sich nicht wiederherstellen.',
        forgotten: 'Vergessen.',
        factsTitle: 'Fakten im Zeitverlauf',
        factsSubtitle: 'Fakten aus Gesprächen und Agenten-Ergebnissen; ein widerlegter Fakt bekommt ein Enddatum.',
        noFacts: 'Noch keine Fakten extrahiert.',
        briefsTitle: 'Lagebilder der KI-Kollegen',
        briefsSubtitle: 'Was jeder KI-Kollege zuerst liest: offene Zusagen, gültige Entscheidungen, laufende Vorgänge und Kunden, jede Nacht aus dem Gedächtnis geschrieben.',
        brief: 'Lagebild',
        updated: 'Aktualisiert',
        noBriefs: 'Noch keine Lagebilder geschrieben.',
        fact: 'Fakt',
        from: 'Von',
        to: 'Zu',
        validUntil: 'Gültig bis',
        stillValid: 'weiterhin gültig',
        entityTitle: 'Nachbarschaft',
        entitySubtitle: 'Womit eine Aufgabe, ein Projekt, eine Person, ein System oder eine Entität verknüpft ist.',
        entityPlaceholder: 'Name, Aufgaben-ID, Mailadresse oder Kennung',
        show: 'Zeigen',
        auditTitle: 'Audit',
        auditSubtitle: 'Protokollierte Modell- und Werkzeugaufrufe, Nachrichten sowie gestartete Sub-Agenten.',
        auditPlaceholder: 'Agenten-Kennung (leer: alle)',
        filter: 'Filtern',
        time: 'Zeit',
        agent: 'Agent',
        event: 'Ereignis',
        toolOrModel: 'Tool oder Modell',
        status: 'Status',
        detail: 'Detail',
        consoleTitle: 'Abfragekonsole',
        consoleSubtitle: 'Nur lesendes Cypher; schreibende Anweisungen werden abgewiesen.',
        run: 'Ausführen',
        truncated: 'weitere Zeilen abgeschnitten',
        graph: {
          clusterPickTitle: "Wissensdomäne im Graphen fokussieren",
          clusterPickHint: "Ein Klick auf einen Geschäftsbereich fokussiert dessen Teilgraphen mit Rollen und Übergabe-Brücken im interaktiven Graphen.",
          allClusters: "Alle Domänen (Gesamtgraph)",
          activeCluster: "Aktive Wissensdomäne",
          publicationsTitle: "Publikationen im Forschungsarchiv",
          storesTitle: 'Speicher des Firmengedächtnisses',
          storesSubtitle: 'Was jeder Speicher des Firmengedächtnisses hält, live gelesen: der Graph in Neo4j, der Zustand von Veridion Core in Postgres, die Vektoren der Wissensbasis in Qdrant.',
          storeNeo4j: 'Neo4j (Graph)',
          storeNeo4jHolds: 'Das Firmengedächtnis: Erinnerungen mit ihrem Bereich, die von Graphiti extrahierten Entitäten und Fakten mit ihrem Gültigkeitszeitraum, die Arbeitspakete mit ihrer Bedeutung, die Softwarearbeit und das Audit der Agenten.',
          storePostgres: 'Postgres (relational)',
          storePostgresHolds: 'Der transaktionale Zustand von Veridion Core: die Prozesstabelle der Agenten, Postfächer, Gespräche, Checkpoints, Coding-Aufgaben, Freigaben, die Organisation und der Verbrauch.',
          storeQdrant: 'Qdrant (Vektoren)',
          storeQdrantHolds: 'Die Firmen-Wissensbasis: die eingebetteten Abschnitte der Dokumente, die ein Admin hinzugefügt hat, durchsucht vom Orchestrator, wenn ein Gesprächsschritt die Wissensbasis braucht.',
          nodes: 'Knoten',
          relationships: 'Beziehungen',
          relationshipType: 'Beziehungstyp',
          tables: 'Tabellen',
          table: 'Tabelle',
          rows: 'Zeilen',
          purpose: 'Was sie hält',
          documents: 'Dokumente',
          session: 'Sitzung',
          collection: 'Collection',
          role: 'Rolle',
          roleDocuments: 'Dokumente',
          roleCurated: 'kuratierte Frage-Antwort-Paare',
          title: 'Graph',
          subtitle: 'Der Graph des Firmengedächtnisses in Neo4j: Einstieg über einen Suchtreffer, die neuesten Erinnerungen oder die Arbeitspakete; ein Klick auf einen Knoten liest ihn, Erweitern holt seine Nachbarn, Ziehen ordnet an, Scrollen zoomt.',
          startNewest: 'Neueste Erinnerungen',
          startWork: 'Arbeitspakete',
          searchPlaceholder: 'Name, Text oder Id, die im Graphen gefunden werden soll',
          find: 'Suchen',
          noHits: 'Nichts gefunden.',
          name: 'Name',
          sources: { memory: 'Erinnerung', entity: 'extrahierte Entität', node: 'Projektgedächtnis', episode: 'Episode' },
          show: 'zeigen',
          shown: '{nodes} Knoten und {edges} Beziehungen im Graphen',
          truncated: 'an der Grenze abgeschnitten; einen Knoten erweitern oder enger suchen',
          selected: 'Gewählter Knoten',
          selectHint: 'Klicken Sie einen Knoten im Graphen an.',
          expand: 'Nachbarn erweitern',
          expandTwo: 'Zwei Ebenen erweitern',
          centre: 'Auf diesen Knoten zentrieren',
          facts: 'Fakten dieser Entität',
          degree: 'Beziehungen',
          direction: 'Richtung',
          out: 'ausgehend',
          in: 'eingehend',
          noRelationships: 'Keine Beziehungen.',
          property: 'Eigenschaft',
          value: 'Wert',
          noProperties: 'Keine Eigenschaften.',
          factsOf: 'Fakten von',
          factsSubtitle: 'Was Graphiti über diese Entität extrahiert hat, mit dem Zeitraum, in dem jeder Fakt gilt; ein widerlegter Fakt trägt ein Enddatum.',
          relation: 'Beziehung',
          other: 'Andere Entität',
          newestTitle: 'Neueste Erinnerungen',
          newestSubtitle: 'Die zuletzt geschriebenen Erinnerungen mit dem, worum es geht; „zeigen“ zeichnet eine mit ihren Verknüpfungen.',
          about: 'Worum es geht',
          workTitle: 'Arbeitspakete',
          workSubtitle: 'Jede bestätigte Arbeit mit Zustand, Verantwortlichem, Issue und den Ergebnissen ihrer Szenarien; „zeigen“ zeichnet eine mit ihrer Bedeutung, ihrem Issue, ihren Coding-Aufgaben und den für sie gebauten Agenten.',
          allStates: 'alle Zustände',
          states: { confirmed: 'bestätigt', in_progress: 'in Arbeit', blocked: 'blockiert', done: 'erledigt', failed: 'fehlgeschlagen', dropped: 'verworfen' },
          workItem: 'Arbeitspaket',
          owner: 'Verantwortlich',
          issue: 'Issue',
          scenarios: 'Szenarien',
          results: { passed: 'bestanden', failed: 'fehlgeschlagen', pending: 'offen' },
        },
        day: {
          title: 'Chronologisches Betriebsprotokoll',
          subtitle: 'Die Zeitleiste der Ereignisse, die Veridion Core festhält: die Worte der Menschen, Karten, Arbeit, Übergaben, Recherchen, Agenten, Coding-Aufgaben, Projekte, Störungen und Meetings, das Neueste zuerst.',
          sinceToday: 'heute',
          sinceDay: 'letzte 24 Stunden',
          sinceWeek: 'letzte 7 Tage',
          allKinds: 'alle Arten',
          refresh: 'Aktualisieren',
          count: '{n} Ereignisse',
          time: 'Zeit',
          actor: 'Akteur',
          happening: 'Ereignis',
          work: 'Arbeit',
          empty: 'In diesem Zeitraum ist nichts festgehalten.',
          kinds: { word: 'Führungsdirektive', request: 'Anliegen', card: 'Karte', work: 'Arbeit', handover: 'Übergabe', research: 'Recherche', agent: 'Agent', task: 'Coding-Aufgabe', project: 'Projekt', incident: 'Störung', schedule: 'Zeitplan', meeting: 'Meeting', message: 'Nachricht' },
        },
      },
      title: 'Admin-Dashboard',
      adminKicker: 'Betrieb',
      smtmStatusTitle: 'SMTM Daten & Forecasts',
      smtmStatusSubtitle: 'Überwacht Broker-Zeitreihen, publizierte Modelle, Prediction-Ausgabe und RSS-Feeds.',
      smtmStatusUnavailable: 'SMTM-Status nicht verfügbar',
      smtmGeneratedAt: 'Erzeugt',
      smtmMinimumRows: 'Minimum für Training',
      smtmBaseFrames: 'Basis-Zeitreihen',
      smtmTrainableFrames: 'Rohdaten bereit',
      smtmWaitingHistory: 'Wartet auf Historie',
      smtmPredictionTrackedInstruments: 'Instrumente gesamt',
      smtmPredictionEnabledCount: 'Predictions aktiv',
      smtmPredictionDisabledCount: 'Predictions pausiert',
      smtmMlFrames: 'ML-Datensätze',
      smtmOnlineModels: 'Online-Modelle',
      smtmModelsWithArtifacts: 'Modelle mit Artefakten',
      smtmPredictionFrames: 'Prediction-Zeitreihen',
      smtmMissingPredictions: 'Zeitreihen ohne Prediction',
      smtmBlobArtifacts: 'Blob-Artefakte',
      smtmStalePredictions: 'Veraltete Predictions',
      smtmRssFrames: 'RSS-Feeds',
      smtmDataframesTotal: 'Datensätze gesamt',
      smtmLatestModelUpload: 'Letzter Modell-Upload',
      smtmLatestPredictionWrite: 'Letzte Prediction-Ausgabe',
      smtmRuntimeHints: 'Runtime-Hinweise',
      smtmNoHints: 'Keine offenen SMTM-Hinweise.',
      smtmInstrument: 'Instrument',
      smtmBaseData: 'Basisdaten',
      smtmMlFrame: 'ML-Datensatz',
      smtmModelPublish: 'Modellstatus',
      smtmArtifacts: 'Artefakte',
      smtmPredictionFrame: 'Prediction-Zeitreihe',
      smtmIssues: 'Hinweise',
      smtmNoIssues: 'Keine Hinweise',
      smtmNoFrames: 'Keine SMTM-Instrumente gefunden.',
      smtmPredictionControlTitle: 'SMTM Prediction-Steuerung',
      smtmPredictionControlSubtitle: 'Legen Sie pro Instrument fest, ob SMTM neue Machine-Learning-Prognosen berechnen soll oder nur Basisdaten sammeln darf.',
      smtmPredictionSettingsUnavailable: 'SMTM-Prediction-Steuerung nicht verfügbar',
      smtmPredictionControlHint: 'Pausierte Instrumente behalten ihre vorhandenen Daten. Neue ML-Frames, Model-Trainings und Predictions werden für sie nicht mehr erzeugt.',
      smtmPredictionMode: 'Prediction-Modus',
      smtmPredictionToggle: 'Admin-Steuerung',
      smtmPredictionToggleLabel: 'Prediction aktivieren oder pausieren',
      smtmPredictionEnabled: 'Prediction aktiv',
      smtmPredictionDisabled: 'Prediction pausiert',
      smtmPredictionSaving: 'Speichert...',
      smtmPredictionSettingsSaved: 'SMTM-Prediction-Steuerung gespeichert.',
      smtmPredictionSaveChanges: 'Änderungen speichern',
      smtmPredictionResetChanges: 'Änderungen verwerfen',
      smtmPredictionPendingChanges: 'offene Änderungen',
      smtmPredictionPendingBadge: 'Wartet auf Speichern',
      smtmOpenAzuriteUi: 'Azurite Web UI öffnen',
      azuriteTitle: 'SMTM Azurite Web UI',
      azuriteSubtitle: 'Read-only Ansicht für Modelstatus-Einträge, Blob-Artefakte und Modell-Downloads.',
      azuriteModelGroups: 'Modellgruppen',
      azuriteBlobArtifacts: 'Blob-Artefakte',
      azuriteFiles: 'Dateien',
      azuriteSearchPlaceholder: 'Modelle filtern',
      azuriteNoModels: 'Keine Azurite-Modelle gefunden.',
      smtmRows: 'Zeilen',
      smtmLatest: 'Letzter Zeitstempel',
      smtmAge: 'Alter',
      smtmValue: 'Wert',
      smtmMinutesAgo: 'Min. alt',
      smtmMinutesAhead: 'Min. voraus',
      smtmHoursAgo: 'Std. alt',
      smtmDaysAgo: 'Tage alt',
      smtmStateLabels: {
        available: 'Verfügbar',
        trainable: 'Trainierbar',
        waiting_for_history: 'Wartet auf Historie',
        missing_base_data: 'Keine Basisdaten',
        missing_machine_learning: 'ML-Datensatz fehlt',
        missing_prediction: 'Prediction fehlt',
        prediction_disabled: 'Prediction pausiert',
        stale_prediction: 'Prediction veraltet',
        open: 'Offen',
        completed: 'Abgeschlossen',
        online: 'Online',
        offline: 'Offline',
        training: 'Training',
        uploading: 'Upload',
        failed: 'Fehlgeschlagen',
        unknown: 'Unbekannt',
        missing: 'Fehlt'
      },
      smtmIssueLabels: {
        empty_base_frame: 'Basis-Zeitreihe leer',
        insufficient_history: 'Zu wenig Historie',
        missing_machine_learning_frame: 'ML-Datensatz fehlt',
        missing_prediction_frame: 'Prediction-Zeitreihe fehlt',
        stale_prediction_frame: 'Prediction-Zeitreihe veraltet',
        missing_online_model: 'Kein Online-Modell',
        model_offline: 'Modell offline',
        missing_model_blob: 'Modelldatei fehlt',
        missing_model_header: 'Header-Datei fehlt',
        missing_modelstatus_entry: 'Modelstatus-Eintrag fehlt',
        inference_not_writing_prediction: 'Inference schreibt keine Prediction',
        prediction_disabled_by_admin: 'Prediction durch Admin pausiert'
      },
      smtmHintLabels: {
        trainable_frames_missing_predictions: 'rohbereite Instrumente ohne Prediction-Ausgabe',
        instruments_waiting_for_history: 'Instrumente warten noch auf Historie',
        models_missing_artifacts: 'Online-Modelle ohne vollständige Artefakte',
        no_online_models: 'Keine Online-Modelle in Azurite',
        azurite_unavailable: 'Azurite-Speicherstatus derzeit nicht erreichbar'
      },
      mailTitle: 'Mail-Konfiguration',
      usersTitle: 'Benutzerverwaltung',
      usersSubtitle: 'Konten, Rollen, Status und 2FA aus Keycloak. Auswählen öffnet die Verwaltung für genau ein Konto.',
      usersHideCreate: 'Formular schließen',
      usersCreateHint: 'Ein neues Konto startet mit Pflicht-2FA und wird erst nach deren Einrichtung aktiv.',
      usersFilterAllStatus: 'Alle Status',
      usersFilterAllRoles: 'Alle Rollen',
      usersManage: 'Verwalten',
      usersClose: 'Schließen',
      usersNoneFound: 'Keine Benutzer gefunden.',
      usersPagePrev: 'Zurück',
      usersPageNext: 'Weiter',
      auditTitle: 'Audit-Log',
      smtpHost: 'SMTP Host',
      smtpPort: 'SMTP Port',
      smtpSecurity: 'SMTP Sicherheit',
      smtpUsername: 'SMTP Benutzername',
      smtpPassword: 'SMTP Passwort',
      fromEmail: 'Absenderadresse',
      fromName: 'Absendername',
      replyToEmail: 'Reply-To Adresse',
      saveMailSettings: 'Mail speichern',
      sendTestMail: 'Testmail senden',
      createUser: 'Benutzer anlegen',
      setPassword: 'Passwort setzen',
      setRoles: 'Rollen setzen',
      setStatus: 'Status setzen',
      resetMfa: '2FA zurücksetzen',
      revokeSessions: 'Sessions widerrufen',
      filterUsers: 'Benutzer filtern',
      testRecipient: 'Empfänger für Testmail',
      statusConfigured: 'Konfiguriert',
      statusMissing: 'Nicht konfiguriert',
      userEmail: 'E-Mail',
      userName: 'Benutzername',
      userRoles: 'Rollen',
      userStatus: 'Status',
      auditEvent: 'Ereignis',
      auditCreatedAt: 'Zeitpunkt',
      auditDetails: 'Details',
      aiGatewayTitle: 'KI-Gateway',
      aiGatewayEndpoint: 'Endpunkt',
      aiGatewayIdentitySource: 'Identität aus Token-Claim',
      aiGatewayBudgetSource: 'Startwerte in',
      aiGatewayModels: 'Geroutete Modelle',
      aiGatewayModel: 'Modell',
      aiGatewayBackend: 'Backend',
      aiGatewayBudgets: 'Token-Budgets',
      aiGatewayIdentity: 'Identität',
      aiGatewayTokenBudget: 'Token-Budget',
      aiGatewayWindow: 'Zeitfenster',
      aiGatewayAnyIdentity: 'alle Identitäten',
      aiGatewayAnyModel: 'alle Modelle',
      aiUsageWindowStarted: 'Fenster seit',
      aiUsageRemaining: 'Verbleibend',
      aiUsageIdentities: 'Identitäten',
      aiGatewaySubtitle: 'Der Envoy AI Gateway ist der einzige Weg zu einem Modell: die gerouteten Modelle, ihre Serving-Backends und das Token-Budget jeder Identität.',
      aiGatewayHint: 'Budgets werden hier gesteuert. Die Deploy-Ebene setzt nur die Startwerte für einen frischen Cluster.',
      aiUsageTitle: 'KI-Verbrauch je Identität',
      aiUsageSubtitle: 'Vom Gateway gebuchter Token-Verbrauch im laufenden Zeitfenster.',
      sessionActiveUsers: 'Eingeloggte Benutzer',
      sessionActiveSessions: 'Aktive Sessions',
      sessionMfaSessions: 'Verifizierte Sessions',
      aiUsageTotalTokens: 'Tokens gesamt',
      aiServicesTitle: 'Dienstzugriffe',
      aiServicesSubtitle: 'Links zu den API- und Betriebsoberflächen der Plattform; jedes Ziel prüft die Admin-Rolle selbst.',
      aiMailSubtitle: 'Die SMTP-Einstellungen, mit denen Keycloak Bestätigungs- und Zurücksetzungsmails sendet, und der Testversand.',
      tabOverview: 'Überblick',
      tabSmtm: 'SMTM',
      tabEnvoy: 'Envoy AI Gateway',
      tabMail: 'E-Mail-Versand',
      tabUsers: 'Benutzer',
      tabAudit: 'Prüfprotokoll',
      tabServiceLinks: 'Dienstzugriffe',
      tabVeridion: 'Veridion SMTM',
      tabVeridionPaioneer: 'Veridion pAIoneer Labs GmbH',
      tabAgenticRag: 'Agentic RAG',
      tabPlatform: 'Plattform',
      platformTitle: 'Plattform-Status',
      platformSubtitle: 'Jeder pAIoneer Labs GmbH-Workload mit bereiten Repliken, Neustarts und Image, direkt aus Kubernetes.',
      platformHostPage: 'Instanzen im App-Host verwalten',
      openVisitorMonitoring: 'Besucher-, Marketing- & SEO-Monitoring öffnen',
      platformUnavailable: 'Plattform-Status nicht verfügbar',
      platformWorkloadsTotal: 'Workloads',
      platformDegradedTotal: 'Nicht bereit',
      platformRestartsTotal: 'Neustarts',
      platformWorkload: 'Workload',
      platformNamespace: 'Namespace',
      platformReplicas: 'Repliken',
      platformRestarts: 'Neustarts',
      platformImage: 'Image',
      platformState: 'Zustand',
      platformStateReady: 'Bereit',
      platformStateDegraded: 'Eingeschränkt',
      platformStateDown: 'Aus',
      platformStateUnknown: 'Unbekannt',
      platformNodes: 'Nodes',
      platformOsImage: 'Betriebssystem',
      platformKernel: 'Kernel',
      platformRuntime: 'Container-Runtime',
      platformKubelet: 'Kubelet',
      platformUsed: 'Aktuell belegt',
      platformReportedCapacity: 'Von Kubernetes gemeldet',
      platformConfiguredCap: 'Konfigurierter Container-Deckel',
      platformPressure: 'Druckzustände',
      platformPressureNone: 'keine',
      platformCpu: 'CPU-Kerne',
      platformNoWorkloads: 'Dieser Namespace hält Konfigurationsobjekte, keine Workloads.',
      platformMemory: 'Speicher',
      platformEvents: 'Aktuelle Warnungen',
      platformEventsNone: 'Keine Warnungen.',
      platformEventObject: 'Objekt',
      platformEventReason: 'Grund',
      platformEventMessage: 'Meldung',
      platformEventLastSeen: 'Zuletzt',
      platformMetricsMissing: 'Keine Verbrauchsdaten verfügbar: metrics-server antwortet nicht.',
      aiGatewayBackends: 'Serving-Backends',
      gpuTitle: 'Grafikkarte',
      gpuNote: 'Auslastung der Engines auf der Grafikkarte, die von ihnen bezogenen Token je Identität und je Webex-Bot sowie die Token-Budgets je Identität und Engine.',
      gpuTokensWindow: 'Token der Grafikkarte im Zeitfenster',
      gpuSinceStart: 'seit dem Start der Engine',
      gpuIdentities: 'Je Identität, laufendes Zeitfenster',
      gpuBots: 'Je Webex-Bot und Agent, 30 Tage',
      gpuBot: 'Webex-Bot / Agent',
      gpuBudgetTitle: 'Budget je Identität für die Engine',
      gpuBudgetSet: 'Budget setzen',
      gpuBudgetHint: 'Token je Stunde auf der Engine; das Gateway setzt es durch. Es engt auch eine Identität ohne Limit ein.',
      gpuNoneYet: 'Noch nichts gebucht.',
      gpuEngines: 'Engines',
      gpuEngine: 'Engine',
      gpuEngineGold: 'Gold-Engine',
      agenticRagTitle: 'Agentic RAG',
      agenticRagSubtitle: 'Laufzeit, Wissensbasis, Trainingsvorbereitung und Nachvollziehbarkeit der Agentic-RAG-Anwendung.',
      agenticRagBackendStatus: 'Backend-Status',
      agenticRagRuntimeMode: 'Laufzeitmodus',
      agenticRagKnowledgeMode: 'Wissensmodus',
      agenticRagDeploymentEnv: 'Deployment-Umgebung',
      agenticRagVectorStores: 'Vektorspeicher',
      agenticRagQdrantStatus: 'Qdrant',
      agenticRagQdrantCollection: 'Dokumenten-Collection',
      agenticRagQdrantCuratedCollection: 'Collection der kuratierten Fragen und Antworten',
      agenticRagQdrantDashboard: 'Dashboard',
      agenticRagPhoenixStatus: 'Phoenix',
      agenticRagOpenDocs: 'Swagger öffnen',
      agenticRagOpenPhoenix: 'Phoenix öffnen',
      agenticRagOpenQdrant: 'Qdrant öffnen',
      agenticRagKnowledgeTitle: 'Wissensbasis',
      agenticRagKnowledgeSubtitle: 'Stand der Dokumente und der kuratierten Fragen und Antworten der Agentic-RAG-Anwendung.',
      agenticRagDocuments: 'Dokumente',
      agenticRagCuratedQaPairs: 'Kuratierte Frage-Antwort-Paare',
      agenticRagTrainingTitle: 'Trainingsvorbereitung',
      agenticRagTrainingSubtitle: 'Der letzte Generator-Lauf und der letzte Stand des Trainers.',
      agenticRagLatestDataset: 'Letzter Datensatz',
      agenticRagDatasetPairs: 'Frage-Antwort-Paare',
      agenticRagDatasetDocuments: 'Verarbeitete Dokumente',
      agenticRagDatasetModifiedAt: 'Zuletzt geändert',
      agenticRagLatestTrainerInput: 'Letzte Trainer-Eingabe',
      agenticRagTrainerInputModifiedAt: 'Eingabe geändert',
      agenticRagLatestTrainerRun: 'Letzter Trainer-Lauf',
      agenticRagTrainerRunModifiedAt: 'Laufbericht geändert',
      gpuEngineSilver: 'Silber-Engine',
      gpuAssignment: 'Zuordnung',
      gpuWho: 'Wer',
      gpuRank: 'Rang',
      gpuRankHint: 'Rang 0 wird zuerst bedient; jede Engine bedient nach Rang.',
      gpuLanes: 'Laufende Aufrufe von Veridion Core je Engine und Rang',
      gpuInFlight: 'laufend',
      gpuWhoMainBotPeople: 'Hauptbot: Gespräche mit Personen',
      gpuWhoMainBotJudgements: 'Hauptbot: Urteile im selben Turn',
      gpuWhoAutopilot: 'Autopilot',
      gpuWhoAgents: 'Agenten, die der Hauptbot ausführt',
      gpuWhoArchitect: 'Architekt',
      gpuWhoChair: 'Meeting-Vorsitz',
      gpuWhoOrchestrator: 'Orchestrator der Firmeninstanz',
      gpuWhoColleagues: 'KI-Kollegen: Turns und ihre Urteile',
      gpuWhoMeetingWords: 'KI-Kollegen: Meeting-Beiträge',
      gpuWhoBackgroundReading: 'Hintergrunddienst: Lesen der Bot-Posts',
      gpuWhoMemory: 'Firmengedächtnis: Aufnahme und Lagebilder',
      gpuWhoCoding: 'Coding-Aufgaben: Urteile und Lernen',
      gpuWhoResearch: 'Web- und OSINT-Recherche',
      gpuWhoKnowledgeBase: 'Wissensbasis der Firma: Lesen gescannter Seiten',
      gpuWhoPipeline: 'Pipeline-Prüfung gegen die IDD',
      gpuWhoSmtm: 'Veridion SMTM: Chat und Wissensbasis der SaaS, letzter Rang',
      gpuUnavailable: 'Die Grafikkarte antwortet nicht',
      aiGatewaySource: 'Quelle',
      aiSourceGpu: 'Grafikkarte',
      aiGatewayMeter: 'Zähler',
      aiGatewayMeterIdentity: 'Jede Identität, gezählt',
      aiGatewayEngines: 'Engines auf der Grafikkarte',
      aiGatewayEnginesHint: 'Live-Kennzahlen jeder Engine aus ihren Metriken: laufende und wartende Anfragen, Cache-Belegung und seit dem Start bediente Token.',
      aiEngineRunning: 'Laufend',
      aiEngineWaiting: 'Wartend',
      aiEngineCache: 'Cache belegt',
      aiEngineServed: 'Token bedient',
      aiEngineIdle: 'Keine Anfragen',
      aiEngineUnavailable: 'Engine antwortet nicht',
      aiGatewayServing: 'Bereit',
      aiBudgetControlTitle: 'Token-Budgets steuern',
      aiBudgetControlSubtitle: 'Das Standardbudget gilt für jede Identität. Eine einzelne Identität kann eine eigene Obergrenze bekommen.',
      aiBudgetDefault: 'Standardbudget',
      aiBudgetIdentity: 'Identität',
      aiBudgetTokens: 'Token',
      aiBudgetApply: 'Übernehmen',
      aiBudgetAdd: 'Obergrenze setzen',
      aiBudgetRemove: 'Entfernen',
      aiBudgetSaved: 'Token-Budget übernommen.',
      aiBudgetIdentityPlaceholder: 'Client-ID, z. B. paioneer-agent-veridion-smtm',
      aiBudgetUnlimited: 'Kein Limit',
      aiBudgetSetUnlimited: 'Limit aufheben',
      aiBudgetRestoreLimit: 'Limit wiederherstellen',
      aiUsageReset: 'Fenster leeren',
      aiUsageResetDone: 'Laufendes Fenster geleert.',
      userMfa: '2FA',
      userMfaOn: 'Eingerichtet',
      userMfaOff: 'Fehlt',
      userCreatedAt: 'Angelegt',
      mailSource: 'Verwaltet in',
      veridionTitle: 'Veridion SMTM',
      veridionSubtitle: 'Konversationskern des Trading-Assistenten: Laufzeit, Tool-Registry, MCP-Server und Aktivität.',
      veridionOpenPage: 'Veridion öffnen',
      veridionOpenDocs: 'Swagger öffnen',
      veridionCoreStatus: 'Veridion MCP orchestrator',
      veridionTools: 'Tools',
      veridionToolsTitle: 'Tool Registry',
      veridionToolsSubtitle: 'Zeigt die derzeit geladenen Toolfamilien und ihre effektive Aktivierung.',
      veridionToolName: 'Tool',
      veridionToolRuntime: 'Runtime',
      veridionToolRisk: 'Risiko',
      veridionToolEnabled: 'Aktiv',
      veridionNoTools: 'Keine Veridion-Tools geladen.',
      veridionRuntimeProfiles: 'Runtime-Profile',
      veridionRegistryReloaded: 'Registry aktualisiert',
      veridionProvider: 'KI-Pfad',
      veridionMcpTitle: 'MCP-Server',
      veridionMcpSubtitle: 'Angebundene externe Werkzeugserver mit ihrem Zustand und der Zahl ihrer Tools.',
      veridionMcpServer: 'Server',
      veridionMcpState: 'Zustand',
      veridionMcpTools: 'Tools',
      veridionMcpLastSuccess: 'Zuletzt erreicht',
      veridionMcpConnected: 'verbunden',
      veridionMcpUnreachable: 'nicht erreichbar',
      veridionMcpDisabled: 'abgeschaltet',
      veridionMcpEmpty: 'Keine MCP-Server konfiguriert.',
      veridionActivityTitle: 'Aktivitätsprotokoll',
      veridionActivitySubtitle: 'Strukturierte Laufzeitereignisse des Orchestrators und seiner Tools.',
      veridionActivityEmpty: 'Noch keine Aktivität erfasst.',
      veridionActivitySource: 'Quelle',
      veridionActivitySurface: 'Oberfläche',
      veridionActivityEvent: 'Ereignis',
      veridionActivityTool: 'Tool',
      veridionActivityStatus: 'Status',
      veridionActivitySummary: 'Zusammenfassung',
      veridionUnavailable: 'Veridion ist derzeit nicht erreichbar.',
      veridionNotConfigured: 'Veridion ist in der Homepage-Runtime noch nicht vollständig konfiguriert.',
      veridionRequestFailed: 'Veridion hat die angeforderte Admin-Anfrage nicht erfolgreich beantwortet.',
      companyTitle: 'Veridion pAIoneer Labs GmbH',
      companySubtitle: 'Die Veridion-Instanz der pAIoneer Labs GmbH für die Mitarbeitenden in Webex, mit YouTrack und eigener Wissensbasis; ihre Modellaufrufe laufen über das Envoy AI Gateway.',
      companyWorkloads: 'Workloads',
      companyTokensWindow: 'Tokens im laufenden Fenster',
      companyBudget: 'Budget',
      companyBudgetDefault: 'Standardbudget',
      companyCost30: 'Kosten der letzten 30 Tage',
      openrouterTitle: 'Von OpenRouter abgerechnet',
      openrouterRemaining: 'Restguthaben',
      openrouterOf: 'von',
      openrouterToday: 'Heute',
      openrouterWeek: 'Diese Woche',
      openrouterMonth: 'Dieser Monat',
      openrouterUnavailable: 'OpenRouter ist gerade nicht lesbar',
      openrouterNote: 'Abrechnung von OpenRouter für den Plattform-Schlüssel in US-Dollar; Tag und Woche nach UTC. Die gebuchten Werte darunter erfassen nur Antworten, die ihre Kosten melden, und liegen deshalb niedriger.',
      companyRequests30: 'Modellaufrufe der letzten 30 Tage',
      companyCostNote: 'Kosten in US-Dollar, wie OpenRouter sie je Anfrage meldet; Tokens bucht das Envoy AI Gateway auf die Identität {identity}.',
      companyCostNotReported: 'nicht gemeldet',
      companyPartUnavailable: 'nicht erreichbar',
      companyWebexTitle: 'Webex-Bot',
      companyWebexSubtitle: 'Webex ruft webex.paioneer-labs.eu/hook auf; die Brücke prüft Signatur und Absender und übergibt nur zugelassene Nachrichten an Veridion.',
      companyWebexBot: 'Bot',
      companyWebexWebhook: 'Webhook',
      companyWebexRegistered: 'registriert',
      companyWebexNotRegistered: 'nicht registriert',
      companyWebexAccess: 'Zugelassen',
      companyWebexAnswered: 'Beantwortet',
      companyWebexRejected: 'Abgewiesen',
      companyWebexFailed: 'Fehlgeschlagen',
      companyWebexRecent: 'Letzte Zustellungen',
      companyWebexTime: 'Zeit',
      companyWebexOutcome: 'Ergebnis',
      companyWebexReason: 'Grund',
      companyWebexSender: 'Absender',
      companyWebexEmpty: 'Seit dem letzten Start keine Zustellung.',
      companyWebexNotConfigured: 'Die Webex-Brücke ist nicht erreichbar oder ihr Statusschlüssel fehlt in der Admin-API.',
      companyUsageTitle: 'Nutzung nach Person',
      companyUsageSubtitle: 'Modellaufrufe, Tokens und Kosten der letzten 30 Tage aus dem Kostenbuch der Instanz.',
      companyUsagePerson: 'Person',
      companyUsageCalls: 'Aufrufe',
      companyUsageTokens: 'Tokens',
      companyUsageCost: 'Kosten (USD)',
      companyUsageEmpty: 'In den letzten 30 Tagen keine Modellaufrufe.',
      companyWebexSendTitle: 'Als Bot schreiben',
      companyWebexSendPerson: 'An eine Person',
      companyWebexSendRoom: 'In einen Raum des Bots',
      companyWebexSendEmail: 'Mailadresse in Webex',
      companyWebexSendText: 'Nachricht (Markdown)',
      companyWebexSendButton: 'Senden',
      companyWebexSendDone: 'Gesendet.',
      companyWebexSendFailed: 'Fehlgeschlagen',
      companyWebexRooms: 'Räume des Bots',
      companyWebexRoomGroup: 'Gruppe',
      companyWebexRoomDirect: 'direkt',
      companyWebexRoomsEmpty: 'Der Bot ist noch in keinem Raum.',
      companyKnowledgeTitle: 'Wissensbasis',
      companyKnowledgeSubtitle: 'Die Dokumente der Wissensbasis der Firmeninstanz (Agentic RAG); der Orchestrator durchsucht sie, wenn ein Gesprächsschritt sie braucht. Phoenix protokolliert jede Suche.',
      companyKnowledgeDocument: 'Dokument',
      companyKnowledgeSize: 'Größe',
      companyKnowledgeModified: 'Aufgenommen',
      companyKnowledgeDelete: 'Entfernen',
      companyKnowledgeDeleteConfirm: '{name} aus der Wissensbasis entfernen?',
      companyKnowledgeUpload: 'Dokument aufnehmen',
      companyKnowledgeUploading: 'Wird hochgeladen …',
      companyKnowledgeIntake: 'Aufnahme',
      companyKnowledgePhoenix: 'Explainable AI (Phoenix)',
      companyKnowledgeEmpty: 'Die Wissensbasis ist leer.',
      companyKnowledgeNotConfigured: 'Die Wissensbasis ist für die Admin-API nicht angebunden.',
      companyGuestsTitle: 'Gäste mit Zugang',
      companyGuestsHint: 'Jede Adresse mit {domains} darf den Bot nutzen. Einzelne externe Adressen tragen Admins hier ein; die Änderung gilt sofort.',
      companyGuestsEmail: 'E-Mail-Adresse',
      companyGuestsAdd: 'Hinzufügen',
      companyGuestsRemove: 'Entfernen',
      companyGuestsRemoveConfirm: '{email} den Zugang zum Bot entziehen?',
      companyGuestsAddedBy: 'Hinzugefügt von',
      companyGuestsAddedAt: 'Hinzugefügt am',
      companyGuestsEmpty: 'Keine Gäste eingetragen.',
      companyGuestsNotPersistent: 'Die Liste wird nicht gespeichert: der Brücke ist kein Datenverzeichnis zugeordnet.',
      companyGuestsLoadFailed: 'Die gespeicherte Liste war nicht lesbar; bis zur nächsten Änderung hat kein Gast Zugang.',
      companyErrorRecipientNotAllowed: 'Diese Adresse darf dem Bot nicht antworten. Erst als Gast eintragen, dann senden.',
      companyErrorDomainAllowed: 'Adressen dieser Domain haben bereits Zugang.',
      companyErrorInvalidEmail: 'Keine gültige E-Mail-Adresse.',
      companyErrorAlreadyListed: 'Diese Adresse steht bereits auf der Liste.',
      companyErrorStoreUnwritable: 'Die Liste konnte nicht gespeichert werden.',
      smtmFilterTitle: 'SMTM Instrumentfilter',
      smtmFilterSubtitle: 'Leere Eingabe zeigt alle Instrumente; mehrere Instrumentnamen werden mit Komma getrennt, zum Beispiel EUR-USD_FOREX_intraday_data_l1,BitcoinEUR_CRYPTO_intraday_data_l1.',
      smtmFilterPlaceholder: 'Instrumentnamen, komma-getrennt',
      smtmFilterApply: 'Filter anwenden',
      smtmFilterClear: 'Filter leeren',
      smtmReportingTitle: 'SMTM Signal Reporting',
      smtmReportingSubtitle: 'Zeigt qualifizierte Kaufsignale, deren Exit-Auswertung und den Zustellstatus der automatischen Benachrichtigungen.',
      smtmReportingUnavailable: 'SMTM-Reporting nicht verfügbar',
      smtmReportingQualifiedSignals: 'Qualifizierte Signale',
      smtmReportingOpenSignals: 'Offene Signale',
      smtmReportingResolvedSignals: 'Aufgelöste Signale',
      smtmReportingWins: 'Gewinne',
      smtmReportingLosses: 'Verluste',
      smtmReportingWinRate: 'Trefferquote',
      smtmReportingAverageActualReturn: 'Ø Realrendite',
      smtmReportingNetActualReturn: 'Netto Realrendite',
      smtmReportingDeliveryFailed: 'Fehlgeschlagene Zustellungen',
      smtmReportingEntryTime: 'Entry-Zeit',
      smtmReportingExitTime: 'Exit-Zeit',
      smtmReportingExpectedReturn: 'Erwartete Rendite',
      smtmReportingActualReturn: 'Reale Rendite',
      smtmReportingSignalStatus: 'Signalstatus',
      smtmReportingNoSignals: 'Noch keine qualifizierten Signale gespeichert.',
      smtmReportingPendingDeliveries: 'Ausstehende Zustellungen',
      smtmReportingFailedDeliveries: 'Fehlgeschlagene Zustellungen',
      smtmReportingDeliveryError: 'Zustellfehler',
      smtmTrainingTitle: 'SMTM Training und Modelle',
      smtmTrainingSubtitle: 'Zeigt Trainingsqualität, Modellzustand und publizierte Artefakte aus dem Train-Service.',
      smtmTrainingUnavailable: 'SMTM-Training nicht verfügbar',
      smtmTrainingModels: 'Modelle',
      smtmTrainingOnlineModels: 'Online-Modelle',
      smtmTrainingFailedModels: 'Fehlgeschlagene Modelle',
      smtmTrainingStaleModels: 'Veraltete Modelle',
      smtmTrainingAverageMae: 'Ø MAE',
      smtmTrainingAverageRmse: 'Ø RMSE',
      smtmTrainingAverageR2: 'Ø R²',
      smtmTrainingAverageMase: 'Ø MASE',
      smtmTrainingAverageHitRate: 'Ø Trefferquote Richtung',
      smtmTrainingHitRate: 'Trefferquote',
      smtmTrainingLastSuccess: 'Letzter Trainingserfolg',
      smtmTrainingResolution: 'Auflösung / Horizont',
      smtmTrainingConsoleTitle: 'SMTM-Trainingskonsole',
      smtmTrainingConsoleSubtitle: 'Live-Tail der aktuellen Ausgabe des Trainingsdienstes.',
      smtmTrainingConsoleUnavailable: 'SMTM-Trainingskonsole nicht verfügbar',
      smtmTrainingConsoleEmpty: 'Noch keine Trainingsausgabe verfügbar.',
      smtmRuntimeTitle: 'SMTM Runtime',
      smtmRuntimeSubtitle: 'Globaler Horizont, Rebuild-Status und Prediction-Gate für das Live-SMTM-System.',
      smtmRuntimeUnavailable: 'SMTM-Runtime nicht verfügbar',
      smtmRuntimeForecastHorizon: 'Forecast-Horizont',
      smtmRuntimeResolution: 'Auflösung',
      smtmRuntimeConfigVersion: 'Konfigurationsversion',
      smtmRuntimePredictionGate: 'Prediction-Gate',
      smtmRuntimeRebuild: 'Rebuild',
      smtmRuntimeStateOpen: 'offen',
      smtmRuntimeStateClosed: 'geschlossen',
      smtmRuntimeStateActive: 'aktiv',
      smtmRuntimeStateIdle: 'inaktiv',
      smtmRuntimeForecastHorizonMinutes: 'Forecast-Horizont in Minuten',
      smtmRuntimeResolutionMinutes: 'Auflösung in Minuten',
      smtmRuntimeRequireCompletedBars: 'Nur abgeschlossene Bars verwenden',
      smtmRuntimePredictionGateOpen: 'Prediction-Gate geöffnet',
      smtmRuntimeRebuildActive: 'Rebuild aktiv',
      smtmRuntimeSaving: 'Runtime wird gespeichert...',
      smtmRuntimeSave: 'Runtime-Einstellungen speichern',
      smtmRuntimeReset: 'Runtime-Änderungen zurücksetzen',
      smtmRuntimeSaved: 'SMTM-Runtime-Einstellungen gespeichert.',
      smtmTrainingRows: 'Train / Test Zeilen',
      smtmTrainingMetrics: 'Metriken',
      smtmTrainingIssues: 'Trainingshinweise',
      smtmTrainingLlmFeatures: 'LLM-Features',
      smtmTrainingNoModels: 'Noch keine Trainingsmodelle im Cache.',
      smtmDirection: 'Richtung',
      smtmSentiment: 'Sentiment',
      smtmDeliveryStage: 'Stufe',
      smtmDeliveryRecipient: 'Empfänger',
      mailSettingsSaved: 'Mail-Konfiguration gespeichert.',
      mailTestSent: 'Testmail versendet.',
      userCreatedSuccess: 'Benutzer erfolgreich angelegt.',
      userUpdatedSuccess: 'Benutzer erfolgreich aktualisiert.',
      userDeletedSuccess: 'Benutzer erfolgreich gelöscht.',
      deleteUser: 'Benutzer löschen',
      roleLabels: {
        admin: 'Admin',
        pro: 'Pro',
        tester: 'Tester',
        user: 'Benutzer'
      },
      statusLabels: {
        pending_email_verification: 'Wartet auf E-Mail-Bestätigung',
        pending_mfa: 'Wartet auf 2FA',
        active: 'Aktiv',
        locked: 'Gesperrt',
        disabled: 'Deaktiviert'
      }
    }
  },
  en: {
    nav: {
      title: 'pAIoneer Labs GmbH',
      home: 'Home',
      team: 'Team',
      events: 'Events',
      finance: 'Finance AI',
      openApp: 'Open App',
      account: 'Account',
      admin: 'Admin',
      logout: 'Logout',
      teaching: 'Teaching',
      agenticdev: 'IDD / Agentic Coding',
      iddLegacy: 'Modernising legacy software',
      iddMethod: 'Intent-Driven Development',
      veridion: 'Veridion',
      kyveil: 'Anonymization',
      quantum: 'Quantum AI',
      login: 'Login',
      languageNames: {
        en: 'English',
        de: 'German',
        nl: 'Dutch',
        uk: 'Ukrainian',
        fr: 'French',
        it: 'Italian',
        es: 'Spanish',
        sv: 'Swedish',
        fi: 'Finnish',
        ja: 'Japanese',
        pl: 'Polish',
        bg: 'Bulgarian'
      }
    },
    footer: {
      managingDirectors: 'Managing directors',
      servicesTitle: 'Services',
      legal: {
        title: 'Legal',
        imprint: 'Imprint',
        privacy: 'Privacy Policy',
        aiTransparency: 'AI Transparency',
        cookieSettings: 'Cookie Settings',
        terms: 'Terms of Service'
      },
      copyright: 'All rights reserved.'
    },
    auth: {
      validating: 'Validating...',
      errors: {
        registrationFailed: 'Registration failed: ',
        unknownError: 'Unknown error',
        exchangeRateUnavailable: 'A live exchange rate is required before saving EUR budgets.',
        passwordTooWeak: 'The password is too short or too weak.',
        adminRequired: 'Only administrators can open this area.',
        lastAdminProtected: 'At least one active administrator must remain.',
        userExists: 'A user with these details already exists.',
        userCreateInvalid: 'The user data is incomplete or invalid.',
        mailNotConfigured: 'The mail system is not fully configured yet.'
      }
    },
    account: {
      username: 'Username',
      email: 'Email',
      roles: 'Roles',
      manageText: 'Your password, two-factor authentication, active sessions and email address are managed in the account console.',
      manageButton: 'Open account console',
      signedOut: 'You are not signed in.'
    },
    admin: {
      datalake: {
        loading: "Loading …",
        loadFailed: "The data lake is unreachable",
        refresh: "Refresh",
        generatedAt: "As of",
        notRolled: "This area is not rolled out in the backend yet. As soon as the new endpoints are live, the measured state appears here.",
        loadMore: "Load more",
        yes: "yes",
        no: "no",
        none: "none",
        close: "Close",
        summaryTitle: "Two hypotheses, one workbench",
        summaryBody: "The architecture hypothesis says: the mathematical vessel decides what the model can become — it lives on the LLM paper page. The data hypothesis says: only linked, verified training data fills that vessel — this page serves it. The autopilot fills the data estate continuously, starts training once the paper's data plan is reached in every area, in German and English, measures the result with the benchmark suite and publishes the model privately on HuggingFace. Every number here is measured or labeled a configured default.",
        summaryArchButton: "Open the architecture hypothesis (LLM paper)",
        apTitle: "Autopilot",
        tpTitle: "Path to the training start",
        tpSubtitle: "Where the autopilot stands right now: every step up to the running training with its state, time and progress.",
        tpNow: "Now",
        tpStep: "Step",
        tpOf: "of",
        tpSince: "since",
        tpFor: "running for",
        tpHeartbeat: "last heartbeat",
        tpDone: "done",
        tpRunning: "running",
        tpWaiting: "waiting",
        tpFailed: "failed",
        tpSkipped: "skipped",
        tpProgress: "Progress",
        tpRows: "rows",
        tpRate: "per second",
        tpRemaining: "estimated time left",
        tpEstimateNote: "estimate from the measured counts",
        tpPhaseReading: "reading a data package",
        tpPhaseAdmission: "admission (duplicates, entropy)",
        tpPhaseEncoding: "encoding",
        tpNoTiming: "This engine version does not report timings yet.",
        tpBlockers: "Blockers and errors",
        tpNone: "No blockers.",
        trTitle: "Training run (live)",
        trSubtitle: "Read straight from the trainer's run directory — works while the worker restarts.",
        trNoRun: "No training run with progress data yet.",
        trStateTraining: "training",
        trStateStarting: "starting",
        trStateFinished: "finished",
        trStateSilent: "silent for {age}",
        trStep: "Step",
        trOf: "of",
        trRemaining: "Remaining (estimate from the measured rate)",
        trSecondsPerStep: "s per step",
        trProgress: "Progress of the planned steps",
        trRun: "Run",
        trResumed: "resumed at step {step}",
        trVersion: "Train data version",
        trModel: "Model",
        trTokensPerSecond: "Tokens/s",
        trTokensSeen: "Tokens seen",
        trVram: "GPU memory",
        trCap: "cap",
        trLastHeartbeat: "Last heartbeat",
        trAgo: "{age} ago",
        trShardReads: "Shard reads local / via the worker",
        trLossTitle: "Loss over the steps",
        trLossTotal: "Total",
        trLossNtp: "Next token",
        trLossMtp: "Multi-token",
        trChartEmpty: "No steps reported yet.",
        trAxisNote: "Horizontal: training step, vertical: loss (natural logarithm). Hover over the curve to see the values of a step.",
        trValue: "Value",
        trCurrentValue: "current",
        trPoints: "{count} measurement points in total",
        trStages: "Curriculum stages",
        trStageFoundation: "Foundation (raw text)",
        trStageCapability: "Capability",
        trStageAnneal: "Anneal",
        trStageCurrent: "current",
        trStageDone: "done",
        trStageAhead: "ahead",
        trShards: "shards",
        trRows: "rows",
        trCheckpoint: "Newest checkpoint",
        trCheckpointNone: "none yet",
        trCheckpoints: "Complete checkpoints on disk",
        trCheckpointEvery: "every {minutes} min",
        trKernels: "Active kernels",
        trDeviations: "Deviations",
        trBlockStorage: "Copy in the block storage",
        trBlockStorageNone: "none yet — the first follows the first checkpoint",
        trUploading: "uploading: step {step}",
        treeCkRun: "Training run",
        treeCkCopy: "Checkpoint in the block storage, copied {time}",
        treeCkLocal: "Checkpoint on the server's disk",
        treeCkUploading: "being copied to the block storage",
        trKpiProgress: "Progress",
        trKpiTokens: "Tokens",
        trKpiThroughput: "Throughput",
        trKpiLoss: "Loss",
        trKpiLr: "Learning rate",
        trKpiGpu: "GPU memory",
        trEndAt: "ends approx. {time}",
        trSeenPlanned: "seen / planned",
        trBest: "best {value}",
        trHourAgo: "{value} vs. 1 h ago",
        trPerplexity: "perplexity {value}",
        trPhaseWarmup: "warm-up",
        trPhaseCosine: "cosine decay",
        trPhaseStable: "stable phase",
        trPhaseDecay: "cooldown",
        trKpiEpoch: "Epoch",
        trEpochValue: "{epoch} of {epochs}",
        trPlanTitle: "Run plan",
        trPlanExplain: "Warm-up to the peak learning rate, then constant across four mixed epochs of the corpus; the cooldown trains on the highest-grade mix (capability samples, textbook texts, anneal) and brings the learning rate down to zero.",
        trPlanPhase: "Phase",
        trPlanStableSteps: "Planned steps of the stable phase",
        trPlanDecay: "Cooldown",
        trPlanDecayAhead: "from step {step} · in about {time}",
        trPlanDecayAheadNoTime: "from step {step}",
        trPlanDecayRunning: "since step {step} · {steps} steps to learning rate zero",
        trPlanTokensPerStep: "Tokens per optimizer step",
        trPlanTokensPerStepValue: "{tokens} ({accum} micro-batches)",
        trPlanRecompute: "Activation recomputation",
        trPlanRecomputeOn: "on – measured faster with a larger micro-batch",
        trPlanRecomputeOff: "off – measured faster without",
        trPlanFim: "Documents in fill-in-the-middle form so far",
        tbTitle: "Textbook program",
        tbSubtitle: "Foundation texts rewritten by teachers as textbook text; every number and every proper name must occur in the source.",
        tbTokens: "Textbook tokens",
        tbTokensSub: "{pct} % of the {target} target",
        tbSamples: "Admitted rewrites",
        tbJobs: "Finished jobs",
        tbTeacher: "Teacher tokens per textbook token",
        tbCost: "Cost per million textbook tokens",
        tbCostNone: "the gateway reports no cost; teacher tokens are counted",
        tbExplain: "Runs beside the training; later epochs and the cooldown read what is sealed by then.",
        trThroughputTitle: "Throughput (tokens/s)",
        trCurriculumTitle: "Curriculum",
        trStageTokens: "{tokens} tokens",
        trStageBegins: "begins at step {step}",
        trPlanWarningLabel: "Warning",
        trPlanWarning: "The run ends after {max} steps in the \"{stage}\" stage — the capability data only begin at step {cap}. A full pass would take {steps} steps (≈ {days} days).",
        trPlanOk: "The planned steps reach the \"{stage}\" stage.",
        trCheckpointsTitle: "Checkpoints",
        trNextCheckpoint: "Next checkpoint",
        trInSpan: "in {span}",
        trResumes: "Resume",
        trNoResume: "none",
        trConfig: "Configuration",
        trHealth: "Health",
        trMicroBatch: "Micro-batch / tokens per step",
        trSeqLen: "Sequence length",
        trLrPlan: "Learning-rate plan",
        trLrPlanValue: "peak {lr}, warm-up {warmup} steps, cosine to step {max}",
        trSpikes: "Loss spikes (last hour)",
        trProgressSub: "step {step} of {max} · training for {elapsed}",
        trTokensSub: "of {planned} planned",
        trPathTrainingDetail: "{pct} % · step {step} of {max} · ends approx. {end}",
        trReadinessRunning: "Training is running: {pct} % done (step {step} of {max}), loss {loss}, ends approx. {end}.",
        tdvDraftsHistory: "Older drafts, never sealed ({count})",
        runsHistory: "Aborted and failed runs ({count})",
        trAxisStep: "Training step",
        trAxisLoss: "Loss (natural logarithm)",
        trCountdown: "{d} d {h} h {m} min {s} s",
        trTimerWaiting: "The timer follows after the first measurements.",
        trTimerStageEnds: "Stage \"{stage}\" ends in",
        trTimerAt: "at {time}",
        trTimerNext: "Then \"{stage}\": {span}, from {time}",
        trTimerRunEnds: "Run ends in {span} (at {time})",
        trStepTimeSub: "{wall} s per step measured · compute {compute} s",
        trEtaTitle: "Remaining time from the measured step duration",
        trEtaEpochEnds: "Epoch {epoch} of {epochs} ends in",
        trEtaEpochAt: "at {time} (step {step})",
        trEtaNextEpoch: "Epoch {epoch}: from {time} (step {step})",
        trEtaDecay: "Cooldown starts in {span} (at {time}, step {step})",
        trEtaBasis: "Basis: {wall} s per step, mean of the last {n} steps without {pauses} pauses (relaunch, stall); compute time reported by the trainer {compute} s per step.",
        devTitle: "Deviations from the blueprint",
        devNone: "No deviations — the run follows the blueprint in full.",
        devPlanned: "planned",
        devLimit: "limitation",
        devSeqLen: "Context length",
        devSeqLenText: "Trained with {trained} tokens of context instead of the {spec} the blueprint plans. The long context comes in a later phase.",
        devFim: "Fill-in-the-middle (FIM)",
        devFimText: "The fill-in-the-middle objective ({rate} % of the blocks) is declared in the blueprint but not active in this run yet.",
        devTermination: "Termination probe",
        devTerminationText: "The termination probe is not a training objective but a mode of its own after training; it runs later over a finished checkpoint.",
        devDecision: "Decision objective",
        devDecisionText: "The decision objective is active, but no decision marks arrived in the post-training stages of this run.",
        devKernelOff: "Acceleration off",
        devKernelUnverifiedText: "The kernel \"{kernel}\" was not verified by the probe and runs as the standard computation.",
        devKernelUnavailableText: "The kernel \"{kernel}\" is not available on this card and runs as the standard computation.",
        devKernelFellBackText: "The kernel \"{kernel}\" fell back to the standard computation during the run ({reason}).",
        devOptimizer: "Optimizer",
        devOptimizerText: "Optimizer states run in bfloat16 instead of 8 bit (bitsandbytes unavailable) — more memory, same mathematics.",
        devScale: "Model size",
        devScaleText: "The model is instantiated at {scale} % of the blueprint size because the full size did not fit the measured memory.",
        devMediaHeads: "Media heads",
        devMediaHeadsText: "The image/audio heads are untrained because the train data holds no media tokens — planned for a text strand.",
        devVision: "Vision path",
        devVisionText: "The vision path is built but trained on zero images because the train data holds none.",
        devOther: "Other",
        trStageShare: "{pct} % of this stage done",
        cap_tool_calling: "Tool calls",
        cap_deep_reasoning: "Deep reasoning",
        cap_software_engineering: "Software engineering",
        cap_office_finance: "Office & finance",
        cap_doc_understanding: "Document understanding",
        tpExplainThresholds: "For every capability of the selected strand enough verified training samples must lie in the data lake. Target and measured count stand here per capability.",
        tpThresholdsDetail: "{met} of {total} capabilities have reached their target",
        tpThresholdRow: "{measured} samples",
        tpForeignThresholds: "Not for this strand: {list} — belongs to another strand and blocks nothing.",
        tpStepTokenizerReleaseExplain: "The tokenizer turns text into numbers. It is fixed once and reported to the architecture, so data and model speak the same language.",
        tpStepTokenizeTdvExplain: "All verified training samples are translated into number sequences with the fixed tokenizer.",
        tpStepTokenizeCorpusExplain: "The whole raw text of the data lake is translated into number sequences — the mass for the foundation stage.",
        tpStepTdvCreateExplain: "A fixed train data version (TDV) is assembled from all tokenized data, with curriculum and measured token mass.",
        tpStepTdvSealExplain: "The version is made immutable and copied, with its description, to the block storage.",
        tpStepCompatExplain: "Twelve rules check that version and architecture fit (tokenizer, context length, objectives, memory). All must be green.",
        tpStepVramExplain: "Measures on the card whether enough GPU memory is free for the declared need.",
        tpVramDetail: "{free} GB free, {need} GB needed",
        tpStepTrainStartExplain: "The autopilot starts the training run as soon as every precondition is met.",
        tpStepTrainingExplain: "The run trains on its own with checkpoints every 30 minutes and continues by itself after any interruption. Details on the \"Training & release\" page.",
        tpVramRunning: "card in use by the running training ({need} GB needed); met at the start",
        trPathTrainingDetailNoEnd: "{pct} % · step {step} of {max}",
        srTitle: "Data readiness per model strand",
        srSubtitle: "While one strand trains, the data lake keeps preparing the others' data — up to their own sealed version, without a training start.",
        srTrainingNow: "training now",
        srSelected: "selected",
        srDataReady: "data ready",
        srPreparing: "in preparation",
        srModalities: "input: {in} · output: {out}",
        srThresholds: "targets: {met} of {total} reached",
        srCorpus: "Tokenized corpus",
        srCorpusValue: "{tokens} tokens in {shards} data packages",
        srVersion: "Newest version",
        srNoVersion: "none yet",
        srLacking: "Still lacking",
        srLacksNothing: "nothing — the version waits for its strand",
        srLackThresholds: "targets not reached",
        srLackCodec: "image/audio codec not released",
        srLackTokenizer: "tokenizer not reported",
        srLackVersion: "no sealed version",
        srSelectedNote: "This strand trains right now; its path stands above.",
        srSelectedIdleNote: "This strand is selected for the next training; its path stands above.",
        srUnselectedNote: "This strand starts no training while another is selected — its data is prepared in full all the same.",
        modText: "text",
        modImage: "image",
        modAudio: "audio",
        modVideo: "video",
        tpStepThresholds: "Reach the thresholds",
        tpStepPlan: "Reach the paper's data plan",
        tpExplainPlan: "The paper sets how many unique, verified tokens every area needs. German and English each carry at least half of it; code counts without a language. Counted are the admitted tokens after duplicates are removed, not the raw estimate.",
        tpPlanDetail: "{met} of {total} areas reached",
        tpPlanRowLang: "{have} / {target} · German {de} / {half} · English {en} / {half}",
        tpPlanRowFree: "{have} / {target}",
        tpPlanOpen: "open: {langs}",
        tpLangDe: "German",
        tpLangEn: "English",
        tpPlanProvisional: "Provisionally counted with the earlier tokenizer; the newly trained one decides.",
        tpStepOwnTokenizer: "The strand's own tokenizer",
        tpStepOwnTokenizerExplain: "The strand trains with its own tokenizer, learned on a balanced corpus that includes code. Only in its tokens does the data plan count for good.",
        tpPlanCat_knowledge: "Knowledge",
        tpPlanCat_code: "Code",
        tpPlanCat_mathematics: "Mathematics",
        tpPlanCat_domain: "Domain texts",
        tpPlanCat_textbook: "Textbook rewrites",
        tpPlanCat_agentic: "Agentic samples",
        tpPlanFlow: "inflow {rate} per hour",
        tpPlanEtaDays: "about {n} days to go",
        tpPlanEtaHours: "about {n} hours to go",
        tpPlanNoFlow: "no inflow in the last 24 hours",
        tpPlanBinding: "bottleneck",
        tpBind_download: "download",
        tpBind_allowance: "the block storage's daily upload allowance",
        tpBind_ingest: "ingest",
        tpBind_teachers: "teacher models",
        thrPlanTitle: "Samples per capability (measured)",
        thrPlanNote: "This strand's targets come from its paper: the data plan per area, German and English, on the path to the training start. Thresholds per capability apply only to strands without a data plan; this lists what each capability holds, as measured.",
        thrPlanRow: "{samples} samples · {tokens} tokens",
        srDataPlan: "Paper's data plan: {met} of {total} areas reached",
        srLackDataPlan: "data plan not reached",
        srPlanOpen: "open: {areas}",
        tpBind_source: "no source in this language",
        tpBind_paused: "download paused",
        tdvPlanEmpty: "No train data version of the active specification yet. The autopilot builds and seals it once the paper's data plan is reached.",
        compatPlanNone: "No check yet: the version of the active specification is checked when it is sealed.",
        mixPlanTitle: "Mix according to the paper",
        mixPlanNote: "Every training step draws the areas in these fixed shares; the decay phase raises the high-grade share up to half. Mixing targets per capability apply only to strands without a data plan.",
        mixPlanShare: "{area} {pct} %",
        sitTitle: "Situation",
        sitSubtitle: "Where the training stands at a glance: what each area of the paper still lacks, what runs now and what comes next.",
        sitHeadlineDays: "The training can start in about {time} at the earliest; {area} takes longest (bottleneck: {bottleneck}).",
        sitHeadlineBlocked: "The data plan is not reached this way: {items} has no source. Work on it runs: research open datasets or translate with checks.",
        sitHeadlineReached: "The data plan is reached; the tokenizer, the new tokenisation, the seal and the checks follow.",
        sitHeadlineUnknown: "The inflow of the rest is not measured yet.",
        sitHold: "The start is held in addition until every building block is verified.",
        sitArea: "Area",
        sitTotal: "Total",
        sitFlow: "Inflow",
        sitLeft: "Still",
        sitBottleneck: "Bottleneck",
        sitNoLanguage: "no language",
        sitNoSource: "no source",
        sitReached: "reached",
        sitDays: "{n} days",
        sitHours: "{n} h",
        sitPerHour: "{value} per hour",
        sitPerHourTokens: "{value} tokens per hour",
        sitRunningTitle: "What runs now",
        sitDownloads: "Downloads",
        sitIngest: "Processing into text chunks",
        sitTokenize: "Tokenisation",
        sitGenerate: "Generation by teacher models",
        sitIdle: "idle",
        sitNextTitle: "What comes next",
        sitNextSteps: "Train the tokenizer with code → tokenise the whole corpus anew → seal the version → checks → training start",
        sitProvisional: "The amounts are counted provisionally with the earlier tokenizer; the newly trained one counts for good.",
        tpPlanSeeSituation: "Areas, languages and remaining times are in the situation picture above.",
        sitHeadlineBlocks: "The training cannot start yet: building blocks still have to be built ({items}). The data grows meanwhile.",
        sitDuration: "Training duration: about {days} days for {budget} tokens at the measured {rate} tokens per second on the same network.",
        sitBlocksTitle: "Building blocks of the training",
        sitStateNotBuilt: "not built yet",
        sitStateWaiting: "waiting",
        sitStateReady: "ready",
        sitBlockWaitsFor: "waits for: {items}",
        sitBenchProgress: "{made} of {total} verified tasks",
        sitBlockParts: "built: {built} · open: {open}",
        part_graph_bundles: "linked documents",
        part_repository_bundles: "whole repositories",
        part_long_context: "long context",
        part_fine_tuning: "fine-tuning",
        part_reinforcement_learning: "reinforcement learning",
        part_real_folding: "real context folding",
        sitBlock_data: "Data by the paper's plan",
        sitBlock_tokenizer: "Tokenizer with code",
        sitBlock_bench: "The paper's benchmark suite",
        sitBlock_trainer: "Trainer: window stages, fixed budget, fixed mix",
        sitBlock_bundles: "Bundles: linked documents and whole repositories",
        sitBlock_post_training: "Post-training: long context, fine-tuning, reinforcement learning",
        tpStepTokenizerRelease: "Tokenizer release",
        tpStepTokenizeTdv: "Tokenise the training samples",
        tpStepTokenizeCorpus: "Tokenise the corpus",
        tpStepTdvCreate: "Create the train data version",
        tpStepTdvSeal: "Seal the train data version",
        apAfterSealLabel: "Continue automatically after the seal",
        apAfterSealOn: "ON",
        apAfterSealOff: "OFF",
        apAfterSealConfirmOn: "Continue automatically after the seal? The path to the training start then goes on without a pause: compatibility check, GPU checks and training start.",
        apAfterSealConfirmOff: "Stop after the seal again? The autopilot then pauses for review once the data version is sealed.",
        apAfterSealTurnedOn: "The path to the training start continues automatically after the seal.",
        apAfterSealTurnedOff: "The autopilot stops after the seal.",
        apAfterSealWaiting: "Data version sealed – the autopilot pauses for review.",
        apAfterSealStep: "Review of the sealed data version",
        apAfterSealHint: "After the seal all data lies processed in the block storage. With the switch off the autopilot pauses there for review; switched on, the path continues automatically.",
        tpStepCompat: "Compatibility check",
        tpStepVram: "VRAM probe",
        tpStepTrainStart: "Training start",
        tpStepTraining: "Training running",
        apSubtitle: "One switch for the whole loop: collect, process and link data, generate samples, train once the paper's data plan is reached, benchmark and release privately. Every blocker is named instead of papered over.",
        apOn: "Autopilot ON",
        apOff: "Autopilot OFF",
        apTurnOn: "Turn the autopilot on",
        apTurnOff: "Turn the autopilot off",
        apConfirmOn: "Turn the autopilot on? It fills the data estate continuously up to the sealed data version; then it pauses for review unless \"Continue automatically after the seal\" is on.",
        apConfirmOff: "Turn the autopilot off? Running work winds down cleanly; nothing is discarded.",
        apEnabled: "Autopilot enabled",
        apDisabled: "Autopilot disabled",
        apPause: "Pause",
        apResume: "Resume",
        apResumed: "Autopilot resumed",
        apPausedNote: "Autopilot paused",
        apPausedPill: "paused",
        apPhaseLabel: "Phase",
        apPhaseSince: "since {time}",
        apCycleId: "Cycle",
        apBlockedLabel: "Blocked",
        apCycleTitle: "Progress of the running cycle",
        apCycleEmpty: "No cycle active.",
        colPhase: "Phase",
        colPending: "Pending",
        colRunning: "Running",
        colDone: "Done",
        colFailed: "Failed",
        thrTitle: "Thresholds per capability",
        thrSubtitle: "At these volumes the autopilot seals a train data version and starts training; the bars show the measured progress.",
        thrMet: "met",
        thrNotMet: "open",
        thrDefault: "seeded default",
        thrForeign: 'not for the selected strand',
        staleSince: 'Worker not answering right now — last measured state from',
        staleHint: 'The autopilot keeps running; the view refreshes as soon as the worker answers again.',
        idxTitle: 'Vector index & deduplication',
        idxSubtitle: 'The lake\'s own HNSW index for graph linking and the measured removal of duplicate chunk shards.',
        idxConfigured: 'Index configured',
        idxReachable: 'Index reachable',
        idxPoints: 'Index points',
        idxBackfill: 'Backfill from the embeddings table',
        idxBackfillDone: 'complete',
        idxBackfillOpen: 'running / open',
        ddLastPass: 'Last dedup pass',
        ddChecked: 'assets checked',
        ddDropped: 'duplicate shards dropped',
        ddRows: 'chunk rows dropped',
        ddRemaining: 'candidates remaining',
        ddNone: 'no pass yet',
        gsTitle: 'Graph stages',
        gsSubtitle: "The teacher stages of the graph — embedding and claim extraction — serve the graph-derived sample synthesis, so they take chunks breadth-first across assets in rank order: rank 0 the owner's documents and tool imports, rank 1 expert knowledge mass (science, engineering, books, reasoning, German Commons, Wikipedia), rank 2 general text (Wikisource, Gutenberg, web corpora, transcripts), rank 3 code (embedded, never claim-extracted). The foundation mass reaches the token corpus without a teacher pass.",
        gsMeasuredAt: 'Measured at',
        gsRanksTitle: 'Rank order',
        gsRanksEmpty: 'No rank plan reported yet.',
        gsColRank: 'Rank',
        gsColLabel: 'Source class',
        gsColSources: 'Sources',
        gsColAssets: 'Assets',
        gsColPendingExtract: 'Pending extraction',
        gsColPendingEmbed: 'Pending embedding',
        gsRankOwner: 'Owner documents and tool imports',
        gsRankExpert: 'Expert knowledge mass',
        gsRankGeneral: 'General text',
        gsRankCode: 'Code (embedded only)',
        gsRankShort: 'rank {n}',
        gsLoopsTitle: 'Last round of every loop',
        gsColLoop: 'Loop',
        gsColSource: 'Source',
        gsColChunks: 'Chunks done',
        gsColClaims: 'Claims',
        gsColEdges: 'Edges',
        gsColSeconds: 'Seconds',
        gsColLast: 'Last round',
        gsLoopEmbed: 'Embedding',
        gsLoopExtract: 'Claim extraction',
        gsLoopLink: 'Linking',
        gsUngrounded: '{n} ungrounded',
        gsNoRound: 'no round yet',
        gsClaims: 'Claims total',
        gsAssetsWithClaims: 'Assets with claims',
        gsDangling: 'Dangling chunk nodes',
        gsStuck: 'Stuck assets (processing without a running ingest)',
        gsConcurrency: 'Extraction concurrency',
        gsOrphansLast: 'Last cleanup pass',
        gsOrphansNone: 'no pass yet',
        gsOrphansStatusCleaned: 'cleaned',
        gsOrphansDropped: 'nodes dropped',
        gsOrphansRemaining: 'remaining',
        gsOrphansHint: 'Nothing to do here: the autopilot plans a bounded cleanup pass by itself while chunk nodes without a shard exist. The summary shows the last pass.',
        thrSamplesBar: "Samples",
        thrTokensBar: "Tokens (estimated)",
        thrNoMinimum: "measured, no minimum",
        thrEditTitle: "Edit thresholds",
        thrEditSubtitle: "Saving replaces all thresholds in full; seeded defaults apply only until own values are set here.",
        thrMinSamples: "Min. samples",
        thrMinTokens: "Min. tokens (estimated)",
        thrEnabled: "enabled",
        thrAdd: "Add row",
        thrSave: "Save thresholds",
        thrSaved: "Thresholds saved",
        thrEmpty: "No thresholds defined yet — without enabled thresholds the autopilot seals nothing and reports that as a blocker.",
        capability: "Capability",
        modSignature: "Signature",
        removeRow: "Remove",
        budgetsTitle: "Daily budgets",
        budgetsSubtitle: "Spend against cap per scope and day — the budgets bound teacher and embedding calls.",
        budgetScope: "Scope",
        budgetDay: "Day",
        budgetSpent: "Spent",
        budgetCap: "Cap",
        budgetsEmpty: "No budgets reported.",
        eventsTitle: "Events",
        eventsSubtitle: "What the autopilot last did or reported, newest first.",
        eventsEmpty: "No events yet.",
        storageTitle: "Cloud storage",
        storageSubtitle: "The Block Storage connection and the initialization of the folder structure — repeatable without side effects.",
        connect: "Connect Block Storage",
        backendLabel: "Cold-store backend",
        backendBlockStorage: "Block Storage",
        backendLocal: "Local storage",
        connectedLabel: "Connection",
        connectedYes: "connected",
        connectedNo: "not connected",
        accountLabel: "Account",
        signinValidUntil: "Sign-in valid until",
        oauthClientLabel: "OAuth client",
        clientConfigured: "configured",
        clientNotConfigured: "not configured",
        bootstrapRun: "Initialize structure",
        bootstrapDone: "Initialization executed",
        bootstrapReportTitle: "Last run",
        bootstrapNoRun: "No bootstrap has run in this session yet.",
        bootstrapLine: "Folders created: {folders} · files in the cold store: {files} · rerun without changes: {idempotent}",
        treeTitle: "Folder tree",
        treeSubtitle: "The tree is a versioned specification: you define folders here, the autopilot may only add. Protected engine folders and non-empty folders are refused by the engine with a reason. Deletions in the Block Storage follow fixed rules only, such as older checkpoint copies (the newest two stay); during a full download, deletions and overwrites wait until it ends.",
        treeActiveVersion: "Active version v{version}",
        treePath: "Path",
        treePurpose: "Purpose",
        treeCreatedBy: "Created by",
        treeShards: "Shards",
        treeBytes: "Size",
        treeActions: "Actions",
        treeRetire: "Retire",
        treeRetired: "Folder retired",
        treeAddFolder: "Add folder",
        treeFolderAdded: "Folder created",
        treeVersionsTitle: "Versions",
        treeEmpty: "No folders defined yet.",
        treePlanned: "Planned — tree specification v{version}",
        treeFiles: "Files",
        treeSizesMeasured: "Sizes measured {measured}; the folders the catalog does not record last counted in the Block Storage {walked}. 1 GB = 10⁹ bytes.",
        treeSizesNoWalk: "Sizes measured {measured}; the folders the catalog does not record have not been counted yet. 1 GB = 10⁹ bytes.",
        treeExpand: "Show {count} subfolders",
        treeCollapse: "Hide subfolders",
        treeShowMore: "Show {count} more folders",
        treeSourceCatalog: "From the catalog: counted are objects that are really in the Block Storage",
        treeSourceWalk: "Counted by the walk through the Block Storage",
        bsUsageTitle: "Block Storage space",
        bsUsageSubtitle: "Used space, limit and free space of the Block Storage account and the data lake's share of it; the values are at most ten minutes old. 1 GB = 10⁹ bytes.",
        bsUsed: "Used",
        bsLimit: "Limit",
        bsFree: "Free",
        bsNoLimit: "no fixed limit",
        bsTrash: "In the trash",
        bsLake: "Of which data lake",
        bsLakeLine: "{size} in {files} files · {share} of the used space",
        bsMeasuredAt: "Measured",
        bsNotConnected: "The Block Storage is not connected; its space appears once the connection stands.",
        bsBarLake: "Data lake",
        bsBarOther: "Rest of the account",
        bsDlTitle: "Full download",
        bsDlSubtitle: "Downloads the whole Block Storage file by file into the same folder tree, without an archive. While it runs, the protection mode holds: deletions and overwrites of the captured files wait until it ends; new files keep being written and are not part of this download. A running training is never held up.",
        bsDlButton: "Download the entire Block Storage",
        bsDlFolderHint: "You pick a target folder once; the subfolders are created there. Files that are already complete are skipped, interrupted ones continue from their length.",
        bsDlScriptHint: "This browser cannot write folders. You receive a download script that builds the same folder tree and fetches every file resumably.",
        bsDlWindowsNames: "Characters Windows does not allow in names (such as “>”) appear in the target folder as a %-code, for example %3E.",
        bsDlActiveNote: "A download has been running since {time}. The button above continues it in this browser; complete files are skipped.",
        bsDlBuilding: "The file list is being built: {files} files so far, {size}.",
        bsDlManifest: "Loading the file list: {done} of {total} entries.",
        bsDlFolder: "Target folder",
        bsDlFiles: "Files",
        bsDlData: "Data",
        bsDlOf: "{done} of {total}",
        bsDlRate: "Rate",
        bsDlEta: "Time left",
        bsDlEtaUnknown: "being estimated",
        bsDlCurrent: "Loading now",
        bsDlSkipped: "{count} already complete, skipped",
        bsDlFailed: "{count} files failed",
        bsDlPausedNote: "Paused. Started files continue from their length when you resume; the protection mode stays while this page is open.",
        bsDlPause: "Pause",
        bsDlContinue: "Continue",
        bsDlRetryFailed: "Load failed files again",
        bsDlFinish: "Finish",
        bsDlStop: "Stop",
        bsDlStateBuilding: "preparing the file list",
        bsDlStateRunning: "downloading",
        bsDlStatePaused: "paused",
        bsDlStateIncomplete: "incomplete",
        bsDlStateScript: "script ready",
        bsDlStateFinished: "finished",
        bsDlStateStopped: "ended",
        bsDlStateActive: "active",
        bsDlFinished: "All {files} files ({size}) are in the target folder; the download is finished.",
        bsDlFinishedNote: "The download is finished; the held-back deletions and overwrites run now.",
        bsDlStopped: "The download is stopped; the held-back deletions and overwrites run now. Files already downloaded stay where they are.",
        bsDlEnded: "The server ended the download, for example after thirty minutes without a sign of life. A new click starts it again; complete files are skipped.",
        bsDlSession: "The sign-in has expired. Please sign in again; afterwards the button above continues the download.",
        bsDlDiskFull: "The target folder has no space left. Free some space, then continue.",
        bsDlPickFailed: "The target folder could not be opened.",
        bsDlScriptPosix: "Script for Linux and macOS",
        bsDlScriptWindows: "Script for Windows",
        bsDlScriptRun: "Save the script in the target folder and start it there: on Windows by double-clicking the .cmd file or from a command prompt, on Linux and macOS in a terminal with “sh <file>”.",
        bsDlScriptKeyValid: "The key in the script is valid until {time}, only for this download and only for reading.",
        bsDlScriptHeartbeat: "While this page is open, it tells the server that the download is still running. Click “Finish” once the script is done.",
        bsDlProtection: "Protection mode",
        bsDlProtectionState: "State",
        bsDlProtectionOn: "active since {time}",
        bsDlProtectionOff: "not active",
        bsDlScope: "Scope of the download",
        bsDlScopeValue: "{files} files, {size}",
        bsDlDeferredDeletes: "Held-back deletions",
        bsDlDeferredOverwrites: "Held-back overwrites",
        bsDlAddedSince: "Added since the start",
        bsDlLastActivity: "Last sign of life",
        acqTitle: "Data sources",
        acqSubtitle: "Curated open-license sources: per source its license, data-protection assessment, language, modality, byte target and measured progress. Disabled sources name their reason instead of being silently absent.",
        acqGdprNote: "GDPR principle: training data is admitted only from sources with an open license and a documented data-protection assessment; inbox data passes a PII scrub before samples are built (the \"PII-scrubbed\" counter shows it).",
        acqSource: "Source",
        acqModality: "Modality · language",
        acqLicense: "License",
        acqProtection: "Data protection",
        acqProgress: "Progress",
        acqDocs: "{count} files/objects landed",
        acqTargetReached: "target reached",
        acqExhausted: "source exhausted (listing serves nothing more)",
        acqEnabledPill: "enabled",
        acqWaitingBuffer: "waiting: buffer full, the upload is catching up",
        acqDisabledPill: "disabled",
        acqEnable: "Enable",
        acqDisable: "Disable",
        acqEnabledMsg: "Source enabled",
        acqDisabledMsg: "Source disabled",
        acqTargetLabel: "Target (GB)",
        acqSetTarget: "Save target",
        acqTargetSaved: "Target saved",
        acqEmpty: "No sources registered yet.",
        balanceTitle: "German/English language balance",
        balanceSubtitle: "Downloaded bytes per modality and language — for the seeded sources German must not fall behind English.",
        balanceEmpty: "No measurements yet.",
        modText: "Text",
        modAudio: "Audio",
        modImage: "Image",
        modVideo: "Video",
        prepTitle: "Preprocessing",
        prepSubtitle: "Counted pipeline stages from the registered raw document to the training sample — every number from the catalog; failures and unsupported items are named.",
        prepRegistered: "registered",
        prepScrubbed: "PII-scrubbed",
        prepChunked: "chunked",
        prepEmbedded: "embedded",
        prepExtracted: "extracted",
        prepLinked: "linked",
        prepSamples: "samples",
        prepByLang: "Per language",
        prepUnsupported: "Unsupported",
        prepAwaiting: "Waiting for a stage",
        prepFailures: "Failures",
        inboxTitle: "Raw inbox",
        assetWhat: "Content",
        assetFromSource: "from source {source}",
        assetFromUpload: "uploaded manually",
        mediaParquet: "Tabular data (Parquet)",
        treeShardsHint: "Shards are the catalog’s Parquet data packages: each row one package with origin, language and purpose — the purpose column says what lives in a folder.",
        mediaWords: {
          text: "Text",
          audio: "Audio",
          video: "Video",
          image: "Image",
          application: "File",
        },
        inboxSubtitle: "Feed your own raw data into the lake: upload here or drop files straight into the cloud folder raw/inbox/. Reconciling registers every file; \"Process now\" runs the same path the autopilot walks on its own.",
        uploadButton: "Upload file",
        uploadHint: "Up to 512 MB per file. Uploads land in the cold store and are chunked, embedded and linked into the knowledge graph on processing.",
        uploadTooLarge: "The file exceeds 512 MB.",
        uploadDone: "File accepted",
        processNow: "Process now",
        processStarted: "Processing started",
        reconcileNow: "Reconcile cloud folder",
        reconcileDone: "Reconcile executed",
        unprocessedCount: "{count} unprocessed",
        inboxEmpty: "The inbox is empty.",
        assetName: "File",
        assetType: "Type",
        assetSize: "Size",
        assetState: "State",
        assetLang: "Language",
        assetRegistered: "Registered",
        assetStates: {
          raw_stored: "raw bytes stored",
          awaiting_stt: "awaiting speech recognition",
          awaiting_content_fetch: "waiting for the content behind the address",
          awaiting_image_codec: "awaiting the image codec",
          awaiting_audio_codec: "awaiting the audio codec",
          awaiting_video_codec: "awaiting the video codec",
          chunked: "chunked & in the graph",
          processed: "processed",
          registered: "registered",
          queued: "queued",
          processing: "processing",
          ingested: "ingested",
          linked: "linked",
          unsupported: "unsupported",
          failed: "failed",
        },
        graphTitle: "Knowledge graph",
        graphSubtitle: "The linked raw corpus: nodes and edges counted from the catalog — the training samples are built from these connections.",
        graphEmbedded: "Embedded nodes",
        graphModel: "Embedding model",
        graphClusters: "Clusters",
        graphAssetsLinked: "Linked raw assets",
        graphLastLink: "Last link",
        graphNodesTitle: "Nodes by kind",
        graphEdgesTitle: "Edges by kind",
        graphEmpty: "The graph is still empty — it grows with the first processed file.",
        kindCol: "Kind",
        countCol: "Count",
        neighborsTitle: "Neighbors of a node",
        nodeIdLabel: "Node ID",
        neighborsRun: "Fetch neighbors",
        neighborsEmpty: "No neighbors found.",
        nodeCol: "Node",
        edgeKindCol: "Edge",
        weightCol: "Weight",
        gapTitle: "Coverage & gap matrix",
        gapSubtitle: "Measured inventory against the configured mixing targets per capability, signature and tier — a SQL view over the catalog, never hardcoded.",
        tier: "Tier",
        gapHave: "Have",
        gapTarget: "Target",
        gapWeight: "Weight",
        gapPriority: "Priority",
        targetsTitle: "Define mixing targets",
        targetsSubtitle: "Targets carry their author and timestamp; without targets the matrix shows the honest empty state.",
        addTargetRow: "Add row",
        saveTargets: "Save targets",
        targetsSaved: "Targets saved",
        statusCol: "Status",
        tdvTitle: "Sealed data version",
        tdvSubtitle: "The data version is immutable and composed of sealed shards; a new one replaces the previous one.",
        createTdv: "Create TDV draft",
        tdvCreated: "TDV draft created",
        tdvId: "TDV",
        tdvName: "Name",
        tdvMembers: "Members",
        tdvCreatedAt: "Created",
        tdvSealedAt: "Sealed",
        tdvStatusDraft: "draft",
        tdvStatusSealed: "sealed",
        sealTdv: "Seal",
        tdvSealed: "TDV sealed",
        tdvEmpty: "No Train Data Version yet — it is composed from sealed shards.",
        compatTitle: "Architecture and data compatibility check",
        compatSubtitle: "Rules R1–R12 over two machine-readable documents; the dashboard renders the engine's stored report and never computes a verdict of its own.",
        compatAllGreen: "ALL-GREEN",
        compatNotGreen: "not ALL-GREEN",
        compatRun: "Run check",
        compatChecked: "Check executed",
        compatSelectTdv: "Select a TDV in the list above to see its report.",
        compatNoReport: "No stored compatibility report exists for this TDV yet.",
        compatDraftNote: "The architecture's data interface is a draft — tokenizer and codec artifacts do not exist yet; checking activates with the first tokenizer release and the first sealed TDV.",
        compatRule: "Rule",
        compatTitleCol: "Title",
        compatKind: "Kind",
        compatEvidence: "Compared values (evidence)",
        kindHard: "hard",
        kindWarn: "advisory",
        reportsTitle: "Stored reports",
        reportsEmpty: "No compatibility report stored yet.",
        phaseLabel: "Training phase",
        phaseA: "Phase A — readiness & evolution",
        phaseB: "Phase B — training running, architecture frozen",
        checklistTitle: "Training readiness (Phase-A checklist)",
        checklistSubtitle: "Preconditions computed live; the start stays disabled until every item is green, and every unmet item is named.",
        checklistReady: "ready",
        checklistUnmet: "{count} items unmet",
        checklistUnavailable: "The checklist is unreachable.",
        itemSatisfied: "met",
        itemUnsatisfied: "unmet",
        startTraining: "Start Phase B",
        strandTitle: 'Training strand',
        strandSubtitle: 'Which model strand trains once every precondition is met; the unselected strand keeps preparing data but never starts.',
        strandSelectedBadge: 'selected',
        strandExplain: 'The autopilot trains {selected}. {other} keeps collecting and preparing but never starts while unselected.',
        strandSwitched: 'Selection saved.',
        strandSwitchFailed: 'Switching failed.',
        strandUnavailable: 'This backend serves no strands yet; the selector appears after the next core rollout.',
        trainingStarted: "Phase B started",
        startBlocked: "Start blocked — unmet: {items}",
        selectedTdvLabel: "Selected data version",
        computedAt: "Computed",
        runsTitle: "Training runs",
        runsSubtitle: "Only real runs from the catalog; there is no simulated training process.",
        runId: "Run",
        archVersion: "Architecture",
        presetCol: "Preset",
        seqLenCol: "Sequence length",
        stepCol: "Step",
        lossCol: "Loss",
        runStarted: "Started",
        runFinished: "Finished",
        runsEmpty: "No training run yet.",
        abortRun: "Abort",
        confirmAbort: "Abort this training run?",
        runAborted: "Abort requested",
        benchLink: "Benchmark",
        benchTitle: "Benchmark reports",
        benchSubtitle: "The frozen, versioned suite runs automatically after every training; every report is stored in the lake and shown here.",
        benchEmpty: "No benchmark report yet.",
        suiteVersion: "Suite",
        benchOpen: "Open",
        benchReportFor: "Benchmark report for run {run}",
        benchNoMarkdown: "This report carries no rendered document; the raw results are below.",
        exportsTitle: "Exports",
        exportsSubtitle: "Downloads exist exclusively for exports of completed real training runs.",
        exportId: "Export",
        exportSize: "Size",
        exportSha: "SHA-256",
        download: "Download",
        exportsEmpty: "No export yet — it is built only from a completed real training run.",
        hfTitle: "HuggingFace releases",
        hfSubtitle: "Every upload is private; visibility is verified via the API after the upload. A non-private result is an error state that stops the cycle.",
        hfEmpty: "No release yet.",
        hfRepo: "Repository",
        hfState: "State",
        hfVisibility: "Visibility",
        hfPrivateVerified: "private — verified",
        hfUnverified: "not verified yet",
        hfVerifiedAt: "Verified",
        connectTitle: "Connect Block Storage",
        connectSubtitle: "Sign in through the storage provider's sign-in window; the storage connects to the account that confirms there.",
        webConnectStart: "Connect with the storage provider",
        webConnectWaiting: "Waiting for the confirmation in the storage provider's sign-in window…",
        webConnectHint: "After the confirmation the storage connects automatically; this dialog updates itself.",
        publicIdentity: "Public app identity (rclone, shared quota)",
        publicIdentityNote: "The storage provider's sign-in window shows “rclone” as the requesting app — the publicly shared identity; an own client ID (GDRIVE_OAUTH_CLIENT_ID) replaces it any time.",
        manualHint: "After confirming, the browser shows an unreachable localhost page. Copy the code= parameter value from the address bar and paste it here (pasting the whole address works too).",
        manualCodeLabel: "Authorization code",
        manualSubmit: "Redeem code",
        deviceInstead: "Use a device code instead",
        licenseAcceptLink: "Confirm the license on Hugging Face",
        deviceFlowTitle: "Connect Block Storage (device flow)",
        deviceFlowSubtitle: "The engine starts the provider's device sign-in flow; confirmation happens on a second device and is polled at bounded intervals.",
        deviceFlowStart: "Start sign-in flow",
        deviceFlowCode: "Device code",
        deviceFlowOpenUrl: "Open confirmation page",
        deviceFlowWaiting: "Waiting for confirmation — polling at the interval the provider prescribes.",
        deviceFlowAuthorized: "Connected",
        deviceFlowExpired: "The device code has expired — start the sign-in flow again.",
        readinessTitle: "Readiness to train",
        readinessSubtitle: "The measured path to the first training run, stage by stage.",
        readinessCounter: "{green} of {total} met",
        readinessReady: "Ready to train",
        unblockLabel: "Next step",
        readinessUnavailable: "The readiness overview is not rolled out in the backend yet. As soon as the endpoint is live, the measured state appears here.",
        stageStates: {
          ok: "met",
          active: "running",
          waiting: "waiting",
          blocked: "blocked",
        },
      },
      gt: {
        loading: '…',
        unavailable: 'unavailable',
        equilibrium: 'Optimal operating state reached: all inquiries answered, all task handovers processed, and redundancies avoided.',
        standby: 'standby',
        defTitle: 'Operational Team Coordination & Performance Metrics',
        defSubtitle: 'Measuring operational communication and handover quality across all AI roles: focus on verified results instead of unproductive activity.',
        defPlayers: 'Participating Roles & Systems',
        defPlayersText: 'The ten specialized AI roles with their Webex bots alongside the human decision-makers who set tasks and governance guidelines.',
        defStrategies: 'Communication & Operating Principles',
        defStrategiesText: 'Direct response to inquiries, unambiguous and complete task handovers, avoidance of redundancies, and consistent completion of open work packages.',
        defPayoff: 'Operational Net Contribution (Net Utility)',
        defPayoffText: 'Completed work packages, successfully processed handovers, and answered inquiries — minus friction losses (redundancies, unprocessed handovers, unanswered inquiries).',
        defEquilibrium: 'Optimal Operating State (Coordination Equilibrium)',
        defEquilibriumText: 'Target collaboration state: every inquiry is answered on time, every task handover is accepted, no information is sent twice, and no work package remains stalled.',
        playersTitle: 'Performance Overview by Role (Positions)',
        playersSubtitle: 'Operational communication and delivery metrics per role: domain contributions and handovers (last 7 days) plus meetings and completed work packages (last 30 days).',
        playersHint: 'Net utility = 3 × completed work packages + processed handovers − friction losses (unprocessed handovers count double). A negative value indicates coordination bottlenecks.',
        player: 'Role / Position',
        contributions: 'Contributions',
        meetingTurns: 'Meetings',
        handovers: 'Handovers',
        consumedShort: 'consumed',
        refusedShort: 'refused',
        delivery: 'Delivery',
        pausedTurns: 'Paused turns',
        pausedTurnsHint: 'Turns saved in the colleague’s own mailbox because the models could not serve them right then. They are not hand-overs.',
        closedOpen: 'closed / open',
        noise: 'Friction Loss',
        utility: 'Net Contribution',
        meetingsLine: '{held} meetings, {turns} turns, {u} unanswered addresses (30 days).',
        interactionsTitle: 'Inter-Role Task Handovers (Handover Matrix)',
        interactionsSubtitle: 'Directed task handovers between mailboxes (last 7 days): count, delivery latency, and processed vs. rejected handovers.',
        interactionsHint: 'A task handover is only complete once processed by the recipient; rejected or unprocessed handovers are flagged as process deviations.',
        interactionsEmpty: 'No handovers in the window.',
        from: 'From',
        to: 'To',
        messages: 'Messages',
        consumed: 'consumed',
        refused: 'refused',
        deviationsTitle: 'Process Deviations & Active Bottlenecks',
        deviationsSubtitle: 'Current coordination gaps: unanswered inquiries, unprocessed task handovers, redundant contributions, or blocked work packages.',
        dev_unanswered_question: 'Unanswered inquiry (timeout exceeded)',
        dev_dead_air: 'Task handover without response',
        dev_repetition: 'Repetition in the meeting',
        dev_meeting_unanswered: 'Direct inquiry without response',
        dev_work_blocked: 'Work blocked',
        dev_handover_hop_budget_reached: 'Handover hop budget exceeded',
        dev_commitment_unkept: 'Sprint commitment unkept',
        devWithheld: 'withheld',
        devRepetition: 'repetition',
        devDeadAir: 'unprocessed handover',
        devMeetingUnanswered: 'unanswered',
        effectiveThresholdCol: 'Eff. threshold',
        excessHopsLabel: 'Excess handover hops',
        timeTitle: 'Cycle Times & Productivity Comparison (AI vs. Manual Execution)',
        timeSubtitle: 'Measured AI execution duration of completed engineering tasks compared against estimated manual effort.',
        timeHint: 'Baseline reference values for effort estimation; configurable by executive management.',
        avgCycle: 'Avg AI cycle',
        fromTasks: 'from {n} tasks',
        speedup: 'Speed-up',
        speedupHint: '{h} human hours assumed per piece',
        humanDelivered: 'Human days delivered',
        humanDays: 'human days',
        forecast: 'Forecast of open work: {d} human days',
        sizes: 'Sizes',
        sizeSmall: 'small',
        sizeMedium: 'medium',
        sizeLarge: 'large',
        scrumTitle: 'Scrum',
        scrumSubtitle: 'The sprint, its story points and the velocity, from the company\'s own store',
        sprintLabel: 'Sprint {n}',
        ends: 'ends',
        committedPts: 'Committed points',
        deliveredPts: 'Delivered points',
        remainingPts: 'Remaining points',
        burndownTitle: 'Burndown (points remaining per day)',
        velocityTitle: 'Velocity of the closed sprints',
        predictability: 'predictability',
        forecastLine: 'Rolling velocity {v} points per sprint · backlog {b} points ≈ {s} sprints',
        noSprint: 'No sprint is running; the next planning opens one.',
        noItems: 'Nothing is committed yet; the sprint takes what the people bring.',
        colItem: 'Item',
        colOwner: 'Owner',
        colPoints: 'Points',
        colState: 'State',
        itemDone: 'delivered',
        itemOpen: 'open',
        unestimated: 'unestimated',
        addedBy: 'added by {who}',
        setGoal: 'Sprint goal',
        sprintDaysLabel: 'Sprint length (days)',
        save: 'Save',
        endSprint: 'End the sprint now',
        confirmEndSprint: 'End the sprint now? The review, retrospective and next planning run at once.',
        planNow: 'Hold the first planning now',
        confirmPlanNow: 'Hold the sprint planning now? It opens the first sprint in pAIoneer-scrum.',
        sprintPointsCol: 'Sprint points',
        ceremonySpaceLabel: 'Ceremony space',
        scrumOfScrums: 'Hold Scrum of Scrums',
        confirmScrumOfScrums: 'Hold Scrum of Scrums across all Business Units now?',
        lastScrumOfScrumsTitle: 'Last Scrum of Scrums',
        escalatedImpedimentsTitle: 'Escalated impediments',
        unitBreakdownTitle: 'Sprint breakdown by Business Unit',
        colUnit: 'Business Unit',
        colWip: 'Open WIP',
        colImpediments: 'Impediments',
      },
      nav: {
        groups: {
          gametheory: 'Team Coordination & Scrum',
          demos: 'Live Previews',
          sovereign: 'Sovereign LLM',
          today: 'Executive Overview & Operations',
          organisation: 'Organisation',
          work: 'Work',
          communication: 'Communication',
          memory: 'Memory',
          platform: 'Platform',
          products: 'Products',
          identity: 'Identity',
        },
        pages: {
          gametheory: 'Team Coordination & Scrum',
          demos: 'Live Previews',
          llm: 'LLM Architecture — Paper',
          training: 'Data Lake & AI Model Training',
          today: 'Executive Overview & Operations',
          work: 'Work items and projects',
          coding: 'Coding Tasks',
          gitlab: 'GitLab & Image Builds',
          agents: 'Agents and designs',
          research: 'Research',
          webex: 'Webex spaces',
          mailboxes: 'Mailboxes',
          conversations: 'Calls and conversations',
          meetings: 'Meetings',
          engines: 'AI Engines & GPU',
          usage: 'Usage and budgets',
          workloads: 'Container Services',
          orchestrator: 'Veridion MCP orchestrator',
        },
        sections: {
          demos: {
            previews: 'Live Previews',
          },
          llm: {
            paper: 'Paper',
            monitoring: 'Monitoring',
          },
          training: {
            autopilot: "Autopilot",
            storage: "Cloud storage & folder tree",
            acquisition: "Acquisition & Preprocessing",
            data: "Data & knowledge graph",
            training: "Training & release",
          },
          platform: {
            nodes: 'Cluster Nodes',
            events: 'Events',
          },
          smtm: {
            runtime: 'Runtime Control',
            prediction: 'Prediction control',
            status: 'Data status',
            reporting: 'Signals',
            training: 'Models',
            console: 'Training console',
          },
          agentic: {
            overview: 'Overview',
            tools: 'Tools',
            mcp: 'MCP servers',
            activity: 'Activity',
          },
          'company-memory': {
            content: 'Content',
            search: 'Search and briefs',
            facts: 'Facts',
            entity: 'Entities',
            remember: 'Record',
            audit: 'Audit Log',
            console: 'Query console',
            stores: 'Stores',
            graph: 'Knowledge Graph',
            day: 'Day',
            bubbles: 'Department Knowledge Domains & Research',
          },
          organisation: {
            chart: 'Organisation chart',
            colleagues: 'AI colleagues and mailboxes',
            voices: 'Voices',
            people: 'People and spaces',
            approvals: 'Approvals and schedules',
            edit: 'Edit organisation',
          },
          work: {
            items: 'Work items',
            projects: 'Projects in development',
          },
          gitlab: {
            gitlab: 'GitLab',
            builds: 'Image Builds',
          },
          agents: {
            agents: 'Agents',
            designs: 'Agent designs',
            definitions: 'Definitions',
          },
          usage: {
            identities: 'Per identity',
            budgets: 'Token budgets',
            company: 'Company instance',
            smtm: 'Veridion SMTM',
          },
          orchestrator: {
            runtime: 'Runtime',
            mcp: 'MCP servers',
            tools: 'Tools',
            activity: 'Activity',
          },
        },
        attentionTitle: 'Needs attention',
        attentionSubtitle: 'States from every area that need someone to act. A click opens the section.',
        attentionNone: 'Nothing needs attention.',
        stateTitle: 'Operating state',
        none: 'none',
        readyOf: '{ready} of {total} ready',
        connectedOf: '{connected} of {total} connected',
        registeredOf: '{registered} of {total} registered',
        showMore: 'Show more',
        shownOf: '{shown} of {total}',
        expand: 'Expand',
        collapse: 'Collapse',
        service: 'Service',
        serviceLinks: 'Links',
        controlsTitle: 'Veridion Core controls',
        confirmRemove: 'Remove {what}?',
        companyIdentitiesTitle: 'Gateway identities of the company instance',
        companyIdentitiesSubtitle: 'The tokens of the orchestrator and of Veridion Core in the running window of the gateway, each identity with its budget.',
        conversationsTitle: 'Conversations from the dashboard',
        conversationsSubtitle: 'Per AI colleague the written conversations from the dashboard; writing and calling open a dialog over the page.',
        conversationCount: 'Messages',
        conversationLastWritten: 'Last written',
        conversationLastAnswered: 'Last answered',
        exchangesTitle: 'Messages and answers',
        exchangesSubtitle: 'Every message from the dashboard with the AI colleague\'s answer, newest first.',
        conversationMessage: 'Message',
        conversationAnswer: 'Answer',
        today: {
          wordTitle: 'Active Executive Directive',
          wordNone: 'No open executive directive is currently set.',
          sinceTitle: 'Events Since Last Visit',
          sinceState: 'since {time}',
          workTitle: 'Active Tasks & Ownership',
          workNone: 'No work item is in progress.',
          nextMeeting: 'Next meeting',
          lastMeeting: 'Last meeting',
        },
        work: {
          title: 'Work items',
          subtitle: 'Every open work item of the company memory with its owner, state, priority, due date and the results of its scenarios; the title opens it in the graph.',
          item: 'Work item',
          kind: 'Kind',
          owner: 'Owner',
          status: 'State',
          priority: 'Priority',
          due: 'Due',
          scenarios: 'Scenarios',
          updated: 'Updated',
          none: 'No open work item.',
          all: 'All owners',
        },
        meetings: {
          subtitle: 'The meetings of the AI colleagues as Veridion Core records them: slot, summary and the commitments that became work.',
          slot: 'Slot',
          kind: 'Kind',
          started: 'Started',
          ended: 'Ended',
          summary: 'Summary',
          commitments: 'Commitments',
          hold: 'Hold a meeting now',
          held: 'The meeting was called.',
          notHeld: 'A meeting runs or was held within the last half hour.',
          holdFailed: 'The meeting could not be called',
          none: 'No meeting recorded yet.',
        },
        research: {
          title: 'Research',
          subtitle: 'The research of the AI colleagues from the company\'s timeline, newest first.',
        },
        attention: {
          toneError: 'Failure',
          toneWarning: 'Notice',
          state: {
            platform: '{ready} of {workloads} workloads ready, {nodes} of {total} nodes ready, {restarts} restarts.',
            gateway: '{state}; {models} models routed, {backends} of {total} serving backends ready.',
            engine: '{engine}: {running} running, {waiting} waiting',
            usage: '{tokens} tokens over {identities} identities in the window {window}.',
            smtm: 'Prediction gate {gate}, rebuild {rebuild}; {online} of {models} models online, {failed} failed.',
            smtmSignals: '{open} open signals, {resolved} resolved, {failed} deliveries failed.',
            smtmVeridion: '{connected} of {servers} MCP servers connected.',
            company: 'Orchestrator {status}; {ready} of {workloads} workloads ready; Veridion Core {core}; {agents} agents running, {waiting} waiting.',
            companyWebex: '{registered} of {bots} bot webhooks registered.',
            approvals: '{approvals} open approvals; {tasks} coding tasks wait for a person or a review.',
            sessions: '{users} signed-in users, {sessions} sessions, {mfa} verified, {total} accounts.',
            mail: 'SMTP {state}.',
          },
          platformUnreadable: 'The platform state cannot be read.',
          nodeNotReady: 'Node {name} is not ready.',
          nodePressure: 'Node {name} reports pressure: {pressure}.',
          workloadDown: '{name} ({namespace}): {ready} of {desired} ready.',
          gatewayNotProgrammed: 'The AI gateway is not programmed.',
          smtmGateClosed: 'The prediction gate is closed.',
          smtmRebuild: 'A rebuild is marked.',
          smtmHint: 'Data status: {hint}.',
          smtmDeliveryFailed: '{count} signal deliveries failed.',
          smtmModelsFailed: '{count} models report an error.',
          mcpUnreachable: 'MCP server {server} of {instance} is unreachable.',
          partUnavailable: 'Veridion pAIoneer Labs GmbH: {part} does not answer.',
          parts: {
            orchestrator: 'orchestrator',
            webex: 'Webex bridge',
            knowledge: 'knowledge base',
            core: 'Veridion Core',
            mcp: 'MCP servers',
            usage: 'usage ledger',
            gateway: 'gateway usage',
          },
          emergencyStop: 'The emergency stop of Veridion Core is on.',
          coreMisconfigured: 'Veridion Core is missing settings: {missing}.',
          agentsWaiting: '{count} agents are waiting for an answer.',
          hostedNotRunning: '{agent} is not running.',
          webhookMissing: 'The webhook of {bot} is not registered.',
          readerNotAuthorised: 'Reading the company spaces is not authorised.',
          approvalOpen: 'Open approval ({position}): {question}',
          taskWaiting: 'Coding task waits for a person: {title}',
          taskReview: 'Merge request ready for review: {title}',
        },
      },
      ops: {
        showDetails: 'Details',
        hideDetails: 'Close',
        mcpVersion: 'Version',
        mcpUrl: 'Address',
        mcpProtocol: 'Transport and protocol',
        mcpLastRefresh: 'Last queried',
        mcpError: 'Error',
        noTools: 'No tools reported.',
        toolServer: 'Source',
        toolAccess: 'Access',
        toolBuiltIn: 'Veridion',
        accessReadOnly: 'reads',
        accessWrites: 'writes',
        accessDestructive: 'changes data',
        accessUndeclared: 'not declared',
        usageTitle: 'Usage',
        smtmUsageSubtitle: 'Model calls, tokens and provider-reported cost of the last 30 days.',
        usageByPerson: 'Per person',
        usageByModel: 'Per model',
        usageByDay: 'Per day',
        model: 'Model',
        day: 'Day',
        promptTokens: 'Input tokens',
        completionTokens: 'Output tokens',
        noUsage: 'No usage booked.',
        runtimeTitle: 'Runtime',
        runtimeSubtitle: 'How the orchestrator of this instance reaches its models and connects its tools.',
        executionMode: 'Execution',
        providerProtocol: 'Model protocol',
        contextWindow: 'Context window',
        requestTimeout: 'Timeout per request',
        diagnostics: 'Diagnostics',
        diagnosticsOn: 'on',
        diagnosticsOff: 'off (performance mode)',
        externalServers: 'Connected MCP servers',
        mcpEndpoint: 'MCP endpoint',
        workloadsTitle: 'Workloads',
        workloadsSubtitle: 'The workloads in the namespace paioneer-veridion as Kubernetes reports them.',
        botsTitle: 'Bots',
        botsSubtitle: 'The bots of the organisation, each with its webhook, and the services of the bridge.',
        botAddress: 'Address',
        cardWebhook: 'Card webhook',
        webhookState: 'State',
        noBots: 'The bridge reports no bots.',
        bridgeServices: {
          knowledgeBase: 'Knowledge base',
          webResearch: 'Web research',
          osint: 'OSINT',
          anonymizer: 'Anonymisation',
        },
        connected: 'connected',
        notConnected: 'not connected',
        activeRooms: 'Active rooms',
        allowedRooms: 'Allowed rooms',
        surface: 'Surface',
        missingSettings: 'Missing settings',
        none: 'none',
        instanceToolsTitle: 'Orchestrator tools',
        instanceToolsSubtitle: 'The tools the orchestrator of the company instance has registered.',
        openMailbox: 'Mailbox',
        positionMailboxHint: 'AI colleagues work hand-overs from other AI colleagues; work for an AI colleague is given in its Webex space.',
        mailboxesTitle: 'Mailboxes',
        mailboxesSubtitle: 'Per agent, what waits in its mailbox, was delivered and was read. A click on a row filters the messages.',
        readAt: 'Read at',
        refresh: 'Refresh',
        mailbox: 'Mailbox',
        mailboxKind: 'Kind',
        mailboxKinds: {
          position: 'AI colleague',
          hosted: 'Hosted agent',
          graph: 'Agent',
        },
        lastMessage: 'Last message',
        noMailboxes: 'No mailbox can be read.',
        messagesTitle: 'Messages',
        messagesSubtitle: 'Messages, commands and hand-overs, newest first. A click shows the full text.',
        allMailboxes: 'All mailboxes',
        allStates: 'All states',
        time: 'Time',
        from: 'From',
        to: 'To',
        messageKind: 'Kind',
        content: 'Content',
        reply: 'Reply',
        noMessages: 'No messages.',
        messageKinds: {
          message: 'Message',
          handover: 'Hand-over',
          command: 'Command',
          resume: 'Resume',
          subagent_result: 'Result of a sub-agent',
          review: 'Review',
        },
        buildsTitle: 'Builds',
        buildsSubtitle: 'The images Veridion Core built for agents, newest first.',
        image: 'Image',
        started: 'Started',
        finished: 'Finished',
        noBuilds: 'No builds.',
        coreToolsTitle: 'Agent tools',
        coreToolsSubtitle: 'The orchestrator tools Veridion Core offers its agents.',
        description: 'Description',
        coreDailyTitle: 'Usage per day and model',
        coreDailySubtitle: 'Model calls of Veridion Core in the last 30 days, per agent and model.',
        coreActivityTitle: 'Veridion Core activity',
        coreActivitySubtitle: 'Events of the agents, AI colleagues and hand-overs in Veridion Core, newest first.',
        event: 'Event',
        tool: 'Tool',
        detail: 'Detail',
      },
      tabCompanyMemory: 'Company memory',
      llmPaper: {
        subtitle: 'The generated scientific description of the sovereign model architecture — rendered from the paper document Veridion Core maintains for the active specification.',
        summaryTitle: 'What this page shows',
        summaryBody: 'Veridion Core maintains a generated scientific document for the active model architecture: title, abstract, numbered sections, architecture diagram, tables and references come unchanged from the backend; design values are labeled as such, and the page invents nothing.',
        refresh: 'Refresh',
        exportPdf: 'Export as PDF',
        strandTraining: 'training',
        strandSelected: 'selected',
        lcTitle: "Implementation & lifecycle",
        lcSelectedTrains: "trains next",
        lcCollectsOnly: "collects & prepares — never starts",
        lcSpec: "Specification",
        lcFrozen: "frozen",
        lcArtifacts: "Artifacts (tokenizer/codec)",
        lcReleased: "released",
        lcNotReleased: "not yet built",
        lcCodecOpen: "codec open",
        lcData: "Data thresholds",
        lcThresholdsMet: "met",
        lcAreasReached: "data plan: {met} of {total} areas reached",
        lcNoLake: "data lake unavailable",
        lcStage_trainer_image: "Trainer image",
        lcStage_sealed_tdv: "TDV sealed",
        lcStage_compat_all_green: "Compatibility ALL-GREEN",
        lcStage_vram_budget: "VRAM budget",
        lcTraining: "Training",
        lcAuto: "starts automatically once thresholds are met",
        lcBench: "Benchmark",
        lcBenchRows: "measurements",
        lcNoneYet: "none yet",
        lcRelease: "Export · Hugging Face (private) · registry",
        lcReleaseRows: "artifacts",
        lcReleaseNote: "after training: private-verified upload + registry entry",
        lcPipeline: "Training pipeline",
        lcDone: "done",
        lcActive: "active",
        lcWaiting: "waiting",
        lcBlocked: "blocked",
        lcCapability: "Capability",
        lcSamples: "Samples",
        lcByLanguage: "by language",
        lcForeign: 'other strand',
        lcCorpus: 'Corpus tokens',
        lcCorpusNone: 'not tokenized yet',
        loading: 'Loading …',
        unavailable: 'The paper document is unreachable.',
        noPaper: 'This Veridion Core version does not serve a paper document yet. The page therefore shows nothing invented.',
        abstract: 'Abstract',
        references: 'References',
        appendix: 'Appendix',
        figure: 'Figure',
        lastUpdated: 'Last updated',
        empty: 'No entries.',
      },
      llmMonitor: {
        summary: "Operations view of the model: status, data, GPU, kernels and throughput, evaluations and events — measured from Veridion Core and the data lake, nothing invented.",
        archTitle: 'Architecture status',
        archSubtitle: "The active architecture with its data-interface state and freeze state.",
        version: 'Version',
        codename: 'Codename',
        statusLabel: 'Status',
        interfaceStatus: 'Data interface',
        specSha: 'Specification hash (SHA-256, shortened)',
        promotedAt: 'Promoted',
        frozenLabel: 'Frozen',
        frozenYes: 'Yes',
        frozenNo: 'No',
        stateWord_active: "active",
        stateWord_draft: "draft",
        stateWord_released: "released",
        stateWord_candidate: "candidate",
        stateWord_retired: "retired",
        gpuModel: "Graphics card",
        gpuTotal: "Total graphics memory",
        gpuWindow: "Training window (measured)",
        gpuMeasuredAt: "Measured at",
        gpuSource: "Measurement source",
        gpuServing: "Serving",
        gpuInferenceTarget: "Single-card inference target",
        vramTitle: 'GPU & VRAM budget',
        vramSubtitle: 'The measured VRAM budget of the graphics card as Veridion Core maintains it.',
        vramNone: 'No VRAM budget in the record.',
        gateTitle: 'Promotion gate',
        gateSubtitle: 'The policy by which a candidate architecture replaces the active one, with the required metrics and their weights.',
        metric: 'Metric',
        weight: 'Weight',
        gateNone: 'No required metrics recorded.',
        candidatesTitle: 'Candidates',
        candidatesNone: 'No candidate architectures.',
        evidenceTitle: 'Evaluations',
        evidenceNone: 'No measured evaluations yet.',
        benchmark: 'Benchmark',
        suite: 'Suite',
        score: 'Score',
        evaluator: 'Evaluator',
        date: 'Date',
        changelogTitle: 'Changelog',
        changelogNone: 'No architecture versions in the history yet.',
        summaryLabel: 'Summary',
        createdAt: 'Created',
        supersededAt: 'Superseded',
        eventsTitle: 'Events',
        eventsNone: 'No events recorded.',
        implTitle: 'Strand implementation status',
        implSubtitle: "Measured facts: data-interface artifacts, selection, token corpus and vector index; the data plan per area is in the situation picture.",
        implSelected: 'Training strand',
        implSelectedYes: 'selected — trains next',
        implSelectedNo: 'prepares only (never starts)',
        implTokenizer: 'Tokenizer artifact',
        implCodec: 'Codec artifact',
        implNotReleased: 'not yet released',
        implCapability: 'Capability',
        implSamples: 'Samples (measured/target)',
        implNoDatalake: 'The sample progress is briefly unreadable (data-lake interface unreachable).',
        implSwitchHint: 'The training-strand selection is switched on the training page.',
        implSituationLink: "Where the data stands and what the training still lacks: the situation picture on the training page",
        kernelTitle: 'Kernel acceleration & throughput',
        kernelSubtitle: 'What the kernel probe measured on the card: every kernel against its reference, the attention backend, the throughput of the selected specification — and the time plan from measured tokens and measured throughput.',
        kernelNone: 'No kernel probe has run on this card yet; nothing is assumed.',
        kernelName: 'Kernel',
        kernelVerified: 'Proven',
        kernelYes: 'yes',
        kernelNo: 'no',
        kernelSpeedup: 'Speed-up',
        kernelMaxErr: 'Max. error',
        kernelError: 'Finding',
        kernelAttention: 'Attention backend',
        kernelDocMask: 'Document-boundary masking',
        kernelThroughput: 'Measured throughput (tokens/s)',
        kernelMicroBatch: 'Micro-batch',
        kernelMeasuredAt: 'Measured at',
        kernelImage: 'Trainer image (digest)',
        kernelRunPath: 'Kernel path of the latest run',
        kernelRunNone: 'No training run with kernel facts yet.',
        kernelPlanTitle: 'Time plan (arithmetic over measurements)',
        kernelPlanTokens: 'Token mass',
        kernelPlanTokensSource: 'Source of the token mass',
        kernelPlanDays: 'Projected days for one pass',
        kernelPlanNone: 'Not measured yet — without measured throughput or measured token mass no time plan is invented.',
        kernelSourceTdv: 'sealed train data version',
        kernelSourceCorpus: 'corpus so far (not sealed)',
        kernelSourcePlan: "the paper's budget",
        implForeign: 'belongs to another strand',
        implIndex: 'Vector index (graph linking)',
        implIndexNone: 'no index reported',
        implIndexDown: 'configured, not answering',
        implIndexPoints: 'points',
        implIndexBackfillDone: 'backfill complete',
        implIndexBackfillOpen: 'backfill in progress',
        implIndexLink: 'Index and deduplication in the lake monitor',
        implCorpus: 'Token corpus (raw text)',
      },
      software: {
        arch: {
          execTitle: "Sovereign model architecture",
          execSubtitle: "The single active architecture specification from Veridion Core: every figure is either backed by a referenced measurement artifact or labeled by the backend as a design target (unverified).",
          openDatalake: "Open Data Lake & AI model training",
          unavailableArch: "The architecture data is unreachable.",
          frozen: "Frozen — a training run is active",
          notFrozen: "Cleared (Phase A)",
          version: "Version",
          codename: "Codename",
          statusLabel: "Status",
          createdAt: "Created",
          promotedAt: "Promoted",
          specSha: "Specification hash (SHA-256)",
          contextWindow: "Context window (design, tokens)",
          dataInterface: "Data interface",
          diStatus: {
            draft: "draft",
            complete: "complete",
            missing: "missing",
          },
          paramsTitle: "Parameter ledger",
          trainingVramTitle: "Training VRAM (declared, GB)",
          inferenceTitle: "Inference VRAM (declared, GB)",
          declaredTotal: "Declared total",
          budgetTitle: "GPU VRAM budget (measured)",
          budgetGpu: "GPU",
          budgetTotal: "Total VRAM (MiB)",
          budgetFreed: "Free training budget (GB)",
          budgetInferenceTarget: "Single-GPU inference target (GB)",
          diagramTitle: "Generated architecture diagram",
          diagramSubtitle: "Deterministically generated from the stored specification; no handwritten diagram exists beside the data.",
          noDiagram: "The response carries no diagram.",
          stagesTitle: "Architecture stage layout",
          stagesSubtitle: "Straight from the stored specification; parameter figures are design values.",
          stageCol: "Stage",
          layersCol: "Layers",
          mechanismCol: "Mechanism",
          paramsCol: "Physical parameters (B) & primary sources",
          paramsCross: "cross-cutting — counted inside the stages",
          researchTitle: "Quantum & Frontier AI Research Repository",
          researchSubtitle: "Live rows from the Veridion Core research archive; new publications arrive through the quantum colleague's tool, each with its origin visible.",
          researchEmpty: "No publication in the archive yet.",
          evidenceTitle: "Evaluation evidence",
          evidenceSubtitle: "Only measured, referenced evaluations appear here; without evidence there is no score.",
          evalMetric: "Metric",
          evalBenchmark: "Benchmark",
          evalSuite: "Suite",
          evalScore: "Score",
          evalEvaluator: "Evaluator",
          evalDate: "Measured at",
          evalArtifact: "Evidence artifact",
          gateTitle: "Promotion rules (evidence gate)",
          gateMetrics: "Required metrics",
          gateEpsilon: "Tolerance (epsilon)",
          gateConfigVersion: "Gate configuration (version)",
          candidatesTitle: "Candidate queue",
          candidatesSubtitle: "Submitted architecture candidates with the state of their evidence; submissions come from the research runtime, never from the dashboard.",
          candidateSubmittedBy: "Submitted by",
          candidateEvidence: "Evidence (present / required)",
          candidatesEmpty: "No candidate submitted.",
          changelogTitle: "Design changelog",
          changelogSubtitle: "Superseded design iterations — deliberately without figures: none were ever measured for them.",
          changelogSummary: "Summary",
          changelogEmpty: "No superseded design.",
          supersededAt: "Superseded at",
          eventsTitle: "Gate events",
          eventsSubtitle: "Submissions, promotions, rejections and freeze transitions as the gate recorded them.",
          eventsEmpty: "No event yet.",
        },
        title: 'Software development',
        subtitle: 'The coding agent\'s tasks, the company\'s GitLab with its sync from Azure DevOps, the merge requests waiting for review and the limits of the GitLab node.',
        openGitlab: 'Open GitLab',
        openSonar: 'Open SonarQube',
        loading: 'Loading …',
        failed: 'Operation failed',
        done: 'Done',
        unavailable: 'Not reachable',
        capacityTitle: 'GitLab node',
        capacitySubtitle: 'The guard sets the node\'s limits every minute from the load of the server; production keeps its reserve.',
        stateLabel: 'State',
        memory: 'Memory',
        cpu: 'CPU',
        disk: 'Disk',
        hostFree: 'Free on the server',
        reserve: 'Reserve for production',
        codingSlots: 'Coding tasks at once',
        pipelineQuota: 'Pipeline jobs',
        recentActions: 'Recent actions of the guard',
        syncTitle: 'Sync from Azure DevOps',
        syncSubtitle: 'The GitLab master follows the Azure master; commits only GitLab held are kept under a tag replaced/<time>.',
        syncNow: 'Sync now',
        syncStarted: 'Sync started',
        azureCommit: 'Azure master',
        gitlabCommit: 'GitLab master',
        lastChange: 'Last change',
        lastRun: 'Last run',
        replaced: 'Kept under tags',
        noneReplaced: 'nothing',
        jobs: 'Recent runs',
        error: 'Error',
        readyTitle: 'Merge requests ready for review',
        readySubtitle: 'Only merge requests with a green pipeline; merge them in GitLab.',
        noReady: 'No merge request waits for review.',
        tasksTitle: 'Coding tasks',
        tasksSubtitle: 'Every piece of the coding agent\'s programming work with its state, merge request and tokens.',
        showFinished: 'Show finished tasks',
        task: 'Task',
        requester: 'Asked by',
        statusLabel: 'State',
        mergeRequest: 'Merge request',
        pipeline: 'Pipeline',
        tokens: 'Tokens',
        updated: 'Updated',
        noTasks: 'No coding task yet.',
        phase: 'Step',
        repository: 'Repository',
        branch: 'Branch',
        openQuestion: 'Open question',
        result: 'Result',
        sendMessage: 'Write to the task',
        answerQuestion: 'Answer the question',
        urgent: 'Urgent: steer the current step at once',
        send: 'Send',
        messageSent: 'Delivered to the task',
        confirmCancel: 'Cancel this task? An open merge request is closed.',
        course: 'Course of the session',
        messages: 'Messages',
        events: 'Events',
        none: 'none',
        close: 'Close',
        newTitle: 'New task',
        newSubtitle: 'Give the coding agent a task from here; follow it here and on its Webex card.',
        brief: 'What should the agent do?',
        issue: 'YouTrack issue (optional)',
        create: 'Create task',
        created: 'Task created',
        usersTitle: 'Administrators in GitLab',
        usersSubtitle: 'Every administrator has a GitLab user with administrator rights; the housekeeping keeps them in step with Keycloak.',
        email: 'E-mail',
        gitlabUser: 'GitLab user',
        lastHousekeeping: 'Last housekeeping',
        sonarDeleted: 'SonarQube projects of deleted branches removed',
        previewsTitle: 'Projects in development',
        previewsSubtitle: 'Every project in development runs exactly once, from its first merge: Veridion Core starts the newest green state of the main branch (migration or master) in containers behind the administrator sign-in, renews it with every green pipeline, and the containers are started, stopped and restarted here. A project whose pipeline builds nothing that runs stands here with the reason.',
        previewsSummaryTitle: 'What this view shows',
        previewsSummaryBody: 'Every project in development runs as its own preview container behind the administrator sign-in. The list above shows each project\'s newest runnable state, the table below the running containers with state, address and controls: open, start, stop, restart.',
        previewProject: 'Project',
        previewState: 'Running state',
        previewSince: 'Since',
        previewAddress: 'Address',
        previewMergedAt: 'Merged',
        noPreviews: 'No project is running.',
        reasonsLabel: 'Blocking Causes & Diagnostics',
        noProjects: 'No project in development.',
        qualityCoverage: 'Coverage',
        qualityBugs: 'Bugs',
        qualitySmells: 'Code smells',
        qualityDuplication: 'Duplication',
        qualityHotspots: 'Open hotspots',
        qualityUnavailable: 'No SonarQube measures',
        openPreview: 'Open',
        startPreview: 'Start containers',
        stopPreview: 'Stop containers',
        previewStarted: 'Containers started',
        previewStopped: 'Containers stopped',
        restartPreview: 'Restart containers',
        previewRestarted: 'Containers restarted',
        previewControl: 'Containers',
        resultTitle: 'Result in GitLab',
        resultJobs: 'Jobs and artifacts',
        resultSonar: 'SonarQube',
        resultDelivered: 'Delivered',
        previewStatus: {
          starting: 'starting',
          running: 'running',
          stopped: 'stopped',
          failed: 'failed',
        },
        capacityStates: {
          ok: 'within limits',
          tight: 'tight: production needs the room',
          full: 'full: no new work',
          node_down: 'node not running',
        },
        status: {
          queued: 'waiting for a free slot',
          working: 'working',
          waiting: 'waiting for an answer',
          review: 'in review',
          merged: 'merged in GitLab',
          done: 'done',
          needs_person: 'needs a person',
          rejected: 'closed without merge',
          paused: 'paused',
          cancelled: 'cancelled',
          failed: 'failed',
        },
        commands: {
          pause: 'Pause',
          resume: 'Resume',
          cancel: 'Cancel',
        },
        repositoryChoice: {
          auto: 'The agent decides',
          company: '{project} (merged by a person)',
          own: 'A project of its own in {group}',
        },
        userState: {
          ok: 'in step',
          created: 'created',
          unblocked: 'unblocked',
          'made administrator': 'made administrator',
          blocked: 'blocked',
        },
      },
      org: {
        write: 'Write',
        call: "Call",
        callTitle: "Call with {bot}",
        writeTitle: 'Message to {bot}',
        callConfirmEnd: 'End the call?',
        callSubtitle: 'The microphone runs for the length of the call. The bot greets in its voice, answers briefly, asks back on open points and can be interrupted. Every sentence also stands in Webex, in the direct room with the bot.',
        callRinging: "Ringing …",
        callConnected: "Connected",
        callEnded: "Ended",
        callEndedHangup: "You hung up",
        callEndedClosed: "The connection was closed",
        callEndedSilence: "90 seconds of silence",
        callEndedLimit: "The bound of 30 minutes was reached",
        callEndedError: "An error ended the call",
        callHangUp: "Hang up",
        callLevel: "Microphone level",
        callYou: "You",
        callSpeaking: "The bot is speaking …",
        callThinking: 'The answer is being generated …',
        callOvertaken: "overtaken by your next question, not spoken",
        callNothingHeard: "No words were heard.",
        callMicDenied: "The browser refused the microphone; allow it for this page and call again.",
        callNoVoice: "The voice is not available right now; the answer stands as text.",
        callRefused: "The call was not accepted: the ticket was invalid or expired; call again.",
        callFailed: "The call failed",
        voice: "Voice",
        voiceHint: "The voice this colleague speaks with, in Webex when a person asks to hear the answer and on the phone. The default is a speaker of the audio model at OpenRouter; an own, cloned voice from the voice store speaks through the platform's voice engine.",
        voiceSave: "Save voice",
        voiceDefault: "default",
        voiceNone: "no voice",
        voiceCloud: "OpenRouter speakers (default)",
        voiceOwn: "Own voices (cloned)",
        voiceUploadTitle: "Upload a voice sample for this colleague",
        voiceUploadHint: "Audio or video, at most 25 MB; the Core converts the sample, keeps up to 20 seconds, hears its words and stores only the reference clip. The colleague speaks with this voice at once.",
        voiceUploadName: "Name of the voice",
        voiceUploadConsent: "I confirm that I have the right to use this voice for the company: it is my own, or the person has agreed.",
        voiceUploadButton: "Upload sample",
        voiceUploadDone: "Voice stored",
        voiceTooLarge: "The file is larger than 25 MB.",
        voicesTitle: "Voices",
        voicesSubtitle: "Every voice of the company is a reference clip in Veridion Core's voice store; the voice engine clones it whenever a bot speaks. The nine former speakers stand in it as captured clips.",
        voiceSeconds: "Seconds",
        voiceSource: "Source",
        voiceSourcePreset: "captured speaker",
        voiceSourceUpload: "uploaded sample",
        voiceAddedBy: "Added by",
        voiceConsentBy: "Consent confirmed by",
        voiceWords: "Words of the clip",
        voiceDelete: "Delete",
        voiceConfirmDelete: "Delete this voice? Colleagues using it speak with their default voice again.",
        voiceCapture: "Capture the preset engine's speakers",
        voiceCaptureHint: "Speaks one fixed sentence per speaker through the preset engine and stores it as a clip; runs before the engine is switched.",
        voiceCaptured: "Captured",
        voiceEnginePresets: "The voice engine offers fixed speakers; the voice store is not used.",
        chartTitle: "Organisation chart",
        executiveTitle: 'Executive layer',
        unitsTitle: 'Business units',
        unitLead: 'Lead',
        unitSupporting: 'Supported by',
        unitMission: 'Mission',
        unitPrefix: 'Thread prefix',
        standingActive: 'active',
        standingStandby: 'standby',
        standbyOn: 'Put on standby',
        standbyOff: 'Activate',
        standbyHint: 'On standby a colleague takes no turn of the company\'s own making and costs no tokens; a person\'s direct message is still answered.',
        confirmStandby: 'Put {name} on standby?',
        confirmActivate: 'Activate {name}?',
        activity: 'Activity',
        runtime: 'Runtime',
        modelCloud: 'cloud model',
        modelGpu: 'company engine',
        callModel: 'Phone model',
        calls30: 'Calls, last 30 days',
        telemetryLine: '{model} · {prompt}+{completion} tokens · {cost} · ear {asr} ms · mind {llm} ms · voice {tts} ms · total {total} ms{deferred}',
        telemetryDeferred: ' · {count} deferred',
        chartSubtitle: "Veridion's AI colleagues: agents in Veridion Core, each reachable as its own Webex bot, by area; above them the human decision makers, below them the agents without a bot of their own and the company spaces, read live from Veridion Core and Webex.",
        chartPeople: "Human decision makers",
        chartPeopleText: "The human decision makers decide everything and act in {space}.",
        chartAgentsTitle: "Agents without a bot of their own: the coding agent, the Veridion MCP orchestrator and the agents the architect builds work on behalf of an AI colleague and speak through its bot",
        chartDesigned: "Agents designed with the architect",
        chartFor: "On behalf of",
        chartSystemsTitle: "Connected systems",
        chartSpaceHome: "Home of",
        chartSpacePurpose: "Purpose",
        chartRoomsTitle: "Company spaces in Webex",
        room: "Space",
        roomBots: "Bots",
        positionsTitle: "AI colleagues",
        positionsSubtitle: "Each AI colleague answers through its own bot and reads its spaces. Its description is the instruction it works by.",
        bot: "Bot",
        position: "Job",
        statusLabel: "Status",
        tokensUsed: "Tokens used",
        tokens30: "Tokens, last 30 days",
        edit: "Edit",
        close: "Close",
        description: "Description of the AI colleague",
        save: "Save",
        resetDescription: "Restore the default description",
        interests: "Interest profile",
        interestsHint: "Which kinds of items and topics concern this AI colleague and when it is not concerned. The AI colleague measures every message in its spaces against it.",
        threshold: 'Threshold for unprompted contributions',
        thresholdHint: 'From 1 to 5: how strongly a message must concern the AI colleague before it speaks up unasked. At 1 it speaks up at low relevance, at 5 only at high relevance.',
        saveProfile: "Save profile",
        tools: "Tools",
        decisionMakersTitle: "Decision makers",
        decisionMakersSubtitle: "Each of them can give every approval and answer every question of an AI colleague in Webex.",
        email: "Mail address",
        add: "Add",
        remove: "Remove",
        confirmRemove: "Remove this decision maker?",
        readerTitle: "Reading the company spaces",
        readerSubtitle: "A bot sees only the messages that mention it. Veridion reads every message of the company spaces through the authorisation of an account that is a member of all of them.",
        notConfigured: "The integration is not configured",
        authorised: "Authorised",
        notAuthorised: "Not authorised",
        account: "Account",
        validUntil: "Access token valid until",
        renewUntil: "Authorisation renewable until",
        authorise: "Authorise reading",
        authoriseAgain: "Authorise again",
        linkOpened: "The Webex sign-in opened in a new tab.",
        found: "found",
        notFound: "not found",
        botsInSpace: "bots",
        transcripts: "Meeting transcripts",
        yes: "yes",
        no: "no",
        approvalsTitle: "Open approvals",
        approvalsSubtitle: "Approvals and questions the AI colleagues asked for and no decision maker has answered yet.",
        originSpace: "Space",
        directRoom: "direct room",
        approvalKinds: { review: "approval", question: "question" },
        schedulesTitle: "Schedules",
        schedulesSubtitle: "Recurring work people asked for in a space; it runs until someone ends it.",
        createdBy: "asked for by",
        lastRun: "last run",
        end: "End",
        confirmEnd: "End this schedule?",
        none: "None",
        loading: "Loading…",
        failed: "Failed",
        working: "Working…",
        done: "Done",
        memoryTitle: "Organisation",
        memorySubtitle: "The people and AI colleagues of the company with the memory scope each AI colleague works in.",
        memoryMember: "Member",
        area: "Area",
        decisionMaker: "Decision maker",
        status: { running: "running" },
      },
      core: {
        conversationTitle: 'Conversation from the dashboard',
        conversationHint: 'Every message and answer is also said in Webex: in the thread of the agent\'s work, otherwise in your direct room with the bot.',
        conversationEmpty: 'No message from the dashboard yet.',
        writeToAgent: 'Message to this agent',
        answerPending: 'Answer pending',
        title: 'Veridion Core',
        subtitle: 'The agentic operating system behind the company bot: its agents, their messages and token usage, the definitions, the architect and the organisation.',
        done: 'Done.',
        failed: 'Operation failed',
        loading: 'Loading …',
        working: 'Working …',
        none: 'None.',
        unavailable: 'Veridion Core cannot be reached',
        errors: {
          AGENT_FINISHED: 'The agent has finished and takes no more messages',
          EMERGENCY_STOP: 'The emergency stop is on',
          DEFINITION_INVALID: 'The definition is not valid',
          TOO_MANY_AGENTS: 'Too many agents are running',
          VERIDION_CORE_NOT_CONFIGURED: 'Veridion Core is not configured',
          MESSAGE_EMPTY: 'The message is empty',
        },
        status: {
          building: 'building image',
          starting: 'starting',
          running: 'running',
          waiting: 'waiting',
          idle: 'idle',
          paused: 'paused',
          completed: 'completed',
          failed: 'failed',
          cancelled: 'cancelled',
          stopped: 'stopped',
          not_deployed: 'not deployed',
        },
        statusLabel: 'Status',
        owner: 'Owner',
        definition: 'Definition',
        parent: 'Parent',
        tokens: 'Tokens',
        progress: 'Progress',
        close: 'Close',
        openQuestion: 'Open question',
        result: 'Result',
        answerQuestion: 'Answer the question',
        sendMessage: 'Message into the agent',
        urgent: 'Urgent: interrupt the current step',
        send: 'Send',
        messageSent: 'Delivered to the agent.',
        commands: {
          pause: 'Pause',
          resume: 'Resume',
          cancel: 'Cancel',
          kill: 'Kill',
        },
        confirmKill: 'Kill this agent and its sub-agents immediately?',
        subAgents: 'Sub-agents',
        graph: 'Graph',
        messages: 'Messages',
        messageStatus: {
          queued: 'queued',
          delivered: 'delivered',
          consumed: 'read',
          refused: 'refused',
        },
        events: 'Events',
        containerLog: 'Container log',
        version: 'Version',
        activeAgents: 'Running agents',
        updated: 'Updated',
        archived: 'archived',
        noDefinitions: 'No definitions yet.',
        versions: 'Versions',
        from: 'from',
        startInput: 'Start input as JSON',
        agentStarted: 'Agent started.',
        startAgent: 'Start agent',
        editAsJson: 'Edit as JSON',
        confirmArchive: 'Archive this definition? Running agents keep running.',
        archive: 'Archive',
        definitionJson: 'Definition as JSON',
        definitionJsonHint: 'A definition in the Veridion graph language. Validate shows its issues and its graph; saving stores it as a new approved version.',
        checked: 'Checked.',
        validate: 'Validate',
        saved: 'Saved as a new version.',
        saveVersion: 'Save as new version',
        valid: 'The definition is valid.',
        you: 'You',
        architect: 'Architect',
        architectPlaceholder: 'Describe what the agent should do …',
        newDesign: 'New design',
        unitKinds: {
          company: 'company',
          department: 'department',
          team: 'team',
          project: 'project',
        },
        partOf: 'part of',
        confirmRemove: 'Remove this unit? Its members lose this scope.',
        remove: 'remove',
        addUnit: 'Add a unit',
        unitId: 'Id (lowercase, dashes)',
        unitName: 'Name',
        add: 'Add',
        addMember: 'Add a member',
        memberKinds: {
          person: 'person (mail address)',
          agent: 'agent (id)',
          definition: 'definition (id)',
        },
        memberId: 'Mail address or id',
        role: 'Role',
        confirmEmergencyOn: 'Stop every agent now? The bot keeps answering.',
        confirmEmergencyOff: 'Release the emergency stop?',
        emergencyStop: 'Emergency stop',
        emergencyRelease: 'Release emergency stop',
        emergencyActive: 'emergency stop is on',
        autopilotOn: 'Switch autopilot on',
        autopilotOff: 'Switch autopilot off',
        autopilotActive: 'Autopilot is active: Veridion Core answers every card to the people itself',
        autopilotUnitsTitle: 'Autopilot by business unit',
        autopilotUnitsHint: 'Switches the autopilot on or off individually for each business unit and the executive layer. Held work is never touched.',
        autopilotUnitOn: 'Autopilot on',
        autopilotUnitOff: 'Autopilot off',
        limitsBuilds: 'Image builds per colleague and day',
        limitsDesigns: 'Agent designs per colleague and day',
        limitsSave: 'Set daily limits',
        limitsNone: '0 = no limit',
        confirmAutopilotOn: 'Switch the autopilot on? Veridion Core\'s own decision maker then answers every open and every new card in pAIoneer-humans-and-bots at once, visibly in the card\'s thread.',
        confirmAutopilotOff: 'Switch the autopilot off? From then on the people decide again.',
        model: 'Model',
        codingModel: 'Coding model',
        modelsTitle: 'Models by role',
        modelsSubtitle: 'Which model each role of Veridion Core thinks on: the company\'s face and steering, the phone, the architect and the judge of requirements engineering\'s verdicts. Only models the gateway routes can be chosen; empty means the configuration\'s default.',
        roleCoordinator: 'Coordinator (face and steering)',
        roleCall: 'Phone',
        roleArchitect: 'Architect',
        roleRequirementsJudge: 'Requirements judge',
        roleJudge: 'Core judgements',
        roleEar: 'Telephony Speech-to-Text (STT)',
        roleStt: 'Webex Speech-to-Text (STT)',
        modelGroupVllm: 'vLLM (own card)',
        modelGroupAudio: 'Audio (own card / cloud)',
        modelGroupCloud: 'OpenRouter (cloud)',
        directLlmTitle: 'Direct LLM access',
        directLlmSubtitle: 'Talk to a vLLM or cloud model directly, without bots, agents or Webex',
        directLlmHint: 'Admin direct access: the chosen model answers raw, booked under “console”, with no lanes, roles or tools.',
        directLlmModel: 'Model',
        directLlmSystem: 'System prompt (optional)',
        directLlmSystemPlaceholder: 'e.g. You are …',
        directLlmPrompt: 'Message',
        directLlmPromptPlaceholder: 'What do you want to ask the model directly?',
        directLlmSend: 'Send',
        directLlmSending: 'Sending …',
        directLlmUsage: '{prompt}+{completion} tokens · {cost}',
        modelCurrent: 'In use',
        modelDefault: 'Default',
        modelChosen: 'Chosen',
        modelDefaultOption: 'the configuration\'s default',
        modelNotRouted: 'not routed by the gateway',
        modelSave: 'Save',
        engineSilver: 'Company engine (silver)',
        engineGold: 'Company engine (gold, the orchestrator\'s)',
        callsTitle: 'Phone calls',
        callsSubtitle: 'Every spoken turn of the phone, booked apart from the colleagues\' work: tokens, cost and the time the ear, the mind and the voice took, per colleague and model, for the last 30 days and today; the newest turns below.',
        callsTurns: 'Turns',
        callsCalls: 'Calls',
        callsAvgTotal: 'Ø total ms',
        callsAvgAsr: 'Avg STT ms',
        callsAvgLlm: 'Avg LLM ms',
        callsAvgTts: 'Ø voice ms',
        callsDeferred: 'Deferred',
        callsToday: 'Today',
        callsWindow: 'Last 30 days',
        callsRecent: 'Newest turns',
        callsPerson: 'Person',
        callsRounds: 'Rounds',
        callsNone: 'No call booked yet.',
        unitKindExecutive: 'Executive layer',
        unitKindBusinessUnit: 'Business unit',
        orgSynced: 'The executive layer and the business units are defined in Veridion Core\'s organisation and synchronised here; they are changed there, not on this page.',
        memory: 'Memory',
        ready: 'ready',
        notReady: 'not ready',
        factExtraction: 'fact extraction on',
        cluster: 'Cluster access',
        agentsRunning: 'Agents running',
        agentsWaiting: 'waiting',
        definitions: 'Definitions',
        gatewayIdentity: 'Gateway identity',
        gatewayTokens: 'Gateway tokens in the window',
        hostedTitle: 'Hosted agents',
        hostedSubtitle: 'AI applications Veridion Core starts and operates in containers of their own.',
        agent: 'Agent',
        actions: 'Actions',
        confirmHosted: '{action}: {agent}?',
        hostedActions: {
          start: 'start',
          stop: 'stop',
          restart: 'restart',
        },
        open: 'open',
        agentsTitle: 'Agents',
        agentsSubtitle: 'Every agent and sub-agent runs in a container of its own. Open one to message it or command it.',
        showFinished: 'Show finished agents',
        noAgents: 'No agents.',
        definitionsTitle: 'Definitions',
        definitionsSubtitle: 'Approved agent graphs with their versions.',
        designsTitle: 'Agent designs',
        designsSubtitle: 'Every agent the architect designed, for a person or for an AI colleague\'s work: what for and why, every question with its answer, the test runs against the scenarios, the approval and the runs.',
        design: 'Design',
        designFor: 'For',
        designWork: 'Work',
        designState: 'State',
        designApprovedBy: 'Approved by',
        designAgent: 'Agent built',
        filterState: 'State',
        filterAll: 'All',
        filterOpen: 'Open',
        filterDone: 'Done',
        filterFailed: 'Failed',
        filterCurrent: 'Active and recently failed',
        filterActive: 'Active',
        filterFinished: 'Finished',
        filterPosition: 'AI colleague',
        pagePrev: 'Previous',
        pageNext: 'Next',
        pageLabel: 'Page',
        searchLabel: 'Search',
        showMore: 'Show more',
        noDesigns: 'No agent designed yet.',
        designReason: 'Why the tools were not enough',
        designRecord: 'Record',
        designAgents: 'Agents of the design',
        designTestRun: 'Test run',
        designRun: 'Run',
        designStatus: { designing: 'being designed', testing: 'in test', asking: 'waits for an answer', approval: 'waits for approval', running: 'running', done: 'done', failed: 'failed', cancelled: 'cancelled' },
        builtBy: 'Built by',
        builtFor: 'For the work',
        viaCodingTask: 'through the coding agent',
        designTests: 'Test runs',
        designRuns: 'Runs',
        designByPerson: 'a person in conversation',
        diagramsTitle: 'Diagrams',
        diagramsSubtitle: 'Pictures of flows, architectures and plans that AI colleagues, agents and the coding agent drew, with title, legend and Mermaid code.',
        noDiagrams: 'No diagram yet.',
        diagramAuthor: 'Author',
        diagramBasedOn: 'Extends',
        diagramCode: 'Mermaid code',
        architectTitle: 'Architect',
        architectSubtitle: 'Design an agent in conversation. The architect asks what it cannot settle itself and creates the agent only after you approve it.',
        orgTitle: 'Organisation',
        orgSubtitle: 'Departments, teams and projects with their members; the company memory is shared along this structure.',
        usageTitle: 'Usage per agent',
        usageSubtitle: 'Model calls, tokens and reported cost of the last 30 days.',
        calls: 'Calls',
        source: 'Source',
        gpuTokens: 'Tokens on the GPU',
        cloudTokens: 'Tokens in the cloud',
        usageByModel: 'Per colleague and model',
        cost: 'Cost',
      },
      memory: {
        archOverviewTitle: "Architecture overview: how the company memory is built",
        archOverviewText: "Veridion Core stores the company's knowledge in three tiers: Neo4j as a temporal knowledge graph for facts, decisions and work items, PostgreSQL for transactional agent, mailbox and sprint state, and Qdrant for vector retrieval over company documents. Each business unit works in a domain-isolated knowledge domain; cross-unit results travel over recorded handovers.",
        clustersTitle: "Business Unit Knowledge Domains",
        clustersSubtitle: "Each business unit works in a delimited Neo4j knowledge domain; node and edge counts come live from Neo4j, the descriptions from the labeled initial seeding. A click opens the domain in the knowledge graph.",
        clusterCode: "Code",
        clusterName: "Knowledge domain",
        clusterId: "Identifier",
        clusterRoles: "Roles",
        clusterBridges: "Handover bridges",
        clusterPolicy: "Domain scope & isolation policy",
        clusterCounts: "Nodes / edges (live)",
        clusterInsights: "Findings (initial seeding)",
        clusterOpenButton: "Open in the knowledge graph",
        countsUnavailable: "Neo4j unreachable — no count",
        researchTitle: "Quantum & Frontier AI Research Repository",
        researchSubtitle: "Foundational research publications & architectural references — live rows from Veridion Core; every row's origin is visible.",
        researchEmpty: "No publication in the archive yet.",
        researchIngestNote: "New publications are added by the quantum colleague through its tool; the dashboard only reads the archive.",
        researchPublication: "Publication",
        researchMechanism: "Key mechanism",
        researchRelevance: "Relevance to the architecture",
        researchOrigin: "Origin",
        researchSeeded: "initial seeding",
        researchMotivates: "Motivates version",
        title: 'Company memory',
        subtitle: 'What Veridion Core keeps in Neo4j: memories by scope, facts with the time they hold, and the audit of what agents did.',
        failed: 'Operation failed',
        loading: 'Loading …',
        unavailable: 'The memory cannot be reached',
        database: 'Database',
        ready: 'ready',
        notReady: 'not ready',
        factExtraction: 'Fact extraction',
        episodesQueued: 'Episodes waiting',
        lastError: 'Last error',
        contentTitle: 'Content',
        contentSubtitle: 'Nodes per label and memories per scope and kind.',
        label: 'Label',
        count: 'Count',
        empty: 'Nothing yet.',
        scope: 'Scope',
        kind: 'Kind',
        kinds: {
          fact: 'fact',
          decision: 'decision',
          task: 'task',
          procedure: 'procedure',
          note: 'note',
          episode: 'episode',
        },
        searchTitle: 'Search',
        searchSubtitle: 'The recall agents use: meaning, words and extracted facts.',
        searchPlaceholder: 'Search term or question',
        allScopes: 'all scopes',
        search: 'Search',
        noResults: 'Nothing found.',
        text: 'Text',
        validFrom: 'Valid from',
        source: 'Source',
        extracted: 'extracted',
        recorded: 'recorded',
        rememberTitle: 'Remember',
        rememberSubtitle: 'Store a fact, decision, task, procedure or note in a scope.',
        remembered: 'Stored.',
        remember: 'Remember',
        created: 'Created',
        validity: 'Validity',
        invalid: 'invalid',
        confirmInvalidate: 'Mark this memory as no longer valid?',
        invalidate: 'mark invalid',
        forget: 'forget',
        confirmForget: 'Forget this entry for good? It is deleted from the memory and cannot be restored.',
        forgotten: 'Forgotten.',
        factsTitle: 'Facts over time',
        factsSubtitle: 'Facts extracted from conversations and agent results; a contradicted fact gets an end date.',
        noFacts: 'No facts extracted yet.',
        briefsTitle: 'Briefs of the AI colleagues',
        briefsSubtitle: 'What each AI colleague reads first: open commitments, valid decisions, running items and customers, written every night from the memory.',
        brief: 'Brief',
        updated: 'Updated',
        noBriefs: 'No briefs written yet.',
        fact: 'Fact',
        from: 'From',
        to: 'To',
        validUntil: 'Valid until',
        stillValid: 'still valid',
        entityTitle: 'Neighbourhood',
        entitySubtitle: 'What a task, project, person, system or entity is linked to.',
        entityPlaceholder: 'Name, task id, mail address or id',
        show: 'Show',
        auditTitle: 'Audit',
        auditSubtitle: 'Model and tool calls, messages and spawns of the agents.',
        auditPlaceholder: 'Agent id (empty: all)',
        filter: 'Filter',
        time: 'Time',
        agent: 'Agent',
        event: 'Event',
        toolOrModel: 'Tool or model',
        status: 'Status',
        detail: 'Detail',
        consoleTitle: 'Query console',
        consoleSubtitle: 'Read-only Cypher; writing statements are refused.',
        run: 'Run',
        truncated: 'more rows were cut off',
        graph: {
          clusterPickTitle: "Focus a knowledge domain in the graph",
          clusterPickHint: "A click on a business unit focuses its subgraph with roles and handover bridges in the interactive graph.",
          allClusters: "All domains (full graph)",
          activeCluster: "Active knowledge domain",
          publicationsTitle: "Publications in the research repository",
          storesTitle: 'Memory stores',
          storesSubtitle: 'What each store of the company memory holds, read live: the graph in Neo4j, the state of Veridion Core in Postgres, the vectors of the knowledge base in Qdrant.',
          storeNeo4j: 'Neo4j (graph)',
          storeNeo4jHolds: 'The company memory: memories with their scope, the entities and facts Graphiti extracted with the time they hold, the work items with their meaning, the software work and the audit of the agents.',
          storePostgres: 'Postgres (relational)',
          storePostgresHolds: 'The transactional state of Veridion Core: the process table of the agents, mailboxes, conversations, checkpoints, coding tasks, approvals, the organisation and the usage.',
          storeQdrant: 'Qdrant (vectors)',
          storeQdrantHolds: 'The company knowledge base: the embedded passages of the documents an admin added, searched by the orchestrator when a turn needs the knowledge base.',
          nodes: 'nodes',
          relationships: 'relationships',
          relationshipType: 'Relationship type',
          tables: 'tables',
          table: 'Table',
          rows: 'rows',
          purpose: 'What it holds',
          documents: 'documents',
          session: 'Session',
          collection: 'Collection',
          role: 'Role',
          roleDocuments: 'documents',
          roleCurated: 'curated question-answer pairs',
          title: 'Graph',
          subtitle: 'The graph of the company memory in Neo4j: start from a search hit, the newest memories or the work items; click a node to read it, expand its neighbours, drag to arrange, scroll to zoom.',
          startNewest: 'Newest memories',
          startWork: 'Work items',
          searchPlaceholder: 'Name, text or id to find in the graph',
          find: 'Find',
          noHits: 'Nothing found.',
          name: 'Name',
          sources: { memory: 'memory', entity: 'extracted entity', node: 'project memory', episode: 'episode' },
          show: 'show',
          shown: '{nodes} nodes and {edges} relationships in the graph',
          truncated: 'cut off at the bound; expand a node or search narrower',
          selected: 'Selected node',
          selectHint: 'Click a node in the graph.',
          expand: 'Expand neighbours',
          expandTwo: 'Expand two levels',
          centre: 'Centre on this node',
          facts: 'Facts of this entity',
          degree: 'Relationships',
          direction: 'Direction',
          out: 'outgoing',
          in: 'incoming',
          noRelationships: 'No relationships.',
          property: 'Property',
          value: 'Value',
          noProperties: 'No properties.',
          factsOf: 'Facts of',
          factsSubtitle: 'What Graphiti extracted about this entity, with the time each fact holds; a contradicted fact carries an end date.',
          relation: 'Relation',
          other: 'Other entity',
          newestTitle: 'Newest memories',
          newestSubtitle: 'The last memories written, with what each is about; "show" draws one with its links.',
          about: 'About',
          workTitle: 'Work items',
          workSubtitle: 'Every piece of confirmed work with its state, owner, issue and the results of its scenarios; "show" draws one with its meaning, its issue, its coding tasks and the agents built for it.',
          allStates: 'all states',
          states: { confirmed: 'confirmed', in_progress: 'in progress', blocked: 'blocked', done: 'done', failed: 'failed', dropped: 'dropped' },
          workItem: 'Work item',
          owner: 'Owner',
          issue: 'Issue',
          scenarios: 'Scenarios',
          results: { passed: 'passed', failed: 'failed', pending: 'pending' },
        },
        day: {
          title: 'The company\'s day',
          subtitle: 'The timeline of events Veridion Core records: the people\'s words, cards, work, hand-overs, research, agents, coding tasks, projects, incidents and meetings, newest first.',
          sinceToday: 'today',
          sinceDay: 'last 24 hours',
          sinceWeek: 'last 7 days',
          allKinds: 'all kinds',
          refresh: 'Refresh',
          count: '{n} events',
          time: 'Time',
          actor: 'Actor',
          happening: 'Event',
          work: 'Work',
          empty: 'Nothing recorded in this window.',
          kinds: { word: 'word', request: 'request', card: 'card', work: 'work', handover: 'hand-over', research: 'research', agent: 'agent', task: 'coding task', project: 'project', incident: 'incident', schedule: 'schedule', meeting: 'meeting', message: 'message' },
        },
      },
      title: 'Admin Dashboard',
      adminKicker: 'Operations',
      smtmStatusTitle: 'SMTM data & forecasts',
      smtmStatusSubtitle: 'Monitors broker time series, published models, prediction output, and RSS feeds.',
      smtmStatusUnavailable: 'SMTM status unavailable',
      smtmGeneratedAt: 'Generated at',
      smtmMinimumRows: 'Minimum training rows',
      smtmBaseFrames: 'Base time series',
      smtmTrainableFrames: 'Raw data ready',
      smtmWaitingHistory: 'Waiting for history',
      smtmPredictionTrackedInstruments: 'Tracked instruments',
      smtmPredictionEnabledCount: 'Predictions enabled',
      smtmPredictionDisabledCount: 'Predictions paused',
      smtmMlFrames: 'ML data sets',
      smtmOnlineModels: 'Online models',
      smtmModelsWithArtifacts: 'Models with artifacts',
      smtmPredictionFrames: 'Prediction series',
      smtmMissingPredictions: 'Series without predictions',
      smtmBlobArtifacts: 'Blob artifacts',
      smtmStalePredictions: 'Stale predictions',
      smtmRssFrames: 'RSS feeds',
      smtmDataframesTotal: 'Total data sets',
      smtmLatestModelUpload: 'Latest model upload',
      smtmLatestPredictionWrite: 'Latest prediction write',
      smtmRuntimeHints: 'Runtime hints',
      smtmNoHints: 'No open SMTM hints.',
      smtmInstrument: 'Instrument',
      smtmBaseData: 'Base data',
      smtmMlFrame: 'ML data set',
      smtmModelPublish: 'Model status',
      smtmArtifacts: 'Artifacts',
      smtmPredictionFrame: 'Prediction series',
      smtmIssues: 'Issues',
      smtmNoIssues: 'No issues',
      smtmNoFrames: 'No SMTM instruments found.',
      smtmPredictionControlTitle: 'SMTM prediction control',
      smtmPredictionControlSubtitle: 'Decide per instrument whether SMTM should calculate new machine-learning predictions or only keep collecting base data.',
      smtmPredictionSettingsUnavailable: 'SMTM prediction control unavailable',
      smtmPredictionControlHint: 'Paused instruments keep their historical data. New ML frames, model training, and predictions are no longer generated for them.',
      smtmPredictionMode: 'Prediction mode',
      smtmPredictionToggle: 'Admin control',
      smtmPredictionToggleLabel: 'Enable or pause predictions',
      smtmPredictionEnabled: 'Prediction enabled',
      smtmPredictionDisabled: 'Prediction paused',
      smtmPredictionSaving: 'Saving...',
      smtmPredictionSettingsSaved: 'SMTM prediction control saved.',
      smtmPredictionSaveChanges: 'Save changes',
      smtmPredictionResetChanges: 'Discard changes',
      smtmPredictionPendingChanges: 'pending changes',
      smtmPredictionPendingBadge: 'Pending save',
      smtmOpenAzuriteUi: 'Open Azurite Web UI',
      azuriteTitle: 'SMTM Azurite Web UI',
      azuriteSubtitle: 'Read-only view for modelstatus entries, blob artifacts, and model downloads.',
      azuriteModelGroups: 'Model groups',
      azuriteBlobArtifacts: 'Blob artifacts',
      azuriteFiles: 'Files',
      azuriteSearchPlaceholder: 'Filter models',
      azuriteNoModels: 'No Azurite models found.',
      smtmRows: 'Rows',
      smtmLatest: 'Latest timestamp',
      smtmAge: 'Age',
      smtmValue: 'Value',
      smtmMinutesAgo: 'min ago',
      smtmMinutesAhead: 'min ahead',
      smtmHoursAgo: 'h ago',
      smtmDaysAgo: 'd ago',
      smtmStateLabels: {
        available: 'Available',
        trainable: 'Trainable',
        waiting_for_history: 'Waiting for history',
        missing_base_data: 'No base data',
        missing_machine_learning: 'Missing ML data set',
        missing_prediction: 'Missing prediction',
        prediction_disabled: 'Prediction paused',
        stale_prediction: 'Stale prediction',
        open: 'Open',
        completed: 'Completed',
        online: 'Online',
        offline: 'Offline',
        training: 'Training',
        uploading: 'Uploading',
        failed: 'Failed',
        unknown: 'Unknown',
        missing: 'Missing'
      },
      smtmIssueLabels: {
        empty_base_frame: 'Base time series empty',
        insufficient_history: 'Not enough history',
        missing_machine_learning_frame: 'ML data set missing',
        missing_prediction_frame: 'Prediction series missing',
        stale_prediction_frame: 'Prediction series stale',
        missing_online_model: 'No online model',
        model_offline: 'Model offline',
        missing_model_blob: 'Model blob missing',
        missing_model_header: 'Model header missing',
        missing_modelstatus_entry: 'Modelstatus entry missing',
        inference_not_writing_prediction: 'Inference is not writing predictions',
        prediction_disabled_by_admin: 'Prediction paused by admin'
      },
      smtmHintLabels: {
        trainable_frames_missing_predictions: 'raw-ready instruments without prediction output',
        instruments_waiting_for_history: 'instruments still waiting for history',
        models_missing_artifacts: 'online models missing complete artifacts',
        no_online_models: 'No online models in Azurite',
        azurite_unavailable: 'Azurite storage state is currently unavailable'
      },
      mailTitle: 'Mail configuration',
      usersTitle: 'User management',
      usersSubtitle: 'Accounts, roles, status and 2FA from Keycloak. Selecting one opens the controls for exactly that account.',
      usersHideCreate: 'Close form',
      usersCreateHint: 'A new account starts with mandatory 2FA and becomes active once it is set up.',
      usersFilterAllStatus: 'All states',
      usersFilterAllRoles: 'All roles',
      usersManage: 'Manage',
      usersClose: 'Close',
      usersNoneFound: 'No users found.',
      usersPagePrev: 'Previous',
      usersPageNext: 'Next',
      auditTitle: 'Audit log',
      smtpHost: 'SMTP host',
      smtpPort: 'SMTP port',
      smtpSecurity: 'SMTP security',
      smtpUsername: 'SMTP username',
      smtpPassword: 'SMTP password',
      fromEmail: 'From email',
      fromName: 'From name',
      replyToEmail: 'Reply-to email',
      saveMailSettings: 'Save mail settings',
      sendTestMail: 'Send test mail',
      createUser: 'Create user',
      setPassword: 'Set password',
      setRoles: 'Set roles',
      setStatus: 'Set status',
      resetMfa: 'Reset 2FA',
      revokeSessions: 'Revoke sessions',
      filterUsers: 'Filter users',
      testRecipient: 'Test mail recipient',
      statusConfigured: 'Configured',
      statusMissing: 'Not configured',
      userEmail: 'Email',
      userName: 'Username',
      userRoles: 'Roles',
      userStatus: 'Status',
      auditEvent: 'Event',
      auditCreatedAt: 'Created at',
      auditDetails: 'Details',
      aiGatewayTitle: 'AI Gateway',
      aiGatewayEndpoint: 'Endpoint',
      aiGatewayIdentitySource: 'Identity from token claim',
      aiGatewayBudgetSource: 'Seed values in',
      aiGatewayModels: 'Routed models',
      aiGatewayModel: 'Model',
      aiGatewayBackend: 'Backend',
      aiGatewayBudgets: 'Token budgets',
      aiGatewayIdentity: 'Identity',
      aiGatewayTokenBudget: 'Token budget',
      aiGatewayWindow: 'Window',
      aiGatewayAnyIdentity: 'any identity',
      aiGatewayAnyModel: 'any model',
      aiUsageWindowStarted: 'Window since',
      aiUsageRemaining: 'Remaining',
      aiUsageIdentities: 'Identities',
      aiGatewaySubtitle: 'The Envoy AI Gateway is the only way to a model: the routed models, their serving backends and the token budget of each identity.',
      aiGatewayHint: 'Budgets are operated here. The deploy layer only seeds the values for a fresh cluster.',
      aiUsageTitle: 'AI usage per identity',
      aiUsageSubtitle: 'Token consumption booked by the gateway in the running window.',
      sessionActiveUsers: 'Logged-in users',
      sessionActiveSessions: 'Active sessions',
      sessionMfaSessions: 'Verified sessions',
      aiUsageTotalTokens: 'Total tokens',
      aiServicesTitle: 'Service Access',
      aiServicesSubtitle: 'Links to the API and operations surfaces of the platform; each target checks the admin role itself.',
      aiMailSubtitle: 'The SMTP settings Keycloak sends verification and reset mails with, and the test mail.',
      tabOverview: 'Overview',
      tabSmtm: 'SMTM',
      tabEnvoy: 'Envoy AI Gateway',
      tabMail: 'Mail Delivery',
      tabUsers: 'Users',
      tabAudit: 'Audit Log',
      tabServiceLinks: 'Service Access',
      tabVeridion: 'Veridion SMTM',
      tabVeridionPaioneer: 'Veridion pAIoneer Labs GmbH',
      tabAgenticRag: 'Agentic RAG',
      tabPlatform: 'Platform',
      platformTitle: 'Platform state',
      platformSubtitle: 'Every pAIoneer Labs GmbH workload with its ready replicas, restarts and image, straight from Kubernetes.',
      platformHostPage: 'Manage instances in the app host',
      openVisitorMonitoring: 'Open Visitor, Marketing & SEO Monitoring',
      platformUnavailable: 'Platform state unavailable',
      platformWorkloadsTotal: 'Workloads',
      platformDegradedTotal: 'Not ready',
      platformRestartsTotal: 'Restarts',
      platformWorkload: 'Workload',
      platformNamespace: 'Namespace',
      platformReplicas: 'Replicas',
      platformRestarts: 'Restarts',
      platformImage: 'Image',
      platformState: 'State',
      platformStateReady: 'Ready',
      platformStateDegraded: 'Degraded',
      platformStateDown: 'Down',
      platformStateUnknown: 'Unknown',
      platformNodes: 'Nodes',
      platformOsImage: 'Operating system',
      platformKernel: 'Kernel',
      platformRuntime: 'Container runtime',
      platformKubelet: 'Kubelet',
      platformUsed: 'Currently used',
      platformReportedCapacity: 'Reported by Kubernetes',
      platformConfiguredCap: 'Configured container cap',
      platformPressure: 'Pressure conditions',
      platformPressureNone: 'none',
      platformCpu: 'CPU cores',
      platformNoWorkloads: 'This namespace holds configuration objects, no workloads.',
      platformMemory: 'Memory',
      platformEvents: 'Recent warnings',
      platformEventsNone: 'No warnings.',
      platformEventObject: 'Object',
      platformEventReason: 'Reason',
      platformEventMessage: 'Message',
      platformEventLastSeen: 'Last seen',
      platformMetricsMissing: 'No consumption data available: metrics-server is not answering.',
      aiGatewayBackends: 'Serving backends',
      gpuTitle: 'GPU',
      gpuNote: 'Load of the engines on the GPU, the tokens taken from them per identity and per Webex bot, and the token budgets per identity and engine.',
      gpuTokensWindow: 'Tokens on the GPU in the window',
      gpuSinceStart: 'since the engine started',
      gpuIdentities: 'Per identity, running window',
      gpuBots: 'Per Webex bot and agent, 30 days',
      gpuBot: 'Webex bot / agent',
      gpuBudgetTitle: 'Budget per identity for the engine',
      gpuBudgetSet: 'Set budget',
      gpuBudgetHint: 'Tokens per hour on the engine; the gateway enforces it. It narrows an identity without a limit too.',
      gpuNoneYet: 'Nothing booked yet.',
      gpuEngines: 'Engines',
      gpuEngine: 'Engine',
      gpuEngineGold: 'Gold engine',
      agenticRagTitle: 'Agentic RAG',
      agenticRagSubtitle: 'Runtime, knowledge base, training preparation and traceability of the Agentic RAG application.',
      agenticRagBackendStatus: 'Backend status',
      agenticRagRuntimeMode: 'Runtime mode',
      agenticRagKnowledgeMode: 'Knowledge mode',
      agenticRagDeploymentEnv: 'Deployment environment',
      agenticRagVectorStores: 'Vector stores',
      agenticRagQdrantStatus: 'Qdrant',
      agenticRagQdrantCollection: 'Document collection',
      agenticRagQdrantCuratedCollection: 'Curated question-and-answer collection',
      agenticRagQdrantDashboard: 'Dashboard',
      agenticRagPhoenixStatus: 'Phoenix',
      agenticRagOpenDocs: 'Open Swagger',
      agenticRagOpenPhoenix: 'Open Phoenix',
      agenticRagOpenQdrant: 'Open Qdrant',
      agenticRagKnowledgeTitle: 'Knowledge base',
      agenticRagKnowledgeSubtitle: 'State of the documents and the curated questions and answers of the Agentic RAG application.',
      agenticRagDocuments: 'Documents',
      agenticRagCuratedQaPairs: 'Curated question-and-answer pairs',
      agenticRagTrainingTitle: 'Training preparation',
      agenticRagTrainingSubtitle: 'The last generator run and the latest state of the trainer.',
      agenticRagLatestDataset: 'Latest dataset',
      agenticRagDatasetPairs: 'Question-and-answer pairs',
      agenticRagDatasetDocuments: 'Documents processed',
      agenticRagDatasetModifiedAt: 'Last modified',
      agenticRagLatestTrainerInput: 'Latest trainer input',
      agenticRagTrainerInputModifiedAt: 'Input modified',
      agenticRagLatestTrainerRun: 'Latest trainer run',
      agenticRagTrainerRunModifiedAt: 'Run summary modified',
      gpuEngineSilver: 'Silver engine',
      gpuAssignment: 'Assignment',
      gpuWho: 'Who',
      gpuRank: 'Rank',
      gpuRankHint: 'Rank 0 is served first; each engine serves by rank.',
      gpuLanes: 'Veridion Core calls in flight per engine and rank',
      gpuInFlight: 'in flight',
      gpuWhoMainBotPeople: 'Main bot: conversations with people',
      gpuWhoMainBotJudgements: 'Main bot: judgements in the same turn',
      gpuWhoAutopilot: 'Autopilot',
      gpuWhoAgents: 'Agents the main bot runs',
      gpuWhoArchitect: 'Architect',
      gpuWhoChair: 'Meeting chair',
      gpuWhoOrchestrator: 'Orchestrator of the company instance',
      gpuWhoColleagues: 'AI colleagues: turns and their judgements',
      gpuWhoMeetingWords: 'AI colleagues: meeting contributions',
      gpuWhoBackgroundReading: 'Background service: reading of bot posts',
      gpuWhoMemory: 'Company memory: intake and briefs',
      gpuWhoCoding: 'Coding tasks: judgements and learning',
      gpuWhoResearch: 'Web and OSINT research',
      gpuWhoKnowledgeBase: 'Company knowledge base: reading of scanned pages',
      gpuWhoPipeline: 'Pipeline review against the IDD',
      gpuWhoSmtm: 'Veridion SMTM: SaaS chat and knowledge base, last rank',
      gpuUnavailable: 'The GPU is not answering',
      aiGatewaySource: 'Source',
      aiSourceGpu: 'GPU',
      aiGatewayMeter: 'Meter',
      aiGatewayMeterIdentity: 'Every identity, counted',
      aiGatewayEngines: 'Engines on the GPU',
      aiGatewayEnginesHint: 'Live figures of each engine from its metrics: requests running and waiting, cache usage and tokens served since start.',
      aiEngineRunning: 'Running',
      aiEngineWaiting: 'Waiting',
      aiEngineCache: 'Cache in use',
      aiEngineServed: 'Tokens served',
      aiEngineIdle: 'No requests',
      aiEngineUnavailable: 'Engine not answering',
      aiGatewayServing: 'Ready',
      aiBudgetControlTitle: 'Operate token budgets',
      aiBudgetControlSubtitle: 'The default budget applies to every identity. A single identity can get its own ceiling.',
      aiBudgetDefault: 'Default budget',
      aiBudgetIdentity: 'Identity',
      aiBudgetTokens: 'Tokens',
      aiBudgetApply: 'Apply',
      aiBudgetAdd: 'Set ceiling',
      aiBudgetRemove: 'Remove',
      aiBudgetSaved: 'Token budget applied.',
      aiBudgetIdentityPlaceholder: 'Client id, e.g. paioneer-agent-veridion-smtm',
      aiBudgetUnlimited: 'No limit',
      aiBudgetSetUnlimited: 'Lift limit',
      aiBudgetRestoreLimit: 'Restore limit',
      aiUsageReset: 'Clear window',
      aiUsageResetDone: 'Running window cleared.',
      userMfa: '2FA',
      userMfaOn: 'Configured',
      userMfaOff: 'Missing',
      userCreatedAt: 'Created',
      mailSource: 'Managed in',
      veridionTitle: 'Veridion SMTM',
      veridionSubtitle: 'Conversation core of the trading assistant: runtime, tool registry, MCP servers and activity.',
      veridionOpenPage: 'Open Veridion',
      veridionOpenDocs: 'Open Swagger',
      veridionCoreStatus: 'Veridion MCP orchestrator',
      veridionTools: 'Tools',
      veridionToolsTitle: 'Tool registry',
      veridionToolsSubtitle: 'Shows the currently loaded tool families and their effective state.',
      veridionToolName: 'Tool',
      veridionToolRuntime: 'Runtime',
      veridionToolRisk: 'Risk',
      veridionToolEnabled: 'Enabled',
      veridionNoTools: 'No Veridion tools are loaded.',
      veridionRuntimeProfiles: 'Runtime profiles',
      veridionRegistryReloaded: 'Registry reloaded',
      veridionProvider: 'AI path',
      veridionMcpTitle: 'MCP servers',
      veridionMcpSubtitle: 'Connected external tool servers with their state and the number of their tools.',
      veridionMcpServer: 'Server',
      veridionMcpState: 'State',
      veridionMcpTools: 'Tools',
      veridionMcpLastSuccess: 'Last reached',
      veridionMcpConnected: 'connected',
      veridionMcpUnreachable: 'unreachable',
      veridionMcpDisabled: 'disabled',
      veridionMcpEmpty: 'No MCP servers configured.',
      veridionActivityTitle: 'Activity feed',
      veridionActivitySubtitle: 'Structured runtime events of the orchestrator and its tools.',
      veridionActivityEmpty: 'No activity recorded yet.',
      veridionActivitySource: 'Source',
      veridionActivitySurface: 'Surface',
      veridionActivityEvent: 'Event',
      veridionActivityTool: 'Tool',
      veridionActivityStatus: 'Status',
      veridionActivitySummary: 'Summary',
      veridionUnavailable: 'Veridion is currently unavailable.',
      veridionNotConfigured: 'Veridion is not fully configured in the Homepage runtime yet.',
      veridionRequestFailed: 'Veridion did not complete the requested admin call successfully.',
      companyTitle: 'Veridion pAIoneer Labs GmbH',
      companySubtitle: 'The Veridion instance of pAIoneer Labs GmbH for its staff in Webex, with YouTrack and its own knowledge base; its model calls run through the Envoy AI Gateway.',
      companyWorkloads: 'Workloads',
      companyTokensWindow: 'Tokens in the running window',
      companyBudget: 'Budget',
      companyBudgetDefault: 'default budget',
      companyCost30: 'Cost of the last 30 days',
      openrouterTitle: 'Billed by OpenRouter',
      openrouterRemaining: 'Credit left',
      openrouterOf: 'of',
      openrouterToday: 'Today',
      openrouterWeek: 'This week',
      openrouterMonth: 'This month',
      openrouterUnavailable: 'OpenRouter cannot be read right now',
      openrouterNote: 'OpenRouter\'s billing for the platform\'s key, in US dollars; day and week in UTC. The booked values below count only answers that report their cost and are therefore lower.',
      companyRequests30: 'Model calls of the last 30 days',
      companyCostNote: 'Cost in US dollars as OpenRouter reports it per request; the Envoy AI Gateway books the tokens to the identity {identity}.',
      companyCostNotReported: 'not reported',
      companyPartUnavailable: 'unreachable',
      companyWebexTitle: 'Webex bot',
      companyWebexSubtitle: 'Webex calls webex.paioneer-labs.eu/hook; the bridge checks signature and sender and hands only allowed messages to Veridion.',
      companyWebexBot: 'Bot',
      companyWebexWebhook: 'Webhook',
      companyWebexRegistered: 'registered',
      companyWebexNotRegistered: 'not registered',
      companyWebexAccess: 'Allowed',
      companyWebexAnswered: 'Answered',
      companyWebexRejected: 'Refused',
      companyWebexFailed: 'Failed',
      companyWebexRecent: 'Recent deliveries',
      companyWebexTime: 'Time',
      companyWebexOutcome: 'Outcome',
      companyWebexReason: 'Reason',
      companyWebexSender: 'Sender',
      companyWebexEmpty: 'No delivery since the last start.',
      companyWebexNotConfigured: 'The Webex bridge is unreachable or its status key is missing in the admin API.',
      companyUsageTitle: 'Usage by person',
      companyUsageSubtitle: "Model calls, tokens and cost of the last 30 days from the instance's usage ledger.",
      companyUsagePerson: 'Person',
      companyUsageCalls: 'Calls',
      companyUsageTokens: 'Tokens',
      companyUsageCost: 'Cost (USD)',
      companyUsageEmpty: 'No model calls in the last 30 days.',
      companyWebexSendTitle: 'Write as the bot',
      companyWebexSendPerson: 'To a person',
      companyWebexSendRoom: 'Into a room of the bot',
      companyWebexSendEmail: 'Mail address in Webex',
      companyWebexSendText: 'Message (Markdown)',
      companyWebexSendButton: 'Send',
      companyWebexSendDone: 'Sent.',
      companyWebexSendFailed: 'Failed',
      companyWebexRooms: 'Rooms of the bot',
      companyWebexRoomGroup: 'group',
      companyWebexRoomDirect: 'direct',
      companyWebexRoomsEmpty: 'The bot is not in any room yet.',
      companyKnowledgeTitle: 'Knowledge base',
      companyKnowledgeSubtitle: 'The documents of the company instance\'s knowledge base (Agentic RAG); the orchestrator searches them when a turn needs them. Phoenix logs every search.',
      companyKnowledgeDocument: 'Document',
      companyKnowledgeSize: 'Size',
      companyKnowledgeModified: 'Added',
      companyKnowledgeDelete: 'Remove',
      companyKnowledgeDeleteConfirm: 'Remove {name} from the knowledge base?',
      companyKnowledgeUpload: 'Add document',
      companyKnowledgeUploading: 'Uploading …',
      companyKnowledgeIntake: 'Intake',
      companyKnowledgePhoenix: 'Explainable AI (Phoenix)',
      companyKnowledgeEmpty: 'The knowledge base is empty.',
      companyKnowledgeNotConfigured: 'The knowledge base is not connected to the admin API.',
      companyGuestsTitle: 'Guests with access',
      companyGuestsHint: 'Every address at {domains} may use the bot. Admins add single outside addresses here; a change applies at once.',
      companyGuestsEmail: 'Email address',
      companyGuestsAdd: 'Add',
      companyGuestsRemove: 'Remove',
      companyGuestsRemoveConfirm: "Revoke {email}'s access to the bot?",
      companyGuestsAddedBy: 'Added by',
      companyGuestsAddedAt: 'Added on',
      companyGuestsEmpty: 'No guests listed.',
      companyGuestsNotPersistent: 'The list is not saved: the bridge has no data directory.',
      companyGuestsLoadFailed: 'The saved list could not be read; no guest has access until the next change.',
      companyErrorRecipientNotAllowed: 'This address may not answer the bot. Add it as a guest first, then send.',
      companyErrorDomainAllowed: 'Addresses of this domain already have access.',
      companyErrorInvalidEmail: 'Not a valid email address.',
      companyErrorAlreadyListed: 'This address is already on the list.',
      companyErrorStoreUnwritable: 'The list could not be saved.',
      smtmFilterTitle: 'SMTM instrument filter',
      smtmFilterSubtitle: 'An empty input shows all instruments; several instrument names are separated by commas, for example EUR-USD_FOREX_intraday_data_l1,BitcoinEUR_CRYPTO_intraday_data_l1.',
      smtmFilterPlaceholder: 'Instrument names, comma-separated',
      smtmFilterApply: 'Apply filter',
      smtmFilterClear: 'Clear filter',
      smtmReportingTitle: 'SMTM signal reporting',
      smtmReportingSubtitle: 'Shows qualified buy signals, their exit evaluation, and delivery status for automatic notifications.',
      smtmReportingUnavailable: 'SMTM reporting unavailable',
      smtmReportingQualifiedSignals: 'Qualified signals',
      smtmReportingOpenSignals: 'Open signals',
      smtmReportingResolvedSignals: 'Resolved signals',
      smtmReportingWins: 'Wins',
      smtmReportingLosses: 'Losses',
      smtmReportingWinRate: 'Win rate',
      smtmReportingAverageActualReturn: 'Avg actual return',
      smtmReportingNetActualReturn: 'Net actual return',
      smtmReportingDeliveryFailed: 'Failed deliveries',
      smtmReportingEntryTime: 'Entry time',
      smtmReportingExitTime: 'Exit time',
      smtmReportingExpectedReturn: 'Expected return',
      smtmReportingActualReturn: 'Actual return',
      smtmReportingSignalStatus: 'Signal status',
      smtmReportingNoSignals: 'No qualified signals stored yet.',
      smtmReportingPendingDeliveries: 'Pending deliveries',
      smtmReportingFailedDeliveries: 'Failed deliveries',
      smtmReportingDeliveryError: 'Delivery error',
      smtmTrainingTitle: 'SMTM training and models',
      smtmTrainingSubtitle: 'Shows training quality, model state, and published artifacts from the training service.',
      smtmTrainingUnavailable: 'SMTM training unavailable',
      smtmTrainingModels: 'Models',
      smtmTrainingOnlineModels: 'Online models',
      smtmTrainingFailedModels: 'Failed models',
      smtmTrainingStaleModels: 'Stale models',
      smtmTrainingAverageMae: 'Avg MAE',
      smtmTrainingAverageRmse: 'Avg RMSE',
      smtmTrainingAverageR2: 'Avg R²',
      smtmTrainingAverageMase: 'Avg MASE',
      smtmTrainingAverageHitRate: 'Avg direction hit rate',
      smtmTrainingHitRate: 'Hit rate',
      smtmTrainingLastSuccess: 'Last successful training',
      smtmTrainingResolution: 'Resolution / horizon',
      smtmTrainingConsoleTitle: 'SMTM training console',
      smtmTrainingConsoleSubtitle: 'Live tail of the current training service output.',
      smtmTrainingConsoleUnavailable: 'SMTM training console unavailable',
      smtmTrainingConsoleEmpty: 'No training output available yet.',
      smtmRuntimeTitle: 'SMTM runtime',
      smtmRuntimeSubtitle: 'Global horizon, rebuild state and prediction gate for the live SMTM system.',
      smtmRuntimeUnavailable: 'SMTM runtime unavailable',
      smtmRuntimeForecastHorizon: 'Forecast horizon',
      smtmRuntimeResolution: 'Resolution',
      smtmRuntimeConfigVersion: 'Config version',
      smtmRuntimePredictionGate: 'Prediction gate',
      smtmRuntimeRebuild: 'Rebuild',
      smtmRuntimeStateOpen: 'open',
      smtmRuntimeStateClosed: 'closed',
      smtmRuntimeStateActive: 'active',
      smtmRuntimeStateIdle: 'idle',
      smtmRuntimeForecastHorizonMinutes: 'Forecast horizon minutes',
      smtmRuntimeResolutionMinutes: 'Resolution minutes',
      smtmRuntimeRequireCompletedBars: 'Require completed bars',
      smtmRuntimePredictionGateOpen: 'Prediction gate open',
      smtmRuntimeRebuildActive: 'Rebuild active',
      smtmRuntimeSaving: 'Saving runtime...',
      smtmRuntimeSave: 'Save runtime settings',
      smtmRuntimeReset: 'Reset runtime changes',
      smtmRuntimeSaved: 'SMTM runtime settings saved.',
      smtmTrainingRows: 'Train / test rows',
      smtmTrainingMetrics: 'Metrics',
      smtmTrainingIssues: 'Training issues',
      smtmTrainingLlmFeatures: 'LLM features',
      smtmTrainingNoModels: 'No cached training models yet.',
      smtmDirection: 'Direction',
      smtmSentiment: 'Sentiment',
      smtmDeliveryStage: 'Stage',
      smtmDeliveryRecipient: 'Recipient',
      mailSettingsSaved: 'Mail settings saved.',
      mailTestSent: 'Test mail sent.',
      userCreatedSuccess: 'User created successfully.',
      userUpdatedSuccess: 'User updated successfully.',
      userDeletedSuccess: 'User deleted successfully.',
      deleteUser: 'Delete user',
      roleLabels: {
        admin: 'Admin',
        pro: 'Pro',
        tester: 'Tester',
        user: 'User'
      },
      statusLabels: {
        pending_email_verification: 'Pending email verification',
        pending_mfa: 'Pending 2FA',
        active: 'Active',
        locked: 'Locked',
        disabled: 'Disabled'
      }
    }
  },
  nl: {
    nav: {
      title: 'pAIoneer Labs GmbH',
      home: 'Home',
      team: 'Team',
      events: 'Evenementen',
      finance: 'Financiële AI',
      openApp: 'App openen',
      account: 'Account',
      admin: 'Admin',
      logout: 'Uitloggen',
      teaching: 'Trainingen',
      agenticdev: 'IDD / Agentic Coding',
      iddLegacy: 'Legacy-software moderniseren',
      iddMethod: 'Intent-Driven Development',
      veridion: 'Veridion',
      kyveil: 'Anonimisering',
      quantum: 'Quantum AI',
      login: 'Inloggen',
      languageNames: {
        en: 'Engels',
        de: 'Duits',
        nl: 'Nederlands',
        uk: 'Oekraïens',
        fr: 'Frans',
        it: 'Italiaans',
        es: 'Spaans',
        sv: 'Zweeds',
        fi: 'Fins',
        ja: 'Japans',
        pl: 'Pools',
        bg: 'Bulgaars'
      }
    },
    footer: {
      managingDirectors: 'Directeuren',
      servicesTitle: 'Diensten',
      legal: {
        title: 'Juridisch',
        imprint: 'Colofon',
        privacy: 'Privacyverklaring',
        aiTransparency: 'AI-transparantie',
        cookieSettings: 'Cookie-instellingen',
        terms: 'Algemene voorwaarden'
      },
      copyright: 'Alle rechten voorbehouden.'
    },
    auth: {
      validating: 'Validatie loopt...',
      errors: {
        registrationFailed: 'Registratie mislukt: ',
        unknownError: 'Onbekende fout',
        exchangeRateUnavailable: 'Er is een live wisselkoers nodig voordat EUR-budgetten kunnen worden opgeslagen.',
        passwordTooWeak: 'Het wachtwoord is te kort of te zwak.',
        adminRequired: 'Alleen beheerders mogen dit gebied openen.',
        lastAdminProtected: 'Er moet minimaal één actieve administrator overblijven.',
        userExists: 'Er bestaat al een gebruiker met deze gegevens.',
        userCreateInvalid: 'De gebruikersgegevens zijn onvolledig of ongeldig.',
        mailNotConfigured: 'Het mailsysteem is nog niet volledig geconfigureerd.'
      }
    },
    account: {
      username: 'Gebruikersnaam',
      email: 'E-mail',
      roles: 'Rollen',
      manageText: 'Uw wachtwoord, tweefactorauthenticatie, actieve sessies en e-mailadres beheert u in het accountbeheer.',
      manageButton: 'Accountbeheer openen',
      signedOut: 'U bent niet ingelogd.'
    },
    admin: {
      datalake: {
        loading: "Laden …",
        loadFailed: "De data lake is onbereikbaar",
        refresh: "Vernieuwen",
        generatedAt: "Stand",
        notRolled: "Dit onderdeel is in de backend nog niet uitgerold. Zodra de nieuwe endpoints live zijn, verschijnt hier de gemeten toestand.",
        loadMore: "Meer laden",
        yes: "ja",
        no: "nee",
        none: "geen",
        close: "Sluiten",
        summaryTitle: "Twee hypothesen, één werkbank",
        summaryBody: "De architectuurhypothese zegt: het wiskundige vat bepaalt wat het model kan worden — zij staat op de LLM-paperpagina. De datahypothese zegt: pas gekoppelde, geverifieerde trainingsdata vult dat vat — daarvoor dient deze pagina. De autopilot vult het databestand doorlopend, start de training zodra het dataplan van de paper in elk domein in het Duits en het Engels is bereikt, meet het resultaat met de benchmarksuite en publiceert het model privé op HuggingFace. Elk getal hier is gemeten of als voorgave gemarkeerd.",
        summaryArchButton: "Naar de architectuurhypothese (LLM-paper)",
        apTitle: "Autopilot",
        tpTitle: "Weg naar de trainingsstart",
        tpSubtitle: "Waar de autopiloot nu staat: elke stap tot de lopende training met status, tijd en voortgang.",
        tpNow: "Nu",
        tpStep: "Stap",
        tpOf: "van",
        tpSince: "sinds",
        tpFor: "loopt sinds",
        tpHeartbeat: "laatste levensteken",
        tpDone: "klaar",
        tpRunning: "loopt",
        tpWaiting: "wacht",
        tpFailed: "mislukt",
        tpSkipped: "overgeslagen",
        tpProgress: "Voortgang",
        tpRows: "rijen",
        tpRate: "per seconde",
        tpRemaining: "geschatte resterende tijd",
        tpEstimateNote: "schatting uit de gemeten tellers",
        tpPhaseReading: "leest een datapakket",
        tpPhaseAdmission: "toelating (duplicaten, entropie)",
        tpPhaseEncoding: "tokenisering",
        tpNoTiming: "Deze engineversie meldt nog geen tijden.",
        tpBlockers: "Blokkades en fouten",
        tpNone: "Geen blokkades.",
        trTitle: "Trainingsrun (live)",
        trSubtitle: "Rechtstreeks uit de runmap van de trainer gelezen — werkt ook terwijl de worker herstart.",
        trNoRun: "Nog geen trainingsrun met voortgangsgegevens.",
        trStateTraining: "traint",
        trStateStarting: "start",
        trStateFinished: "klaar",
        trStateSilent: "stil sinds {age}",
        trStep: "Stap",
        trOf: "van",
        trRemaining: "Resterende tijd (schatting op basis van de gemeten snelheid)",
        trSecondsPerStep: "s per stap",
        trProgress: "Voortgang van de geplande stappen",
        trRun: "Run",
        trResumed: "hervat bij stap {step}",
        trVersion: "Trainingsdataversie",
        trModel: "Model",
        trTokensPerSecond: "Tokens/s",
        trTokensSeen: "Tokens gezien",
        trVram: "GPU-geheugen",
        trCap: "limiet",
        trLastHeartbeat: "Laatste heartbeat",
        trAgo: "{age} geleden",
        trShardReads: "Shard-leesacties lokaal / via de worker",
        trLossTitle: "Loss-verloop",
        trLossTotal: "Totaal",
        trLossNtp: "Next-token",
        trLossMtp: "Multi-token",
        trChartEmpty: "Nog geen stappen gemeld.",
        trAxisNote: "Horizontaal: trainingsstap, verticaal: loss (natuurlijke logaritme). Beweeg over de curve om de waarden van een stap te zien.",
        trValue: "Waarde",
        trCurrentValue: "huidig",
        trPoints: "{count} meetpunten in totaal",
        trStages: "Curriculumfasen",
        trStageFoundation: "Fundament (ruwe tekst)",
        trStageCapability: "Vaardigheden",
        trStageAnneal: "Anneal",
        trStageCurrent: "loopt",
        trStageDone: "klaar",
        trStageAhead: "komt nog",
        trShards: "shards",
        trRows: "rijen",
        trCheckpoint: "Nieuwste checkpoint",
        trCheckpointNone: "nog geen",
        trCheckpoints: "Volledige checkpoints op schijf",
        trCheckpointEvery: "elke {minutes} min",
        trKernels: "Actieve kernels",
        trDeviations: "Afwijkingen",
        trBlockStorage: "Kopie in de block storage",
        trBlockStorageNone: "nog geen — de eerste volgt na het eerste checkpoint",
        trUploading: "upload loopt: stap {step}",
        treeCkRun: "Trainingsrun",
        treeCkCopy: "Checkpoint in de block storage, gekopieerd {time}",
        treeCkLocal: "Checkpoint op de schijf van de server",
        treeCkUploading: "wordt nu naar de block storage gekopieerd",
        trKpiProgress: "Voortgang",
        trKpiTokens: "Tokens",
        trKpiThroughput: "Doorvoer",
        trKpiLoss: "Loss",
        trKpiLr: "Leersnelheid",
        trKpiGpu: "GPU-geheugen",
        trEndAt: "einde ca. {time}",
        trSeenPlanned: "gezien / gepland",
        trBest: "beste {value}",
        trHourAgo: "{value} t.o.v. 1 u geleden",
        trPerplexity: "perplexiteit {value}",
        trPhaseWarmup: "warm-up",
        trPhaseCosine: "cosinusafname",
        trPhaseStable: "stabiele fase",
        trPhaseDecay: "afkoeling",
        trKpiEpoch: "Epoch",
        trEpochValue: "{epoch} van {epochs}",
        trPlanTitle: "Runplan",
        trPlanExplain: "Warm-up naar de piekleersnelheid, daarna constant over vier gemengde epochs van het corpus; de afkoelfase traint op de hoogwaardigste mix (vaardigheidssamples, leerboekteksten, anneal) en verlaagt de leersnelheid tot nul.",
        trPlanPhase: "Fase",
        trPlanStableSteps: "Geplande stappen van de stabiele fase",
        trPlanDecay: "Afkoeling",
        trPlanDecayAhead: "vanaf stap {step} · over ongeveer {time}",
        trPlanDecayAheadNoTime: "vanaf stap {step}",
        trPlanDecayRunning: "sinds stap {step} · {steps} stappen tot leersnelheid nul",
        trPlanTokensPerStep: "Tokens per optimalisatiestap",
        trPlanTokensPerStepValue: "{tokens} ({accum} microbatches)",
        trPlanRecompute: "Activatieherberekening",
        trPlanRecomputeOn: "aan – gemeten sneller met een grotere microbatch",
        trPlanRecomputeOff: "uit – gemeten sneller zonder",
        trPlanFim: "Documenten in fill-in-the-middle-vorm tot nu toe",
        tbTitle: "Leerboekprogramma",
        tbSubtitle: "Foundationteksten door teachers herschreven als leerboektekst; elk getal en elke eigennaam moet in de bron staan.",
        tbTokens: "Leerboektokens",
        tbTokensSub: "{pct} % van het doel van {target}",
        tbSamples: "Geaccepteerde herschrijvingen",
        tbJobs: "Afgeronde jobs",
        tbTeacher: "Teachertokens per leerboektoken",
        tbCost: "Kosten per miljoen leerboektokens",
        tbCostNone: "de gateway meldt geen kosten; teachertokens worden geteld",
        tbExplain: "Loopt naast de training; latere epochs en de afkoeling lezen wat dan verzegeld is.",
        trThroughputTitle: "Doorvoer (tokens/s)",
        trCurriculumTitle: "Curriculum",
        trStageTokens: "{tokens} tokens",
        trStageBegins: "begint bij stap {step}",
        trPlanWarningLabel: "Let op",
        trPlanWarning: "De run eindigt na {max} stappen in de fase „{stage}” — de vaardigheidsdata beginnen pas bij stap {cap}. Een volledige doorloop zou {steps} stappen vergen (≈ {days} dagen).",
        trPlanOk: "De geplande stappen reiken tot de fase „{stage}”.",
        trCheckpointsTitle: "Checkpoints",
        trNextCheckpoint: "Volgend checkpoint",
        trInSpan: "over {span}",
        trResumes: "Hervatting",
        trNoResume: "geen",
        trConfig: "Configuratie",
        trHealth: "Toestand",
        trMicroBatch: "Microbatch / tokens per stap",
        trSeqLen: "Sequentielengte",
        trLrPlan: "Leersnelheidsplan",
        trLrPlanValue: "piek {lr}, warm-up {warmup} stappen, cosinus tot stap {max}",
        trSpikes: "Loss-pieken (laatste uur)",
        trProgressSub: "stap {step} van {max} · traint sinds {elapsed}",
        trTokensSub: "van {planned} gepland",
        trPathTrainingDetail: "{pct} % · stap {step} van {max} · einde ca. {end}",
        trReadinessRunning: "De training loopt: {pct} % klaar (stap {step} van {max}), loss {loss}, einde ca. {end}.",
        tdvDraftsHistory: "Oudere concepten, nooit verzegeld ({count})",
        runsHistory: "Afgebroken en mislukte runs ({count})",
        trAxisStep: "Trainingsstap",
        trAxisLoss: "Loss (natuurlijke logaritme)",
        trCountdown: "{d} d {h} u {m} min {s} s",
        trTimerWaiting: "De timer volgt na de eerste meetpunten.",
        trTimerStageEnds: "Fase „{stage}” eindigt over",
        trTimerAt: "om {time}",
        trTimerNext: "Daarna „{stage}”: {span}, vanaf {time}",
        trTimerRunEnds: "Run eindigt over {span} (om {time})",
        trStepTimeSub: "{wall} s per stap gemeten · rekentijd {compute} s",
        trEtaTitle: "Resterende tijd uit de gemeten stapduur",
        trEtaEpochEnds: "Epoch {epoch} van {epochs} eindigt over",
        trEtaEpochAt: "om {time} (stap {step})",
        trEtaNextEpoch: "Epoch {epoch}: vanaf {time} (stap {step})",
        trEtaDecay: "Afkoelfase begint over {span} (om {time}, stap {step})",
        trEtaBasis: "Basis: {wall} s per stap, gemiddelde van de laatste {n} stappen zonder {pauses} pauzes (herstart, stilstand); rekentijd volgens de trainer {compute} s per stap.",
        devTitle: "Afwijkingen van het bouwplan",
        devNone: "Geen afwijkingen — de run volgt het bouwplan volledig.",
        devPlanned: "gepland",
        devLimit: "beperking",
        devSeqLen: "Contextlengte",
        devSeqLenText: "Getraind met {trained} tokens context in plaats van de {spec} uit het bouwplan. De lange context volgt in een latere fase.",
        devFim: "Gaten vullen (FIM)",
        devFimText: "Het gatenvul-doel ({rate} % van de blokken) staat in het bouwplan maar is in deze run nog niet actief.",
        devTermination: "Afbreek-sonde",
        devTerminationText: "De afbreek-sonde is geen trainingsdoel maar een eigen modus na de training; die draait later over een afgeronde checkpoint.",
        devDecision: "Beslissingsdoel",
        devDecisionText: "Het beslissingsdoel is actief, maar in de natrainingsfasen van deze run kwamen geen beslissingsmarkeringen aan.",
        devKernelOff: "Versnelling uit",
        devKernelUnverifiedText: "De kernel „{kernel}” is niet door de probe bevestigd en draait als standaardberekening.",
        devKernelUnavailableText: "De kernel „{kernel}” is op deze kaart niet beschikbaar en draait als standaardberekening.",
        devKernelFellBackText: "De kernel „{kernel}” is tijdens de run teruggevallen op de standaardberekening ({reason}).",
        devOptimizer: "Optimizer",
        devOptimizerText: "Optimizer-toestanden draaien in bfloat16 in plaats van 8 bit (bitsandbytes niet beschikbaar) — meer geheugen, dezelfde wiskunde.",
        devScale: "Modelgrootte",
        devScaleText: "Het model is op {scale} % van de bouwplangrootte geïnstantieerd omdat de volle grootte niet in het gemeten geheugen paste.",
        devMediaHeads: "Mediakoppen",
        devMediaHeadsText: "De koppen voor beeld/audio zijn ongetraind omdat de trainingsdata geen mediatokens bevat — gepland voor een tekststreng.",
        devVision: "Beeldpad",
        devVisionText: "Het beeldpad is gebouwd maar heeft met nul beelden getraind omdat de trainingsdata er geen bevat.",
        devOther: "Overig",
        trStageShare: "{pct} % van deze fase klaar",
        cap_tool_calling: "Tool-aanroepen",
        cap_deep_reasoning: "Diep redeneren",
        cap_software_engineering: "Softwareontwikkeling",
        cap_office_finance: "Kantoor & financiën",
        cap_doc_understanding: "Documentbegrip",
        tpExplainThresholds: "Voor elke vaardigheid van de gekozen streng moeten genoeg gecontroleerde trainingsvoorbeelden in de data lake liggen. Doel en meting staan hier per vaardigheid.",
        tpThresholdsDetail: "{met} van {total} vaardigheden hebben hun doel bereikt",
        tpThresholdRow: "{measured} voorbeelden",
        tpForeignThresholds: "Niet voor deze streng: {list} — hoort bij een andere streng en blokkeert niets.",
        tpStepTokenizerReleaseExplain: "De tokenizer zet tekst om in getallen. Hij wordt eenmaal vastgelegd en aan de architectuur gemeld, zodat data en model dezelfde taal spreken.",
        tpStepTokenizeTdvExplain: "Alle gecontroleerde trainingsvoorbeelden worden met de vastgelegde tokenizer in getalreeksen vertaald.",
        tpStepTokenizeCorpusExplain: "De hele ruwe tekst van de data lake wordt in getalreeksen vertaald — de massa voor het fundament.",
        tpStepTdvCreateExplain: "Uit alle getokeniseerde data wordt een vaste trainingsdataversie (TDV) samengesteld, met curriculum en gemeten tokenhoeveelheid.",
        tpStepTdvSealExplain: "De versie wordt onveranderlijk gemaakt en met beschrijving naar de block storage gekopieerd.",
        tpStepCompatExplain: "Twaalf regels controleren of versie en architectuur bij elkaar passen (tokenizer, contextlengte, doelen, geheugen). Alle moeten groen zijn.",
        tpStepVramExplain: "Meet op de kaart of genoeg GPU-geheugen vrij is voor de opgegeven behoefte.",
        tpVramDetail: "{free} GB vrij, {need} GB nodig",
        tpStepTrainStartExplain: "De autopilot start de trainingsrun zodra aan alle voorwaarden is voldaan.",
        tpStepTrainingExplain: "De run traint zelfstandig met checkpoints elke 30 minuten en gaat na elke onderbreking vanzelf verder. Details op de pagina „Training & publicatie”.",
        tpVramRunning: "kaart in gebruik door de lopende training ({need} GB nodig); bij de start voldaan",
        trPathTrainingDetailNoEnd: "{pct} % · stap {step} van {max}",
        srTitle: "Datagereedheid per modelstreng",
        srSubtitle: "Terwijl één streng traint, bereidt de data lake de data van de andere verder voor — tot hun eigen verzegelde versie, zonder trainingsstart.",
        srTrainingNow: "traint nu",
        srSelected: "geselecteerd",
        srDataReady: "data gereed",
        srPreparing: "in voorbereiding",
        srModalities: "invoer: {in} · uitvoer: {out}",
        srThresholds: "doelen: {met} van {total} bereikt",
        srCorpus: "Getokeniseerd corpus",
        srCorpusValue: "{tokens} tokens in {shards} datapakketten",
        srVersion: "Nieuwste versie",
        srNoVersion: "nog geen",
        srLacking: "Ontbreekt nog",
        srLacksNothing: "niets — de versie wacht op haar streng",
        srLackThresholds: "doelen niet bereikt",
        srLackCodec: "beeld-/audiocodec niet vrijgegeven",
        srLackTokenizer: "tokenizer niet gemeld",
        srLackVersion: "geen verzegelde versie",
        srSelectedNote: "Deze streng traint nu; zijn pad staat hierboven.",
        srSelectedIdleNote: "Deze streng is geselecteerd voor de volgende training; zijn pad staat hierboven.",
        srUnselectedNote: "Deze streng start geen training zolang een andere is gekozen — zijn data wordt toch volledig voorbereid.",
        modText: "tekst",
        modImage: "beeld",
        modAudio: "audio",
        modVideo: "video",
        tpStepThresholds: "Doelen bereiken",
        tpStepPlan: "Het dataplan van de paper bereiken",
        tpExplainPlan: "De paper legt vast hoeveel unieke, gecontroleerde tokens elk domein nodig heeft. Duits en Engels dragen elk minstens de helft daarvan; code telt zonder taal. Geteld worden de toegelaten tokens na het verwijderen van duplicaten, niet de ruwe schatting.",
        tpPlanDetail: "{met} van {total} domeinen bereikt",
        tpPlanRowLang: "{have} / {target} · Duits {de} / {half} · Engels {en} / {half}",
        tpPlanRowFree: "{have} / {target}",
        tpPlanOpen: "open: {langs}",
        tpLangDe: "Duits",
        tpLangEn: "Engels",
        tpPlanProvisional: "Voorlopig geteld met de eerdere tokenizer; beslissend is de nieuw getrainde.",
        tpStepOwnTokenizer: "Eigen tokenizer van de streng",
        tpStepOwnTokenizerExplain: "De streng traint met een eigen tokenizer, geleerd op een evenwichtig corpus met code. Pas in zijn tokens telt het dataplan definitief.",
        tpPlanCat_knowledge: "Kennis",
        tpPlanCat_code: "Code",
        tpPlanCat_mathematics: "Wiskunde",
        tpPlanCat_domain: "Vakteksten",
        tpPlanCat_textbook: "Leerboek",
        tpPlanCat_agentic: "Agentisch",
        tpPlanFlow: "instroom {rate} per uur",
        tpPlanEtaDays: "nog ongeveer {n} dagen",
        tpPlanEtaHours: "nog ongeveer {n} uur",
        tpPlanNoFlow: "geen instroom in de laatste 24 uur",
        tpPlanBinding: "knelpunt",
        tpBind_download: "download",
        tpBind_allowance: "dagquotum van de block storage",
        tpBind_ingest: "ingest",
        tpBind_teachers: "leraarmodellen",
        thrPlanTitle: "Samples per vaardigheid (gemeten)",
        thrPlanNote: "De doelen van deze streng legt zijn paper vast: het dataplan per domein, Duits en Engels, op de weg naar de trainingsstart. Drempels per vaardigheid gelden alleen voor strengen zonder dataplan; hier staat wat elke vaardigheid gemeten bevat.",
        thrPlanRow: "{samples} samples · {tokens} tokens",
        srDataPlan: "Dataplan van de paper: {met} van {total} domeinen bereikt",
        srLackDataPlan: "dataplan niet bereikt",
        srPlanOpen: "open: {areas}",
        tpBind_source: "geen bron in deze taal",
        tpBind_paused: "download gepauzeerd",
        tdvPlanEmpty: "Nog geen datastand van de actieve specificatie. De autopilot bouwt en verzegelt hem zodra het dataplan van de paper is bereikt.",
        compatPlanNone: "Nog geen controle: de datastand van de actieve specificatie wordt gecontroleerd zodra hij wordt verzegeld.",
        mixPlanTitle: "Mix volgens de paper",
        mixPlanNote: "Elke trainingsstap trekt de domeinen in deze vaste aandelen; de afbouwfase verhoogt het hoogwaardige aandeel tot de helft. Mixdoelen per vaardigheid gelden alleen voor strengen zonder dataplan.",
        mixPlanShare: "{area} {pct} %",
        sitTitle: "Situatie",
        sitSubtitle: "Waar de training staat in één oogopslag: wat elk domein van de paper nog mist, wat nu loopt en wat daarna komt.",
        sitHeadlineDays: "De training kan op zijn vroegst over ongeveer {time} starten; {area} duurt het langst (knelpunt: {bottleneck}).",
        sitHeadlineBlocked: "Zo wordt het dataplan niet bereikt: {items} heeft geen bron. Eraan wordt gewerkt: open datasets zoeken of gecontroleerd vertalen.",
        sitHeadlineReached: "Het dataplan is bereikt; tokenizer, nieuwe tokenisatie, verzegeling en controles volgen.",
        sitHeadlineUnknown: "De instroom van de rest is nog niet gemeten.",
        sitHold: "De start is daarnaast aangehouden tot elke bouwsteen gecontroleerd is.",
        sitArea: "Domein",
        sitTotal: "Totaal",
        sitFlow: "Instroom",
        sitLeft: "Nog",
        sitBottleneck: "Knelpunt",
        sitNoLanguage: "zonder taal",
        sitNoSource: "geen bron",
        sitReached: "bereikt",
        sitDays: "{n} dagen",
        sitHours: "{n} u",
        sitPerHour: "{value} per uur",
        sitPerHourTokens: "{value} tokens per uur",
        sitRunningTitle: "Wat nu loopt",
        sitDownloads: "Downloads",
        sitIngest: "Verwerking tot tekstfragmenten",
        sitTokenize: "Tokenisatie",
        sitGenerate: "Generatie door leraarmodellen",
        sitIdle: "rust",
        sitNextTitle: "Wat daarna komt",
        sitNextSteps: "Tokenizer met code trainen → hele corpus opnieuw tokeniseren → datastand verzegelen → controles → trainingsstart",
        sitProvisional: "De hoeveelheden zijn voorlopig met de eerdere tokenizer geteld; definitief telt de nieuw getrainde.",
        tpPlanSeeSituation: "Domeinen, talen en resterende tijden staan in het situatiebeeld hierboven.",
        sitHeadlineBlocks: "De training kan nog niet starten: er ontbreken bouwstenen die nog gebouwd moeten worden ({items}). De data groeit intussen.",
        sitDuration: "Duur van de training: ongeveer {days} dagen voor {budget} tokens bij gemeten {rate} tokens per seconde op hetzelfde netwerk.",
        sitBlocksTitle: "Bouwstenen van de training",
        sitStateNotBuilt: "nog niet gebouwd",
        sitStateWaiting: "wacht",
        sitStateReady: "klaar",
        sitBlockWaitsFor: "wacht op: {items}",
        sitBenchProgress: "{made} van {total} gecontroleerde taken",
        sitBlockParts: "gebouwd: {built} · open: {open}",
        part_graph_bundles: "gekoppelde documenten",
        part_repository_bundles: "volledige repositories",
        part_long_context: "lange context",
        part_fine_tuning: "fijnafstemming",
        part_reinforcement_learning: "versterkingsleren",
        part_real_folding: "echt vouwen van de context",
        sitBlock_data: "Data volgens het plan van de paper",
        sitBlock_tokenizer: "Tokenizer met code",
        sitBlock_bench: "Benchmarksuite van de paper",
        sitBlock_trainer: "Trainer: vensterstappen, vast budget, vaste mix",
        sitBlock_bundles: "Bundels: gekoppelde documenten en volledige repositories",
        sitBlock_post_training: "Natraining: lange context, finetuning, beloningsleren",
        tpStepTokenizerRelease: "Tokenizer-vrijgave",
        tpStepTokenizeTdv: "Trainingsvoorbeelden tokeniseren",
        tpStepTokenizeCorpus: "Corpus tokeniseren",
        tpStepTdvCreate: "Datastand aanmaken",
        tpStepTdvSeal: "Datastand verzegelen",
        apAfterSealLabel: "Na het verzegelen automatisch doorgaan",
        apAfterSealOn: "AAN",
        apAfterSealOff: "UIT",
        apAfterSealConfirmOn: "Na het verzegelen automatisch doorgaan? De weg naar de trainingsstart gaat dan zonder pauze verder: compatibiliteitscontrole, GPU-controles en trainingsstart.",
        apAfterSealConfirmOff: "Na het verzegelen weer stoppen? De autopilot pauzeert dan na het verzegelen van de datastand voor beoordeling.",
        apAfterSealTurnedOn: "De weg naar de trainingsstart gaat na het verzegelen automatisch verder.",
        apAfterSealTurnedOff: "De autopilot stopt na het verzegelen.",
        apAfterSealWaiting: "Datastand verzegeld – de autopilot pauzeert voor beoordeling.",
        apAfterSealStep: "Beoordeling van de verzegelde datastand",
        apAfterSealHint: "Na het verzegelen liggen alle gegevens verwerkt in de block storage. Staat de schakelaar uit, dan pauzeert de autopilot daar voor beoordeling; aan gaat de weg automatisch verder.",
        tpStepCompat: "Compatibiliteitscontrole",
        tpStepVram: "VRAM-test",
        tpStepTrainStart: "Trainingsstart",
        tpStepTraining: "Training loopt",
        apSubtitle: "Eén schakelaar voor de hele kringloop: data verzamelen, verwerken en koppelen, voorbeelden genereren, trainen zodra het dataplan van de paper is bereikt, benchmarken en privé publiceren. Elke blokkade wordt benoemd in plaats van verdoezeld.",
        apOn: "Autopilot AAN",
        apOff: "Autopilot UIT",
        apTurnOn: "Autopilot inschakelen",
        apTurnOff: "Autopilot uitschakelen",
        apConfirmOn: "Autopilot inschakelen? Hij vult de databestand doorlopend tot de verzegelde datastand; daarna pauzeert hij voor beoordeling, tenzij \"Na het verzegelen automatisch doorgaan\" aan staat.",
        apConfirmOff: "Autopilot uitschakelen? Lopend werk eindigt gecontroleerd; niets wordt weggegooid.",
        apEnabled: "Autopilot ingeschakeld",
        apDisabled: "Autopilot uitgeschakeld",
        apPause: "Pauzeren",
        apResume: "Hervatten",
        apResumed: "Autopilot hervat",
        apPausedNote: "Autopilot gepauzeerd",
        apPausedPill: "gepauzeerd",
        apPhaseLabel: "Fase",
        apPhaseSince: "sinds {time}",
        apCycleId: "Cyclus",
        apBlockedLabel: "Geblokkeerd",
        apCycleTitle: "Voortgang van de lopende cyclus",
        apCycleEmpty: "Geen cyclus actief.",
        colPhase: "Fase",
        colPending: "Wacht",
        colRunning: "Loopt",
        colDone: "Klaar",
        colFailed: "Mislukt",
        thrTitle: "Drempels per vaardigheid",
        thrSubtitle: "Vanaf deze hoeveelheden verzegelt de autopilot een trainingsdataversie en start hij de training; de balken tonen de gemeten voortgang.",
        thrMet: "bereikt",
        thrNotMet: "open",
        thrDefault: "vooraf ingestelde standaard",
        thrForeign: 'niet voor de gekozen streng',
        staleSince: 'Worker antwoordt momenteel niet — laatste gemeten stand van',
        staleHint: 'De autopilot blijft lopen; de weergave ververst zodra de worker weer antwoordt.',
        idxTitle: 'Vectorindex & deduplicatie',
        idxSubtitle: 'De eigen HNSW-index van het lake voor graafkoppeling en de gemeten verwijdering van dubbele chunk-shards.',
        idxConfigured: 'Index geconfigureerd',
        idxReachable: 'Index bereikbaar',
        idxPoints: 'Indexpunten',
        idxBackfill: 'Vulling vanuit de embeddings-tabel',
        idxBackfillDone: 'voltooid',
        idxBackfillOpen: 'loopt / open',
        ddLastPass: 'Laatste dedup-doorloop',
        ddChecked: 'gecontroleerde assets',
        ddDropped: 'verwijderde dubbele shards',
        ddRows: 'verwijderde chunk-rijen',
        ddRemaining: 'resterende kandidaten',
        ddNone: 'nog geen doorloop',
        gsTitle: 'Graaffasen',
        gsSubtitle: 'De teacher-fasen van de graaf — embedding en claim-extractie — dienen de graafgestuurde voorbeeldsynthese; daarom nemen ze chunks in rangvolgorde en in de breedte over de assets: rang 0 de documenten van de eigenaar en tool-imports, rang 1 expertkennis (wetenschap, techniek, boeken, redeneren, German Commons, Wikipedia), rang 2 algemene tekst (Wikisource, Gutenberg, webcorpora, transcripties), rang 3 code (alleen ingebed, nooit claim-geëxtraheerd). De basismassa bereikt het tokencorpus zonder teacher-doorloop.',
        gsMeasuredAt: 'Gemeten om',
        gsRanksTitle: 'Rangvolgorde',
        gsRanksEmpty: 'Nog geen rangplan gemeld.',
        gsColRank: 'Rang',
        gsColLabel: 'Bronklasse',
        gsColSources: 'Bronnen',
        gsColAssets: 'Assets',
        gsColPendingExtract: 'Openstaande extractie',
        gsColPendingEmbed: 'Openstaande embedding',
        gsRankOwner: 'Documenten van de eigenaar en tool-imports',
        gsRankExpert: 'Expertkennis',
        gsRankGeneral: 'Algemene tekst',
        gsRankCode: 'Code (alleen ingebed)',
        gsRankShort: 'rang {n}',
        gsLoopsTitle: 'Laatste ronde van elke lus',
        gsColLoop: 'Lus',
        gsColSource: 'Bron',
        gsColChunks: 'Chunks verwerkt',
        gsColClaims: 'Claims',
        gsColEdges: 'Kanten',
        gsColSeconds: 'Seconden',
        gsColLast: 'Laatste ronde',
        gsLoopEmbed: 'Embedding',
        gsLoopExtract: 'Claim-extractie',
        gsLoopLink: 'Koppeling',
        gsUngrounded: '{n} niet onderbouwd',
        gsNoRound: 'nog geen ronde',
        gsClaims: 'Claims totaal',
        gsAssetsWithClaims: 'Assets met claims',
        gsDangling: 'Verweesde chunk-knopen',
        gsStuck: 'Vastgelopen assets (in verwerking zonder lopende ingest)',
        gsConcurrency: 'Parallelisme van de extractie',
        gsOrphansLast: 'Laatste opschoonronde',
        gsOrphansNone: 'nog geen ronde',
        gsOrphansStatusCleaned: 'opgeschoond',
        gsOrphansDropped: 'knopen verwijderd',
        gsOrphansRemaining: 'resterend',
        gsOrphansHint: 'Niets te doen: de autopilot plant zelf een begrensde opschoonronde zolang er chunk-knopen zonder shard bestaan. De samenvatting toont de laatste ronde.',
        thrSamplesBar: "Voorbeelden",
        thrTokensBar: "Tokens (geschat)",
        thrNoMinimum: "gemeten, geen minimum",
        thrEditTitle: "Drempels bewerken",
        thrEditSubtitle: "Opslaan vervangt alle drempels volledig; vooraf ingestelde standaarden gelden slechts tot hier eigen waarden zijn gezet.",
        thrMinSamples: "Min. voorbeelden",
        thrMinTokens: "Min. tokens (geschat)",
        thrEnabled: "actief",
        thrAdd: "Rij toevoegen",
        thrSave: "Drempels opslaan",
        thrSaved: "Drempels opgeslagen",
        thrEmpty: "Nog geen drempels gedefinieerd — zonder actieve drempels verzegelt de autopilot niets en meldt dat als blokkade.",
        capability: "Vaardigheid",
        modSignature: "Signatuur",
        removeRow: "Verwijderen",
        budgetsTitle: "Dagbudgetten",
        budgetsSubtitle: "Verbruik tegen bovengrens per bereik en dag — de budgetten begrenzen leraar- en embedding-aanroepen.",
        budgetScope: "Bereik",
        budgetDay: "Dag",
        budgetSpent: "Verbruikt",
        budgetCap: "Bovengrens",
        budgetsEmpty: "Geen budgetten gemeld.",
        eventsTitle: "Gebeurtenissen",
        eventsSubtitle: "Wat de autopilot als laatste deed of meldde, nieuwste eerst.",
        eventsEmpty: "Nog geen gebeurtenissen.",
        storageTitle: "Cloudopslag",
        storageSubtitle: "De verbinding met Block Storage en de initialisatie van de mappenstructuur — herhaalbaar zonder bijwerkingen.",
        connect: "Block Storage verbinden",
        backendLabel: "Cold-store-backend",
        backendBlockStorage: "Block Storage",
        backendLocal: "Lokale opslag",
        connectedLabel: "Verbinding",
        connectedYes: "verbonden",
        connectedNo: "niet verbonden",
        accountLabel: "Account",
        signinValidUntil: "Aanmelding geldig tot",
        oauthClientLabel: "OAuth-client",
        clientConfigured: "geconfigureerd",
        clientNotConfigured: "niet geconfigureerd",
        bootstrapRun: "Structuur initialiseren",
        bootstrapDone: "Initialisatie uitgevoerd",
        bootstrapReportTitle: "Laatste uitvoering",
        bootstrapNoRun: "In deze sessie is nog geen bootstrap uitgevoerd.",
        bootstrapLine: "Aangemaakte mappen: {folders} · bestanden in de cold store: {files} · herhaling zonder wijzigingen: {idempotent}",
        treeTitle: "Mappenboom",
        treeSubtitle: "De boom is een geversioneerde specificatie: hier definieert u mappen, de autopilot mag alleen aanvullen. Beschermde engine-mappen en niet-lege mappen weigert de engine met reden. In de Block Storage wordt alleen volgens vaste regels verwijderd, zoals oudere checkpointkopieën (de nieuwste twee blijven); tijdens een volledige download wachten verwijderingen en overschrijvingen tot hij eindigt.",
        treeActiveVersion: "Actieve versie v{version}",
        treePath: "Pad",
        treePurpose: "Doel",
        treeCreatedBy: "Aangemaakt door",
        treeShards: "Shards",
        treeBytes: "Grootte",
        treeActions: "Acties",
        treeRetire: "Buiten gebruik stellen",
        treeRetired: "Map buiten gebruik gesteld",
        treeAddFolder: "Map toevoegen",
        treeFolderAdded: "Map aangemaakt",
        treeVersionsTitle: "Versies",
        treeEmpty: "Nog geen mappen gedefinieerd.",
        treePlanned: "Gepland — boomspecificatie v{version}",
        treeFiles: "Bestanden",
        treeSizesMeasured: "Groottes gemeten {measured}; de mappen die de catalogus niet bijhoudt, laatst in de Block Storage geteld {walked}. 1 GB = 10⁹ bytes.",
        treeSizesNoWalk: "Groottes gemeten {measured}; de mappen die de catalogus niet bijhoudt, zijn nog niet geteld. 1 GB = 10⁹ bytes.",
        treeExpand: "{count} submappen tonen",
        treeCollapse: "Submappen verbergen",
        treeShowMore: "Nog {count} mappen tonen",
        treeSourceCatalog: "Uit de catalogus: geteld zijn objecten die echt in de Block Storage staan",
        treeSourceWalk: "Geteld tijdens de rondgang door de Block Storage",
        bsUsageTitle: "Opslagruimte van de Block Storage",
        bsUsageSubtitle: "Gebruikte ruimte, limiet en vrije ruimte van het Block Storage-account en het aandeel van de data lake daarin; de waarden zijn hooguit tien minuten oud. 1 GB = 10⁹ bytes.",
        bsUsed: "Gebruikt",
        bsLimit: "Limiet",
        bsFree: "Vrij",
        bsNoLimit: "zonder vaste limiet",
        bsTrash: "In de prullenbak",
        bsLake: "Waarvan data lake",
        bsLakeLine: "{size} in {files} bestanden · {share} van de gebruikte ruimte",
        bsMeasuredAt: "Gemeten",
        bsNotConnected: "De Block Storage is niet verbonden; de opslagruimte verschijnt zodra de verbinding er is.",
        bsBarLake: "Data lake",
        bsBarOther: "Overig in het account",
        bsDlTitle: "Volledige download",
        bsDlSubtitle: "Downloadt de hele Block Storage bestand voor bestand in dezelfde mappenstructuur, zonder archief. Zolang hij loopt, geldt de beschermingsmodus: verwijderingen en overschrijvingen van de vastgelegde bestanden wachten tot hij eindigt; nieuwe bestanden worden verder geschreven en horen niet bij deze download. Een lopende training wordt nooit opgehouden.",
        bsDlButton: "Volledige Block Storage downloaden",
        bsDlFolderHint: "U kiest één keer een doelmap; de submappen ontstaan daar. Volledig aanwezige bestanden worden overgeslagen, afgebroken bestanden vanaf hun lengte hervat.",
        bsDlScriptHint: "Deze browser kan geen mappen schrijven. U krijgt een downloadscript dat dezelfde mappenstructuur aanlegt en elk bestand hervatbaar downloadt.",
        bsDlWindowsNames: "Tekens die Windows in namen niet toestaat (zoals ‘>’), staan in de doelmap als %-code, bijvoorbeeld %3E.",
        bsDlActiveNote: "Er loopt een download sinds {time}. De knop hierboven zet hem in deze browser voort; volledige bestanden worden overgeslagen.",
        bsDlBuilding: "De bestandslijst wordt opgesteld: tot nu toe {files} bestanden, {size}.",
        bsDlManifest: "De bestandslijst wordt geladen: {done} van {total} items.",
        bsDlFolder: "Doelmap",
        bsDlFiles: "Bestanden",
        bsDlData: "Gegevens",
        bsDlOf: "{done} van {total}",
        bsDlRate: "Snelheid",
        bsDlEta: "Resterende tijd",
        bsDlEtaUnknown: "wordt bepaald",
        bsDlCurrent: "Wordt nu geladen",
        bsDlSkipped: "{count} al volledig aanwezig, overgeslagen",
        bsDlFailed: "{count} bestanden mislukt",
        bsDlPausedNote: "Gepauzeerd. Begonnen bestanden worden bij het hervatten vanaf hun lengte verder geladen; de beschermingsmodus blijft zolang deze pagina open is.",
        bsDlPause: "Pauzeren",
        bsDlContinue: "Hervatten",
        bsDlRetryFailed: "Mislukte opnieuw laden",
        bsDlFinish: "Afronden",
        bsDlStop: "Stoppen",
        bsDlStateBuilding: "bestandslijst in voorbereiding",
        bsDlStateRunning: "laadt",
        bsDlStatePaused: "gepauzeerd",
        bsDlStateIncomplete: "onvolledig",
        bsDlStateScript: "script klaar",
        bsDlStateFinished: "afgerond",
        bsDlStateStopped: "beëindigd",
        bsDlStateActive: "actief",
        bsDlFinished: "Alle {files} bestanden ({size}) staan in de doelmap; de download is afgerond.",
        bsDlFinishedNote: "De download is afgerond; de tegengehouden verwijderingen en overschrijvingen lopen nu.",
        bsDlStopped: "De download is gestopt; de tegengehouden verwijderingen en overschrijvingen lopen nu. Al geladen bestanden blijven behouden.",
        bsDlEnded: "De server heeft de download beëindigd, bijvoorbeeld na dertig minuten zonder levensteken. Een nieuwe klik start hem opnieuw; volledige bestanden worden overgeslagen.",
        bsDlSession: "De aanmelding is verlopen. Meld u opnieuw aan; daarna zet de knop hierboven de download voort.",
        bsDlDiskFull: "In de doelmap is geen ruimte meer. Maak ruimte vrij en hervat dan.",
        bsDlPickFailed: "De doelmap kon niet worden geopend.",
        bsDlScriptPosix: "Script voor Linux en macOS",
        bsDlScriptWindows: "Script voor Windows",
        bsDlScriptRun: "Sla het script op in de doelmap en start het daar: onder Windows door te dubbelklikken op het .cmd-bestand of via de opdrachtprompt, onder Linux en macOS in de terminal met ‘sh <bestand>’.",
        bsDlScriptKeyValid: "De sleutel in het script is geldig tot {time}, alleen voor deze download en alleen om te lezen.",
        bsDlScriptHeartbeat: "Zolang deze pagina open is, meldt ze de server dat de download nog loopt. Klik op ‘Afronden’ wanneer het script klaar is.",
        bsDlProtection: "Beschermingsmodus",
        bsDlProtectionState: "Toestand",
        bsDlProtectionOn: "actief sinds {time}",
        bsDlProtectionOff: "niet actief",
        bsDlScope: "Omvang van de download",
        bsDlScopeValue: "{files} bestanden, {size}",
        bsDlDeferredDeletes: "Tegengehouden verwijderingen",
        bsDlDeferredOverwrites: "Tegengehouden overschrijvingen",
        bsDlAddedSince: "Sinds de start nieuw toegevoegd",
        bsDlLastActivity: "Laatste levensteken",
        acqTitle: "Databronnen",
        acqSubtitle: "Gecureerde bronnen met open licentie: per bron licentie, gegevensbeschermings-beoordeling, taal, modaliteit, byte-doel en gemeten voortgang. Uitgeschakelde bronnen noemen hun reden in plaats van stil te ontbreken.",
        acqGdprNote: "AVG-grondbeginsel: trainingsdata wordt alleen toegelaten uit bronnen met een open licentie en een gedocumenteerde gegevensbeschermings-beoordeling; postvak-data doorloopt vóór de voorbeeldvorming een PII-scrub (de teller \"PII-gescrubd\" toont dit).",
        acqSource: "Bron",
        acqModality: "Modaliteit · taal",
        acqLicense: "Licentie",
        acqProtection: "Gegevensbescherming",
        acqProgress: "Voortgang",
        acqDocs: "{count} bestanden/objecten binnengekomen",
        acqTargetReached: "doel bereikt",
        acqExhausted: "bron uitgeput (listing levert niets meer)",
        acqEnabledPill: "actief",
        acqWaitingBuffer: "wacht: buffer vol, de upload haalt in",
        acqDisabledPill: "uitgeschakeld",
        acqEnable: "Inschakelen",
        acqDisable: "Uitschakelen",
        acqEnabledMsg: "Bron ingeschakeld",
        acqDisabledMsg: "Bron uitgeschakeld",
        acqTargetLabel: "Doel (GB)",
        acqSetTarget: "Doel opslaan",
        acqTargetSaved: "Doel opgeslagen",
        acqEmpty: "Nog geen bronnen geregistreerd.",
        balanceTitle: "Taalbalans Duits/Engels",
        balanceSubtitle: "Gedownloade bytes per modaliteit en taal — Duits mag bij de seed-bronnen niet achterblijven bij Engels.",
        balanceEmpty: "Nog geen meetwaarden.",
        modText: "Tekst",
        modAudio: "Audio",
        modImage: "Beeld",
        modVideo: "Video",
        prepTitle: "Voorverwerking",
        prepSubtitle: "Getelde pipeline-stadia van het geregistreerde ruwe document tot het trainingsvoorbeeld — elk getal uit de catalogus; fouten en niet-ondersteunde items zijn benoemd.",
        prepRegistered: "geregistreerd",
        prepScrubbed: "PII-gescrubd",
        prepChunked: "opgedeeld",
        prepEmbedded: "ge-embed",
        prepExtracted: "geëxtraheerd",
        prepLinked: "gekoppeld",
        prepSamples: "voorbeelden",
        prepByLang: "Per taal",
        prepUnsupported: "Niet ondersteund",
        prepAwaiting: "Wacht op een stap",
        prepFailures: "Fouten",
        inboxTitle: "Ruwe-data-postvak",
        assetWhat: "Inhoud",
        assetFromSource: "uit bron {source}",
        assetFromUpload: "handmatig geüpload",
        mediaParquet: "Tabeldata (Parquet)",
        treeShardsHint: "Shards zijn de Parquet-datapakketten van de catalogus: per rij één pakket met herkomst, taal en doel — de kolom ‘doel’ zegt wat er in een map zit.",
        mediaWords: {
          text: "Tekst",
          audio: "Audio",
          video: "Video",
          image: "Afbeelding",
          application: "Bestand",
        },
        inboxSubtitle: "Eigen ruwe data aan de lake geven: hier uploaden of rechtstreeks in de cloudmap raw/inbox/ plaatsen. De afstemming registreert elk bestand; \"Nu verwerken\" start dezelfde weg die de autopilot zelfstandig gaat.",
        uploadButton: "Bestand uploaden",
        uploadHint: "Tot 512 MB per bestand. Uploads belanden in de cold store en worden bij verwerking opgedeeld, ge-embed en in de kennisgraaf gekoppeld.",
        uploadTooLarge: "Het bestand is groter dan 512 MB.",
        uploadDone: "Bestand overgenomen",
        processNow: "Nu verwerken",
        processStarted: "Verwerking gestart",
        reconcileNow: "Cloudmap afstemmen",
        reconcileDone: "Afstemming uitgevoerd",
        unprocessedCount: "{count} onverwerkt",
        inboxEmpty: "Het postvak is leeg.",
        assetName: "Bestand",
        assetType: "Type",
        assetSize: "Grootte",
        assetState: "Toestand",
        assetLang: "Taal",
        assetRegistered: "Geregistreerd",
        assetStates: {
          raw_stored: "ruwe data opgeslagen",
          awaiting_stt: "wacht op spraakherkenning",
          awaiting_content_fetch: "wacht op de inhoud achter het adres",
          awaiting_image_codec: "wacht op de beeldcodec",
          awaiting_audio_codec: "wacht op de audiocodec",
          awaiting_video_codec: "wacht op de videocodec",
          chunked: "opgedeeld & in de graaf",
          processed: "verwerkt",
          registered: "geregistreerd",
          queued: "wacht",
          processing: "in verwerking",
          ingested: "overgenomen",
          linked: "gekoppeld",
          unsupported: "niet ondersteund",
          failed: "mislukt",
        },
        graphTitle: "Kennisgraaf",
        graphSubtitle: "Het gekoppelde ruwe bestand: knopen en kanten, geteld uit de catalogus — uit deze verbindingen ontstaan de trainingsvoorbeelden.",
        graphEmbedded: "Ge-embedde knopen",
        graphModel: "Embedding-model",
        graphClusters: "Clusters",
        graphAssetsLinked: "Gekoppelde ruwe data",
        graphLastLink: "Laatste koppeling",
        graphNodesTitle: "Knopen per soort",
        graphEdgesTitle: "Kanten per soort",
        graphEmpty: "De graaf is nog leeg — hij ontstaat met het eerste verwerkte bestand.",
        kindCol: "Soort",
        countCol: "Aantal",
        neighborsTitle: "Buren van een knoop",
        nodeIdLabel: "Knoop-ID",
        neighborsRun: "Buren ophalen",
        neighborsEmpty: "Geen buren gevonden.",
        nodeCol: "Knoop",
        edgeKindCol: "Kant",
        weightCol: "Gewicht",
        gapTitle: "Dekkings- & hiaatmatrix",
        gapSubtitle: "Gemeten voorraad tegen de ingestelde mixdoelen per vaardigheid, signatuur en niveau — een SQL-weergave over de catalogus, nooit vast ingebouwd.",
        tier: "Niveau",
        gapHave: "Is",
        gapTarget: "Doel",
        gapWeight: "Gewicht",
        gapPriority: "Prioriteit",
        targetsTitle: "Mixdoelen definiëren",
        targetsSubtitle: "Doelen dragen auteur en tijdstip; zonder doelen toont de matrix de eerlijke lege toestand.",
        addTargetRow: "Rij toevoegen",
        saveTargets: "Doelen opslaan",
        targetsSaved: "Doelen opgeslagen",
        statusCol: "Status",
        tdvTitle: "Verzegelde datastand",
        tdvSubtitle: "De datastand is onveranderlijk en samengesteld uit verzegelde shards; een nieuwe vervangt de vorige.",
        createTdv: "TDV-concept aanmaken",
        tdvCreated: "TDV-concept aangemaakt",
        tdvId: "TDV",
        tdvName: "Naam",
        tdvMembers: "Leden",
        tdvCreatedAt: "Aangemaakt",
        tdvSealedAt: "Verzegeld",
        tdvStatusDraft: "concept",
        tdvStatusSealed: "verzegeld",
        sealTdv: "Verzegelen",
        tdvSealed: "TDV verzegeld",
        tdvEmpty: "Nog geen Train Data Version — die ontstaat uit verzegelde shards.",
        compatTitle: "Compatibiliteitscontrole architectuur en data",
        compatSubtitle: "Regels R1–R12 over twee machineleesbare documenten; het dashboard toont het opgeslagen rapport van de engine en berekent geen eigen oordeel.",
        compatAllGreen: "ALL-GREEN",
        compatNotGreen: "niet ALL-GREEN",
        compatRun: "Controle uitvoeren",
        compatChecked: "Controle uitgevoerd",
        compatSelectTdv: "Selecteer een TDV in de lijst hierboven om het rapport te zien.",
        compatNoReport: "Voor deze TDV bestaat nog geen opgeslagen compatibiliteitsrapport.",
        compatDraftNote: "De data-interface van de architectuur is een concept — tokenizer- en codec-artefacten bestaan nog niet; de controle wordt actief met de eerste tokenizer-release en de eerste verzegelde TDV.",
        compatRule: "Regel",
        compatTitleCol: "Titel",
        compatKind: "Soort",
        compatEvidence: "Vergeleken waarden (bewijs)",
        kindHard: "hard",
        kindWarn: "advies",
        reportsTitle: "Opgeslagen rapporten",
        reportsEmpty: "Nog geen compatibiliteitsrapport opgeslagen.",
        phaseLabel: "Trainingsfase",
        phaseA: "Fase A — gereedheid & evolutie",
        phaseB: "Fase B — training loopt, architectuur bevroren",
        checklistTitle: "Trainingsgereedheid (fase-A-checklist)",
        checklistSubtitle: "Live berekende voorwaarden; de start blijft geblokkeerd tot elk punt groen is, en elk onvervuld punt wordt benoemd.",
        checklistReady: "gereed",
        checklistUnmet: "{count} punten onvervuld",
        checklistUnavailable: "De checklist is onbereikbaar.",
        itemSatisfied: "vervuld",
        itemUnsatisfied: "onvervuld",
        startTraining: "Fase B starten",
        strandTitle: 'Trainingsstreng',
        strandSubtitle: 'Welke modelstreng traint zodra alle voorwaarden zijn vervuld; de niet-gekozen streng blijft data voorbereiden maar start nooit.',
        strandSelectedBadge: 'geselecteerd',
        strandExplain: 'De autopiloot traint {selected}. {other} blijft verzamelen en voorbereiden, maar start niet zolang die niet is geselecteerd.',
        strandSwitched: 'Selectie opgeslagen.',
        strandSwitchFailed: 'Omschakelen mislukt.',
        strandUnavailable: 'Deze backend levert nog geen strengen; na de volgende core-rollout verschijnt hier de keuze.',
        trainingStarted: "Fase B gestart",
        startBlocked: "Start geblokkeerd — onvervuld: {items}",
        selectedTdvLabel: "Gekozen datastand",
        computedAt: "Berekend",
        runsTitle: "Trainingsruns",
        runsSubtitle: "Alleen echte runs uit de catalogus; er bestaat geen gesimuleerd trainingsproces.",
        runId: "Run",
        archVersion: "Architectuur",
        presetCol: "Preset",
        seqLenCol: "Sequentielengte",
        stepCol: "Stap",
        lossCol: "Loss",
        runStarted: "Gestart",
        runFinished: "Beëindigd",
        runsEmpty: "Nog geen trainingsrun.",
        abortRun: "Afbreken",
        confirmAbort: "Deze trainingsrun afbreken?",
        runAborted: "Afbreken aangevraagd",
        benchLink: "Benchmark",
        benchTitle: "Benchmarkrapporten",
        benchSubtitle: "De bevroren, geversioneerde suite draait automatisch na elke training; elk rapport ligt in de lake en staat hier.",
        benchEmpty: "Nog geen benchmarkrapport.",
        suiteVersion: "Suite",
        benchOpen: "Openen",
        benchReportFor: "Benchmarkrapport bij run {run}",
        benchNoMarkdown: "Dit rapport draagt geen gerenderd document; de ruwe resultaten staan eronder.",
        exportsTitle: "Exporten",
        exportsSubtitle: "Downloads bestaan uitsluitend voor exporten van afgeronde echte trainingsruns.",
        exportId: "Export",
        exportSize: "Grootte",
        exportSha: "SHA-256",
        download: "Downloaden",
        exportsEmpty: "Nog geen export — die ontstaat pas uit een afgeronde echte trainingsrun.",
        hfTitle: "HuggingFace-publicaties",
        hfSubtitle: "Elke upload gebeurt privé; de zichtbaarheid wordt na de upload via de API geverifieerd. Een niet-privaat resultaat is een fouttoestand die de kringloop stopt.",
        hfEmpty: "Nog geen publicatie.",
        hfRepo: "Repository",
        hfState: "Toestand",
        hfVisibility: "Zichtbaarheid",
        hfPrivateVerified: "privé — geverifieerd",
        hfUnverified: "nog niet geverifieerd",
        hfVerifiedAt: "Geverifieerd",
        connectTitle: "Block Storage verbinden",
        connectSubtitle: "Aanmelden via het aanmeldvenster van de opslagaanbieder; de opslag verbindt met het account dat daar bevestigt.",
        webConnectStart: "Verbinden met de opslagaanbieder",
        webConnectWaiting: "Wachten op de bevestiging in het aanmeldvenster van de opslagaanbieder…",
        webConnectHint: "Na de bevestiging verbindt de opslag automatisch; dit venster werkt zichzelf bij.",
        publicIdentity: "Publieke app-identiteit (rclone, gedeelde quota)",
        publicIdentityNote: "Het aanmeldvenster van de opslagaanbieder toont „rclone” als aanvragende app — de publiek gedeelde identiteit; een eigen client-ID (GDRIVE_OAUTH_CLIENT_ID) vervangt die altijd.",
        manualHint: "Na de bevestiging toont de browser een onbereikbare localhost-pagina. Kopieer de waarde van de parameter code= uit de adresbalk en plak die hier (de hele adresregel plakken werkt ook).",
        manualCodeLabel: "Autorisatiecode",
        manualSubmit: "Code inwisselen",
        deviceInstead: "In plaats daarvan apparaatcode gebruiken",
        licenseAcceptLink: "Licentie bevestigen op Hugging Face",
        deviceFlowTitle: "Block Storage verbinden (device flow)",
        deviceFlowSubtitle: "De engine start de apparaataanmelding van de aanbieder; de bevestiging gebeurt op een tweede apparaat en wordt met begrensde intervallen opgevraagd.",
        deviceFlowStart: "Aanmeldflow starten",
        deviceFlowCode: "Apparaatcode",
        deviceFlowOpenUrl: "Bevestigingspagina openen",
        deviceFlowWaiting: "Wachten op bevestiging — de peiling loopt op het door de aanbieder voorgeschreven interval.",
        deviceFlowAuthorized: "Verbonden",
        deviceFlowExpired: "De apparaatcode is verlopen — start de aanmeldflow opnieuw.",
        readinessTitle: "Gereedheid tot training",
        readinessSubtitle: "De gemeten weg naar de eerste trainingsrun, stap voor stap.",
        readinessCounter: "{green} van {total} voldaan",
        readinessReady: "Klaar voor training",
        unblockLabel: "Volgende stap",
        readinessUnavailable: "Het gereedheidsoverzicht is in de backend nog niet uitgerold. Zodra het endpoint live is, verschijnt hier de gemeten stand.",
        stageStates: {
          ok: "voldaan",
          active: "bezig",
          waiting: "wacht",
          blocked: "geblokkeerd",
        },
      },
      gt: {
        loading: '…',
        unavailable: 'niet beschikbaar',
        equilibrium: 'Optimale bedrijfstoestand bereikt: alle vragen zijn beantwoord, alle taakoverdrachten verwerkt en redundantie is vermeden.',
        standby: 'stand-by',
        defTitle: 'Operationele Teamcoördinatie & Prestatiemetrieken',
        defSubtitle: 'Meting van de operationele communicatie- en overdrachtskwaliteit van alle AI-rollen: focus op geverifieerde resultaten in plaats van onproductieve activiteit.',
        defPlayers: 'Betrokken Rollen & Systemen',
        defPlayersText: 'De tien gespecialiseerde AI-rollen met hun Webex-bots, samen met de menselijke beslissers die opdrachten en richtlijnen vaststellen.',
        defStrategies: 'Communicatie- & Werkprincipes',
        defStrategiesText: 'Directe beantwoording van vragen, eenduidige en volledige taakoverdrachten, vermijding van redundantie en consequente afronding van open werkpakketten.',
        defPayoff: 'Operationele Resultaatbijdrage (Netto-nut)',
        defPayoffText: 'Afgeronde werkpakketten, succesvol verwerkte overdrachten en beantwoorde vragen — minus frictieverliezen (redundantie, onverwerkte overdrachten, onbeantwoorde vragen).',
        defEquilibrium: 'Optimale Bedrijfstoestand (Coördinatie-evenwicht)',
        defEquilibriumText: 'Doeltoestand van de samenwerking: elke vraag wordt tijdig beantwoord, elke taakoverdracht wordt overgenomen, geen informatie wordt dubbel verzonden en geen werkpakket blijft liggen.',
        playersTitle: 'Prestatieoverzicht per Rol (Posities)',
        playersSubtitle: 'Operationele communicatie- en leveringskengetallen per rol: inhoudelijke bijdragen en overdrachten (laatste 7 dagen) evenals vergaderingen en afgeronde werkpakketten (laatste 30 dagen).',
        playersHint: 'Netto-nut = 3 × afgeronde werkpakketten + verwerkte overdrachten − frictieverliezen (onverwerkte overdrachten tellen dubbel). Een negatieve waarde duidt op coördinatiebehoefte.',
        player: 'Rol / Positie',
        contributions: 'Bijdragen',
        meetingTurns: 'Meetings',
        handovers: 'Overdrachten',
        consumedShort: 'verwerkt',
        refusedShort: 'geweigerd',
        delivery: 'Bezorging',
        pausedTurns: 'Gepauzeerde beurten',
        pausedTurnsHint: 'Beurten die in de eigen mailbox van de collega zijn bewaard omdat de modellen ze op dat moment niet konden bedienen. Geen overdrachten.',
        closedOpen: 'afgesloten / open',
        noise: 'Frictieverlies',
        utility: 'Netto-resultaatbijdrage',
        meetingsLine: '{held} meetings, {turns} bijdragen, {u} onbeantwoorde aanspreken (30 dagen).',
        interactionsTitle: 'Taakoverdrachten tussen Rollen (Handover-matrix)',
        interactionsSubtitle: 'Gerichte taakoverdrachten tussen de postvakken (laatste 7 dagen): aantal, doorlooptijd en verwerkte en geweigerde overdrachten.',
        interactionsHint: 'Een taakoverdracht geldt pas na verwerking door de ontvanger als afgerond; geweigerde of onverwerkte overdrachten worden als procesafwijking gemeld.',
        interactionsEmpty: 'Geen overdrachten in het venster.',
        from: 'Van',
        to: 'Aan',
        messages: 'Berichten',
        consumed: 'verwerkt',
        refused: 'geweigerd',
        deviationsTitle: 'Procesafwijkingen & Open Knelpunten',
        deviationsSubtitle: 'Actuele coördinatietekorten: onbeantwoorde vragen, onverwerkte taakoverdrachten, redundante bijdragen of geblokkeerde werkpakketten.',
        dev_unanswered_question: 'Onbeantwoorde vraag (tijdslimiet overschreden)',
        dev_dead_air: 'Taakoverdracht zonder terugkoppeling',
        dev_repetition: 'Herhaling in de meeting',
        dev_meeting_unanswered: 'Directe aanvraag zonder terugkoppeling',
        dev_work_blocked: 'Werk geblokkeerd',
        dev_handover_hop_budget_reached: 'Overdracht-hopbudget overschreden',
        dev_commitment_unkept: 'Sprinttoezegging niet nagekomen',
        devWithheld: 'tegengehouden',
        devRepetition: 'herhaling',
        devDeadAir: 'onverwerkte overdracht',
        devMeetingUnanswered: 'onbeantwoord',
        effectiveThresholdCol: 'Eff. drempel',
        excessHopsLabel: 'Overtollige overdracht-hops',
        timeTitle: 'Doorlooptijden & Productiviteitsvergelijking (AI vs. handmatige verwerking)',
        timeSubtitle: 'Gemeten AI-verwerkingsduur van afgeronde ontwikkelopdrachten vergeleken met de geschatte handmatige werklast.',
        timeHint: 'Calculatoire referentiewaarden voor inspanningsraming; configureerbaar door de directie.',
        avgCycle: 'Gem. AI-cyclus',
        fromTasks: 'uit {n} taken',
        speedup: 'Versnelling',
        speedupHint: '{h} mensuren aangenomen per stuk',
        humanDelivered: 'Mensdagen geleverd',
        humanDays: 'mensdagen',
        forecast: 'Prognose open werk: {d} mensdagen',
        sizes: 'Groottes',
        sizeSmall: 'klein',
        sizeMedium: 'middel',
        sizeLarge: 'groot',
        scrumTitle: 'Scrum',
        scrumSubtitle: 'De sprint, de storypoints en de velocity, uit de eigen gegevens van het bedrijf',
        sprintLabel: 'Sprint {n}',
        ends: 'eindigt',
        committedPts: 'Toegezegde punten',
        deliveredPts: 'Geleverde punten',
        remainingPts: 'Resterende punten',
        burndownTitle: 'Burndown (resterende punten per dag)',
        velocityTitle: 'Velocity van de afgesloten sprints',
        predictability: 'voorspelbaarheid',
        forecastLine: 'Lopende velocity {v} punten per sprint · backlog {b} punten ≈ {s} sprints',
        noSprint: 'Er loopt geen sprint; de volgende planning opent er een.',
        noItems: 'Nog niets toegezegd; de sprint neemt wat de mensen brengen.',
        colItem: 'Item',
        colOwner: 'Eigenaar',
        colPoints: 'Punten',
        colState: 'Status',
        itemDone: 'geleverd',
        itemOpen: 'open',
        unestimated: 'niet geschat',
        addedBy: 'toegevoegd door {who}',
        setGoal: 'Sprintdoel',
        sprintDaysLabel: 'Sprintlengte (dagen)',
        save: 'Opslaan',
        endSprint: 'Sprint nu beëindigen',
        confirmEndSprint: 'Sprint nu beëindigen? Review, retrospective en de volgende planning lopen direct.',
        planNow: 'Eerste planning nu houden',
        confirmPlanNow: 'De sprintplanning nu houden? Dit opent de eerste sprint in pAIoneer-scrum.',
        sprintPointsCol: 'Sprintpunten',
        ceremonySpaceLabel: 'Ceremonieruimte',
        scrumOfScrums: 'Scrum of Scrums houden',
        confirmScrumOfScrums: 'Scrum of Scrums nu over alle Business Units houden?',
        lastScrumOfScrumsTitle: 'Laatste Scrum of Scrums',
        escalatedImpedimentsTitle: 'Geëscaleerde impediments',
        unitBreakdownTitle: 'Sprint-uitsplitsing per Business Unit',
        colUnit: 'Business Unit',
        colWip: 'Open werk',
        colImpediments: 'Impediments',
      },
      nav: {
        groups: {
          gametheory: 'Teamcoördinatie & Scrum',
          demos: 'Live-voorbeelden',
          sovereign: 'Soeverein LLM',
          today: 'Dagoverzicht & Leitstand',
          organisation: 'Organisatie',
          work: 'Werk',
          communication: 'Communicatie',
          memory: 'Geheugen',
          platform: 'Platform',
          products: 'Producten',
          identity: 'Identiteit',
        },
        pages: {
          gametheory: 'Teamcoördinatie & Scrum',
          demos: 'Live-voorbeelden',
          llm: 'LLM-architectuur — paper',
          training: 'Data Lake & AI-modeltraining',
          today: 'Dagoverzicht & Leitstand',
          work: 'Werkpakketten en projecten',
          coding: 'Programmeeropdrachten',
          gitlab: 'GitLab & Image-builds',
          agents: 'Agenten en ontwerpen',
          research: 'Onderzoek',
          webex: 'Webex-ruimtes',
          mailboxes: 'Postvakken',
          conversations: 'Gesprekken en oproepen',
          meetings: 'Besprekingen',
          engines: 'AI-engines & GPU',
          usage: 'Verbruik en budgetten',
          workloads: 'Containerdiensten',
          orchestrator: 'Veridion MCP-orchestrator',
        },
        sections: {
          demos: {
            previews: 'Live-voorbeelden',
          },
          llm: {
            paper: 'Paper',
            monitoring: 'Bewaking',
          },
          training: {
            autopilot: "Autopilot",
            storage: "Cloudopslag & mappenboom",
            acquisition: "Dataverwerving & voorverwerking",
            data: "Data & kennisgraaf",
            training: "Training & publicatie",
          },
          platform: {
            nodes: 'Clusternodes',
            events: 'Gebeurtenissen',
          },
          smtm: {
            runtime: 'Runtimebesturing',
            prediction: 'Prognosesturing',
            status: 'Datastatus',
            reporting: 'Signalen',
            training: 'Modellen',
            console: 'Trainingsconsole',
          },
          agentic: {
            overview: 'Overzicht',
            tools: 'Tools',
            mcp: 'MCP-servers',
            activity: 'Activiteit',
          },
          'company-memory': {
            content: 'Inhoud',
            search: 'Zoeken en situatiebeelden',
            facts: 'Feiten',
            entity: 'Entiteiten',
            remember: 'Vastleggen',
            audit: 'Auditlogboek',
            console: 'Queryconsole',
            stores: 'Opslag',
            graph: 'Kennisgraaf',
            day: 'Dag',
            bubbles: 'Afdelings-kennisdomeinen & Onderzoek',
          },
          organisation: {
            chart: 'Organigram',
            colleagues: 'AI-collega\'s en postvakken',
            voices: 'Stemmen',
            people: 'Personen en ruimtes',
            approvals: 'Goedkeuringen en schema\'s',
            edit: 'Organisatie bewerken',
          },
          work: {
            items: 'Werkpakketten',
            projects: 'Projecten in ontwikkeling',
          },
          gitlab: {
            gitlab: 'GitLab',
            builds: 'Image-builds',
          },
          agents: {
            agents: 'Agenten',
            designs: 'Agentontwerpen',
            definitions: 'Definities',
          },
          usage: {
            identities: 'Per identiteit',
            budgets: 'Tokenbudgetten',
            company: 'Bedrijfsinstantie',
            smtm: 'Veridion SMTM',
          },
          orchestrator: {
            runtime: 'Runtime',
            mcp: 'MCP-servers',
            tools: 'Tools',
            activity: 'Activiteit',
          },
        },
        attentionTitle: 'Actie nodig',
        attentionSubtitle: 'Toestanden uit alle onderdelen die ingrijpen vragen. Een klik opent het onderdeel.',
        attentionNone: 'Geen actie nodig.',
        stateTitle: 'Bedrijfstoestand',
        none: 'geen',
        readyOf: '{ready} van {total} gereed',
        connectedOf: '{connected} van {total} verbonden',
        registeredOf: '{registered} van {total} geregistreerd',
        showMore: 'Meer tonen',
        shownOf: '{shown} van {total}',
        expand: 'Uitklappen',
        collapse: 'Inklappen',
        service: 'Dienst',
        serviceLinks: 'Links',
        controlsTitle: 'Besturing van Veridion Core',
        confirmRemove: '{what} verwijderen?',
        companyIdentitiesTitle: 'Gateway-identiteiten van de bedrijfsinstantie',
        companyIdentitiesSubtitle: 'De tokens van de orchestrator en van Veridion Core in het lopende venster van de gateway, elke identiteit met haar budget.',
        conversationsTitle: 'Gesprekken vanuit het dashboard',
        conversationsSubtitle: 'Per AI-collega de schriftelijke gesprekken vanuit het dashboard; schrijven en bellen openen een dialoog boven de pagina.',
        conversationCount: 'Berichten',
        conversationLastWritten: 'Laatst geschreven',
        conversationLastAnswered: 'Laatst beantwoord',
        exchangesTitle: 'Berichten en antwoorden',
        exchangesSubtitle: 'Elk bericht vanuit het dashboard met het antwoord van de AI-collega, nieuwste eerst.',
        conversationMessage: 'Bericht',
        conversationAnswer: 'Antwoord',
        today: {
          wordTitle: 'Actuele Directierichtlijn',
          wordNone: 'Er is momenteel geen openstaande directierichtlijn vastgelegd.',
          sinceTitle: 'Gebeurtenissen sinds laatste bezoek',
          sinceState: 'sinds {time}',
          workTitle: 'Actieve taken & Verantwoordelijkheden',
          workNone: 'Geen werkpakket is in uitvoering.',
          nextMeeting: 'Volgende meeting',
          lastMeeting: 'Laatste meeting',
        },
        work: {
          title: 'Werkpakketten',
          subtitle: 'Elk open werkpakket uit het bedrijfsgeheugen met verantwoordelijke, toestand, prioriteit, termijn en de resultaten van zijn scenario\'s; de titel opent het in de graaf.',
          item: 'Werkpakket',
          kind: 'Soort',
          owner: 'Verantwoordelijke',
          status: 'Toestand',
          priority: 'Prioriteit',
          due: 'Termijn',
          scenarios: 'Scenario\'s',
          updated: 'Bijgewerkt',
          none: 'Geen open werkpakket.',
          all: 'Alle verantwoordelijken',
        },
        meetings: {
          subtitle: 'De meetings van de AI-collega\'s zoals Veridion Core ze vastlegt: tijdvak, samenvatting en de toezeggingen die werk werden.',
          slot: 'Tijdvak',
          kind: 'Soort',
          started: 'Begonnen',
          ended: 'Beëindigd',
          summary: 'Samenvatting',
          commitments: 'Toezeggingen',
          hold: 'Nu een meeting houden',
          held: 'De meeting is bijeengeroepen.',
          notHeld: 'Een meeting loopt of is in het laatste halfuur gehouden.',
          holdFailed: 'De meeting kon niet worden bijeengeroepen',
          none: 'Nog geen meeting vastgelegd.',
        },
        research: {
          title: 'Onderzoek',
          subtitle: 'Het onderzoek van de AI-collega\'s uit de tijdlijn van het bedrijf, nieuwste eerst.',
        },
        attention: {
          toneError: 'Storing',
          toneWarning: 'Melding',
          state: {
            platform: '{ready} van {workloads} workloads gereed, {nodes} van {total} nodes gereed, {restarts} herstarts.',
            gateway: '{state}; {models} modellen gerouteerd, {backends} van {total} serving-backends gereed.',
            engine: '{engine}: {running} lopend, {waiting} wachtend',
            usage: '{tokens} tokens over {identities} identiteiten in het venster {window}.',
            smtm: 'Voorspellingspoort {gate}, herbouw {rebuild}; {online} van {models} modellen online, {failed} mislukt.',
            smtmSignals: '{open} open signalen, {resolved} afgehandeld, {failed} bezorgingen mislukt.',
            smtmVeridion: '{connected} van {servers} MCP-servers verbonden.',
            company: 'Orchestrator {status}; {ready} van {workloads} workloads gereed; Veridion Core {core}; {agents} agenten actief, {waiting} wachtend.',
            companyWebex: '{registered} van {bots} bot-webhooks geregistreerd.',
            approvals: '{approvals} open goedkeuringen; {tasks} coding-taken wachten op een persoon of een review.',
            sessions: '{users} aangemelde gebruikers, {sessions} sessies, {mfa} geverifieerd, {total} accounts.',
            mail: 'SMTP {state}.',
          },
          platformUnreadable: 'De toestand van het platform is niet leesbaar.',
          nodeNotReady: 'Node {name} is niet gereed.',
          nodePressure: 'Node {name} meldt een tekort: {pressure}.',
          workloadDown: '{name} ({namespace}): {ready} van {desired} gereed.',
          gatewayNotProgrammed: 'De AI-gateway is niet geprogrammeerd.',
          smtmGateClosed: 'De prognosepoort is gesloten.',
          smtmRebuild: 'Er is een herbouw gemarkeerd.',
          smtmHint: 'Datastatus: {hint}.',
          smtmDeliveryFailed: '{count} signaalbezorgingen zijn mislukt.',
          smtmModelsFailed: '{count} modellen melden een fout.',
          mcpUnreachable: 'MCP-server {server} van {instance} is niet bereikbaar.',
          partUnavailable: 'Veridion pAIoneer Labs GmbH: {part} antwoordt niet.',
          parts: {
            orchestrator: 'orchestrator',
            webex: 'Webex-bridge',
            knowledge: 'kennisbank',
            core: 'Veridion Core',
            mcp: 'MCP-servers',
            usage: 'verbruiksregister',
            gateway: 'gatewayverbruik',
          },
          emergencyStop: 'De noodstop van Veridion Core is actief.',
          coreMisconfigured: 'Veridion Core mist instellingen: {missing}.',
          agentsWaiting: '{count} agents wachten op een antwoord.',
          hostedNotRunning: '{agent} draait niet.',
          webhookMissing: 'De webhook van {bot} is niet geregistreerd.',
          readerNotAuthorised: 'Het lezen van de bedrijfsruimtes is niet vrijgegeven.',
          approvalOpen: 'Open goedkeuring ({position}): {question}',
          taskWaiting: 'Codeertaak wacht op een persoon: {title}',
          taskReview: 'Merge request klaar voor review: {title}',
        },
      },
      ops: {
        showDetails: 'Details',
        hideDetails: 'Sluiten',
        mcpVersion: 'Versie',
        mcpUrl: 'Adres',
        mcpProtocol: 'Transport en protocol',
        mcpLastRefresh: 'Laatst opgevraagd',
        mcpError: 'Fout',
        noTools: 'Geen tools gemeld.',
        toolServer: 'Herkomst',
        toolAccess: 'Toegang',
        toolBuiltIn: 'Veridion',
        accessReadOnly: 'lezend',
        accessWrites: 'schrijvend',
        accessDestructive: 'wijzigend',
        accessUndeclared: 'niet opgegeven',
        usageTitle: 'Verbruik',
        smtmUsageSubtitle: 'Modelaanroepen, tokens en door de aanbieder gemelde kosten van de laatste 30 dagen.',
        usageByPerson: 'Per persoon',
        usageByModel: 'Per model',
        usageByDay: 'Per dag',
        model: 'Model',
        day: 'Dag',
        promptTokens: 'Invoertokens',
        completionTokens: 'Uitvoertokens',
        noUsage: 'Geen verbruik geboekt.',
        runtimeTitle: 'Runtime',
        runtimeSubtitle: 'Hoe de orchestrator van deze instantie zijn modellen aanspreekt en tools koppelt.',
        executionMode: 'Uitvoering',
        providerProtocol: 'Protocol naar het model',
        contextWindow: 'Contextvenster',
        requestTimeout: 'Tijdslimiet per verzoek',
        diagnostics: 'Diagnose',
        diagnosticsOn: 'aan',
        diagnosticsOff: 'uit (prestatiemodus)',
        externalServers: 'Verbonden MCP-servers',
        mcpEndpoint: 'MCP-eindpunt',
        workloadsTitle: 'Workloads',
        workloadsSubtitle: 'De workloads in de namespace paioneer-veridion zoals Kubernetes ze meldt.',
        botsTitle: 'Bots',
        botsSubtitle: 'De bots van de organisatie, elk met zijn webhook, en de diensten van de bridge.',
        botAddress: 'Adres',
        cardWebhook: 'Kaart-webhook',
        webhookState: 'Toestand',
        noBots: 'De bridge meldt geen bots.',
        bridgeServices: {
          knowledgeBase: 'Kennisbank',
          webResearch: 'Internetonderzoek',
          osint: 'OSINT',
          anonymizer: 'Anonimisering',
        },
        connected: 'gekoppeld',
        notConnected: 'niet gekoppeld',
        activeRooms: 'Actieve ruimtes',
        allowedRooms: 'Toegestane ruimtes',
        surface: 'Oppervlak',
        missingSettings: 'Ontbrekende instellingen',
        none: 'geen',
        instanceToolsTitle: 'Tools van de orchestrator',
        instanceToolsSubtitle: 'De tools die de orchestrator van de bedrijfsinstantie heeft geregistreerd.',
        openMailbox: 'Postvak',
        positionMailboxHint: 'AI-collega\'s verwerken overdrachten van andere AI-collega\'s; opdrachten aan een AI-collega gaan via zijn Webex-ruimte.',
        mailboxesTitle: 'Postvakken',
        mailboxesSubtitle: 'Per agent wat in zijn postvak wacht, bezorgd en gelezen is. Een klik op een rij filtert de berichten.',
        readAt: 'Gelezen',
        refresh: 'Vernieuwen',
        mailbox: 'Postvak',
        mailboxKind: 'Soort',
        mailboxKinds: {
          position: 'AI-collega',
          hosted: 'Gehoste agent',
          graph: 'Agent',
        },
        lastMessage: 'Laatste bericht',
        noMailboxes: 'Geen postvak leesbaar.',
        messagesTitle: 'Berichten',
        messagesSubtitle: 'Berichten, opdrachten en overdrachten, nieuwste eerst. Een klik toont de volledige tekst.',
        allMailboxes: 'Alle postvakken',
        allStates: 'Alle toestanden',
        time: 'Tijd',
        from: 'Van',
        to: 'Aan',
        messageKind: 'Soort',
        content: 'Inhoud',
        reply: 'Antwoord',
        noMessages: 'Geen berichten.',
        messageKinds: {
          message: 'Bericht',
          handover: 'Overdracht',
          command: 'Opdracht',
          resume: 'Voortzetting',
          subagent_result: 'Resultaat van een subagent',
          review: 'Review',
        },
        buildsTitle: 'Builds',
        buildsSubtitle: 'De images die Veridion Core voor agents heeft gebouwd, nieuwste eerst.',
        image: 'Image',
        started: 'Gestart',
        finished: 'Klaar',
        noBuilds: 'Geen builds.',
        coreToolsTitle: 'Tools van de agents',
        coreToolsSubtitle: 'De tools van de orchestrator die Veridion Core zijn agents aanbiedt.',
        description: 'Beschrijving',
        coreDailyTitle: 'Verbruik per dag en model',
        coreDailySubtitle: 'Modelaanroepen van Veridion Core in de laatste 30 dagen, per agent en model.',
        coreActivityTitle: 'Activiteit van Veridion Core',
        coreActivitySubtitle: 'Gebeurtenissen van de agents, AI-collega\'s en overdrachten in Veridion Core, nieuwste eerst.',
        event: 'Gebeurtenis',
        tool: 'Tool',
        detail: 'Detail',
      },
      tabCompanyMemory: 'Bedrijfsgeheugen',
      llmPaper: {
        subtitle: 'De gegenereerde wetenschappelijke beschrijving van de soevereine modelarchitectuur — weergegeven uit het paper-document dat Veridion Core bij de actieve specificatie bijhoudt.',
        summaryTitle: 'Wat deze pagina toont',
        summaryBody: 'Veridion Core houdt bij de actieve modelarchitectuur een gegenereerd wetenschappelijk document bij: titel, samenvatting, genummerde secties, architectuurdiagram, tabellen en referenties komen onveranderd uit de backend; ontwerpwaarden zijn als zodanig gemarkeerd, en de pagina verzint niets.',
        refresh: 'Vernieuwen',
        exportPdf: 'Als pdf exporteren',
        strandTraining: 'traint',
        strandSelected: 'geselecteerd',
        lcTitle: "Implementatie & levensloop",
        lcSelectedTrains: "traint als volgende",
        lcCollectsOnly: "verzamelt & bereidt voor — start niet",
        lcSpec: "Specificatie",
        lcFrozen: "bevroren",
        lcArtifacts: "Artefacten (tokenizer/codec)",
        lcReleased: "vrijgegeven",
        lcNotReleased: "nog niet gebouwd",
        lcCodecOpen: "codec open",
        lcData: "Datadrempels",
        lcThresholdsMet: "gehaald",
        lcAreasReached: "dataplan: {met} van {total} domeinen bereikt",
        lcNoLake: "datalake niet bereikbaar",
        lcStage_trainer_image: "Trainer-image",
        lcStage_sealed_tdv: "TDV verzegeld",
        lcStage_compat_all_green: "Compatibiliteit ALL-GREEN",
        lcStage_vram_budget: "VRAM-budget",
        lcTraining: "Training",
        lcAuto: "start automatisch zodra de drempels gehaald zijn",
        lcBench: "Benchmark",
        lcBenchRows: "metingen",
        lcNoneYet: "nog geen",
        lcRelease: "Export · Hugging Face (privé) · register",
        lcReleaseRows: "artefacten",
        lcReleaseNote: "na de training: privé-geverifieerde upload + registervermelding",
        lcPipeline: "Trainingspipeline",
        lcDone: "gereed",
        lcActive: "actief",
        lcWaiting: "wacht",
        lcBlocked: "geblokkeerd",
        lcCapability: "Vaardigheid",
        lcSamples: "Voorbeelden",
        lcByLanguage: "per taal",
        lcForeign: 'andere streng',
        lcCorpus: 'Corpustokens',
        lcCorpusNone: 'nog niet getokeniseerd',
        loading: 'Laden …',
        unavailable: 'Het paper-document is niet bereikbaar.',
        noPaper: 'Deze versie van Veridion Core levert nog geen paper-document. De pagina toont daarom niets verzonnen.',
        abstract: 'Samenvatting',
        references: 'Referenties',
        appendix: 'Bijlage',
        figure: 'Figuur',
        lastUpdated: 'Laatst bijgewerkt',
        empty: 'Geen vermeldingen.',
      },
      llmMonitor: {
        summary: "Bedrijfsbewaking van het model: status, data, GPU, kernels en doorvoer, evaluaties en gebeurtenissen — gemeten uit Veridion Core en de data lake, niets verzonnen.",
        archTitle: 'Architectuurstatus',
        archSubtitle: "De actieve architectuur met de stand van de data-interface en de bevriestoestand.",
        version: 'Versie',
        codename: 'Codenaam',
        statusLabel: 'Status',
        interfaceStatus: 'Data-interface',
        specSha: 'Specificatie-hash (SHA-256, verkort)',
        promotedAt: 'Gepromoveerd',
        frozenLabel: 'Bevroren',
        frozenYes: 'Ja',
        frozenNo: 'Nee',
        stateWord_active: "actief",
        stateWord_draft: "concept",
        stateWord_released: "vrijgegeven",
        stateWord_candidate: "kandidaat",
        stateWord_retired: "beëindigd",
        gpuModel: "Grafische kaart",
        gpuTotal: "Totaal grafisch geheugen",
        gpuWindow: "Trainingsvenster (gemeten)",
        gpuMeasuredAt: "Gemeten op",
        gpuSource: "Meetbron",
        gpuServing: "Serving",
        gpuInferenceTarget: "Doel voor inferentie op één kaart",
        vramTitle: 'GPU & VRAM-budget',
        vramSubtitle: 'Het gemeten VRAM-budget van de grafische kaart zoals Veridion Core het bijhoudt.',
        vramNone: 'Geen VRAM-budget in het record.',
        gateTitle: 'Promotion-gate',
        gateSubtitle: 'Het beleid waarmee een kandidaat-architectuur de actieve vervangt, met de vereiste metrieken en hun gewichten.',
        metric: 'Metriek',
        weight: 'Gewicht',
        gateNone: 'Geen vereiste metrieken vastgelegd.',
        candidatesTitle: 'Kandidaten',
        candidatesNone: 'Geen kandidaat-architecturen.',
        evidenceTitle: 'Evaluaties',
        evidenceNone: 'Nog geen gemeten evaluaties.',
        benchmark: 'Benchmark',
        suite: 'Suite',
        score: 'Score',
        evaluator: 'Beoordelaar',
        date: 'Datum',
        changelogTitle: 'Wijzigingshistorie',
        changelogNone: 'Nog geen architectuurversies in de historie.',
        summaryLabel: 'Samenvatting',
        createdAt: 'Aangemaakt',
        supersededAt: 'Vervangen',
        eventsTitle: 'Gebeurtenissen',
        eventsNone: 'Geen gebeurtenissen vastgelegd.',
        implTitle: 'Implementatiestatus van de streng',
        implSubtitle: "Gemeten feiten: artefacten van de data-interface, selectie, tokencorpus en vectorindex; het dataplan per domein staat in het situatiebeeld.",
        implSelected: 'Trainingsstreng',
        implSelectedYes: 'geselecteerd — traint als volgende',
        implSelectedNo: 'bereidt alleen voor (start nooit)',
        implTokenizer: 'Tokenizer-artefact',
        implCodec: 'Codec-artefact',
        implNotReleased: 'nog niet vrijgegeven',
        implCapability: 'Vaardigheid',
        implSamples: 'Voorbeelden (gemeten/doel)',
        implNoDatalake: 'De voorbeeldvoortgang is tijdelijk niet leesbaar (data-lake-interface onbereikbaar).',
        implSwitchHint: 'De selectie van de trainingsstreng wordt op de trainingspagina omgeschakeld.',
        implSituationLink: "Waar de data staat en wat de training nog mist: situatiebeeld op de trainingspagina",
        kernelTitle: 'Kernelversnelling & doorvoer',
        kernelSubtitle: 'Wat de kernelsonde op de kaart heeft gemeten: elke kernel tegen zijn referentie, de attention-backend, de doorvoer van de gekozen specificatie — en het tijdplan uit gemeten tokens en gemeten doorvoer.',
        kernelNone: 'Er heeft nog geen kernelsonde op deze kaart gedraaid; er wordt niets aangenomen.',
        kernelName: 'Kernel',
        kernelVerified: 'Bewezen',
        kernelYes: 'ja',
        kernelNo: 'nee',
        kernelSpeedup: 'Versnelling',
        kernelMaxErr: 'Max. fout',
        kernelError: 'Bevinding',
        kernelAttention: 'Attention-backend',
        kernelDocMask: 'Maskering van documentgrenzen',
        kernelThroughput: 'Gemeten doorvoer (tokens/s)',
        kernelMicroBatch: 'Micro-batch',
        kernelMeasuredAt: 'Gemeten op',
        kernelImage: 'Trainer-image (digest)',
        kernelRunPath: 'Kernelpad van de laatste run',
        kernelRunNone: 'Nog geen trainingsrun met kernelfeiten.',
        kernelPlanTitle: 'Tijdplan (rekenwerk over metingen)',
        kernelPlanTokens: 'Tokenmassa',
        kernelPlanTokensSource: 'Bron van de tokenmassa',
        kernelPlanDays: 'Geprojecteerde dagen voor één doorloop',
        kernelPlanNone: 'Nog niet gemeten — zonder gemeten doorvoer of gemeten tokenmassa wordt geen tijdplan verzonnen.',
        kernelSourceTdv: 'verzegelde trainingsdataversie',
        kernelSourceCorpus: 'corpus tot nu toe (niet verzegeld)',
        kernelSourcePlan: "budget volgens de paper",
        implForeign: 'hoort bij een andere streng',
        implIndex: 'Vectorindex (graafkoppeling)',
        implIndexNone: 'geen index gemeld',
        implIndexDown: 'geconfigureerd, antwoordt niet',
        implIndexPoints: 'punten',
        implIndexBackfillDone: 'vulling voltooid',
        implIndexBackfillOpen: 'vulling loopt',
        implIndexLink: 'Index en deduplicatie in de lake-monitor',
        implCorpus: 'Tokencorpus (ruwe tekst)',
      },
      software: {
        arch: {
          execTitle: "Soevereine modelarchitectuur",
          execSubtitle: "De ene actieve architectuurspecificatie uit Veridion Core: elk cijfer is óf gestaafd met een gerefereerd meetartefact óf door de backend gemarkeerd als ontwerpdoel (niet gemeten).",
          openDatalake: "Data Lake & AI-modeltraining openen",
          unavailableArch: "De architectuurdata is onbereikbaar.",
          frozen: "Bevroren — een trainingsrun is actief",
          notFrozen: "Vrijgegeven (fase A)",
          version: "Versie",
          codename: "Codenaam",
          statusLabel: "Status",
          createdAt: "Aangemaakt",
          promotedAt: "Gepromoveerd",
          specSha: "Specificatie-hash (SHA-256)",
          contextWindow: "Contextvenster (ontwerp, tokens)",
          dataInterface: "Data-interface",
          diStatus: {
            draft: "concept",
            complete: "volledig",
            missing: "ontbreekt",
          },
          paramsTitle: "Parameterbalans",
          trainingVramTitle: "Trainings-VRAM (gedeclareerd, GB)",
          inferenceTitle: "Inferentie-VRAM (gedeclareerd, GB)",
          declaredTotal: "Gedeclareerd totaal",
          budgetTitle: "GPU-VRAM-budget (gemeten)",
          budgetGpu: "GPU",
          budgetTotal: "Totaal VRAM (MiB)",
          budgetFreed: "Vrij trainingsbudget (GB)",
          budgetInferenceTarget: "Single-GPU-inferentiedoel (GB)",
          diagramTitle: "Gegenereerd architectuurdiagram",
          diagramSubtitle: "Deterministisch gegenereerd uit de opgeslagen specificatie; naast de data bestaat geen handgeschreven diagram.",
          noDiagram: "Het antwoord bevat geen diagram.",
          stagesTitle: "Fasenopbouw van de architectuur",
          stagesSubtitle: "Rechtstreeks uit de opgeslagen specificatie; parameterwaarden zijn ontwerpwaarden.",
          stageCol: "Fase",
          layersCol: "Lagen",
          mechanismCol: "Werking",
          paramsCol: "Fysieke parameters (mld.) & primaire bronnen",
          paramsCross: "overkoepelend — meegeteld in de fasen",
          researchTitle: "Onderzoeksarchief kwantum- & frontier-AI",
          researchSubtitle: "Live rijen uit het onderzoeksarchief van Veridion Core; nieuwe publicaties komen binnen via het werktuig van de kwantumcollega, elk met zichtbare herkomst.",
          researchEmpty: "Nog geen publicatie in het archief.",
          evidenceTitle: "Evaluatiebewijzen",
          evidenceSubtitle: "Alleen gemeten, gerefereerde evaluaties verschijnen hier; zonder bewijs is er geen score.",
          evalMetric: "Metriek",
          evalBenchmark: "Benchmark",
          evalSuite: "Suite",
          evalScore: "Waarde",
          evalEvaluator: "Beoordelaar",
          evalDate: "Gemeten op",
          evalArtifact: "Bewijsartefact",
          gateTitle: "Promotieregels (bewijs-gate)",
          gateMetrics: "Verplichte metrieken",
          gateEpsilon: "Tolerantie (epsilon)",
          gateConfigVersion: "Gate-configuratie (versie)",
          candidatesTitle: "Kandidatenwachtrij",
          candidatesSubtitle: "Ingediende architectuurkandidaten met de stand van hun bewijzen; indienen gebeurt via de onderzoeksruntime, nooit via het dashboard.",
          candidateSubmittedBy: "Ingediend door",
          candidateEvidence: "Bewijzen (aanwezig / vereist)",
          candidatesEmpty: "Geen kandidaat ingediend.",
          changelogTitle: "Ontwerp-wijzigingslog",
          changelogSubtitle: "Vervangen ontwerpiteraties — bewust zonder cijfers: ervoor is nooit gemeten.",
          changelogSummary: "Samenvatting",
          changelogEmpty: "Geen vervangen ontwerp.",
          supersededAt: "Vervangen op",
          eventsTitle: "Gate-gebeurtenissen",
          eventsSubtitle: "Indieningen, promoties, afwijzingen en freeze-overgangen zoals de gate ze heeft vastgelegd.",
          eventsEmpty: "Nog geen gebeurtenis.",
        },
        title: 'Softwareontwikkeling',
        subtitle: 'De taken van de coding-agent, de GitLab van het bedrijf met de synchronisatie uit Azure DevOps, de merge requests die op een review wachten en de grenzen van de GitLab-node.',
        openGitlab: 'GitLab openen',
        openSonar: 'SonarQube openen',
        loading: 'Laden …',
        failed: 'Dat is niet gelukt',
        done: 'Gedaan',
        unavailable: 'Niet bereikbaar',
        capacityTitle: 'GitLab-node',
        capacitySubtitle: 'De bewaker stelt de grenzen van de node elke minuut in op basis van de belasting van de server; productie houdt haar reserve.',
        stateLabel: 'Toestand',
        memory: 'Geheugen',
        cpu: 'CPU',
        disk: 'Schijf',
        hostFree: 'Vrij op de server',
        reserve: 'Reserve voor productie',
        codingSlots: 'Coding-taken tegelijk',
        pipelineQuota: 'Pipeline-jobs',
        recentActions: 'Laatste ingrepen van de bewaker',
        syncTitle: 'Synchronisatie uit Azure DevOps',
        syncSubtitle: 'De GitLab-master volgt de Azure-master; commits die alleen GitLab had, blijven bewaard onder een tag replaced/<tijd>.',
        syncNow: 'Nu synchroniseren',
        syncStarted: 'Synchronisatie gestart',
        azureCommit: 'Azure-master',
        gitlabCommit: 'GitLab-master',
        lastChange: 'Laatste wijziging',
        lastRun: 'Laatste run',
        replaced: 'Bewaard onder tags',
        noneReplaced: 'niets',
        jobs: 'Laatste runs',
        error: 'Fout',
        readyTitle: 'Merge requests klaar voor review',
        readySubtitle: 'Alleen merge requests met een groene pipeline; mergen gebeurt in GitLab.',
        noReady: 'Geen merge request wacht op een review.',
        tasksTitle: 'Coding-taken',
        tasksSubtitle: 'Elk programmeerwerk van de coding-agent met toestand, merge request en tokens.',
        showFinished: 'Beëindigde taken tonen',
        task: 'Taak',
        requester: 'Opdrachtgever',
        statusLabel: 'Toestand',
        mergeRequest: 'Merge request',
        pipeline: 'Pipeline',
        tokens: 'Tokens',
        updated: 'Bijgewerkt',
        noTasks: 'Nog geen coding-taak.',
        phase: 'Stap',
        repository: 'Repository',
        branch: 'Branch',
        openQuestion: 'Open vraag',
        result: 'Resultaat',
        sendMessage: 'Naar de taak schrijven',
        answerQuestion: 'Vraag beantwoorden',
        urgent: 'Dringend: de lopende stap meteen sturen',
        send: 'Versturen',
        messageSent: 'Bij de taak afgeleverd',
        confirmCancel: 'Deze taak afbreken? Een open merge request wordt gesloten.',
        course: 'Verloop van de sessie',
        messages: 'Berichten',
        events: 'Gebeurtenissen',
        none: 'geen',
        close: 'Sluiten',
        newTitle: 'Nieuwe taak',
        newSubtitle: 'Geef de coding-agent hier een taak; volg haar hier en op haar Webex-kaart.',
        brief: 'Wat moet de agent doen?',
        issue: 'YouTrack-issue (optioneel)',
        create: 'Taak aanmaken',
        created: 'Taak aangemaakt',
        usersTitle: 'Beheerders in GitLab',
        usersSubtitle: 'Elke beheerder heeft een GitLab-gebruiker met beheerdersrechten; de housekeeping houdt ze gelijk met Keycloak.',
        email: 'E-mail',
        gitlabUser: 'GitLab-gebruiker',
        lastHousekeeping: 'Laatste housekeeping',
        sonarDeleted: 'SonarQube-projecten van verwijderde branches verwijderd',
        previewsTitle: 'Projecten in ontwikkeling',
        previewsSubtitle: 'Elk project in ontwikkeling draait vanaf de eerste merge precies één keer: Veridion Core start de nieuwste groene stand van de hoofdbranch (migration of master) in containers achter de beheerdersaanmelding, vernieuwt die bij elke groene pipeline, en hier worden de containers gestart, gestopt en herstart. Een project waarvan de pipeline niets draaiends bouwt, staat hier met de reden.',
        previewsSummaryTitle: 'Wat deze weergave toont',
        previewsSummaryBody: 'Elk project in ontwikkeling draait als eigen preview-container achter de beheerdersaanmelding. De lijst bovenaan toont de nieuwste werkende stand van elk project, de tabel daaronder de draaiende containers met status, adres en bediening: openen, starten, stoppen, herstarten.',
        previewProject: 'Project',
        previewState: 'Draaiende stand',
        previewSince: 'Sinds',
        previewAddress: 'Adres',
        previewMergedAt: 'Gemerged',
        noPreviews: 'Er draait geen project.',
        reasonsLabel: 'Blokkerende oorzaken & Diagnose',
        noProjects: 'Geen project in ontwikkeling.',
        qualityCoverage: 'Testdekking',
        qualityBugs: 'Bugs',
        qualitySmells: 'Code smells',
        qualityDuplication: 'Duplicatie',
        qualityHotspots: 'Open hotspots',
        qualityUnavailable: 'Geen SonarQube-metingen',
        openPreview: 'Openen',
        startPreview: 'Containers starten',
        stopPreview: 'Containers stoppen',
        previewStarted: 'Containers gestart',
        previewStopped: 'Containers gestopt',
        restartPreview: 'Containers herstarten',
        previewRestarted: 'Containers herstart',
        previewControl: 'Containers',
        resultTitle: 'Resultaat in GitLab',
        resultJobs: 'Jobs en artefacten',
        resultSonar: 'SonarQube',
        resultDelivered: 'Geleverd',
        previewStatus: {
          starting: 'start',
          running: 'draait',
          stopped: 'gestopt',
          failed: 'mislukt',
        },
        capacityStates: {
          ok: 'binnen de grenzen',
          tight: 'krap: productie heeft de ruimte nodig',
          full: 'vol: geen nieuw werk',
          node_down: 'node draait niet',
        },
        status: {
          queued: 'wacht op een vrije plek',
          working: 'bezig',
          waiting: 'wacht op antwoord',
          review: 'in review',
          merged: 'gemerged in GitLab',
          done: 'klaar',
          needs_person: 'heeft een mens nodig',
          rejected: 'gesloten zonder merge',
          paused: 'gepauzeerd',
          cancelled: 'afgebroken',
          failed: 'mislukt',
        },
        commands: {
          pause: 'Pauzeren',
          resume: 'Hervatten',
          cancel: 'Afbreken',
        },
        repositoryChoice: {
          auto: 'De agent beslist',
          company: '{project} (merge door een mens)',
          own: 'Een eigen project in {group}',
        },
        userState: {
          ok: 'gelijk',
          created: 'aangemaakt',
          unblocked: 'gedeblokkeerd',
          'made administrator': 'beheerder gemaakt',
          blocked: 'geblokkeerd',
        },
      },
      org: {
        write: 'Schrijven',
        call: "Bellen",
        callTitle: "Gesprek met {bot}",
        writeTitle: 'Bericht aan {bot}',
        callConfirmEnd: 'De oproep beëindigen?',
        callSubtitle: 'De microfoon loopt zolang het gesprek duurt. De bot begroet met zijn stem, antwoordt kort, vraagt door bij open punten en kan worden onderbroken. Elke zin staat ook in Webex, in de directe ruimte met de bot.',
        callRinging: "Gaat over …",
        callConnected: "Verbonden",
        callEnded: "Beëindigd",
        callEndedHangup: "U heeft opgehangen",
        callEndedClosed: "De verbinding is verbroken",
        callEndedSilence: "90 seconden stilte",
        callEndedLimit: "De grens van 30 minuten is bereikt",
        callEndedError: "Een fout heeft het gesprek beëindigd",
        callHangUp: "Ophangen",
        callLevel: "Microfoonniveau",
        callYou: "U",
        callSpeaking: "De bot spreekt …",
        callThinking: 'Het antwoord wordt gegenereerd …',
        callOvertaken: "ingehaald door uw volgende vraag, niet uitgesproken",
        callNothingHeard: "Er zijn geen woorden gehoord.",
        callMicDenied: "De browser heeft de microfoon geweigerd; sta hem toe voor deze pagina en bel opnieuw.",
        callNoVoice: "De stem is nu niet beschikbaar; het antwoord staat als tekst.",
        callRefused: "Het gesprek is niet aangenomen: het ticket was ongeldig of verlopen; bel opnieuw.",
        callFailed: "Het gesprek is mislukt",
        voice: "Stem",
        voiceHint: "De stem waarmee deze collega spreekt: in Webex wanneer iemand het antwoord wil horen, en aan de telefoon. Standaard is een spreker van het audiomodel bij OpenRouter; een eigen, gekloonde stem uit de stemopslag spreekt via de stemengine van het platform.",
        voiceSave: "Stem opslaan",
        voiceDefault: "standaard",
        voiceNone: "geen stem",
        voiceCloud: "OpenRouter-sprekers (standaard)",
        voiceOwn: "Eigen stemmen (gekloond)",
        voiceUploadTitle: "Stemvoorbeeld voor deze collega uploaden",
        voiceUploadHint: "Audio of video, maximaal 25 MB; de Core zet het voorbeeld om, bewaart tot 20 seconden, hoort de woorden en slaat alleen de referentieclip op. De collega spreekt meteen met deze stem.",
        voiceUploadName: "Naam van de stem",
        voiceUploadConsent: "Ik bevestig dat ik het recht heb deze stem voor het bedrijf te gebruiken: het is mijn eigen stem of de persoon heeft ingestemd.",
        voiceUploadButton: "Voorbeeld uploaden",
        voiceUploadDone: "Stem opgeslagen",
        voiceTooLarge: "Het bestand is groter dan 25 MB.",
        voicesTitle: "Stemmen",
        voicesSubtitle: "Elke stem van het bedrijf is een referentieclip in de stemopslag van Veridion Core; de stemengine kloont hem telkens als een bot spreekt. De negen vroegere sprekers staan erin als vastgelegde clips.",
        voiceSeconds: "Seconden",
        voiceSource: "Herkomst",
        voiceSourcePreset: "vastgelegde spreker",
        voiceSourceUpload: "geüpload voorbeeld",
        voiceAddedBy: "Toegevoegd door",
        voiceConsentBy: "Toestemming bevestigd door",
        voiceWords: "Woorden van de clip",
        voiceDelete: "Verwijderen",
        voiceConfirmDelete: "Deze stem verwijderen? Collega's die hem gebruiken spreken weer met hun standaardstem.",
        voiceCapture: "Sprekers van de preset-engine vastleggen",
        voiceCaptureHint: "Spreekt per spreker één vaste zin via de preset-engine en slaat die op als clip; loopt vóór de wissel van de engine.",
        voiceCaptured: "Vastgelegd",
        voiceEnginePresets: "De stemengine biedt vaste sprekers; de stemopslag wordt niet gebruikt.",
        chartTitle: "Organogram",
        executiveTitle: 'Directieniveau',
        unitsTitle: 'Business units',
        unitLead: 'Leiding',
        unitSupporting: 'Ondersteund door',
        unitMission: 'Opdracht',
        unitPrefix: 'Thread-prefix',
        standingActive: 'actief',
        standingStandby: 'stand-by',
        standbyOn: 'Op stand-by zetten',
        standbyOff: 'Activeren',
        standbyHint: 'Op stand-by neemt een collega geen beurt uit eigen beweging van het bedrijf en kost geen tokens; een direct bericht van een persoon wordt nog steeds beantwoord.',
        confirmStandby: '{name} op stand-by zetten?',
        confirmActivate: '{name} activeren?',
        activity: 'Activiteit',
        runtime: 'Runtime',
        modelCloud: 'cloudmodel',
        modelGpu: 'bedrijfsengine',
        callModel: 'Telefoonmodel',
        calls30: 'Gesprekken, laatste 30 dagen',
        telemetryLine: '{model} · {prompt}+{completion} tokens · {cost} · oor {asr} ms · verstand {llm} ms · stem {tts} ms · totaal {total} ms{deferred}',
        telemetryDeferred: ' · {count} uitgesteld',
        chartSubtitle: "Veridions AI-collega's: agents in Veridion Core, elk bereikbaar als eigen Webex-bot, per werkgebied; daarboven de menselijke beslissers, daaronder de agents zonder eigen bot en de bedrijfsruimtes, live gelezen uit Veridion Core en Webex.",
        chartPeople: "Menselijke beslissers",
        chartPeopleText: "De menselijke beslissers beslissen alles en handelen in {space}.",
        chartAgentsTitle: "Agents zonder eigen bot: de coding-agent, de Veridion MCP-orchestrator en de door de architect gebouwde agents werken namens een AI-collega en spreken via diens bot",
        chartDesigned: "Agents ontworpen met de architect",
        chartFor: "Namens",
        chartSystemsTitle: "Gekoppelde systemen",
        chartSpaceHome: "Thuisruimte van",
        chartSpacePurpose: "Doel",
        chartRoomsTitle: "Bedrijfsruimtes in Webex",
        room: "Ruimte",
        roomBots: "Bots",
        positionsTitle: "AI-collega's",
        positionsSubtitle: "Elke AI-collega antwoordt via een eigen bot en leest zijn ruimtes. Zijn beschrijving is de instructie waarmee hij werkt.",
        bot: "Bot",
        position: "Taak",
        statusLabel: "Status",
        tokensUsed: "Verbruikte tokens",
        tokens30: "Tokens, laatste 30 dagen",
        edit: "Bewerken",
        close: "Sluiten",
        description: "Beschrijving van de AI-collega",
        save: "Opslaan",
        resetDescription: "Standaardbeschrijving herstellen",
        interests: "Interesseprofiel",
        interestsHint: "Welke soorten punten en onderwerpen deze AI-collega aangaan en wanneer hij er niet bij betrokken is. De AI-collega toetst elk bericht in zijn ruimtes hieraan.",
        threshold: 'Drempel voor ongevraagde bijdragen',
        thresholdHint: 'Van 1 tot 5: hoe sterk een bericht de AI-collega moet aangaan voordat hij ongevraagd reageert. Bij 1 reageert hij al bij geringe relevantie, bij 5 alleen bij hoge.',
        saveProfile: "Profiel opslaan",
        tools: "Hulpmiddelen",
        decisionMakersTitle: "Beslissers",
        decisionMakersSubtitle: "Elk van hen kan elke goedkeuring geven en elke vraag van een AI-collega in Webex beantwoorden.",
        email: "E-mailadres",
        add: "Toevoegen",
        remove: "Verwijderen",
        confirmRemove: "Deze beslisser verwijderen?",
        readerTitle: "Lezen van de bedrijfsruimtes",
        readerSubtitle: "Een bot ziet alleen berichten waarin hij wordt genoemd. Veridion leest elk bericht van de bedrijfsruimtes via de toestemming van een account dat lid is van alle ruimtes.",
        notConfigured: "De integratie is niet ingericht",
        authorised: "Toegestaan",
        notAuthorised: "Niet toegestaan",
        account: "Account",
        validUntil: "Toegangstoken geldig tot",
        renewUntil: "Toestemming verlengbaar tot",
        authorise: "Lezen toestaan",
        authoriseAgain: "Opnieuw toestaan",
        linkOpened: "De Webex-aanmelding is in een nieuw tabblad geopend.",
        found: "gevonden",
        notFound: "niet gevonden",
        botsInSpace: "bots",
        transcripts: "Vergadertranscripten",
        yes: "ja",
        no: "nee",
        approvalsTitle: "Openstaande goedkeuringen",
        approvalsSubtitle: "Goedkeuringen en vragen waar AI-collega's om hebben gevraagd en die nog geen beslisser heeft beantwoord.",
        originSpace: "Ruimte",
        directRoom: "direct gesprek",
        approvalKinds: { review: "goedkeuring", question: "vraag" },
        schedulesTitle: "Planningen",
        schedulesSubtitle: "Terugkerend werk waar iemand in een ruimte om heeft gevraagd; het loopt tot iemand het beëindigt.",
        createdBy: "gevraagd door",
        lastRun: "laatst uitgevoerd",
        end: "Beëindigen",
        confirmEnd: "Deze planning beëindigen?",
        none: "Geen",
        loading: "Laden…",
        failed: "Mislukt",
        working: "Bezig…",
        done: "Klaar",
        memoryTitle: "Organisatie",
        memorySubtitle: "De mensen en AI-collega's van het bedrijf met het geheugenbereik waarin elke AI-collega werkt.",
        memoryMember: "Lid",
        area: "Afdeling",
        decisionMaker: "Beslisser",
        status: { running: "actief" },
      },
      core: {
        conversationTitle: 'Gesprek vanuit het dashboard',
        conversationHint: 'Elk bericht en elk antwoord wordt ook in Webex gezegd: in de thread van het werk van de agent, anders in uw directe ruimte met de bot.',
        conversationEmpty: 'Nog geen bericht vanuit het dashboard.',
        writeToAgent: 'Bericht aan deze agent',
        answerPending: 'Antwoord in afwachting',
        title: 'Veridion Core',
        subtitle: 'Het agentische besturingssysteem achter de bedrijfsbot: zijn agents, hun berichten en tokenverbruik, de definities, de architect en de organisatie.',
        done: 'Gereed.',
        failed: 'Dat is niet gelukt',
        loading: 'Laden …',
        working: 'Bezig …',
        none: 'Geen.',
        unavailable: 'Veridion Core is niet bereikbaar',
        errors: {
          AGENT_FINISHED: 'De agent is beëindigd en neemt geen berichten meer aan',
          EMERGENCY_STOP: 'De noodstop is actief',
          DEFINITION_INVALID: 'De definitie is niet geldig',
          TOO_MANY_AGENTS: 'Er draaien te veel agents',
          VERIDION_CORE_NOT_CONFIGURED: 'Veridion Core is niet geconfigureerd',
          MESSAGE_EMPTY: 'Het bericht is leeg',
        },
        status: {
          building: 'image wordt gebouwd',
          starting: 'start',
          running: 'actief',
          waiting: 'wacht',
          idle: 'gereed',
          paused: 'gepauzeerd',
          completed: 'voltooid',
          failed: 'mislukt',
          cancelled: 'afgebroken',
          stopped: 'gestopt',
          not_deployed: 'niet uitgerold',
        },
        statusLabel: 'Status',
        owner: 'Eigenaar',
        definition: 'Definitie',
        parent: 'Bovenliggende agent',
        tokens: 'Tokens',
        progress: 'Voortgang',
        close: 'Sluiten',
        openQuestion: 'Open vraag',
        result: 'Resultaat',
        answerQuestion: 'Vraag beantwoorden',
        sendMessage: 'Bericht aan de agent',
        urgent: 'Dringend: huidige stap onderbreken',
        send: 'Verzenden',
        messageSent: 'Aan de agent bezorgd.',
        commands: {
          pause: 'Pauzeren',
          resume: 'Hervatten',
          cancel: 'Afbreken',
          kill: 'Direct beëindigen',
        },
        confirmKill: 'Deze agent en zijn subagents direct beëindigen?',
        subAgents: 'Subagents',
        graph: 'Graaf',
        messages: 'Berichten',
        messageStatus: {
          queued: 'in wachtrij',
          delivered: 'bezorgd',
          consumed: 'gelezen',
          refused: 'geweigerd',
        },
        events: 'Gebeurtenissen',
        containerLog: 'Containerlog',
        version: 'Versie',
        activeAgents: 'Actieve agents',
        updated: 'Bijgewerkt',
        archived: 'gearchiveerd',
        noDefinitions: 'Nog geen definities.',
        versions: 'Versies',
        from: 'van',
        startInput: 'Startinvoer als JSON',
        agentStarted: 'Agent gestart.',
        startAgent: 'Agent starten',
        editAsJson: 'Als JSON bewerken',
        confirmArchive: 'Deze definitie archiveren? Actieve agents blijven draaien.',
        archive: 'Archiveren',
        definitionJson: 'Definitie als JSON',
        definitionJsonHint: 'Een definitie in de Veridion-graaftaal. Valideren toont de problemen en de graaf; opslaan legt haar vast als nieuwe goedgekeurde versie.',
        checked: 'Gecontroleerd.',
        validate: 'Valideren',
        saved: 'Opgeslagen als nieuwe versie.',
        saveVersion: 'Opslaan als nieuwe versie',
        valid: 'De definitie is geldig.',
        you: 'U',
        architect: 'Architect',
        architectPlaceholder: 'Beschrijf wat de agent moet doen …',
        newDesign: 'Nieuw ontwerp',
        unitKinds: {
          company: 'bedrijf',
          department: 'afdeling',
          team: 'team',
          project: 'project',
        },
        partOf: 'onderdeel van',
        confirmRemove: 'Deze eenheid verwijderen? De leden verliezen dit bereik.',
        remove: 'verwijderen',
        addUnit: 'Eenheid toevoegen',
        unitId: 'ID (kleine letters, koppeltekens)',
        unitName: 'Naam',
        add: 'Toevoegen',
        addMember: 'Lid toevoegen',
        memberKinds: {
          person: 'persoon (e-mailadres)',
          agent: 'agent (ID)',
          definition: 'definitie (ID)',
        },
        memberId: 'E-mailadres of ID',
        role: 'Rol',
        confirmEmergencyOn: 'Alle agents nu stoppen? De bot blijft antwoorden.',
        confirmEmergencyOff: 'Noodstop opheffen?',
        emergencyStop: 'Noodstop',
        emergencyRelease: 'Noodstop opheffen',
        emergencyActive: 'noodstop is actief',
        autopilotOn: 'Autopilot inschakelen',
        autopilotOff: 'Autopilot uitschakelen',
        autopilotActive: 'Autopilot is actief: Veridion Core beantwoordt elke kaart aan de mensen zelf',
        autopilotUnitsTitle: 'Autopilot per business unit',
        autopilotUnitsHint: 'Schakelt de autopilot afzonderlijk in of uit per business unit en voor de directielaag. Gepauzeerd werk blijft altijd onaangeroerd.',
        autopilotUnitOn: 'Autopilot aan',
        autopilotUnitOff: 'Autopilot uit',
        limitsBuilds: 'Image-builds per collega en dag',
        limitsDesigns: 'Agentontwerpen per collega en dag',
        limitsSave: 'Daglimieten instellen',
        limitsNone: '0 = geen limiet',
        confirmAutopilotOn: 'Autopilot inschakelen? De eigen beslisser van Veridion Core beantwoordt dan meteen elke open en elke nieuwe kaart in pAIoneer-humans-and-bots, zichtbaar in de thread van de kaart.',
        confirmAutopilotOff: 'Autopilot uitschakelen? Daarna beslissen de mensen weer.',
        model: 'Model',
        codingModel: 'Codeermodel',
        modelsTitle: 'Modellen per rol',
        modelsSubtitle: 'Op welk model elke rol van Veridion Core denkt: het gezicht en de sturing van het bedrijf, de telefoon, de architect en de rechter van de requirements-oordelen. Alleen modellen die de gateway routeert zijn te kiezen; leeg betekent de standaard van de configuratie.',
        roleCoordinator: 'Coördinator (gezicht en sturing)',
        roleCall: 'Telefoon',
        roleArchitect: 'Architect',
        roleRequirementsJudge: 'Requirements-rechter',
        roleJudge: 'Oordelen van de Core',
        roleEar: 'Telefoonoor',
        roleStt: 'Webex-oor',
        modelGroupVllm: 'vLLM (eigen kaart)',
        modelGroupAudio: 'Audio (eigen kaart / cloud)',
        modelGroupCloud: 'OpenRouter (cloud)',
        directLlmTitle: 'Directe LLM-toegang',
        directLlmSubtitle: 'Praat rechtstreeks met een vLLM of cloudmodel, zonder bots, agents of Webex',
        directLlmHint: 'Directe admintoegang: het gekozen model antwoordt rauw, geboekt onder “console”, zonder lanes, rollen of tools.',
        directLlmModel: 'Model',
        directLlmSystem: 'Systeemprompt (optioneel)',
        directLlmSystemPlaceholder: 'bijv. Je bent …',
        directLlmPrompt: 'Bericht',
        directLlmPromptPlaceholder: 'Wat wil je het model rechtstreeks vragen?',
        directLlmSend: 'Versturen',
        directLlmSending: 'Versturen …',
        directLlmUsage: '{prompt}+{completion} tokens · {cost}',
        modelCurrent: 'In gebruik',
        modelDefault: 'Standaard',
        modelChosen: 'Gekozen',
        modelDefaultOption: 'standaard van de configuratie',
        modelNotRouted: 'niet gerouteerd door de gateway',
        modelSave: 'Opslaan',
        engineSilver: 'Bedrijfsengine (zilver)',
        engineGold: 'Bedrijfsengine (goud, van de orchestrator)',
        callsTitle: 'Telefoongesprekken',
        callsSubtitle: 'Elke gesproken beurt van de telefoon, apart van het werk van de collega\'s geboekt: tokens, kosten en de tijd van oor, verstand en stem, per collega en model, voor de laatste 30 dagen en vandaag; daaronder de nieuwste beurten.',
        callsTurns: 'Beurten',
        callsCalls: 'Gesprekken',
        callsAvgTotal: 'Ø totaal ms',
        callsAvgAsr: 'Ø oor ms',
        callsAvgLlm: 'Ø verstand ms',
        callsAvgTts: 'Ø stem ms',
        callsDeferred: 'Uitgesteld',
        callsToday: 'Vandaag',
        callsWindow: 'Laatste 30 dagen',
        callsRecent: 'Nieuwste beurten',
        callsPerson: 'Persoon',
        callsRounds: 'Rondes',
        callsNone: 'Nog geen gesprek geboekt.',
        unitKindExecutive: 'Directieniveau',
        unitKindBusinessUnit: 'Business unit',
        orgSynced: 'Het directieniveau en de business units zijn gedefinieerd in de organisatie van Veridion Core en hierheen gesynchroniseerd; ze worden daar gewijzigd, niet op deze pagina.',
        memory: 'Geheugen',
        ready: 'gereed',
        notReady: 'niet gereed',
        factExtraction: 'feitenextractie actief',
        cluster: 'Clustertoegang',
        agentsRunning: 'Actieve agents',
        agentsWaiting: 'wachtend',
        definitions: 'Definities',
        gatewayIdentity: 'Gateway-identiteit',
        gatewayTokens: 'Gateway-tokens in het tijdvenster',
        hostedTitle: 'Gehoste agents',
        hostedSubtitle: 'AI-toepassingen die Veridion Core in eigen containers start en beheert.',
        agent: 'Agent',
        actions: 'Acties',
        confirmHosted: '{action}: {agent}?',
        hostedActions: {
          start: 'starten',
          stop: 'stoppen',
          restart: 'herstarten',
        },
        open: 'openen',
        agentsTitle: 'Agents',
        agentsSubtitle: 'Elke agent en subagent draait in een eigen container. Open er een om hem een bericht te sturen of aan te sturen.',
        showFinished: 'Beëindigde agents tonen',
        noAgents: 'Geen agents.',
        definitionsTitle: 'Definities',
        definitionsSubtitle: 'Goedgekeurde agentgrafen met hun versies.',
        designsTitle: 'Agentontwerpen',
        designsSubtitle: 'Elke agent die de architect heeft ontworpen, voor een persoon of voor het werk van een AI-collega: waarvoor en waarom, elke vraag met antwoord, de testruns tegen de scenario\'s, de goedkeuring en de runs.',
        design: 'Ontwerp',
        designFor: 'Voor',
        designWork: 'Werk',
        designState: 'Status',
        designApprovedBy: 'Goedgekeurd door',
        designAgent: 'Gebouwde agent',
        filterState: 'Status',
        filterAll: 'Alle',
        filterOpen: 'Open',
        filterDone: 'Klaar',
        filterFailed: 'Mislukt',
        filterCurrent: 'Actief en recent mislukt',
        filterActive: 'Actief',
        filterFinished: 'Beëindigd',
        filterPosition: 'AI-collega',
        pagePrev: 'Vorige',
        pageNext: 'Volgende',
        pageLabel: 'Pagina',
        searchLabel: 'Zoeken',
        showMore: 'Meer tonen',
        noDesigns: 'Nog geen agent ontworpen.',
        designReason: 'Waarom de tools niet volstonden',
        designRecord: 'Verloop',
        designAgents: 'Agents van het ontwerp',
        designTestRun: 'Testrun',
        designRun: 'Run',
        designStatus: { designing: 'wordt ontworpen', testing: 'in test', asking: 'wacht op antwoord', approval: 'wacht op goedkeuring', running: 'draait', done: 'klaar', failed: 'mislukt', cancelled: 'geannuleerd' },
        builtBy: 'Gebouwd door',
        builtFor: 'Voor het werk',
        viaCodingTask: 'via de coding-agent',
        designTests: 'Testruns',
        designRuns: 'Runs',
        designByPerson: 'een persoon in gesprek',
        diagramsTitle: 'Diagrammen',
        diagramsSubtitle: 'Afbeeldingen van processen, architecturen en plannen die AI-collega\'s, agents en de coding-agent tekenden, met titel, legenda en Mermaid-code.',
        noDiagrams: 'Nog geen diagram.',
        diagramAuthor: 'Auteur',
        diagramBasedOn: 'Breidt uit',
        diagramCode: 'Mermaid-code',
        architectTitle: 'Architect',
        architectSubtitle: 'Ontwerp een agent in gesprek. De architect vraagt wat hij zelf niet kan beslissen en maakt de agent pas aan na uw goedkeuring.',
        orgTitle: 'Organisatie',
        orgSubtitle: 'Afdelingen, teams en projecten met hun leden; het bedrijfsgeheugen wordt langs deze structuur gedeeld.',
        usageTitle: 'Verbruik per agent',
        usageSubtitle: 'Modelaanroepen, tokens en gemelde kosten van de afgelopen 30 dagen.',
        calls: 'Aanroepen',
        source: 'Bron',
        gpuTokens: 'Tokens op de GPU',
        cloudTokens: 'Tokens in de cloud',
        usageByModel: 'Per collega en model',
        cost: 'Kosten',
      },
      memory: {
        archOverviewTitle: "Architectuuroverzicht: hoe het bedrijfsgeheugen is opgebouwd",
        archOverviewText: "Veridion Core bewaart de bedrijfskennis in drie lagen: Neo4j als temporele kennisgraaf voor feiten, beslissingen en werkpakketten, PostgreSQL voor transactionele agent-, postbus- en sprinttoestanden en Qdrant voor vectorzoeken over bedrijfsdocumenten. Elke business unit werkt in een vakinhoudelijk geïsoleerd kennisdomein; resultaten tussen units lopen via vastgelegde overdrachten.",
        clustersTitle: "Kennisdomeinen van de business units",
        clustersSubtitle: "Elke business unit werkt in een afgebakend Neo4j-kennisdomein; knoop- en kantenaantallen komen live uit Neo4j, de beschrijvingen uit de gemarkeerde eerste vulling. Een klik opent het domein in de kennisgraaf.",
        clusterCode: "Code",
        clusterName: "Kennisdomein",
        clusterId: "Identificatie",
        clusterRoles: "Rollen",
        clusterBridges: "Overdrachtsbruggen",
        clusterPolicy: "Vakfocus & isolatierichtlijn",
        clusterCounts: "Knopen / kanten (live)",
        clusterInsights: "Inzichten (eerste vulling)",
        clusterOpenButton: "In de kennisgraaf openen",
        countsUnavailable: "Neo4j onbereikbaar — geen telling",
        researchTitle: "Onderzoeksarchief kwantum- & frontier-AI",
        researchSubtitle: "Wetenschappelijke kernpublicaties & architectuurreferenties — live rijen uit Veridion Core; de herkomst van elke rij is zichtbaar.",
        researchEmpty: "Nog geen publicatie in het archief.",
        researchIngestNote: "Nieuwe publicaties worden toegevoegd door de kwantumcollega via zijn werktuig; het dashboard leest het archief alleen.",
        researchPublication: "Publicatie",
        researchMechanism: "Kernmechanisme",
        researchRelevance: "Relevantie voor de architectuur",
        researchOrigin: "Herkomst",
        researchSeeded: "eerste vulling",
        researchMotivates: "Onderbouwt versie",
        title: 'Bedrijfsgeheugen',
        subtitle: 'Wat Veridion Core in Neo4j bewaart: herinneringen per bereik, feiten met hun geldigheidsperiode en de audit van wat agents hebben gedaan.',
        failed: 'Dat is niet gelukt',
        loading: 'Laden …',
        unavailable: 'Het geheugen is niet bereikbaar',
        database: 'Database',
        ready: 'gereed',
        notReady: 'niet gereed',
        factExtraction: 'Feitenextractie',
        episodesQueued: 'Wachtende episodes',
        lastError: 'Laatste fout',
        contentTitle: 'Inhoud',
        contentSubtitle: 'Knooppunten per label en herinneringen per bereik en soort.',
        label: 'Label',
        count: 'Aantal',
        empty: 'Nog niets.',
        scope: 'Bereik',
        kind: 'Soort',
        kinds: {
          fact: 'feit',
          decision: 'besluit',
          task: 'taak',
          procedure: 'werkwijze',
          note: 'notitie',
          episode: 'episode',
        },
        searchTitle: 'Zoeken',
        searchSubtitle: 'De opvraging die agents gebruiken: betekenis, woorden en geëxtraheerde feiten.',
        searchPlaceholder: 'Zoekterm of vraag',
        allScopes: 'alle bereiken',
        search: 'Zoeken',
        noResults: 'Niets gevonden.',
        text: 'Tekst',
        validFrom: 'Geldig vanaf',
        source: 'Bron',
        extracted: 'geëxtraheerd',
        recorded: 'vastgelegd',
        rememberTitle: 'Onthouden',
        rememberSubtitle: 'Een feit, besluit, taak, werkwijze of notitie in een bereik opslaan.',
        remembered: 'Opgeslagen.',
        remember: 'Onthouden',
        created: 'Aangemaakt',
        validity: 'Geldigheid',
        invalid: 'ongeldig',
        confirmInvalidate: 'Deze herinnering markeren als niet langer geldig?',
        invalidate: 'als ongeldig markeren',
        forget: 'vergeten',
        confirmForget: 'Dit item definitief vergeten? Het wordt uit het geheugen verwijderd en kan niet worden hersteld.',
        forgotten: 'Vergeten.',
        factsTitle: 'Feiten in de tijd',
        factsSubtitle: 'Feiten uit gesprekken en agentresultaten; een weerlegd feit krijgt een einddatum.',
        noFacts: 'Nog geen feiten geëxtraheerd.',
        briefsTitle: 'Overzichten van de AI-collega\'s',
        briefsSubtitle: 'Wat elke AI-collega als eerste leest: open toezeggingen, geldige beslissingen, lopende zaken en klanten, elke nacht uit het geheugen geschreven.',
        brief: 'Overzicht',
        updated: 'Bijgewerkt',
        noBriefs: 'Nog geen overzichten geschreven.',
        fact: 'Feit',
        from: 'Van',
        to: 'Naar',
        validUntil: 'Geldig tot',
        stillValid: 'nog geldig',
        entityTitle: 'Omgeving',
        entitySubtitle: 'Waarmee een taak, project, persoon, systeem of entiteit verbonden is.',
        entityPlaceholder: 'Naam, taak-ID, e-mailadres of ID',
        show: 'Tonen',
        auditTitle: 'Audit',
        auditSubtitle: 'Model- en toolaanroepen, berichten en gestarte subagents.',
        auditPlaceholder: 'Agent-ID (leeg: alle)',
        filter: 'Filteren',
        time: 'Tijd',
        agent: 'Agent',
        event: 'Gebeurtenis',
        toolOrModel: 'Tool of model',
        status: 'Status',
        detail: 'Detail',
        consoleTitle: 'Queryconsole',
        consoleSubtitle: 'Alleen lezende Cypher; schrijvende statements worden geweigerd.',
        run: 'Uitvoeren',
        truncated: 'meer rijen afgekapt',
        graph: {
          clusterPickTitle: "Kennisdomein in de graaf focussen",
          clusterPickHint: "Een klik op een business unit focust haar deelgraaf met rollen en overdrachtsbruggen in de interactieve graaf.",
          allClusters: "Alle domeinen (volledige graaf)",
          activeCluster: "Actief kennisdomein",
          publicationsTitle: "Publicaties in het onderzoeksarchief",
          storesTitle: 'Opslagen van het bedrijfsgeheugen',
          storesSubtitle: 'Wat elke opslag van het bedrijfsgeheugen bevat, live gelezen: de graaf in Neo4j, de toestand van Veridion Core in Postgres, de vectoren van de kennisbank in Qdrant.',
          storeNeo4j: 'Neo4j (graaf)',
          storeNeo4jHolds: 'Het bedrijfsgeheugen: herinneringen met hun bereik, de door Graphiti geëxtraheerde entiteiten en feiten met hun geldigheidsperiode, de werkitems met hun betekenis, het softwarewerk en de audit van de agenten.',
          storePostgres: 'Postgres (relationeel)',
          storePostgresHolds: 'De transactionele toestand van Veridion Core: de procestabel van de agenten, postvakken, gesprekken, checkpoints, codeertaken, goedkeuringen, de organisatie en het verbruik.',
          storeQdrant: 'Qdrant (vectoren)',
          storeQdrantHolds: 'De bedrijfskennisbank: de ingebedde passages van de documenten die een beheerder heeft toegevoegd, doorzocht door de orchestrator wanneer een gespreksbeurt de kennisbank nodig heeft.',
          nodes: 'knopen',
          relationships: 'relaties',
          relationshipType: 'Relatietype',
          tables: 'tabellen',
          table: 'Tabel',
          rows: 'rijen',
          purpose: 'Wat ze bevat',
          documents: 'documenten',
          session: 'Sessie',
          collection: 'Collectie',
          role: 'Rol',
          roleDocuments: 'documenten',
          roleCurated: 'gecureerde vraag-antwoordparen',
          title: 'Graaf',
          subtitle: 'De graaf van het bedrijfsgeheugen in Neo4j: begin bij een zoekresultaat, de nieuwste herinneringen of de werkitems; klik op een knoop om hem te lezen, breid zijn buren uit, sleep om te ordenen, scrol om te zoomen.',
          startNewest: 'Nieuwste herinneringen',
          startWork: 'Werkitems',
          searchPlaceholder: 'Naam, tekst of id om in de graaf te vinden',
          find: 'Zoeken',
          noHits: 'Niets gevonden.',
          name: 'Naam',
          sources: { memory: 'herinnering', entity: 'geëxtraheerde entiteit', node: 'projectgeheugen', episode: 'episode' },
          show: 'tonen',
          shown: '{nodes} knopen en {edges} relaties in de graaf',
          truncated: 'afgekapt bij de grens; breid een knoop uit of zoek nauwer',
          selected: 'Gekozen knoop',
          selectHint: 'Klik op een knoop in de graaf.',
          expand: 'Buren uitbreiden',
          expandTwo: 'Twee niveaus uitbreiden',
          centre: 'Op deze knoop centreren',
          facts: 'Feiten van deze entiteit',
          degree: 'Relaties',
          direction: 'Richting',
          out: 'uitgaand',
          in: 'inkomend',
          noRelationships: 'Geen relaties.',
          property: 'Eigenschap',
          value: 'Waarde',
          noProperties: 'Geen eigenschappen.',
          factsOf: 'Feiten van',
          factsSubtitle: 'Wat Graphiti over deze entiteit heeft geëxtraheerd, met de periode waarin elk feit geldt; een weersproken feit draagt een einddatum.',
          relation: 'Relatie',
          other: 'Andere entiteit',
          newestTitle: 'Nieuwste herinneringen',
          newestSubtitle: 'De laatst geschreven herinneringen met waar elke over gaat; „tonen“ tekent er een met zijn koppelingen.',
          about: 'Waarover',
          workTitle: 'Werkitems',
          workSubtitle: 'Elk bevestigd stuk werk met zijn toestand, eigenaar, issue en de resultaten van zijn scenario\'s; „tonen“ tekent er een met zijn betekenis, zijn issue, zijn codeertaken en de ervoor gebouwde agenten.',
          allStates: 'alle toestanden',
          states: { confirmed: 'bevestigd', in_progress: 'in uitvoering', blocked: 'geblokkeerd', done: 'afgerond', failed: 'mislukt', dropped: 'vervallen' },
          workItem: 'Werkitem',
          owner: 'Eigenaar',
          issue: 'Issue',
          scenarios: 'Scenario\'s',
          results: { passed: 'geslaagd', failed: 'mislukt', pending: 'open' },
        },
        day: {
          title: 'De dag van het bedrijf',
          subtitle: 'De tijdlijn van gebeurtenissen die Veridion Core vastlegt: de woorden van mensen, kaarten, werk, overdrachten, onderzoeken, agenten, codeertaken, projecten, storingen en vergaderingen, het nieuwste eerst.',
          sinceToday: 'vandaag',
          sinceDay: 'laatste 24 uur',
          sinceWeek: 'laatste 7 dagen',
          allKinds: 'alle soorten',
          refresh: 'Vernieuwen',
          count: '{n} gebeurtenissen',
          time: 'Tijd',
          actor: 'Actor',
          happening: 'Gebeurtenis',
          work: 'Werk',
          empty: 'Niets vastgelegd in dit venster.',
          kinds: { word: 'woord', request: 'verzoek', card: 'kaart', work: 'werk', handover: 'overdracht', research: 'onderzoek', agent: 'agent', task: 'codeertaak', project: 'project', incident: 'storing', schedule: 'schema', meeting: 'vergadering', message: 'bericht' },
        },
      },
      title: 'Beheerdersdashboard',
      adminKicker: 'Operatie',
      smtmStatusTitle: 'SMTM-gegevens en prognoses',
      smtmStatusSubtitle: 'Bewaakt broker-tijdreeksen, gepubliceerde modellen, prediction-uitvoer en RSS-feeds.',
      smtmStatusUnavailable: 'SMTM-status niet beschikbaar',
      smtmGeneratedAt: 'Gegenereerd op',
      smtmMinimumRows: 'Minimum aantal trainingsrijen',
      smtmBaseFrames: 'Basistijdreeksen',
      smtmTrainableFrames: 'Ruwe data gereed',
      smtmWaitingHistory: 'Wacht op historie',
      smtmPredictionTrackedInstruments: 'Gevolgde instrumenten',
      smtmPredictionEnabledCount: 'Voorspellingen actief',
      smtmPredictionDisabledCount: 'Voorspellingen gepauzeerd',
      smtmMlFrames: 'ML-datasets',
      smtmOnlineModels: 'Online modellen',
      smtmModelsWithArtifacts: 'Modellen met artefacten',
      smtmPredictionFrames: 'Voorspellingsreeksen',
      smtmMissingPredictions: 'Reeksen zonder voorspellingen',
      smtmBlobArtifacts: 'Blob-artefacten',
      smtmStalePredictions: 'Verouderde voorspellingen',
      smtmRssFrames: 'RSS-feeds',
      smtmDataframesTotal: 'Totaal aantal datasets',
      smtmLatestModelUpload: 'Laatste modelupload',
      smtmLatestPredictionWrite: 'Laatste voorspellingsschrijving',
      smtmRuntimeHints: 'Runtime-aanwijzingen',
      smtmNoHints: 'Geen open SMTM-hints.',
      smtmInstrument: 'Instrument',
      smtmBaseData: 'Basisgegevens',
      smtmMlFrame: 'ML-dataset',
      smtmModelPublish: 'Modelstatus',
      smtmArtifacts: 'Artefacten',
      smtmPredictionFrame: 'Voorspellingsreeks',
      smtmIssues: 'Problemen',
      smtmNoIssues: 'Geen problemen',
      smtmNoFrames: 'Geen SMTM-instrumenten gevonden.',
      smtmPredictionControlTitle: 'SMTM prediction-besturing',
      smtmPredictionControlSubtitle: 'Bepaal per instrument of SMTM nieuwe machine-learning predictions mag berekenen of alleen basisdata moet blijven verzamelen.',
      smtmPredictionSettingsUnavailable: 'SMTM prediction-besturing niet beschikbaar',
      smtmPredictionControlHint: 'Gepauzeerde instrumenten behouden hun historische data. Nieuwe ML-frames, modeltrainingen en predictions worden niet langer voor hen aangemaakt.',
      smtmPredictionMode: 'Voorspellingsmodus',
      smtmPredictionToggle: 'Beheerdersbesturing',
      smtmPredictionToggleLabel: 'Voorspellingen inschakelen of pauzeren',
      smtmPredictionEnabled: 'Voorspelling actief',
      smtmPredictionDisabled: 'Voorspelling gepauzeerd',
      smtmPredictionSaving: 'Opslaan...',
      smtmPredictionSettingsSaved: 'SMTM prediction-besturing opgeslagen.',
      smtmPredictionSaveChanges: 'Wijzigingen opslaan',
      smtmPredictionResetChanges: 'Wijzigingen verwerpen',
      smtmPredictionPendingChanges: 'openstaande wijzigingen',
      smtmPredictionPendingBadge: 'Wacht op opslaan',
      smtmOpenAzuriteUi: 'Azurite-webinterface openen',
      azuriteTitle: 'Azurite-webinterface (SMTM)',
      azuriteSubtitle: 'Read-only overzicht voor modelstatus-records, blob-artefacten en modeldownloads.',
      azuriteModelGroups: 'Modelgroepen',
      azuriteBlobArtifacts: 'Blob-artefacten',
      azuriteFiles: 'Bestanden',
      azuriteSearchPlaceholder: 'Modellen filteren',
      azuriteNoModels: 'Geen Azurite-modellen gevonden.',
      smtmRows: 'Rijen',
      smtmLatest: 'Laatste tijdstempel',
      smtmAge: 'Ouderdom',
      smtmValue: 'Waarde',
      smtmMinutesAgo: 'min geleden',
      smtmMinutesAhead: 'min vooruit',
      smtmHoursAgo: 'u geleden',
      smtmDaysAgo: 'd geleden',
      smtmStateLabels: {
        available: 'Beschikbaar',
        trainable: 'Trainbaar',
        waiting_for_history: 'Wacht op historie',
        missing_base_data: 'Geen basisdata',
        missing_machine_learning: 'ML-dataset ontbreekt',
        missing_prediction: 'Prediction ontbreekt',
        prediction_disabled: 'Prediction gepauzeerd',
        stale_prediction: 'Prediction verouderd',
        open: 'Open',
        completed: 'Voltooid',
        online: 'Online',
        offline: 'Offline',
        training: 'Trainen',
        uploading: 'Uploaden',
        failed: 'Mislukt',
        unknown: 'Onbekend',
        missing: 'Ontbreekt'
      },
      smtmIssueLabels: {
        empty_base_frame: 'Basistijdreeks leeg',
        insufficient_history: 'Te weinig historie',
        missing_machine_learning_frame: 'ML-dataset ontbreekt',
        missing_prediction_frame: 'Prediction-tijdreeks ontbreekt',
        stale_prediction_frame: 'Prediction-tijdreeks verouderd',
        missing_online_model: 'Geen online model',
        model_offline: 'Model offline',
        missing_model_blob: 'Modelbestand ontbreekt',
        missing_model_header: 'Headerbestand ontbreekt',
        missing_modelstatus_entry: 'Modelstatus-item ontbreekt',
        inference_not_writing_prediction: 'Inference schrijft geen predictions',
        prediction_disabled_by_admin: 'Prediction door admin gepauzeerd'
      },
      smtmHintLabels: {
        trainable_frames_missing_predictions: 'ruwe-klaar instrumenten zonder prediction-uitvoer',
        instruments_waiting_for_history: 'instrumenten wachten nog op historie',
        models_missing_artifacts: 'online modellen zonder volledige artefacten',
        no_online_models: 'Geen online modellen in Azurite',
        azurite_unavailable: 'Azurite-opslagstatus is momenteel niet beschikbaar'
      },
      mailTitle: 'Mailconfiguratie',
      usersTitle: 'Gebruikersbeheer',
      usersSubtitle: 'Accounts, rollen, status en 2FA uit Keycloak. Een selectie opent de bediening voor precies dat account.',
      usersHideCreate: 'Formulier sluiten',
      usersCreateHint: 'Een nieuw account start met verplichte 2FA en wordt actief zodra die is ingesteld.',
      usersFilterAllStatus: 'Alle statussen',
      usersFilterAllRoles: 'Alle rollen',
      usersManage: 'Beheren',
      usersClose: 'Sluiten',
      usersNoneFound: 'Geen gebruikers gevonden.',
      usersPagePrev: 'Vorige',
      usersPageNext: 'Volgende',
      auditTitle: 'Auditlogboek',
      smtpHost: 'SMTP-host',
      smtpPort: 'SMTP-poort',
      smtpSecurity: 'SMTP-beveiliging',
      smtpUsername: 'SMTP-gebruiker',
      smtpPassword: 'SMTP-wachtwoord',
      fromEmail: 'Afzenderadres',
      fromName: 'Afzendernaam',
      replyToEmail: 'Antwoordadres',
      saveMailSettings: 'Mailinstellingen opslaan',
      sendTestMail: 'Testmail versturen',
      createUser: 'Gebruiker aanmaken',
      setPassword: 'Wachtwoord instellen',
      setRoles: 'Rollen instellen',
      setStatus: 'Status instellen',
      resetMfa: '2FA resetten',
      revokeSessions: 'Sessies intrekken',
      filterUsers: 'Gebruikers filteren',
      testRecipient: 'Ontvanger van de testmail',
      statusConfigured: 'Geconfigureerd',
      statusMissing: 'Niet geconfigureerd',
      userEmail: 'E-mail',
      userName: 'Gebruikersnaam',
      userRoles: 'Rollen',
      userStatus: 'Status',
      auditEvent: 'Gebeurtenis',
      auditCreatedAt: 'Aangemaakt op',
      auditDetails: 'Details',
      aiGatewayTitle: 'AI Gateway',
      aiGatewayEndpoint: 'Eindpunt',
      aiGatewayIdentitySource: 'Identiteit uit tokenclaim',
      aiGatewayBudgetSource: 'Startwaarden in',
      aiGatewayModels: 'Gerouteerde modellen',
      aiGatewayModel: 'Model',
      aiGatewayBackend: 'Backend',
      aiGatewayBudgets: 'Tokenbudgetten',
      aiGatewayIdentity: 'Identiteit',
      aiGatewayTokenBudget: 'Tokenbudget',
      aiGatewayWindow: 'Venster',
      aiGatewayAnyIdentity: 'elke identiteit',
      aiGatewayAnyModel: 'elk model',
      aiUsageWindowStarted: 'Venster sinds',
      aiUsageRemaining: 'Resterend',
      aiUsageIdentities: 'Identiteiten',
      aiGatewaySubtitle: 'De Envoy AI Gateway is de enige weg naar een model: de gerouteerde modellen, hun serving-backends en het tokenbudget van elke identiteit.',
      aiGatewayHint: 'Budgetten worden hier bestuurd. De deploy-laag levert alleen de startwaarden voor een nieuw cluster.',
      aiUsageTitle: 'AI-gebruik per identiteit',
      aiUsageSubtitle: 'Tokenverbruik dat de gateway in het lopende venster heeft geboekt.',
      sessionActiveUsers: 'Ingelogde gebruikers',
      sessionActiveSessions: 'Actieve sessies',
      sessionMfaSessions: 'Geverifieerde sessies',
      aiUsageTotalTokens: 'Totaal aantal tokens',
      aiServicesTitle: 'Diensttoegang',
      aiServicesSubtitle: 'Links naar de API- en beheeroppervlakken van het platform; elk doel controleert de adminrol zelf.',
      aiMailSubtitle: 'De SMTP-instellingen waarmee Keycloak verificatie- en resetmails verstuurt, en de testverzending.',
      tabOverview: 'Overzicht',
      tabSmtm: 'SMTM',
      tabEnvoy: 'Envoy AI Gateway',
      tabMail: 'E-mailverzending',
      tabUsers: 'Gebruikers',
      tabAudit: 'Auditlogboek',
      tabServiceLinks: 'Diensttoegang',
      tabVeridion: 'Veridion SMTM',
      tabVeridionPaioneer: 'Veridion pAIoneer Labs GmbH',
      tabAgenticRag: 'Agentic RAG',
      tabPlatform: 'Platform',
      platformTitle: 'Platformstatus',
      platformSubtitle: 'Elke pAIoneer Labs GmbH-workload met gereede replicas, herstarts en image, rechtstreeks uit Kubernetes.',
      platformHostPage: 'Instanties in de app-host beheren',
      openVisitorMonitoring: 'Bezoekers-, Marketing- & SEO-monitoring openen',
      platformUnavailable: 'Platformstatus niet beschikbaar',
      platformWorkloadsTotal: 'Workloads',
      platformDegradedTotal: 'Niet gereed',
      platformRestartsTotal: 'Herstarts',
      platformWorkload: 'Workload',
      platformNamespace: 'Naamruimte',
      platformReplicas: 'Replica\'s',
      platformRestarts: 'Herstarts',
      platformImage: 'Image',
      platformState: 'Status',
      platformStateReady: 'Gereed',
      platformStateDegraded: 'Verslechterd',
      platformStateDown: 'Uit',
      platformStateUnknown: 'Onbekend',
      platformNodes: 'Nodes',
      platformOsImage: 'Besturingssysteem',
      platformKernel: 'Kernel',
      platformRuntime: 'Containerruntime',
      platformKubelet: 'Kubelet',
      platformUsed: 'Nu in gebruik',
      platformReportedCapacity: 'Gerapporteerd door Kubernetes',
      platformConfiguredCap: 'Ingestelde containerlimiet',
      platformPressure: 'Drukcondities',
      platformPressureNone: 'geen',
      platformCpu: 'CPU-cores',
      platformNoWorkloads: 'Deze naamruimte bevat configuratieobjecten, geen workloads.',
      platformMemory: 'Geheugen',
      platformEvents: 'Recente waarschuwingen',
      platformEventsNone: 'Geen waarschuwingen.',
      platformEventObject: 'Object',
      platformEventReason: 'Reden',
      platformEventMessage: 'Bericht',
      platformEventLastSeen: 'Laatst gezien',
      platformMetricsMissing: 'Geen verbruiksgegevens beschikbaar: metrics-server antwoordt niet.',
      aiGatewayBackends: 'Serverende backends',
      gpuTitle: 'GPU',
      gpuNote: 'Belasting van de engines op de GPU, de tokens die ze per identiteit en per Webex-bot leverden, en de tokenbudgetten per identiteit en engine.',
      gpuTokensWindow: 'Tokens op de GPU in het venster',
      gpuSinceStart: 'sinds de start van de engine',
      gpuIdentities: 'Per identiteit, lopend venster',
      gpuBots: 'Per Webex-bot en agent, 30 dagen',
      gpuBot: 'Webex-bot / agent',
      gpuBudgetTitle: 'Budget per identiteit voor de engine',
      gpuBudgetSet: 'Budget instellen',
      gpuBudgetHint: 'Tokens per uur op de engine; de gateway dwingt het af. Het begrenst ook een identiteit zonder limiet.',
      gpuNoneYet: 'Nog niets geboekt.',
      gpuEngines: 'Engines',
      gpuEngine: 'Engine',
      gpuEngineGold: 'Goud-engine',
      agenticRagTitle: 'Agentic RAG',
      agenticRagSubtitle: 'Runtime, kennisbank, trainingsvoorbereiding en traceerbaarheid van de Agentic RAG-toepassing.',
      agenticRagBackendStatus: 'Backend-status',
      agenticRagRuntimeMode: 'Runtime-modus',
      agenticRagKnowledgeMode: 'Kennismodus',
      agenticRagDeploymentEnv: 'Deployment-omgeving',
      agenticRagVectorStores: 'Vectoropslag',
      agenticRagQdrantStatus: 'Qdrant',
      agenticRagQdrantCollection: 'Documentcollectie',
      agenticRagQdrantCuratedCollection: 'Collectie van gecureerde vragen en antwoorden',
      agenticRagQdrantDashboard: 'Dashboard',
      agenticRagPhoenixStatus: 'Phoenix',
      agenticRagOpenDocs: 'Swagger openen',
      agenticRagOpenPhoenix: 'Phoenix openen',
      agenticRagOpenQdrant: 'Qdrant openen',
      agenticRagKnowledgeTitle: 'Kennisbank',
      agenticRagKnowledgeSubtitle: 'Stand van de documenten en de gecureerde vragen en antwoorden van de Agentic RAG-toepassing.',
      agenticRagDocuments: 'Documenten',
      agenticRagCuratedQaPairs: 'Gecureerde vraag-antwoordparen',
      agenticRagTrainingTitle: 'Trainingsvoorbereiding',
      agenticRagTrainingSubtitle: 'De laatste generatorrun en de laatste stand van de trainer.',
      agenticRagLatestDataset: 'Laatste dataset',
      agenticRagDatasetPairs: 'Vraag-antwoordparen',
      agenticRagDatasetDocuments: 'Verwerkte documenten',
      agenticRagDatasetModifiedAt: 'Laatst gewijzigd',
      agenticRagLatestTrainerInput: 'Laatste trainerinvoer',
      agenticRagTrainerInputModifiedAt: 'Invoer gewijzigd',
      agenticRagLatestTrainerRun: 'Laatste trainerrun',
      agenticRagTrainerRunModifiedAt: 'Runsamenvatting gewijzigd',
      gpuEngineSilver: 'Zilver-engine',
      gpuAssignment: 'Toewijzing',
      gpuWho: 'Wie',
      gpuRank: 'Rang',
      gpuRankHint: 'Rang 0 wordt eerst bediend; elke engine bedient op rang.',
      gpuLanes: 'Lopende aanroepen van Veridion Core per engine en rang',
      gpuInFlight: 'lopend',
      gpuWhoMainBotPeople: 'Hoofdbot: gesprekken met mensen',
      gpuWhoMainBotJudgements: 'Hoofdbot: oordelen in dezelfde beurt',
      gpuWhoAutopilot: 'Autopilot',
      gpuWhoAgents: 'Agents die de hoofdbot uitvoert',
      gpuWhoArchitect: 'Architect',
      gpuWhoChair: 'Voorzitter van de meeting',
      gpuWhoOrchestrator: 'Orchestrator van de bedrijfsinstantie',
      gpuWhoColleagues: 'AI-collega\'s: beurten en hun oordelen',
      gpuWhoMeetingWords: 'AI-collega\'s: bijdragen in meetings',
      gpuWhoBackgroundReading: 'Achtergronddienst: lezen van botberichten',
      gpuWhoMemory: 'Bedrijfsgeheugen: opname en briefings',
      gpuWhoCoding: 'Codeertaken: oordelen en leren',
      gpuWhoResearch: 'Web- en OSINT-onderzoek',
      gpuWhoKnowledgeBase: 'Bedrijfskennisbank: lezen van gescande pagina\'s',
      gpuWhoPipeline: 'Pipelinecontrole tegen de IDD',
      gpuWhoSmtm: 'Veridion SMTM: SaaS-chat en kennisbank, laatste rang',
      gpuUnavailable: 'De GPU antwoordt niet',
      aiGatewaySource: 'Bron',
      aiSourceGpu: 'GPU',
      aiGatewayMeter: 'Teller',
      aiGatewayMeterIdentity: 'Elke identiteit, geteld',
      aiGatewayEngines: 'Engines op de GPU',
      aiGatewayEnginesHint: 'Live-cijfers van elke engine uit haar metrieken: lopende en wachtende verzoeken, cachegebruik en sinds de start bediende tokens.',
      aiEngineRunning: 'Lopend',
      aiEngineWaiting: 'Wachtend',
      aiEngineCache: 'Cache in gebruik',
      aiEngineServed: 'Tokens bediend',
      aiEngineIdle: 'Geen verzoeken',
      aiEngineUnavailable: 'Engine antwoordt niet',
      aiGatewayServing: 'Gereed',
      aiBudgetControlTitle: 'Tokenbudgetten besturen',
      aiBudgetControlSubtitle: 'Het standaardbudget geldt voor elke identiteit. Een afzonderlijke identiteit kan een eigen bovengrens krijgen.',
      aiBudgetDefault: 'Standaardbudget',
      aiBudgetIdentity: 'Identiteit',
      aiBudgetTokens: 'Tokens',
      aiBudgetApply: 'Toepassen',
      aiBudgetAdd: 'Limiet instellen',
      aiBudgetRemove: 'Verwijderen',
      aiBudgetSaved: 'Tokenbudget toegepast.',
      aiBudgetIdentityPlaceholder: 'Client-id, bijv. paioneer-agent-veridion-smtm',
      aiBudgetUnlimited: 'Geen limiet',
      aiBudgetSetUnlimited: 'Limiet opheffen',
      aiBudgetRestoreLimit: 'Limiet herstellen',
      aiUsageReset: 'Venster leegmaken',
      aiUsageResetDone: 'Lopend venster gewist.',
      userMfa: '2FA',
      userMfaOn: 'Geconfigureerd',
      userMfaOff: 'Ontbreekt',
      userCreatedAt: 'Aangemaakt',
      mailSource: 'Beheerd in',
      veridionTitle: 'Veridion SMTM',
      veridionSubtitle: 'Conversatiekern van de handelsassistent: runtime, toolregister, MCP-servers en activiteit.',
      veridionOpenPage: 'Veridion openen',
      veridionOpenDocs: 'Swagger openen',
      veridionCoreStatus: 'Veridion MCP orchestrator',
      veridionTools: 'Tools',
      veridionToolsTitle: 'Toolregister',
      veridionToolsSubtitle: 'Toont de geladen toolfamilies en hun effectieve status.',
      veridionToolName: 'Tool',
      veridionToolRuntime: 'Runtime',
      veridionToolRisk: 'Risico',
      veridionToolEnabled: 'Ingeschakeld',
      veridionNoTools: 'Geen Veridion-tools geladen.',
      veridionRuntimeProfiles: 'Runtimeprofielen',
      veridionRegistryReloaded: 'Register opnieuw geladen',
      veridionProvider: 'AI-pad',
      veridionMcpTitle: 'MCP-servers',
      veridionMcpSubtitle: 'Gekoppelde externe toolservers met hun status en het aantal tools.',
      veridionMcpServer: 'Server',
      veridionMcpState: 'Status',
      veridionMcpTools: 'Tools',
      veridionMcpLastSuccess: 'Laatst bereikt',
      veridionMcpConnected: 'verbonden',
      veridionMcpUnreachable: 'onbereikbaar',
      veridionMcpDisabled: 'uitgeschakeld',
      veridionMcpEmpty: 'Geen MCP-servers geconfigureerd.',
      veridionActivityTitle: 'Activiteitenstroom',
      veridionActivitySubtitle: 'Gestructureerde runtimegebeurtenissen van de orchestrator en zijn tools.',
      veridionActivityEmpty: 'Nog geen activiteit geregistreerd.',
      veridionActivitySource: 'Bron',
      veridionActivitySurface: 'Oppervlak',
      veridionActivityEvent: 'Gebeurtenis',
      veridionActivityTool: 'Tool',
      veridionActivityStatus: 'Status',
      veridionActivitySummary: 'Samenvatting',
      veridionUnavailable: 'Veridion is momenteel niet bereikbaar.',
      veridionNotConfigured: 'Veridion is nog niet volledig geconfigureerd in de Homepage-runtime.',
      veridionRequestFailed: 'Veridion heeft de gevraagde admin-aanroep niet succesvol afgerond.',
      companyTitle: 'Veridion pAIoneer Labs GmbH',
      companySubtitle: 'De Veridion-instantie van pAIoneer Labs GmbH voor de medewerkers in Webex, met YouTrack en een eigen kennisbank; haar modelaanroepen lopen via de Envoy AI Gateway.',
      companyWorkloads: 'Workloads',
      companyTokensWindow: 'Tokens in het lopende venster',
      companyBudget: 'Budget',
      companyBudgetDefault: 'standaardbudget',
      companyCost30: 'Kosten van de laatste 30 dagen',
      openrouterTitle: 'Gefactureerd door OpenRouter',
      openrouterRemaining: 'Resterend tegoed',
      openrouterOf: 'van',
      openrouterToday: 'Vandaag',
      openrouterWeek: 'Deze week',
      openrouterMonth: 'Deze maand',
      openrouterUnavailable: 'OpenRouter is nu niet leesbaar',
      openrouterNote: 'De facturering van OpenRouter voor de platformsleutel, in Amerikaanse dollars; dag en week in UTC. De geboekte waarden hieronder tellen alleen antwoorden die hun kosten melden en liggen daarom lager.',
      companyRequests30: 'Modelaanroepen van de laatste 30 dagen',
      companyCostNote: 'Kosten in US-dollar zoals OpenRouter ze per aanvraag meldt; tokens boekt de Envoy AI Gateway op de identiteit {identity}.',
      companyCostNotReported: 'niet gemeld',
      companyPartUnavailable: 'onbereikbaar',
      companyWebexTitle: 'Webex-bot',
      companyWebexSubtitle: 'Webex roept webex.paioneer-labs.eu/hook aan; de brug controleert handtekening en afzender en geeft alleen toegestane berichten door aan Veridion.',
      companyWebexBot: 'Bot',
      companyWebexWebhook: 'Webhook',
      companyWebexRegistered: 'geregistreerd',
      companyWebexNotRegistered: 'niet geregistreerd',
      companyWebexAccess: 'Toegestaan',
      companyWebexAnswered: 'Beantwoord',
      companyWebexRejected: 'Geweigerd',
      companyWebexFailed: 'Mislukt',
      companyWebexRecent: 'Recente leveringen',
      companyWebexTime: 'Tijd',
      companyWebexOutcome: 'Resultaat',
      companyWebexReason: 'Reden',
      companyWebexSender: 'Afzender',
      companyWebexEmpty: 'Geen levering sinds de laatste start.',
      companyWebexNotConfigured: 'De Webex-brug is onbereikbaar of de statussleutel ontbreekt in de admin-API.',
      companyUsageTitle: 'Gebruik per persoon',
      companyUsageSubtitle: 'Modelaanroepen, tokens en kosten van de laatste 30 dagen uit het verbruiksregister van de instantie.',
      companyUsagePerson: 'Persoon',
      companyUsageCalls: 'Aanroepen',
      companyUsageTokens: 'Tokens',
      companyUsageCost: 'Kosten (USD)',
      companyUsageEmpty: 'Geen modelaanroepen in de laatste 30 dagen.',
      companyWebexSendTitle: 'Schrijven als de bot',
      companyWebexSendPerson: 'Aan een persoon',
      companyWebexSendRoom: 'In een ruimte van de bot',
      companyWebexSendEmail: 'E-mailadres in Webex',
      companyWebexSendText: 'Bericht (Markdown)',
      companyWebexSendButton: 'Verzenden',
      companyWebexSendDone: 'Verzonden.',
      companyWebexSendFailed: 'Mislukt',
      companyWebexRooms: 'Ruimten van de bot',
      companyWebexRoomGroup: 'groep',
      companyWebexRoomDirect: 'direct',
      companyWebexRoomsEmpty: 'De bot zit nog in geen enkele ruimte.',
      companyKnowledgeTitle: 'Kennisbank',
      companyKnowledgeSubtitle: 'De documenten van de kennisbank van de bedrijfsinstantie (Agentic RAG); de orchestrator doorzoekt ze wanneer een gespreksstap ze nodig heeft. Phoenix logt elke zoekopdracht.',
      companyKnowledgeDocument: 'Document',
      companyKnowledgeSize: 'Grootte',
      companyKnowledgeModified: 'Toegevoegd',
      companyKnowledgeDelete: 'Verwijderen',
      companyKnowledgeDeleteConfirm: '{name} uit de kennisbank verwijderen?',
      companyKnowledgeUpload: 'Document toevoegen',
      companyKnowledgeUploading: 'Wordt geüpload …',
      companyKnowledgeIntake: 'Verwerking',
      companyKnowledgePhoenix: 'Explainable AI (Phoenix)',
      companyKnowledgeEmpty: 'De kennisbank is leeg.',
      companyKnowledgeNotConfigured: 'De kennisbank is niet gekoppeld aan de admin-API.',
      companyGuestsTitle: 'Gasten met toegang',
      companyGuestsHint: 'Elk adres bij {domains} mag de bot gebruiken. Losse externe adressen voegen admins hier toe; een wijziging geldt direct.',
      companyGuestsEmail: 'E-mailadres',
      companyGuestsAdd: 'Toevoegen',
      companyGuestsRemove: 'Verwijderen',
      companyGuestsRemoveConfirm: 'De toegang van {email} tot de bot intrekken?',
      companyGuestsAddedBy: 'Toegevoegd door',
      companyGuestsAddedAt: 'Toegevoegd op',
      companyGuestsEmpty: 'Geen gasten ingevoerd.',
      companyGuestsNotPersistent: 'De lijst wordt niet opgeslagen: de brug heeft geen datamap.',
      companyGuestsLoadFailed: 'De opgeslagen lijst was niet leesbaar; tot de volgende wijziging heeft geen gast toegang.',
      companyErrorRecipientNotAllowed: 'Dit adres mag de bot niet antwoorden. Voeg het eerst als gast toe en verstuur dan.',
      companyErrorDomainAllowed: 'Adressen van dit domein hebben al toegang.',
      companyErrorInvalidEmail: 'Geen geldig e-mailadres.',
      companyErrorAlreadyListed: 'Dit adres staat al op de lijst.',
      companyErrorStoreUnwritable: 'De lijst kon niet worden opgeslagen.',
      smtmFilterTitle: 'SMTM instrumentfilter',
      smtmFilterSubtitle: 'Een lege invoer toont alle instrumenten; meerdere instrumentnamen worden door komma\'s gescheiden, bijvoorbeeld EUR-USD_FOREX_intraday_data_l1,BitcoinEUR_CRYPTO_intraday_data_l1.',
      smtmFilterPlaceholder: 'Instrumentnamen, kommagescheiden',
      smtmFilterApply: 'Filter toepassen',
      smtmFilterClear: 'Filter wissen',
      smtmReportingTitle: 'SMTM-signaalrapportage',
      smtmReportingSubtitle: 'Toont gekwalificeerde koopsignalen, hun uitstapevaluatie en de leveringsstatus van automatische meldingen.',
      smtmReportingUnavailable: 'SMTM-rapportage niet beschikbaar',
      smtmReportingQualifiedSignals: 'Gekwalificeerde signalen',
      smtmReportingOpenSignals: 'Openstaande signalen',
      smtmReportingResolvedSignals: 'Afgeronde signalen',
      smtmReportingWins: 'Winsten',
      smtmReportingLosses: 'Verliezen',
      smtmReportingWinRate: 'Trefkans',
      smtmReportingAverageActualReturn: 'Gem. werkelijk rendement',
      smtmReportingNetActualReturn: 'Netto werkelijk rendement',
      smtmReportingDeliveryFailed: 'Mislukte leveringen',
      smtmReportingEntryTime: 'Instaptijd',
      smtmReportingExitTime: 'Uitstaptijd',
      smtmReportingExpectedReturn: 'Verwacht rendement',
      smtmReportingActualReturn: 'Werkelijk rendement',
      smtmReportingSignalStatus: 'Signaalstatus',
      smtmReportingNoSignals: 'Nog geen gekwalificeerde signalen opgeslagen.',
      smtmReportingPendingDeliveries: 'Openstaande leveringen',
      smtmReportingFailedDeliveries: 'Mislukte leveringen',
      smtmReportingDeliveryError: 'Leveringsfout',
      smtmTrainingTitle: 'SMTM-training en modellen',
      smtmTrainingSubtitle: 'Toont trainingskwaliteit, modelstatus en artefacten die de trainingsdienst publiceert.',
      smtmTrainingUnavailable: 'SMTM-training niet beschikbaar',
      smtmTrainingModels: 'Modellen',
      smtmTrainingOnlineModels: 'Online modellen',
      smtmTrainingFailedModels: 'Mislukte modellen',
      smtmTrainingStaleModels: 'Verouderde modellen',
      smtmTrainingAverageMae: 'Gem. MAE',
      smtmTrainingAverageRmse: 'Gem. RMSE',
      smtmTrainingAverageR2: 'Gem. R²',
      smtmTrainingAverageMase: 'Gem. MASE',
      smtmTrainingAverageHitRate: 'Gem. richtingstrefkans',
      smtmTrainingHitRate: 'Trefkans',
      smtmTrainingLastSuccess: 'Laatste geslaagde training',
      smtmTrainingResolution: 'Resolutie / horizon',
      smtmTrainingConsoleTitle: 'SMTM trainingsconsole',
      smtmTrainingConsoleSubtitle: 'Live-tail van de huidige uitvoer van de trainingsservice.',
      smtmTrainingConsoleUnavailable: 'SMTM trainingsconsole niet beschikbaar',
      smtmTrainingConsoleEmpty: 'Nog geen trainingsuitvoer beschikbaar.',
      smtmRuntimeTitle: 'SMTM-runtime',
      smtmRuntimeSubtitle: 'Globale horizon, rebuild-status en prediction-gate voor het live SMTM-systeem.',
      smtmRuntimeUnavailable: 'SMTM runtime niet beschikbaar',
      smtmRuntimeForecastHorizon: 'Prognosehorizon',
      smtmRuntimeResolution: 'Resolutie',
      smtmRuntimeConfigVersion: 'Configuratieversie',
      smtmRuntimePredictionGate: 'Voorspellingspoort',
      smtmRuntimeRebuild: 'Herbouw',
      smtmRuntimeStateOpen: 'open',
      smtmRuntimeStateClosed: 'gesloten',
      smtmRuntimeStateActive: 'actief',
      smtmRuntimeStateIdle: 'inactief',
      smtmRuntimeForecastHorizonMinutes: 'Prognosehorizon in minuten',
      smtmRuntimeResolutionMinutes: 'Resolutie in minuten',
      smtmRuntimeRequireCompletedBars: 'Alleen voltooide candles',
      smtmRuntimePredictionGateOpen: 'Voorspellingspoort open',
      smtmRuntimeRebuildActive: 'Herbouw actief',
      smtmRuntimeSaving: 'Runtime opslaan...',
      smtmRuntimeSave: 'Runtime-instellingen opslaan',
      smtmRuntimeReset: 'Runtime-wijzigingen verwerpen',
      smtmRuntimeSaved: 'SMTM runtime-instellingen opgeslagen.',
      smtmTrainingRows: 'Trainings-/testrijen',
      smtmTrainingMetrics: 'Metrieken',
      smtmTrainingIssues: 'Trainingsproblemen',
      smtmTrainingLlmFeatures: 'LLM-kenmerken',
      smtmTrainingNoModels: 'Nog geen trainingsmodellen in de cache.',
      smtmDirection: 'Richting',
      smtmSentiment: 'Sentiment',
      smtmDeliveryStage: 'Fase',
      smtmDeliveryRecipient: 'Ontvanger',
      mailSettingsSaved: 'Mailinstellingen opgeslagen.',
      mailTestSent: 'Testmail verzonden.',
      userCreatedSuccess: 'Gebruiker succesvol aangemaakt.',
      userUpdatedSuccess: 'Gebruiker succesvol bijgewerkt.',
      userDeletedSuccess: 'Gebruiker succesvol verwijderd.',
      deleteUser: 'Gebruiker verwijderen',
      roleLabels: {
        admin: 'Beheerder',
        pro: 'Pro',
        tester: 'Tester',
        user: 'Gebruiker'
      },
      statusLabels: {
        pending_email_verification: 'Wacht op e-mailverificatie',
        pending_mfa: 'Wacht op 2FA',
        active: 'Actief',
        locked: 'Vergrendeld',
        disabled: 'Uitgeschakeld'
      }
    }
  }
};
